import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M110.768 41.87C110.768 41.87 83.1376 27.42 81.7376 25.66C80.3376 23.9 79.3976 1 79.3976 1H57.3876C57.3876 1 56.4476 23.9 55.0476 25.66C53.6476 27.42 26.0176 41.87 26.0176 41.87C26.0176 41.87 38.2676 56.92 68.3976 56.92C98.5176 56.92 110.768 41.87 110.768 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M61.3275 28.11L50.8675 47.33L49.9375 26.76" stroke="#BC4222" strokeMiterlimit="10" />
      <path d="M75.4775 28.11L85.9375 47.33L86.8675 26.76" stroke="#BC4222" strokeMiterlimit="10" />
      <path
        d="M68.3879 49.6601C69.382 49.6601 70.1879 48.8542 70.1879 47.8601C70.1879 46.866 69.382 46.0601 68.3879 46.0601C67.3938 46.0601 66.5879 46.866 66.5879 47.8601C66.5879 48.8542 67.3938 49.6601 68.3879 49.6601Z"
        fill="#BC4222"
      />
      <path
        d="M68.3879 67.36C69.382 67.36 70.1879 66.5541 70.1879 65.56C70.1879 64.5659 69.382 63.76 68.3879 63.76C67.3938 63.76 66.5879 64.5659 66.5879 65.56C66.5879 66.5541 67.3938 67.36 68.3879 67.36Z"
        fill="#BC4222"
      />
      <path
        d="M79.9694 16.3873C80.2084 16.0353 80.4568 15.6904 80.6839 15.3314C81.0677 14.724 81.4385 14.1072 81.8128 13.4939C81.8328 13.4621 81.8363 13.4209 81.8469 13.3833C82.0059 13.1537 82.1648 12.923 82.3543 12.6499C82.5097 12.9324 82.6545 13.1902 82.7934 13.4503C84.6391 16.897 86.4825 20.346 88.3353 23.7879C88.4153 23.9374 88.5695 24.0751 88.7225 24.1528C92.6942 26.1775 96.6823 28.168 100.642 30.215C107.211 33.6122 113.768 37.0306 120.183 40.7162C122.476 42.0334 124.749 43.3812 126.893 44.9374C127.975 45.7225 128.716 46.7525 129.264 47.9473C130.134 49.846 130.807 51.8165 131.373 53.8223C132.109 56.425 132.863 59.0252 133.502 61.6514C134.378 65.2475 135.157 68.8684 135.969 72.4798C136.164 73.3462 136.327 74.2196 136.508 75.1119C91.0038 75.1119 45.5184 75.1119 0 75.1119C0.274271 73.8053 0.543833 72.5246 0.811042 71.2438C1.75628 66.7107 2.82864 62.207 4.01166 57.7304C4.84153 54.5898 5.76087 51.4763 7.0098 48.4688C7.69018 46.8314 8.68132 45.4671 10.2045 44.516C10.8849 44.091 11.5359 43.6178 12.2151 43.1893C15.4392 41.1564 18.7611 39.293 22.1159 37.4897C26.1299 35.3332 30.1533 33.1932 34.1979 31.0967C38.7193 28.753 43.2713 26.4659 47.8044 24.1457C47.9562 24.0681 48.1022 23.9233 48.1834 23.7738C50.1339 20.1494 52.0738 16.5215 54.0173 12.8936C54.0538 12.8253 54.0985 12.7617 54.1621 12.6605C54.3374 12.9136 54.4987 13.1467 54.6588 13.3797C54.9931 13.94 55.3215 14.5039 55.6617 15.0607C55.9466 15.5256 56.2456 15.9824 56.5387 16.4438C57.1473 17.4267 57.757 18.4084 58.3656 19.3913C58.767 20.0482 59.1648 20.7073 59.5698 21.363C62.3349 25.8349 65.0999 30.3045 67.8674 34.7752C67.9863 34.9683 68.1169 35.1542 68.277 35.3967C71.5859 30.022 74.8583 24.7072 78.1308 19.3925C78.6181 18.6203 79.1089 17.8505 79.5927 17.0759C79.7281 16.8511 79.8435 16.6156 79.9694 16.3873ZM101.084 32.9048C100.927 32.8106 100.772 32.7176 100.615 32.6234C100.335 32.4822 100.056 32.3397 99.7758 32.1985C98.86 31.7253 97.943 31.2509 97.0272 30.7777C96.1844 30.348 95.3404 29.9184 94.4975 29.4876C94.3845 29.4299 94.2715 29.3734 94.1585 29.3157C93.3086 28.8884 92.4588 28.4599 91.6089 28.0326C91.337 27.8925 91.0639 27.7536 90.7919 27.6136C90.633 27.5312 90.4741 27.4488 90.3152 27.3664C90.0339 27.2275 89.7514 27.0886 89.47 26.9485C89.3664 26.8955 89.264 26.8425 89.1604 26.7896C88.8497 26.6259 88.5377 26.4623 88.1646 26.2658C88.1646 26.4906 88.1646 26.6424 88.1646 26.7943C88.1269 27.6383 88.0904 28.4835 88.0528 29.3275C88.0069 30.2845 87.961 31.2403 87.915 32.1973C87.9103 32.4751 87.9056 32.7529 87.9021 33.0307C87.888 33.2037 87.8727 33.3768 87.8585 33.5486C87.8515 33.8241 87.8444 34.1007 87.8374 34.3762C87.7926 35.2778 87.7491 36.1795 87.7043 37.0812C87.6678 37.9252 87.6314 38.7692 87.5949 39.6132C87.5454 40.5714 87.496 41.5296 87.4465 42.4866C87.423 42.7844 87.4006 43.0834 87.3771 43.3812C87.3806 43.5331 87.3842 43.6861 87.3877 43.8379C87.383 44.1157 87.3783 44.3947 87.3724 44.6725C87.3288 45.593 87.2853 46.5147 87.2417 47.4352C87.2182 47.7342 87.1958 48.0332 87.1687 48.3911C87.0028 48.1085 86.8674 47.879 86.732 47.6495C86.6908 47.5777 86.6485 47.5059 86.6073 47.4341C86.3271 46.9032 86.0528 46.3699 85.7668 45.8426C85.549 45.4435 85.3159 45.0527 85.0899 44.6584C84.9475 44.3865 84.8039 44.1145 84.6615 43.8426C84.5696 43.679 84.4767 43.5166 84.3848 43.353C84.2365 43.0693 84.0882 42.7844 83.9399 42.5007C83.4137 41.539 82.8887 40.5773 82.3625 39.6156C82.0129 38.9834 81.6645 38.3502 81.3149 37.718C81.2019 37.5062 81.09 37.2943 80.977 37.0812C80.8217 36.8046 80.6651 36.5268 80.5097 36.2502C80.3449 35.9406 80.1801 35.6322 80.0165 35.3226C80.0212 35.3037 80.0189 35.2861 80.0106 35.2684C79.8399 34.9694 79.6681 34.6716 79.4974 34.3726C79.3809 34.1584 79.2643 33.943 79.1466 33.7287C79.1066 33.6499 79.0677 33.5722 79.0277 33.4933C78.9312 33.3321 78.8358 33.1708 78.7393 33.0095C78.5969 32.7411 78.4545 32.4727 78.3109 32.2044C77.7906 31.2391 77.2703 30.2727 76.75 29.3075C76.4133 28.6824 76.0778 28.0585 75.7153 27.3852C75.2998 28.0762 74.9242 28.6989 74.5476 29.3228C74.331 29.6724 74.1132 30.0231 73.8966 30.3728C73.5188 30.9825 73.1397 31.5934 72.7619 32.2032C72.5935 32.4786 72.4252 32.7541 72.2569 33.0307C72.1556 33.1861 72.0556 33.3403 71.9544 33.4957C71.7766 33.7876 71.6 34.0795 71.4223 34.3726C71.2681 34.6387 71.1151 34.9047 70.9609 35.1707C70.6678 35.6157 70.3758 36.0606 70.0827 36.5056C69.9344 36.774 69.7861 37.0424 69.6378 37.3096C69.5707 37.3896 69.4918 37.4614 69.4365 37.5497C69.214 37.9028 68.9998 38.2595 68.782 38.615C68.6125 38.8799 68.443 39.1459 68.2535 39.4425C67.7414 38.628 67.2564 37.8569 66.7715 37.0859C66.5396 36.7151 66.3077 36.3431 66.0758 35.9724C65.745 35.4379 65.4142 34.9047 65.0846 34.3703C64.9081 34.0784 64.7303 33.7864 64.5537 33.4945C64.4407 33.3297 64.3266 33.1661 64.2136 33.0013C64.057 32.7364 63.9004 32.4716 63.7427 32.2067C63.1483 31.245 62.555 30.2833 61.9605 29.3216C61.585 28.6953 61.2083 28.0679 60.7975 27.384C60.7257 27.5818 60.6798 27.7077 60.6351 27.8337C60.3691 28.3069 60.1042 28.7789 59.8382 29.2521C59.6757 29.5464 59.5145 29.8419 59.352 30.1361C59.0648 30.6506 58.7776 31.165 58.4892 31.6794C58.395 31.8524 58.3008 32.0254 58.2067 32.1985C58.0619 32.4928 57.9183 32.7859 57.7735 33.0801C57.6793 33.2391 57.5863 33.398 57.4921 33.5581C57.3462 33.8253 57.2014 34.0937 57.0554 34.3609C56.6281 35.1307 56.202 35.8994 55.7747 36.6692C55.7135 36.7846 55.6523 36.9011 55.5923 37.0165C55.1214 37.8817 54.6506 38.7468 54.1797 39.6109C53.8689 40.1818 53.5594 40.7539 53.2486 41.3248C53.0332 41.7144 52.8178 42.1052 52.6024 42.4948C52.4635 42.7667 52.3246 43.0387 52.1868 43.3094C52.088 43.4683 51.9891 43.6272 51.8902 43.7861C51.736 44.0816 51.5806 44.3771 51.4264 44.6725C51.0662 45.3364 50.706 46.0003 50.3458 46.663C50.0774 47.1551 49.8102 47.6483 49.5418 48.1403C49.4912 48.2015 49.4394 48.2628 49.3653 48.3534C49.3405 48.0214 49.3182 47.7272 49.297 47.4329C49.2664 46.6772 49.2393 45.9214 49.2028 45.1657C49.1946 44.9974 49.1569 44.8302 49.1334 44.6631C49.151 44.4559 49.1828 44.2476 49.1793 44.0404C49.1781 43.9356 49.1133 43.832 49.078 43.7285C49.0745 43.6131 49.0698 43.4977 49.0663 43.3824C49.0733 43.0928 49.0804 42.8032 49.0874 42.5137C49.0392 41.5484 48.9921 40.582 48.9438 39.6167C48.905 38.7727 48.8661 37.9299 48.8261 37.0859C48.7873 36.1866 48.7496 35.2873 48.7108 34.3879C48.6931 34.1113 48.6755 33.8347 48.659 33.5581C48.6554 33.385 48.6519 33.212 48.6484 33.0378C48.6319 32.76 48.6154 32.4822 48.5989 32.2044C48.5566 31.245 48.5142 30.2856 48.473 29.3263C48.4377 28.3222 48.4024 27.3193 48.3659 26.2834C48.2858 26.3187 48.2376 26.3399 48.1881 26.3623C47.908 26.5059 47.629 26.6483 47.3488 26.7919C46.7073 27.1121 46.0669 27.4323 45.4254 27.7525C44.4013 28.2728 43.376 28.793 42.3519 29.3145C41.5868 29.7065 40.8205 30.0985 40.0553 30.4893C39.7858 30.6305 39.515 30.7718 39.2455 30.9131C39.0642 31.0072 38.8829 31.1014 38.7005 31.1956C38.4309 31.3298 38.1613 31.464 37.8918 31.5981C37.5198 31.783 37.149 31.9678 36.777 32.1526C36.6158 32.2385 36.4533 32.3233 36.2921 32.4104C35.9189 32.6116 35.5458 32.8141 35.1726 33.0166C34.8218 33.1979 34.471 33.3791 34.1203 33.5604C33.5917 33.8312 33.0632 34.1031 32.5347 34.3738C31.8449 34.7305 31.1527 35.0848 30.4641 35.4462C30.2075 35.5815 29.9591 35.7334 29.7072 35.877C29.4129 36.0206 29.1175 36.1642 28.8232 36.309C28.6843 36.3879 28.5454 36.4667 28.4065 36.5468C28.1334 36.6904 27.8615 36.8352 27.5884 36.9788C26.6655 37.4755 25.7426 37.9723 24.8198 38.469C24.1158 38.8516 23.4119 39.233 22.708 39.6156C22.5703 39.6897 22.4337 39.7627 22.296 39.8369C21.6297 40.2041 20.9611 40.5679 20.2972 40.941C19.9924 41.1129 19.6969 41.3012 19.3967 41.4825C19.1272 41.6285 18.8576 41.7744 18.588 41.9204C18.428 42.011 18.269 42.1017 18.109 42.1923C17.9324 42.2947 17.7558 42.3959 17.5781 42.4984C17.4851 42.5584 17.3909 42.6172 17.2979 42.6773C16.8824 42.9056 16.4669 43.1352 16.0513 43.3635C15.8006 43.5072 15.5499 43.6508 15.2991 43.7944C15.1591 43.8803 15.0155 43.9615 14.8777 44.0522C14.5799 44.2487 14.2845 44.45 13.989 44.6502C13.9078 44.6808 13.8195 44.6984 13.7477 44.7443C13.1627 45.1222 12.58 45.5047 11.9973 45.8861C11.5041 46.2452 11.0038 46.5959 10.5188 46.9667C10.3446 47.0998 10.2057 47.2775 10.0515 47.4341C9.59949 47.9461 9.28401 48.5311 9.0945 49.1868C9.05801 49.2292 9.00621 49.2645 8.9862 49.3139C8.73665 49.9249 8.49181 50.537 8.24579 51.1502C8.07157 51.6352 7.89736 52.1214 7.72314 52.6064C7.72667 52.6323 7.73021 52.6582 7.73491 52.6841C7.72314 52.7241 7.71137 52.7629 7.69842 52.8029C7.60543 53.0937 7.51244 53.3844 7.42062 53.6764C7.37824 53.8317 7.33469 53.9871 7.29231 54.1425C7.21109 54.4286 7.12869 54.7158 7.04747 55.0018C6.99803 55.1301 6.94859 55.2584 6.89915 55.3879C6.88738 55.435 6.87561 55.4821 6.86266 55.528C6.65549 56.2613 6.44713 56.9959 6.23878 57.7292C6.01631 58.5685 5.79383 59.409 5.57135 60.2483C5.33004 61.2147 5.08873 62.1811 4.84742 63.1475C4.78385 63.4206 4.71911 63.6937 4.65554 63.9657C4.6167 64.1399 4.57903 64.3129 4.54019 64.4871C4.47544 64.759 4.4107 65.031 4.34596 65.3017C4.2871 65.5489 4.22942 65.7961 4.17057 66.0445C4.01872 66.7025 3.86569 67.3617 3.71384 68.0197C3.52315 68.8625 3.33127 69.7065 3.14058 70.5493C2.96872 71.3462 2.79804 72.142 2.62029 72.966C3.17236 72.966 3.67853 72.966 4.18352 72.966C5.10639 72.9648 6.02925 72.9648 6.95212 72.9636C7.22639 72.9613 7.50066 72.9589 7.77494 72.9566C7.9515 72.9577 8.1269 72.9601 8.30347 72.9613C8.57656 72.9613 8.84966 72.9624 9.12275 72.9624C10.0845 72.9636 11.0474 72.9648 12.0091 72.966C12.8519 72.966 13.6935 72.966 14.5364 72.9672C15.4428 72.9683 16.3491 72.9695 17.2555 72.9707C17.5428 72.9695 17.83 72.9683 18.1184 72.9672C18.2796 72.966 18.4397 72.9648 18.601 72.9636C18.8753 72.9624 19.1484 72.9601 19.4226 72.9589C20.3832 72.9613 21.3437 72.9636 22.3042 72.966C23.1471 72.966 23.9899 72.966 24.8327 72.966C25.7544 72.9636 26.6761 72.9613 27.5978 72.9601C27.8709 72.9613 28.1452 72.9624 28.4182 72.9636C28.5795 72.9648 28.7408 72.9672 28.902 72.9683C29.1893 72.9683 29.4777 72.9695 29.7649 72.9695C30.7101 72.9683 31.6553 72.9683 32.6006 72.9672C33.4434 72.9672 34.2862 72.966 35.1279 72.966C36.0507 72.9648 36.9736 72.9648 37.8965 72.9636C38.1696 72.9624 38.4439 72.9613 38.7169 72.9601C38.8923 72.9589 39.0689 72.9589 39.2443 72.9577C39.5186 72.9601 39.7928 72.9613 40.0671 72.9636C41.0288 72.9636 41.9905 72.9648 42.9534 72.9648C43.7774 72.9648 44.6014 72.9648 45.4254 72.9648C46.3494 72.966 47.2735 72.966 48.1975 72.9672C48.4848 72.9683 48.772 72.9683 49.0592 72.9695C49.2216 72.9672 49.3829 72.9648 49.5454 72.9624C49.8184 72.9624 50.0915 72.9613 50.3658 72.9613C51.3275 72.9624 52.2892 72.9648 53.2498 72.966C54.0926 72.966 54.9354 72.966 55.7771 72.966C56.6976 72.9624 57.6193 72.9589 58.5398 72.9554C58.8141 72.9577 59.0895 72.9601 59.3638 72.9624C59.5227 72.9624 59.6816 72.9624 59.8417 72.9624C60.116 72.9601 60.3902 72.9577 60.6657 72.9554C61.6262 72.9589 62.5856 72.9613 63.5461 72.9648C64.3889 72.9648 65.2318 72.9648 66.0746 72.9648C66.9963 72.9636 67.9192 72.9613 68.8409 72.9601C69.1139 72.9613 69.387 72.9613 69.6613 72.9624C69.8237 72.9648 69.985 72.966 70.1475 72.9683C70.4347 72.9683 70.7219 72.9672 71.0103 72.9672C71.9555 72.9672 72.8996 72.9672 73.8448 72.966C74.6877 72.966 75.5293 72.9648 76.3721 72.9648C77.295 72.9636 78.2179 72.9636 79.1407 72.9624C79.415 72.9613 79.6893 72.9589 79.9624 72.9577C80.1378 72.9577 80.3143 72.9589 80.4897 72.9589C80.764 72.9601 81.0371 72.9613 81.3114 72.9624C82.2731 72.9636 83.236 72.9636 84.1977 72.9648C85.0405 72.9648 85.8821 72.966 86.725 72.966C87.6314 72.966 88.5366 72.9672 89.443 72.9672C89.7302 72.9672 90.0174 72.9672 90.3058 72.9672C90.4671 72.966 90.6295 72.9636 90.7908 72.9624C91.0639 72.9613 91.3381 72.9601 91.6112 72.9589C92.5718 72.9613 93.5335 72.9624 94.494 72.9648C95.3368 72.9648 96.1797 72.9648 97.0225 72.9648C97.9442 72.9624 98.8647 72.9589 99.7864 72.9566C100.061 72.9589 100.335 72.9601 100.609 72.9624C100.768 72.9624 100.927 72.9624 101.087 72.9624C101.377 72.9648 101.665 72.9672 101.955 72.9695C102.9 72.9683 103.846 72.966 104.792 72.9648C105.634 72.9648 106.477 72.9648 107.319 72.9648C108.242 72.9636 109.165 72.9624 110.086 72.9613C110.359 72.9613 110.632 72.9613 110.906 72.9613C111.081 72.9589 111.258 72.9577 111.433 72.9554C111.707 72.9577 111.983 72.9601 112.257 72.9624C113.219 72.9624 114.18 72.9636 115.142 72.9636C115.966 72.9636 116.79 72.9636 117.614 72.9636C118.537 72.9636 119.46 72.9624 120.383 72.9624C120.657 72.9601 120.931 72.9589 121.205 72.9566C121.381 72.9577 121.557 72.9589 121.733 72.9601C122.006 72.9613 122.279 72.9613 122.553 72.9624C123.515 72.9636 124.478 72.9648 125.44 72.9648C126.282 72.9648 127.124 72.966 127.967 72.966C128.873 72.9672 129.78 72.9683 130.686 72.9695C130.973 72.9683 131.26 72.9683 131.549 72.9672C131.71 72.966 131.871 72.9648 132.033 72.9636C132.307 72.9624 132.58 72.9613 132.854 72.9601C133.19 72.9601 133.526 72.9601 133.896 72.9601C133.716 72.1337 133.544 71.3427 133.372 70.5517C133.214 69.8301 133.057 69.1085 132.899 68.3869C132.865 68.2645 132.832 68.1433 132.798 68.0209C132.606 67.1639 132.418 66.307 132.217 65.4512C132.203 65.39 132.107 65.3488 132.049 65.2982C132.022 65.0286 131.996 64.7602 131.969 64.4907C131.93 64.3141 131.893 64.1375 131.854 63.9609C131.777 63.6631 131.701 63.3665 131.624 63.0687C131.543 62.6814 131.477 62.2894 131.377 61.9057C131.172 61.1194 130.949 60.3377 130.732 59.5538C130.579 58.9452 130.426 58.3366 130.273 57.7281C130.006 56.8099 129.737 55.8905 129.47 54.9724C129.385 54.7016 129.302 54.4309 129.217 54.1602C129.173 53.9977 129.129 53.8353 129.085 53.6728C128.997 53.3833 128.909 53.0949 128.82 52.8053C128.538 52.0107 128.256 51.2162 127.974 50.4228C127.908 50.2521 127.842 50.0802 127.776 49.9096C127.475 49.268 127.183 48.623 126.866 47.9897C126.765 47.786 126.597 47.6165 126.458 47.4317C126.12 47.1374 125.782 46.842 125.443 46.5477C124.528 45.9344 123.614 45.3199 122.698 44.709C122.662 44.6843 122.606 44.6866 122.56 44.6772C122.545 44.6666 122.527 44.6607 122.509 44.6607C122.252 44.4877 121.995 44.3135 121.739 44.1404C121.282 43.8721 120.824 43.6037 120.367 43.3353C120.331 43.3188 120.296 43.3012 120.259 43.2847C119.856 43.041 119.454 42.7973 119.051 42.5549C119.023 42.5348 118.995 42.5148 118.968 42.4936L118.965 42.4995C118.516 42.2429 118.066 41.9875 117.616 41.7309C116.791 41.2671 115.966 40.8033 115.141 40.3395C114.696 40.097 114.251 39.8533 113.806 39.6109C113.292 39.3331 112.776 39.0553 112.262 38.7775C111.993 38.6421 111.725 38.5055 111.456 38.3702C111.296 38.2713 111.136 38.1724 110.975 38.0724C110.688 37.9335 110.401 37.7945 110.113 37.6556C109.774 37.465 109.436 37.2743 109.097 37.0847C108.505 36.7693 107.914 36.4526 107.322 36.1372C106.478 35.691 105.634 35.2449 104.789 34.7976C104.516 34.6563 104.244 34.5151 103.971 34.3738C103.466 34.1031 102.963 33.8265 102.454 33.5628C102.305 33.4863 102.13 33.4615 101.978 33.3897C101.752 33.2826 101.536 33.1555 101.315 33.0354C101.237 32.9907 101.16 32.9483 101.084 32.9048ZM86.3036 43.8391C86.3059 43.6873 86.3071 43.5354 86.3094 43.3824C86.3271 43.0846 86.3459 42.7867 86.3636 42.4889C86.4024 41.5308 86.4413 40.5737 86.4813 39.6156C86.5201 38.7727 86.5602 37.9287 86.599 37.0859C86.639 36.1866 86.6791 35.2861 86.7191 34.3868C86.7344 34.1066 86.7497 33.8264 86.765 33.5451C86.7685 33.3756 86.7709 33.2061 86.7744 33.0366C86.7921 32.7564 86.8109 32.4763 86.8286 32.1961C86.8698 31.2391 86.9098 30.2821 86.951 29.3251C86.9898 28.4811 87.0275 27.6383 87.0663 26.7943C87.084 26.5141 87.1064 26.234 87.1146 25.9538C87.117 25.8761 87.0946 25.7831 87.0499 25.7219C86.9557 25.5936 86.8391 25.4818 86.732 25.3629C86.5001 24.9321 86.2682 24.5012 86.0363 24.0704C85.8868 23.7797 85.7385 23.4877 85.589 23.197C85.4996 23.0428 85.4101 22.8874 85.3207 22.7332C85.1759 22.4566 85.0311 22.1799 84.8863 21.9045C84.6603 21.4878 84.4343 21.0711 84.2083 20.6544C83.9199 20.1105 83.6315 19.5667 83.3443 19.0217C82.9758 18.326 82.6074 17.6303 82.2071 16.8746C81.8823 17.4443 81.5844 17.9658 81.2866 18.4885C81.0218 18.9052 80.7557 19.3219 80.4909 19.7386C80.3108 20.0305 80.1295 20.3213 79.9494 20.6132C79.6799 21.0475 79.4103 21.4831 79.1407 21.9174C78.9771 22.1846 78.8135 22.4507 78.6499 22.7179C78.5545 22.8603 78.4592 23.0028 78.3626 23.1452C78.1696 23.4595 77.9754 23.7749 77.7823 24.0892C77.3997 24.6978 77.0407 25.324 76.6264 25.9103C76.3898 26.2457 76.3874 26.5129 76.6464 26.8061C77.1055 27.6465 77.5646 28.487 78.0236 29.3263C78.378 29.9902 78.7323 30.6541 79.0866 31.318C79.2584 31.617 79.4303 31.9148 79.6022 32.2138C79.7175 32.3915 79.8317 32.5693 79.9471 32.747C79.9883 32.8624 80.0295 32.9777 80.0718 33.0931C80.1766 33.2803 80.2814 33.4662 80.3861 33.6534C80.5203 33.8971 80.6545 34.1396 80.7887 34.3832C80.9594 34.6999 81.1301 35.0165 81.2996 35.3332C81.6186 35.9182 81.9364 36.5032 82.2554 37.0883C82.7121 37.9311 83.1677 38.7751 83.6244 39.6179C83.8128 39.9593 84.0011 40.3007 84.1906 40.642C84.5249 41.2612 84.8604 41.8815 85.1947 42.5007C85.3548 42.7938 85.5149 43.0869 85.6738 43.3788C85.7668 43.5413 85.8598 43.7049 85.9528 43.8674C86.0387 44.0392 86.1246 44.2111 86.2094 44.3818C86.2412 44.3723 86.2729 44.3629 86.3047 44.3535C86.3036 44.1816 86.3036 44.0098 86.3036 43.8391ZM59.8652 26.8084C60.1948 26.4364 60.1937 26.3552 59.8511 25.9067C59.691 25.6513 59.5298 25.3958 59.3697 25.1404C59.3355 25.0721 59.3096 24.998 59.2661 24.9368C59.0389 24.6189 58.7882 24.3153 58.581 23.9845C58.4138 23.7184 58.2973 23.423 58.1572 23.1393C58.056 22.998 57.9548 22.8556 57.8535 22.7144C57.6934 22.4483 57.5334 22.1811 57.3744 21.9151C56.8436 21.0534 56.3115 20.1918 55.7806 19.3301C55.7206 19.2312 55.6605 19.1324 55.6005 19.0335C55.1779 18.3366 54.7541 17.6409 54.2904 16.877C53.9172 17.6103 53.5794 18.2742 53.2427 18.9381C53.2156 18.9652 53.1803 18.9876 53.1638 19.0193C52.66 19.9634 52.1574 20.9086 51.6548 21.8527C51.5006 22.1482 51.3452 22.4424 51.191 22.7367C51.1015 22.8933 51.0132 23.0498 50.9238 23.2076C50.7731 23.496 50.6224 23.7855 50.4718 24.0739C50.4317 24.154 50.3929 24.2352 50.3529 24.3153C50.2599 24.473 50.1669 24.6319 50.0727 24.7896C49.895 25.0886 49.7172 25.3876 49.5406 25.6866C49.5018 25.7631 49.4265 25.8396 49.4288 25.915C49.4441 26.4976 49.4747 27.0803 49.5006 27.663C49.5348 28.2174 49.5689 28.7707 49.6019 29.3251C49.6442 30.2833 49.6854 31.2427 49.7278 32.2008C49.7443 32.4775 49.7608 32.7541 49.7772 33.0295C49.7808 33.2037 49.7843 33.378 49.789 33.5522C49.8043 33.8288 49.8184 34.1042 49.8337 34.3809C49.8561 35.2508 49.8773 36.1195 49.902 36.9894C49.9032 37.0247 49.9279 37.06 49.9409 37.0953C49.9668 37.811 49.9927 38.5267 50.0221 39.2436C50.0268 39.3684 50.0527 39.492 50.068 39.6156C50.1092 40.5773 50.1492 41.539 50.1904 42.5007C50.2081 43.1446 50.2257 43.7885 50.2422 44.4324C50.2658 44.4371 50.2893 44.4418 50.3128 44.4477C50.4105 44.2523 50.5094 44.0557 50.6071 43.8603C50.6942 43.7002 50.7825 43.5413 50.8696 43.3812C51.0226 43.0952 51.1757 42.8079 51.3287 42.5219C51.8549 41.5543 52.3822 40.5879 52.9084 39.6203C53.0249 39.4072 53.1403 39.1942 53.2568 38.9811C53.6029 38.3502 53.9502 37.7192 54.2962 37.0871C54.7753 36.2066 55.2544 35.3273 55.7335 34.4468C55.8889 34.1549 56.0431 33.8618 56.1985 33.5698C56.275 33.4097 56.3527 33.2497 56.4292 33.0896C56.5928 32.8035 56.7553 32.5175 56.9189 32.2314C57.1237 31.8771 57.3368 31.5275 57.531 31.1685C57.8618 30.5587 58.1808 29.9431 58.5045 29.331C58.5292 29.2698 58.5551 29.2086 58.5798 29.1474C58.8435 28.68 59.1072 28.2127 59.3697 27.7454C59.5298 27.4323 59.6898 27.1192 59.8499 26.8049L59.8652 26.8084Z"
        fill={outline}
      />
      <path
        d="M76.3693 72.9623C75.5265 72.9623 74.6848 72.9634 73.842 72.9634C73.842 72.2607 73.8314 71.5579 73.8455 70.8552C73.8503 70.6162 73.7867 70.535 73.5371 70.5397C72.6978 70.555 71.8574 70.5456 71.0181 70.5456L70.9922 70.548C71.0004 69.704 71.0075 68.8611 71.0157 68.0183C71.8586 68.0183 72.7014 68.0113 73.543 68.0219C73.769 68.0254 73.8503 67.9677 73.8455 67.7276C73.8302 66.9248 73.8397 66.122 73.8385 65.318C73.8585 65.3121 73.8785 65.3074 73.8973 65.3015C74.7213 65.3074 75.5465 65.3133 76.3705 65.3204C76.3705 66.2185 76.3693 67.1166 76.3693 68.0148C75.6454 68.0148 74.9226 68.0266 74.1987 68.0101C73.948 68.0042 73.8856 68.0889 73.8915 68.3279C73.9068 68.9624 73.9068 69.598 73.8915 70.2337C73.8856 70.4715 73.948 70.5562 74.1987 70.5515C74.9214 70.5362 75.6454 70.5468 76.3693 70.5468C76.3705 71.3519 76.3705 72.1571 76.3693 72.9623Z"
        fill="#CFE3E7"
      />
      <path
        d="M94.16 29.3157C94.273 29.3734 94.386 29.4299 94.499 29.4875C94.4978 30.3904 94.4955 31.2932 94.4943 32.1961C93.5373 32.1949 92.5815 32.1938 91.6245 32.1938C91.6198 31.2379 91.6151 30.2809 91.6104 29.3251L91.628 29.3274C92.472 29.3239 93.316 29.3192 94.16 29.3157Z"
        fill="#F1F0F0"
      />
      <path
        d="M113.802 39.6072C114.247 39.8497 114.692 40.0933 115.137 40.3358C115.138 41.0586 115.14 41.7802 115.141 42.5029C115.139 42.5182 115.135 42.5335 115.133 42.5488C114.18 42.5465 113.225 42.5441 112.271 42.5418C112.267 42.5265 112.261 42.5123 112.251 42.4994C112.25 41.5377 112.25 40.5748 112.249 39.6131L112.264 39.6178C112.776 39.6142 113.29 39.6107 113.802 39.6072Z"
        fill="#F1F1F1"
      />
      <path
        d="M50.3525 24.315C50.3926 24.235 50.4314 24.1538 50.4714 24.0737C51.3978 24.0808 52.3242 24.0879 53.2506 24.0949C53.2495 24.9943 53.2495 25.8936 53.2483 26.7941C52.2924 26.7929 51.3378 26.7929 50.382 26.7917L50.3643 26.7964C50.3608 25.9689 50.3561 25.1426 50.3525 24.315Z"
        fill="#F1F1F1"
      />
      <path
        d="M83.3416 19.0205C83.63 19.5643 83.9184 20.1082 84.2057 20.6532C84.2009 21.0699 84.1962 21.4854 84.1903 21.9021L84.1951 21.9186C83.2381 21.9139 82.281 21.908 81.324 21.9033C81.3229 20.9475 81.3205 19.9905 81.3193 19.0346C81.9938 19.0299 82.6671 19.0252 83.3416 19.0205Z"
        fill="#F1F0F0"
      />
      <path
        d="M70.96 35.1704C71.1142 34.9044 71.2672 34.6383 71.4214 34.3723C72.2277 34.377 73.0341 34.3829 73.8404 34.3876C73.8404 35.2869 73.8416 36.1874 73.8416 37.0868C72.901 37.0868 71.9593 37.0868 71.0188 37.0856C71.0165 36.6865 71.02 36.2875 71.0094 35.8885C71.0059 35.6495 70.9776 35.4105 70.96 35.1704Z"
        fill="#F1F1F1"
      />
      <path
        d="M103.972 34.3713C104.245 34.5126 104.517 34.6538 104.79 34.7951C104.79 35.5591 104.79 36.3218 104.79 37.0858C103.846 37.0846 102.903 37.0846 101.959 37.0834C101.961 36.1829 101.965 35.2824 101.967 34.3819C102.636 34.3796 103.303 34.376 103.972 34.3713Z"
        fill="#F1F1F1"
      />
      <path
        d="M4.16992 66.0411C4.22878 65.7939 4.28646 65.5467 4.34531 65.2983C5.20933 65.3054 6.07452 65.3125 6.93853 65.3195C6.93735 66.2189 6.93735 67.1182 6.93617 68.0175C6.01801 68.0163 5.10103 68.0151 4.18287 68.0151C4.17934 67.3571 4.17463 66.6991 4.16992 66.0411Z"
        fill="#F1F1F1"
      />
      <path
        d="M127.771 49.9072C127.837 50.0779 127.903 50.2498 127.969 50.4205C127.966 51.2209 127.965 52.0202 127.963 52.8206V52.8465C127.119 52.8383 126.275 52.8312 125.431 52.823C125.432 51.8507 125.432 50.8795 125.433 49.9072C126.212 49.9084 126.992 49.9072 127.771 49.9072Z"
        fill="#CFE3E7"
      />
      <path
        d="M55.5997 19.0322C55.6598 19.1311 55.7198 19.23 55.7799 19.3289C55.7787 20.1858 55.7787 21.0416 55.7787 21.8985L55.7799 21.9209C54.9358 21.9209 54.093 21.9209 53.249 21.9209L53.2514 21.8985C53.2514 20.9427 53.2526 19.9869 53.2526 19.0322C54.0342 19.0322 54.817 19.0322 55.5997 19.0322Z"
        fill="#CFE3E7"
      />
      <path
        d="M22.2988 39.8331C22.4366 39.759 22.5731 39.686 22.7108 39.6118C23.4183 39.6118 24.1257 39.613 24.832 39.613L24.8355 39.6165C24.8344 40.5771 24.8332 41.5376 24.8308 42.4981C23.9892 42.4981 23.1475 42.4981 22.3059 42.4981C22.3047 41.6106 22.3024 40.7218 22.2988 39.8331Z"
        fill="#CFE3E7"
      />
      <path
        d="M53.2541 38.98C53.1376 39.193 53.0222 39.4061 52.9057 39.6192C52.0641 39.6192 51.2212 39.6192 50.3796 39.6192C50.3725 38.7752 50.3655 37.9312 50.3584 37.0883L50.3819 37.0907C51.3378 37.0895 52.2924 37.0883 53.2483 37.0872L53.2518 37.0907C53.253 37.7193 53.2541 38.3502 53.2541 38.98Z"
        fill="#CFE3E7"
      />
      <path
        d="M40.0566 30.488C40.8218 30.096 41.5881 29.704 42.3532 29.3132C42.5533 29.3179 42.7523 29.3227 42.9524 29.3262C42.9524 30.2832 42.9536 31.239 42.9536 32.196C41.9954 32.1972 41.0372 32.1972 40.079 32.1984C40.0719 31.6275 40.0637 31.0577 40.0566 30.488Z"
        fill="#F1F0F0"
      />
      <path
        d="M82.2547 37.0871C81.9357 36.502 81.6178 35.917 81.2988 35.332C81.3035 35.0153 81.3094 34.6987 81.3141 34.382V34.3832C82.2747 34.3797 83.2352 34.3773 84.1969 34.3738L84.1934 34.3891C84.1946 35.2884 84.1957 36.1877 84.1969 37.0871C83.5495 37.0871 82.9021 37.0871 82.2547 37.0871Z"
        fill="#F1F0F0"
      />
      <path
        d="M58.5779 29.1449C58.5532 29.2061 58.5273 29.2673 58.5026 29.3285C57.595 29.3262 56.6863 29.325 55.7787 29.3227C55.7775 28.481 55.7775 27.6394 55.7764 26.7977L55.7799 26.7942C56.6898 26.7954 57.5986 26.7965 58.5085 26.7977L58.525 26.7989L58.5414 26.7977C58.5391 27.351 58.5332 27.9042 58.5379 28.4575C58.5391 28.687 58.5638 28.9154 58.5779 29.1449Z"
        fill="#CFE3E7"
      />
      <path
        d="M50.3477 46.6641C50.7079 46.0002 51.0681 45.3363 51.4283 44.6736C52.0357 44.6806 52.6442 44.6877 53.2516 44.6948C53.2505 45.6071 53.2481 46.5193 53.2469 47.4328C52.2923 47.4328 51.3376 47.4328 50.383 47.434C50.3712 47.1773 50.3594 46.9207 50.3477 46.6641Z"
        fill="#F1F0F0"
      />
      <path
        d="M94.4931 72.9624C93.5326 72.9601 92.5709 72.9589 91.6104 72.9566C91.6174 72.1526 91.6245 71.3486 91.6315 70.5435C92.585 70.5446 93.5385 70.5458 94.4908 70.547C94.4908 71.3521 94.492 72.1573 94.4931 72.9624Z"
        fill="#F1F1F1"
      />
      <path
        d="M84.1949 72.9623C83.2332 72.9611 82.2703 72.9611 81.3086 72.9599C81.3133 72.1547 81.318 71.3496 81.3215 70.5444C82.2785 70.5456 83.2356 70.5468 84.1914 70.548C84.1926 71.3531 84.1937 72.1571 84.1949 72.9623Z"
        fill="#F1F1F1"
      />
      <path
        d="M63.5445 72.9624C62.584 72.9589 61.6246 72.9566 60.6641 72.953C60.6664 72.8459 60.6688 72.74 60.6699 72.634C60.6782 71.9372 60.6864 71.2403 60.6935 70.5435C61.6423 70.5446 62.5922 70.5458 63.541 70.547C63.5421 71.3521 63.5433 72.1573 63.5445 72.9624Z"
        fill="#F1F1F1"
      />
      <path
        d="M53.2531 72.9624C52.2914 72.9613 51.3297 72.9589 50.3691 72.9577C50.375 72.1526 50.3809 71.3486 50.3868 70.5435C51.3414 70.5446 52.2961 70.5458 53.2507 70.547C53.2519 71.3533 53.2531 72.1573 53.2531 72.9624Z"
        fill="#F1F1F1"
      />
      <path
        d="M115.139 72.9611C114.177 72.9611 113.216 72.9599 112.254 72.9599C112.259 72.1547 112.263 71.3496 112.267 70.5444C113.223 70.5456 114.18 70.548 115.136 70.5491C115.137 71.3531 115.138 72.1571 115.139 72.9611Z"
        fill="#F1F1F1"
      />
      <path
        d="M42.9537 72.9623C41.992 72.9623 41.0303 72.9611 40.0674 72.9611C40.0721 72.156 40.0768 71.3508 40.0803 70.5457C41.0373 70.5468 41.9932 70.548 42.9502 70.5504C42.9525 71.3532 42.9537 72.1571 42.9537 72.9623Z"
        fill="#F1F1F1"
      />
      <path
        d="M125.437 72.9623C124.475 72.9611 123.512 72.9599 122.551 72.9599C122.555 72.1547 122.56 71.3496 122.565 70.5444C123.521 70.5456 124.478 70.5468 125.434 70.548C125.436 71.3531 125.436 72.1571 125.437 72.9623Z"
        fill="#F1F1F1"
      />
      <path
        d="M12.0084 72.9634C11.0467 72.9623 10.0838 72.9611 9.12207 72.9599C9.12796 72.1547 9.13267 71.3496 9.13855 70.5444C10.0944 70.5456 11.0502 70.5468 12.006 70.548C12.0072 71.3531 12.0072 72.1583 12.0084 72.9634Z"
        fill="#F1F1F1"
      />
      <path
        d="M22.3054 72.9623C21.3449 72.9599 20.3844 72.9576 19.4238 72.9552C19.4321 72.1512 19.4415 71.3484 19.4497 70.5444C20.4008 70.5456 21.352 70.5468 22.3031 70.548C22.3031 71.3519 22.3043 72.1571 22.3054 72.9623Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.6023 72.9635C31.6571 72.9647 30.7118 72.9647 29.7666 72.9659C29.7701 72.1595 29.7725 71.3532 29.776 70.5469C30.7177 70.5469 31.6582 70.5469 32.5999 70.5469C32.5999 71.352 32.6011 72.1584 32.6023 72.9635Z"
        fill="#F1F1F1"
      />
      <path
        d="M71.0194 70.5459C71.8587 70.5459 72.6991 70.5541 73.5384 70.54C73.788 70.5353 73.8516 70.6165 73.8468 70.8554C73.8327 71.5582 73.8421 72.2609 73.8433 72.9637C72.8981 72.9637 71.954 72.9637 71.0088 72.9649C71.0123 72.1585 71.0159 71.3522 71.0194 70.5459Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.785 72.9635C103.84 72.9647 102.893 72.9671 101.948 72.9682C101.951 72.1619 101.953 71.3556 101.955 70.5481C102.898 70.5481 103.84 70.5469 104.783 70.5469C104.784 71.352 104.785 72.1572 104.785 72.9635Z"
        fill="#F1F1F1"
      />
      <path
        d="M73.8945 30.374C74.1111 30.0244 74.3289 29.6736 74.5455 29.324C75.1541 29.324 75.7626 29.3252 76.3712 29.3252C76.3712 30.2822 76.37 31.238 76.37 32.195L76.3724 32.215C75.5472 32.215 74.7209 32.2162 73.8957 32.2162L73.8981 32.1962C73.8969 31.5888 73.8957 30.9814 73.8945 30.374Z"
        fill="#CFE3E7"
      />
      <path
        d="M109.094 37.0823C109.433 37.273 109.771 37.4637 110.11 37.6532C110.1 37.7591 110.082 37.8662 110.081 37.9722C110.075 38.5207 110.073 39.0693 110.07 39.6178C109.152 39.6166 108.235 39.6155 107.317 39.6155C107.316 38.7738 107.315 37.931 107.313 37.0893L107.317 37.0858C107.909 37.0846 108.502 37.0835 109.094 37.0823Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1979 37.0871C84.1967 36.1877 84.1955 35.2884 84.1943 34.3891C85.036 34.3879 85.8776 34.3879 86.7205 34.3867C86.6804 35.286 86.6404 36.1865 86.6004 37.0859C85.7988 37.0859 84.9983 37.0871 84.1979 37.0871Z"
        fill="#CFE3E7"
      />
      <path
        d="M27.601 72.9566C26.6793 72.9589 25.7576 72.9613 24.8359 72.9624C24.8371 72.1573 24.8383 71.3521 24.8383 70.547C25.7517 70.5458 26.6652 70.5446 27.5786 70.5435C27.5869 71.3486 27.594 72.1526 27.601 72.9566Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.9004 72.9599C36.9776 72.9611 36.0547 72.9611 35.1318 72.9623C35.133 72.1571 35.1342 71.3531 35.1342 70.548C36.0512 70.5468 36.9693 70.5456 37.8863 70.5444C37.8922 71.3496 37.8957 72.1547 37.9004 72.9599Z"
        fill="#F1F1F1"
      />
      <path
        d="M48.1989 72.9635C47.2748 72.9623 46.3508 72.9623 45.4268 72.9611C45.4279 72.1571 45.4291 71.3532 45.4303 70.5492C46.3496 70.548 47.269 70.5468 48.1883 70.5457C48.1918 71.352 48.1954 72.1583 48.1989 72.9635Z"
        fill="#F1F1F1"
      />
      <path
        d="M58.5449 72.953C57.6244 72.9566 56.7027 72.9601 55.7822 72.9636C55.7834 72.1585 55.7846 71.3533 55.7846 70.547C56.6933 70.5458 57.6032 70.5446 58.512 70.5435C58.5202 70.6494 58.5367 70.7542 58.5367 70.8601C58.5414 71.5581 58.5426 72.255 58.5449 72.953Z"
        fill="#F1F1F1"
      />
      <path
        d="M6.95513 72.9611C6.03226 72.9623 5.10939 72.9623 4.18652 72.9635C4.18652 72.1583 4.1877 71.3532 4.1877 70.548C5.10586 70.5468 6.02284 70.5457 6.941 70.5457C6.94571 71.3496 6.95042 72.1548 6.95513 72.9611Z"
        fill="#F1F1F1"
      />
      <path
        d="M68.8434 72.9577C67.9217 72.9589 66.9988 72.9613 66.0771 72.9624C66.0783 72.1573 66.0795 71.3521 66.0795 70.547C66.9941 70.5458 67.9088 70.5446 68.8234 70.5435C68.8304 71.3486 68.8363 72.1538 68.8434 72.9577Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.373 72.9623C76.373 72.1571 76.3742 71.3519 76.3742 70.5468C77.2924 70.5456 78.2105 70.5456 79.1275 70.5444C79.1322 71.3496 79.1369 72.1547 79.1405 72.9599C78.2188 72.9611 77.2959 72.9611 76.373 72.9623Z"
        fill="#F1F1F1"
      />
      <path
        d="M99.7815 72.9542C98.8598 72.9566 97.9393 72.9601 97.0176 72.9624C97.0188 72.1573 97.0199 71.3521 97.0199 70.547C97.931 70.5458 98.8421 70.5446 99.7532 70.5435C99.7626 71.3474 99.7721 72.1514 99.7815 72.9542Z"
        fill="#F1F1F1"
      />
      <path
        d="M110.086 72.9589C109.163 72.9601 108.24 72.9613 107.318 72.9624C107.32 72.1573 107.321 71.3521 107.321 70.547C108.237 70.5458 109.154 70.5446 110.069 70.5435C110.075 71.3498 110.08 72.1538 110.086 72.9589Z"
        fill="#F1F1F1"
      />
      <path
        d="M120.377 72.9601C119.454 72.9601 118.531 72.9613 117.608 72.9613C117.61 72.1573 117.611 71.3521 117.612 70.5482C118.529 70.547 119.446 70.5458 120.364 70.5435C120.369 71.3498 120.373 72.1549 120.377 72.9601Z"
        fill="#F1F1F1"
      />
      <path
        d="M130.27 57.7268C130.423 58.3354 130.576 58.944 130.729 59.5525C130.713 59.7856 130.697 60.0198 130.681 60.2529C129.775 60.2517 128.869 60.2506 127.963 60.2494C127.964 59.4089 127.964 58.5685 127.965 57.7268C128.734 57.7268 129.503 57.7268 130.27 57.7268Z"
        fill="#CFE3E7"
      />
      <path
        d="M130.682 72.9671C129.776 72.9659 128.869 72.9647 127.963 72.9635C127.964 72.1584 127.965 71.352 127.965 70.5469C128.868 70.5469 129.77 70.5469 130.673 70.5481C130.676 71.3532 130.679 72.1595 130.682 72.9671Z"
        fill="#F1F1F1"
      />
      <path
        d="M17.2592 72.967C16.3528 72.9658 15.4464 72.9647 14.54 72.9635C14.5412 72.1571 14.5424 71.352 14.5424 70.5457C15.4453 70.5457 16.3481 70.5468 17.2521 70.5468C17.2533 71.3543 17.2569 72.1607 17.2592 72.967Z"
        fill="#F1F1F1"
      />
      <path
        d="M89.4385 72.9647C88.5321 72.9647 87.6269 72.9635 86.7217 72.9635C86.7229 72.1571 86.724 71.352 86.724 70.5457C87.6257 70.5457 88.5274 70.5457 89.4279 70.5457C89.4326 71.352 89.4361 72.1583 89.4385 72.9647Z"
        fill="#F1F1F1"
      />
      <path
        d="M53.2502 41.3247C53.561 40.7538 53.8705 40.1817 54.1813 39.6108C54.7145 39.612 55.2466 39.6132 55.7799 39.6144C55.7787 40.5761 55.7775 41.5378 55.7775 42.4995C54.9347 42.5078 54.0918 42.516 53.249 42.5242L53.2502 42.4972C53.249 42.1063 53.249 41.7155 53.2502 41.3247Z"
        fill="#CFE3E7"
      />
      <path
        d="M9.10059 49.1834C9.2901 48.5289 9.60675 47.9427 10.0576 47.4307C10.7074 47.4307 11.3571 47.4318 12.0069 47.4318L12.0116 47.4365C12.0104 48.2605 12.0093 49.0834 12.0093 49.9073C11.0523 49.9085 10.0964 49.9097 9.13943 49.9109C9.12648 49.6684 9.11353 49.4259 9.10059 49.1834Z"
        fill="#CFE3E7"
      />
      <path
        d="M86.0354 24.0706C86.2673 24.5014 86.4992 24.9322 86.731 25.3642C86.7299 25.8421 86.7275 26.3189 86.7263 26.7968L86.7216 26.8015C85.8788 26.8003 85.0372 26.798 84.1943 26.7968C84.1943 25.8951 84.1955 24.9934 84.1955 24.0917C84.81 24.0835 85.4221 24.0764 86.0354 24.0706Z"
        fill="#CFE3E7"
      />
      <path
        d="M86.7299 47.6507C86.8653 47.8803 87.0007 48.1098 87.1666 48.3923C87.1937 48.0345 87.2173 47.7355 87.2396 47.4365C87.9694 47.4365 88.6981 47.4365 89.4279 47.4353C89.4291 48.2581 89.4314 49.0809 89.4326 49.9037C88.5286 49.9037 87.6257 49.9049 86.7217 49.9049C86.7252 49.1539 86.7276 48.4017 86.7299 47.6507Z"
        fill="#CFE3E7"
      />
      <path
        d="M61.9624 29.3228C62.5569 30.2845 63.1501 31.2462 63.7446 32.2079C63.6787 32.2103 63.6127 32.2114 63.548 32.2138C62.5933 32.2055 61.6387 32.1985 60.684 32.1902C60.6793 31.2368 60.6746 30.2821 60.6699 29.3286L60.6888 29.3298C61.1137 29.3263 61.5386 29.3251 61.9624 29.3228Z"
        fill="#F1F0F0"
      />
      <path
        d="M86.7299 47.6507C86.7275 48.4017 86.7252 49.1527 86.7228 49.9049C85.88 49.9049 85.0372 49.9049 84.1943 49.9049C84.1943 49.0821 84.1943 48.2593 84.1943 47.4365C84.9983 47.4365 85.8011 47.4353 86.6051 47.4353C86.6463 47.5071 86.6887 47.5789 86.7299 47.6507Z"
        fill="#B3D6DD"
      />
      <path
        d="M45.4254 27.7511C46.0669 27.4309 46.7073 27.1107 47.3488 26.7905C47.629 26.7929 47.908 26.7952 48.1881 26.7976C48.1952 27.6404 48.2023 28.4832 48.2093 29.3272L48.1846 29.3249C47.2653 29.3261 46.3459 29.3272 45.4266 29.3296L45.4219 29.3249C45.4242 28.7987 45.4254 28.2749 45.4254 27.7511Z"
        fill="#CFE3E7"
      />
      <path
        d="M24.8369 70.5482C24.8357 71.3533 24.8345 72.1585 24.8345 72.9636C23.9917 72.9636 23.1489 72.9636 22.3061 72.9636C22.3049 72.1585 22.3037 71.3533 22.3037 70.5482L22.3072 70.5446C23.1489 70.5446 23.9917 70.5446 24.8334 70.5446C24.8322 70.5434 24.8369 70.5482 24.8369 70.5482Z"
        fill="#CFE3E7"
      />
      <path
        d="M127.969 70.5467C127.967 71.3518 127.966 72.1582 127.966 72.9633C127.123 72.9633 126.282 72.9622 125.439 72.9622C125.438 72.157 125.437 71.3518 125.437 70.5479L125.44 70.5443C126.282 70.5432 127.123 70.5432 127.965 70.542L127.969 70.5467Z"
        fill="#CFE3E7"
      />
      <path
        d="M14.5398 70.5467C14.5386 71.353 14.5375 72.1582 14.5375 72.9645C13.6946 72.9645 12.853 72.9645 12.0102 72.9633C12.009 72.1582 12.0078 71.353 12.0078 70.5479L12.0113 70.5443C12.853 70.5443 13.6946 70.5432 14.5363 70.5432C14.5351 70.542 14.5398 70.5467 14.5398 70.5467Z"
        fill="#CFE3E7"
      />
      <path
        d="M107.318 70.5479C107.317 71.353 107.316 72.1582 107.316 72.9633C106.473 72.9633 105.63 72.9633 104.788 72.9633C104.787 72.1582 104.787 71.3518 104.786 70.5467L104.791 70.542C105.632 70.542 106.474 70.5432 107.316 70.5432C107.315 70.5432 107.318 70.5479 107.318 70.5479Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.1316 70.5481C35.1304 71.3532 35.1293 72.1572 35.1293 72.9624C34.2864 72.9624 33.4448 72.9635 32.602 72.9635C32.6008 72.1572 32.6008 71.352 32.5996 70.5457L32.6043 70.541C33.446 70.5422 34.2876 70.5422 35.1293 70.5434L35.1316 70.5481Z"
        fill="#CFE3E7"
      />
      <path
        d="M97.0244 70.548C97.0232 71.3531 97.022 72.1583 97.022 72.9634C96.1792 72.9634 95.3364 72.9634 94.4936 72.9634C94.4924 72.1583 94.4912 71.3531 94.4912 70.548L94.4947 70.5444C95.3364 70.5444 96.178 70.5444 97.0209 70.5444L97.0244 70.548Z"
        fill="#CFE3E7"
      />
      <path
        d="M55.781 70.547C55.7799 71.3521 55.7787 72.1573 55.7787 72.9636C54.9358 72.9636 54.093 72.9636 53.2514 72.9636C53.2502 72.1585 53.249 71.3533 53.249 70.5482L53.2526 70.5446C54.0942 70.5446 54.9358 70.5435 55.7775 70.5435L55.781 70.547Z"
        fill="#CFE3E7"
      />
      <path
        d="M86.7263 70.5455C86.7252 71.3518 86.724 72.157 86.724 72.9633C85.8812 72.9633 85.0395 72.9622 84.1967 72.9622C84.1955 72.157 84.1943 71.353 84.1943 70.5479L84.1979 70.5443C85.0395 70.5432 85.8812 70.542 86.7228 70.542L86.7263 70.5455Z"
        fill="#CFE3E7"
      />
      <path
        d="M66.0781 70.548C66.0769 71.3531 66.0757 72.1583 66.0757 72.9634C65.2329 72.9634 64.3901 72.9634 63.5473 72.9634C63.5461 72.1583 63.5449 71.3531 63.5449 70.548L63.5484 70.5444C64.3901 70.5444 65.2329 70.5444 66.0746 70.5444L66.0781 70.548Z"
        fill="#CFE3E7"
      />
      <path
        d="M65.0846 34.3701C65.4154 34.9045 65.7462 35.4378 66.0757 35.9722C66.0757 36.343 66.0757 36.715 66.0769 37.0858L66.0734 37.0893C65.2317 37.0881 64.3901 37.0881 63.5484 37.0869C63.5473 36.1876 63.5461 35.2883 63.5449 34.3889C64.0582 34.3831 64.5714 34.3772 65.0846 34.3701Z"
        fill="#CFE3E7"
      />
      <path
        d="M55.7764 36.6689C56.2037 35.8991 56.6298 35.1304 57.0571 34.3606C57.5468 34.3735 58.0365 34.3865 58.5261 34.3983C58.5226 35.2941 58.5191 36.191 58.5155 37.088C57.6033 37.088 56.691 37.0892 55.7787 37.0892L55.7775 37.088C55.7775 36.9479 55.7775 36.8078 55.7764 36.6689Z"
        fill="#F1F0F0"
      />
      <path
        d="M45.4283 70.5491C45.4271 71.3531 45.4259 72.1571 45.4247 72.9611C44.6007 72.9611 43.7767 72.9611 42.9527 72.9611C42.9516 72.1571 42.9504 71.3519 42.9492 70.548L42.9527 70.5444C43.7756 70.5444 44.5996 70.5444 45.4224 70.5444L45.4283 70.5491Z"
        fill="#CFE3E7"
      />
      <path
        d="M117.615 70.5492C117.614 71.3532 117.612 72.1583 117.611 72.9623C116.787 72.9623 115.963 72.9623 115.139 72.9623C115.138 72.1583 115.137 71.3543 115.136 70.5504L115.14 70.5457C115.963 70.5457 116.787 70.5457 117.61 70.5457L117.615 70.5492Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1943 37.0871C84.9948 37.0871 85.7952 37.0871 86.5957 37.0859C86.5568 37.9288 86.5168 38.7728 86.478 39.6156C85.7164 39.6144 84.9559 39.6144 84.1943 39.6132C84.1955 38.7716 84.1943 37.9288 84.1943 37.0871Z"
        fill="#B3D6DD"
      />
      <path
        d="M89.4295 47.4351C88.6997 47.4351 87.971 47.4351 87.2412 47.4363C87.2848 46.5158 87.3283 45.5941 87.3719 44.6736C88.0546 44.6759 88.7362 44.6795 89.4189 44.6818C89.4248 44.7984 89.4342 44.9161 89.4354 45.0326C89.4413 45.8342 89.4448 46.637 89.4495 47.4387C89.4507 47.4387 89.4295 47.4351 89.4295 47.4351Z"
        fill="#F1F0F0"
      />
      <path
        d="M12.0029 45.8825C12.5856 45.5011 13.1683 45.1185 13.7533 44.7407C13.8239 44.6947 13.9134 44.6771 13.9946 44.6465C14.1771 44.6618 14.3595 44.6759 14.5432 44.6912C14.542 45.6058 14.542 46.5205 14.5408 47.4351C13.698 47.4351 12.854 47.4363 12.0112 47.4363L12.0065 47.4316C12.0053 46.916 12.0041 46.3992 12.0029 45.8825Z"
        fill="#CFE3E7"
      />
      <path
        d="M76.645 26.8047C76.3849 26.5116 76.3872 26.2432 76.625 25.9089C77.0394 25.3227 77.3984 24.6976 77.781 24.0879C78.2306 24.0902 78.6803 24.0938 79.1299 24.0961C79.1288 24.9966 79.1276 25.896 79.1264 26.7965C78.2989 26.7988 77.4725 26.8012 76.645 26.8047Z"
        fill="#F1F0F0"
      />
      <path
        d="M29.708 35.8745C29.9599 35.7297 30.2083 35.5779 30.4649 35.4437C31.1535 35.0823 31.8445 34.728 32.5355 34.3713C32.5567 34.3772 32.5778 34.3831 32.599 34.3902C32.599 35.2895 32.599 36.1888 32.599 37.0881C31.6573 37.0881 30.7156 37.087 29.7728 37.087C29.7704 36.9799 29.7727 36.8727 29.7669 36.7656C29.7492 36.4678 29.728 36.1712 29.708 35.8745Z"
        fill="#F1F0F0"
      />
      <path
        d="M55.7822 29.3228C56.6898 29.3251 57.5985 29.3263 58.5061 29.3286C58.1824 29.9419 57.8634 30.5576 57.5326 31.1661C57.3372 31.5252 57.1253 31.8748 56.9205 32.2291C56.5415 32.2185 56.1613 32.2067 55.7822 32.1961C55.7822 31.2391 55.7822 30.2809 55.7822 29.3228Z"
        fill="#F1F0F0"
      />
      <path
        d="M84.1977 39.6133C84.9593 39.6145 85.7197 39.6145 86.4813 39.6156C86.4425 40.5738 86.4036 41.5308 86.3636 42.489C85.974 42.4925 85.5832 42.4961 85.1935 42.4996C84.8592 41.8804 84.5238 41.2601 84.1895 40.6409C84.1906 40.2996 84.193 39.9582 84.1942 39.618L84.1977 39.6133Z"
        fill="#CFE2E5"
      />
      <path
        d="M87.4453 42.4867C87.4948 41.5285 87.5442 40.5703 87.5936 39.6133C88.2057 39.6145 88.8178 39.6156 89.4299 39.6168C89.4311 40.5774 89.4311 41.5379 89.4323 42.4984C88.7696 42.4949 88.108 42.4914 87.4453 42.4867Z"
        fill="#F1F1F1"
      />
      <path
        d="M122.556 44.6746C122.602 44.6852 122.657 44.6816 122.693 44.7063C123.609 45.3173 124.524 45.9317 125.438 46.545C125.436 46.8417 125.435 47.1371 125.433 47.4338C124.477 47.4338 123.521 47.4349 122.565 47.4349C122.562 46.5144 122.559 45.5951 122.556 44.6746Z"
        fill="#F1F0F0"
      />
      <path
        d="M22.3004 39.8335C22.3028 40.7222 22.3051 41.611 22.3087 42.4997L22.3122 42.5209C22.2063 42.515 22.0991 42.5056 21.9932 42.5044C21.1374 42.4997 20.2828 42.4962 19.4271 42.4926C19.4188 42.1548 19.4106 41.817 19.4023 41.4791C19.7025 41.2978 19.998 41.1095 20.3028 40.9376C20.9656 40.5645 21.6342 40.2008 22.3004 39.8335Z"
        fill="#F1F0F0"
      />
      <path
        d="M82.3596 39.6156C82.8858 40.5774 83.4108 41.5391 83.937 42.5008C83.0635 42.4984 82.1901 42.4949 81.3155 42.4925C81.312 41.5332 81.3084 40.5726 81.3037 39.6133L81.319 39.618C81.6651 39.6168 82.0123 39.6168 82.3596 39.6156Z"
        fill="#F1F0F0"
      />
      <path
        d="M94.4936 32.1961C94.4947 31.2933 94.4971 30.3904 94.4983 29.4875C95.3411 29.9172 96.1851 30.3468 97.0279 30.7777C97.0268 31.2509 97.0256 31.7253 97.0244 32.1985C96.1804 32.2044 95.3364 32.2102 94.4912 32.2161L94.4936 32.1961Z"
        fill="#CFE3E7"
      />
      <path
        d="M24.8252 38.4653C25.7481 37.9686 26.6709 37.4718 27.5938 36.9751C27.5973 37.0128 27.602 37.0504 27.6056 37.0893C27.5985 37.9321 27.5903 38.7749 27.5832 39.6189C26.6686 39.6189 25.7539 39.6178 24.8393 39.6178L24.8358 39.6142C24.8323 39.2305 24.8287 38.8479 24.8252 38.4653Z"
        fill="#CFE2E5"
      />
      <path
        d="M130.267 57.7269C129.499 57.7269 128.73 57.7269 127.963 57.728C127.964 56.824 127.964 55.9211 127.965 55.0171C128.464 55.0018 128.965 54.9865 129.464 54.9712C129.731 55.8894 129.999 56.8087 130.267 57.7269Z"
        fill="#F1F0F0"
      />
      <path
        d="M50.3809 39.6178C51.2226 39.6178 52.0654 39.6178 52.9071 39.6178C52.3809 40.5854 51.8535 41.5518 51.3273 42.5194C51.0095 42.51 50.6917 42.4994 50.3751 42.49C50.3715 41.5318 50.3668 40.5724 50.3633 39.6143L50.3809 39.6178Z"
        fill="#F1F0F0"
      />
      <path
        d="M4.84961 63.1441C5.09092 62.1777 5.33223 61.2113 5.57354 60.2449C6.02909 60.2472 6.48464 60.2508 6.94019 60.2531C6.94019 61.2113 6.93901 62.1695 6.93901 63.1265C6.24215 63.1336 5.54529 63.1383 4.84961 63.1441Z"
        fill="#F1F0F0"
      />
      <path
        d="M55.7328 34.4454C55.2537 35.3259 54.7746 36.2052 54.2955 37.0857C53.9482 37.0869 53.601 37.0881 53.2537 37.0893L53.2502 37.0857C53.2502 36.1876 53.249 35.2883 53.249 34.3901C54.0071 34.3878 54.7652 34.3831 55.5232 34.3854C55.5927 34.3842 55.6633 34.4243 55.7328 34.4454Z"
        fill="#CFE3E7"
      />
      <path
        d="M86.6061 47.4353C85.8021 47.4353 84.9993 47.4365 84.1953 47.4365L84.1906 47.4318C84.1906 46.5184 84.1895 45.6037 84.1895 44.6903C84.4884 44.6797 84.7886 44.6703 85.0876 44.6597C85.3136 45.054 85.5479 45.4448 85.7645 45.8439C86.0517 46.3712 86.3259 46.9045 86.6061 47.4353Z"
        fill="#CFE2E5"
      />
      <path
        d="M76.6465 26.8048C77.474 26.8024 78.3015 26.7989 79.1279 26.7965L79.1479 26.7942C79.1479 27.6382 79.1479 28.4822 79.1479 29.325L79.1279 29.3227C78.7594 29.3238 78.391 29.3238 78.0225 29.325C77.5646 28.4845 77.1056 27.6452 76.6465 26.8048Z"
        fill="#CFE3E7"
      />
      <path
        d="M89.4311 39.6166C88.8189 39.6154 88.2068 39.6142 87.5947 39.6131C87.6312 38.7691 87.6677 37.9251 87.7042 37.0811C88.281 37.0834 88.8566 37.0869 89.4334 37.0893C89.4416 37.9321 89.4499 38.7749 89.4581 39.6178L89.4311 39.6166Z"
        fill="#CFE2E5"
      />
      <path
        d="M89.4362 37.0893C88.8594 37.0869 88.2838 37.0834 87.707 37.081C87.7518 36.1793 87.7953 35.2777 87.84 34.376C88.3697 34.3795 88.9006 34.3819 89.4303 34.3854C89.4339 34.4925 89.4398 34.5985 89.4409 34.7056C89.4468 35.5013 89.4527 36.2971 89.4574 37.0928L89.4362 37.0893Z"
        fill="#F1F0F0"
      />
      <path
        d="M127.774 49.9071C126.995 49.9071 126.216 49.9071 125.437 49.9071C125.437 49.0831 125.437 48.2579 125.437 47.4339C125.777 47.4327 126.117 47.4304 126.456 47.4292C126.594 47.614 126.762 47.7847 126.864 47.9872C127.181 48.6205 127.473 49.2667 127.774 49.9071Z"
        fill="#B3D6DD"
      />
      <path
        d="M58.1589 23.1401C58.2978 23.4226 58.4155 23.7193 58.5826 23.9853C58.7898 24.3161 59.0394 24.6186 59.2677 24.9376C59.3113 24.9988 59.3372 25.073 59.3713 25.1413C59.369 25.6933 59.3654 26.2466 59.3631 26.7987C59.09 26.7987 58.8169 26.7987 58.5438 26.7987L58.5273 26.7998C58.5273 26.7998 58.5108 26.7987 58.512 26.7987C58.512 25.9052 58.512 25.013 58.512 24.0936C57.5915 24.0936 56.6863 24.0936 55.7811 24.0936L55.7834 24.0701C55.7811 23.7946 55.7787 23.518 55.7764 23.2425C56.4638 23.2343 57.1513 23.2308 57.8375 23.2167C57.9458 23.2131 58.0518 23.166 58.1589 23.1401Z"
        fill={fill}
      />
      <path
        d="M87.916 32.1974C87.9619 31.2404 88.0078 30.2846 88.0537 29.3276C88.514 29.3264 88.9731 29.324 89.4333 29.3229L89.4522 29.3193C89.4439 30.2799 89.4357 31.2404 89.4274 32.201C88.9236 32.1998 88.4198 32.1986 87.916 32.1974Z"
        fill="#F1F0F0"
      />
      <path
        d="M104.786 37.0871C104.786 36.3231 104.786 35.5603 104.786 34.7964C105.63 35.2425 106.474 35.6887 107.319 36.136C107.318 36.4526 107.317 36.7693 107.317 37.0859L107.313 37.0894C106.473 37.0906 105.632 37.0918 104.792 37.093L104.786 37.0871Z"
        fill="#CFE3E7"
      />
      <path
        d="M66.7715 37.0859C67.2565 37.8569 67.7414 38.6279 68.2535 39.4425C68.443 39.1459 68.6125 38.881 68.782 38.615C68.7961 38.9493 68.8114 39.2836 68.8256 39.6179C67.9086 39.6167 66.9928 39.6155 66.0758 39.6144C66.0746 38.7727 66.0734 37.9311 66.0723 37.0882L66.0758 37.0847C66.3089 37.0859 66.5408 37.0859 66.7715 37.0859Z"
        fill="#CFE2E5"
      />
      <path
        d="M115.145 42.503C115.144 41.7803 115.142 41.0587 115.141 40.3359C115.966 40.7997 116.791 41.2635 117.616 41.7273C117.616 41.9839 117.616 42.2394 117.616 42.496C117.616 42.496 117.617 42.523 117.617 42.5219C116.793 42.516 115.969 42.5089 115.145 42.503Z"
        fill="#CFE2E5"
      />
      <path
        d="M76.373 32.1949C76.373 31.2379 76.3742 30.282 76.3742 29.325C76.5002 29.3191 76.625 29.3133 76.7509 29.3074C77.2712 30.2726 77.7915 31.239 78.3118 32.2043C77.6644 32.2019 77.0181 32.1984 76.373 32.1949Z"
        fill="#F1EFEF"
      />
      <path
        d="M89.4343 29.3227C88.974 29.3239 88.5149 29.3263 88.0547 29.3274C88.0924 28.4834 88.1288 27.6383 88.1665 26.7943C88.4985 26.7931 88.8304 26.7907 89.1624 26.7896C89.266 26.8425 89.3684 26.8955 89.472 26.9485C89.4614 27.065 89.4425 27.1804 89.4413 27.2969C89.4355 27.9714 89.4355 28.6471 89.4343 29.3227Z"
        fill="#CFE2E5"
      />
      <path
        d="M84.1979 37.0872C84.1979 37.9288 84.1979 38.7716 84.1991 39.6133L84.1956 39.6168C84.0061 39.6168 83.8154 39.6168 83.6258 39.6168C83.1691 38.774 82.7136 37.93 82.2568 37.0872C82.9031 37.0872 83.5505 37.0872 84.1979 37.0872Z"
        fill="#CFE2E5"
      />
      <path
        d="M4.18647 70.5481C4.18647 71.3532 4.1853 72.1584 4.1853 72.9635C3.68031 72.9635 3.17414 72.9635 2.62207 72.9635C2.79982 72.1407 2.9705 71.3438 3.14236 70.5469C3.48961 70.5469 3.83804 70.5469 4.18647 70.5481Z"
        fill="#CFE2E5"
      />
      <path
        d="M28.4072 36.5432C28.5461 36.4643 28.685 36.3855 28.8239 36.3054C28.8545 36.5667 28.8851 36.8281 28.9146 37.0882C28.9146 37.9299 28.9146 38.7703 28.9146 39.612C28.9075 40.5737 28.9004 41.5354 28.8934 42.4971C28.7368 42.4948 28.5803 42.4936 28.4237 42.4912C28.4202 41.5319 28.4155 40.5713 28.4119 39.612C28.4119 38.7703 28.4108 37.9275 28.4108 37.0859C28.4096 36.9069 28.4084 36.7245 28.4072 36.5432Z"
        fill="#E1EAEC"
      />
      <path
        d="M6.94477 60.2541C6.48922 60.2517 6.03367 60.2482 5.57812 60.2458C5.8006 59.4065 6.02308 58.5661 6.24556 57.7268C6.47863 57.7268 6.71052 57.7279 6.94359 57.7279L6.96361 57.7256C6.96478 58.5696 6.96478 59.4124 6.96596 60.2564L6.94477 60.2541Z"
        fill="#CFE2E5"
      />
      <path
        d="M55.6019 19.0322C54.8191 19.0322 54.0375 19.0322 53.2547 19.031C53.2512 18.9992 53.2477 18.9674 53.2441 18.9357C53.582 18.2718 53.9198 17.6079 54.2918 16.8745C54.7556 17.6396 55.1782 18.3365 55.6019 19.0322Z"
        fill="#B3D6DD"
      />
      <path
        d="M81.3188 42.4922C82.1923 42.4945 83.0657 42.4981 83.9403 42.5004C84.0886 42.7841 84.2369 43.069 84.3853 43.3527C84.3217 43.3597 84.2593 43.368 84.1957 43.375C83.234 43.3739 82.2735 43.3739 81.3118 43.3727C81.3071 43.0855 81.3035 42.7971 81.2988 42.5098L81.3188 42.4922Z"
        fill={fill}
      />
      <path
        d="M53.2434 18.9368C53.247 18.9686 53.2505 19.0003 53.254 19.0321C53.254 19.9879 53.2528 20.9438 53.2528 21.8984C52.8962 21.9031 52.5407 21.9149 52.184 21.909C52.0074 21.9067 51.8309 21.8725 51.6543 21.8525C52.1569 20.9073 52.6584 19.9632 53.1634 19.0192C53.1822 18.9862 53.2163 18.9638 53.2434 18.9368Z"
        fill="#F1EFEF"
      />
      <path
        d="M45.428 27.7512C45.4268 28.275 45.4256 28.8 45.4256 29.3239C44.6016 29.325 43.7776 29.325 42.9537 29.3262C42.7535 29.3215 42.5546 29.3168 42.3545 29.3133C43.3798 28.7918 44.4039 28.2715 45.428 27.7512Z"
        fill="#B3D6DD"
      />
      <path
        d="M83.3387 19.0206C82.6642 19.0253 81.9909 19.03 81.3164 19.0347C81.3046 18.8523 81.2928 18.6698 81.2822 18.4874C81.58 17.9647 81.8779 17.4433 82.2027 16.8735C82.6018 17.6293 82.9702 18.3249 83.3387 19.0206Z"
        fill="#CFE2E5"
      />
      <path
        d="M48.943 39.6165C48.9912 40.5818 49.0383 41.5482 49.0866 42.5134C48.7911 42.5099 48.4957 42.5064 48.2002 42.5028C48.2025 41.5388 48.2049 40.5759 48.2061 39.6118C48.4521 39.613 48.6981 39.6142 48.943 39.6165Z"
        fill={fill}
      />
      <path
        d="M81.2835 18.4873C81.2952 18.6698 81.3058 18.8522 81.3176 19.0347C81.3188 19.9905 81.3211 20.9475 81.3223 21.9033L81.3035 21.9222C81.0292 21.9163 80.7538 21.9104 80.4795 21.9045C80.4818 21.1817 80.4842 20.4602 80.4866 19.7374C80.7526 19.3207 81.0174 18.904 81.2835 18.4873Z"
        fill={fill}
      />
      <path
        d="M9.09871 49.1833C9.11166 49.4258 9.12461 49.6683 9.13638 49.9108C9.1352 50.8855 9.1352 51.8613 9.13402 52.836C8.85387 52.8348 8.57253 52.8348 8.29238 52.8336C8.29473 52.57 8.30415 52.3051 8.29709 52.0414C8.28885 51.7436 8.26648 51.4446 8.25 51.1468C8.49602 50.5347 8.74086 49.9214 8.99041 49.3105C9.01043 49.261 9.06222 49.2257 9.09871 49.1833Z"
        fill={fill}
      />
      <path
        d="M55.7802 39.6142C55.2469 39.6131 54.7149 39.6119 54.1816 39.6107C54.6525 38.7455 55.1233 37.8803 55.5942 37.0151C55.6554 37.0399 55.7166 37.0634 55.7778 37.0881L55.779 37.0893C55.7802 37.9309 55.7802 38.7726 55.7802 39.6142Z"
        fill="#B3D6DD"
      />
      <path
        d="M122.56 44.6746C122.562 45.5951 122.566 46.5157 122.568 47.4362L122.548 47.4338C122.276 47.4338 122.006 47.4338 121.734 47.4338C121.728 46.5204 121.721 45.6057 121.715 44.6923C121.722 44.6841 121.729 44.677 121.736 44.6687C121.994 44.6652 122.25 44.6617 122.508 44.6593C122.527 44.6582 122.545 44.664 122.56 44.6746Z"
        fill={fill}
      />
      <path
        d="M79.0275 33.4944C79.0675 33.5733 79.1063 33.6509 79.1464 33.7298C79.1464 33.944 79.1475 34.1571 79.1475 34.3713L79.1299 34.389C78.2105 34.3902 77.2924 34.3914 76.373 34.3914L76.3754 34.3713C76.3754 34.1006 76.3754 33.8287 76.3754 33.5579C77.1582 33.5568 77.941 33.5568 78.7238 33.5509C78.825 33.5497 78.9262 33.5144 79.0275 33.4944Z"
        fill={fill}
      />
      <path
        d="M55.7339 34.4455C55.6633 34.4243 55.5939 34.3843 55.5232 34.3843C54.7652 34.382 54.0071 34.3867 53.249 34.389L53.2526 34.3737C53.2514 34.103 53.2514 33.8323 53.2502 33.5615C54.093 33.5545 54.937 33.5486 55.7799 33.5415C55.9188 33.5497 56.0577 33.5592 56.1966 33.5674C56.0435 33.8605 55.8893 34.1536 55.7339 34.4455Z"
        fill={fill}
      />
      <path
        d="M53.2499 24.0951C52.3235 24.088 51.3971 24.0809 50.4707 24.0739C50.6214 23.7855 50.772 23.4959 50.9227 23.2075C51.0298 23.2111 51.137 23.2158 51.2429 23.2181C51.9139 23.2264 52.5836 23.2334 53.2546 23.2393C53.2523 23.5159 53.2499 23.7926 53.2475 24.0704L53.2499 24.0951Z"
        fill={fill}
      />
      <path
        d="M14.5437 44.6915C14.3612 44.6762 14.1787 44.6621 13.9951 44.6468C14.2918 44.4467 14.586 44.2454 14.8838 44.0488C15.0216 43.9582 15.164 43.8769 15.3053 43.791C15.3959 43.8098 15.4865 43.8452 15.5772 43.8463C16.1351 43.8534 16.6931 43.8534 17.2511 43.8558C17.2499 44.1277 17.2487 44.3996 17.2475 44.6703C16.347 44.6786 15.4453 44.6856 14.5437 44.6915Z"
        fill={fill}
      />
      <path
        d="M6.90625 55.3844C6.95569 55.2561 7.00513 55.1278 7.05457 54.9983C7.2947 55.0054 7.53366 55.0124 7.77379 55.0195C7.77733 55.92 7.77968 56.8217 7.78321 57.7222C7.51012 57.7233 7.23702 57.7245 6.96393 57.7245L6.94392 57.7269C6.94745 57.0583 6.95216 56.3885 6.95098 55.7199C6.95098 55.608 6.92155 55.4962 6.90625 55.3844Z"
        fill={fill}
      />
      <path
        d="M79.6035 32.2126C79.4316 31.9136 79.2598 31.6158 79.0879 31.3168C79.1044 31.2638 79.1362 31.212 79.1362 31.1591C79.1362 30.547 79.1314 29.9349 79.1291 29.3228L79.1491 29.3251C79.421 29.3251 79.6929 29.3251 79.9649 29.3251C79.9684 30.2798 79.9731 31.2344 79.9766 32.1891C79.9696 32.1961 79.9637 32.2044 79.9566 32.2114C79.8389 32.2126 79.7212 32.2126 79.6035 32.2126Z"
        fill={fill}
      />
      <path
        d="M76.7493 29.3073C76.6233 29.3132 76.4986 29.3191 76.3726 29.325C75.764 29.325 75.1555 29.3238 74.5469 29.3238C74.9224 28.6999 75.2979 28.0772 75.7146 27.3862C76.0771 28.0584 76.4138 28.6834 76.7493 29.3073Z"
        fill="#B3D6DD"
      />
      <path
        d="M86.8288 32.196C86.8111 32.4762 86.7923 32.7564 86.7746 33.0365C85.9153 33.033 85.056 33.0295 84.1955 33.0259C84.1955 32.7564 84.1943 32.4868 84.1943 32.2161C85.0372 32.2102 85.88 32.2055 86.7228 32.1996C86.7581 32.1984 86.7934 32.1972 86.8288 32.196Z"
        fill={fill}
      />
      <path
        d="M130.686 72.9669C130.684 72.1605 130.68 71.3542 130.678 70.5479L130.706 70.549C130.984 70.5467 131.26 70.5443 131.538 70.542C131.542 71.3495 131.545 72.157 131.549 72.9645C131.26 72.9645 130.973 72.9657 130.686 72.9669Z"
        fill={fill}
      />
      <path
        d="M55.7764 21.8995C55.7764 21.0426 55.7775 20.1868 55.7775 19.3298C56.3084 20.1915 56.8405 21.0532 57.3714 21.9148C56.8405 21.9101 56.3084 21.9042 55.7764 21.8995Z"
        fill="#F1EFEF"
      />
      <path
        d="M101.956 70.548C101.953 71.3543 101.951 72.1606 101.949 72.9682C101.659 72.9658 101.371 72.9634 101.081 72.9611C101.082 72.1559 101.083 71.3496 101.085 70.5444C101.365 70.5456 101.645 70.5468 101.924 70.5491L101.939 70.5503L101.956 70.548Z"
        fill={fill}
      />
      <path
        d="M89.4413 72.9647C89.4377 72.1583 89.4342 71.352 89.4307 70.5457L89.4566 70.548C89.7344 70.5457 90.011 70.5433 90.2888 70.5398C90.2935 71.3485 90.2982 72.156 90.3029 72.9647C90.0169 72.9647 89.7297 72.9647 89.4413 72.9647Z"
        fill={fill}
      />
      <path
        d="M71.0199 70.5457C71.0164 71.352 71.0129 72.1583 71.0093 72.9647C70.7221 72.9647 70.4349 72.9659 70.1465 72.9659C70.1512 72.1572 70.1571 71.3485 70.1618 70.5398C70.4384 70.5421 70.7162 70.5445 70.994 70.548L71.0199 70.5457Z"
        fill={fill}
      />
      <path
        d="M48.2 72.9635C48.1965 72.1572 48.193 71.3509 48.1895 70.5457L48.2142 70.5481C48.4908 70.5457 48.7674 70.5434 49.0452 70.541C49.0511 71.3497 49.057 72.1584 49.0629 72.9671C48.7745 72.9659 48.4873 72.9647 48.2 72.9635Z"
        fill={fill}
      />
      <path
        d="M29.7765 70.5469C29.773 71.3532 29.7707 72.1596 29.7671 72.9659C29.4799 72.9659 29.1915 72.9647 28.9043 72.9647C28.9078 72.1572 28.9125 71.3485 28.9161 70.541C29.1939 70.5434 29.4705 70.5457 29.7483 70.5481L29.7765 70.5469Z"
        fill={fill}
      />
      <path
        d="M17.2582 72.967C17.2559 72.1607 17.2535 71.3544 17.25 70.5469L17.2653 70.548L17.2806 70.5469C17.5572 70.5445 17.8339 70.5421 18.1117 70.5398C18.1152 71.3473 18.1187 72.1548 18.1211 72.9623C17.8327 72.9647 17.5455 72.9659 17.2582 72.967Z"
        fill={fill}
      />
      <path
        d="M50.3479 46.6643C50.3597 46.9209 50.3715 47.1764 50.3832 47.433C50.375 48.2581 50.3679 49.0821 50.3597 49.9073C50.0913 49.9073 49.8229 49.9073 49.5534 49.9073C49.5498 49.3187 49.5463 48.7302 49.5439 48.1416C49.8123 47.6496 50.0795 47.1575 50.3479 46.6643Z"
        fill={fill}
      />
      <path
        d="M86.7205 34.3866C85.8788 34.3878 85.0372 34.3878 84.1943 34.389L84.1979 34.3737C84.1967 34.1041 84.1967 33.8334 84.1955 33.5638C85.0525 33.5579 85.9094 33.552 86.7664 33.5461C86.7511 33.8263 86.7358 34.1065 86.7205 34.3866Z"
        fill={fill}
      />
      <path
        d="M49.6022 29.3237C49.5681 28.7693 49.5339 28.216 49.501 27.6616C49.5186 27.3732 49.5375 27.0848 49.5551 26.7952C49.8259 26.7952 50.0954 26.7952 50.3662 26.7952L50.3838 26.7905C50.3768 27.6345 50.3697 28.4797 50.3626 29.3237C50.1084 29.3249 49.8553 29.3237 49.6022 29.3237Z"
        fill={fill}
      />
      <path
        d="M132.792 68.0175C132.826 68.1399 132.859 68.2612 132.894 68.3836C132.884 69.1063 132.875 69.8291 132.865 70.5519L132.849 70.5471C132.577 70.546 132.304 70.5448 132.032 70.5436L132.017 70.5471C132.022 69.7031 132.028 68.8591 132.034 68.0151C132.287 68.0163 132.539 68.0175 132.792 68.0175Z"
        fill={fill}
      />
      <path
        d="M6.93989 65.3206C6.07588 65.3135 5.21069 65.3064 4.34668 65.2994C4.41142 65.0274 4.47616 64.7555 4.54091 64.4848C5.34018 64.4836 6.13827 64.4836 6.93754 64.4824C6.94343 64.7567 6.95049 65.0298 6.95637 65.3041L6.93989 65.3206Z"
        fill={fill}
      />
      <path
        d="M49.6035 29.3239C49.8566 29.3239 50.1097 29.3239 50.3639 29.3251L50.3875 29.3228C50.3828 30.2821 50.3792 31.2427 50.3745 32.202C50.1591 32.202 49.9449 32.2008 49.7295 32.2008C49.6871 31.2415 49.6447 30.2833 49.6035 29.3239Z"
        fill={fill}
      />
      <path
        d="M79.497 34.3735C79.6676 34.6725 79.8395 34.9703 80.0102 35.2693C79.9984 35.2881 79.9866 35.3081 79.9749 35.3281C79.9713 35.9144 79.9666 36.5006 79.9631 37.0856C79.6912 37.0868 79.4193 37.0879 79.1473 37.0891C79.1415 36.1898 79.1367 35.2893 79.1309 34.39L79.1485 34.3723C79.2639 34.3723 79.3804 34.3735 79.497 34.3735Z"
        fill={fill}
      />
      <path
        d="M97.0223 32.1984C97.0235 31.7252 97.0246 31.2508 97.0258 30.7776C97.9416 31.2508 98.8586 31.7252 99.7744 32.1984L99.7544 32.189C98.8421 32.1972 97.9299 32.2054 97.0176 32.2137L97.0223 32.1984Z"
        fill="#F1EFEF"
      />
      <path
        d="M130.681 60.2529C130.698 60.0198 130.713 59.7856 130.73 59.5525C130.946 60.3365 131.169 61.1181 131.375 61.9044C131.475 62.287 131.541 62.6789 131.622 63.0674C131.596 63.0933 131.57 63.118 131.544 63.1439C131.256 63.1427 130.967 63.1404 130.678 63.1392C130.679 62.1775 130.68 61.2146 130.681 60.2529Z"
        fill={fill}
      />
      <path
        d="M27.5995 72.9564C27.5925 72.1524 27.5842 71.3484 27.5771 70.5444L27.603 70.5456C27.8738 70.5456 28.1457 70.5444 28.4164 70.5444C28.4176 71.3496 28.4188 72.1559 28.42 72.9611C28.1469 72.9587 27.8738 72.9576 27.5995 72.9564Z"
        fill={fill}
      />
      <path
        d="M19.452 70.5446C19.4438 71.3486 19.4344 72.1514 19.4261 72.9554C19.1519 72.9566 18.8788 72.9589 18.6045 72.9601C18.6057 72.1549 18.6068 71.3486 18.608 70.5435C18.8799 70.5435 19.1519 70.5434 19.4238 70.5446H19.452Z"
        fill={fill}
      />
      <path
        d="M9.13947 70.5444C9.13359 71.3496 9.12888 72.1547 9.12299 72.9599C8.8499 72.9599 8.5768 72.9587 8.30371 72.9587C8.30489 72.1547 8.30489 71.3496 8.30607 70.5444C8.57681 70.5444 8.84755 70.5456 9.11828 70.5456L9.13947 70.5444Z"
        fill={fill}
      />
      <path
        d="M80.9784 37.0823C81.0914 37.2942 81.2032 37.506 81.3163 37.7191C81.3186 38.3524 81.321 38.9845 81.3233 39.6178L81.308 39.6131C81.0373 39.6131 80.7665 39.6143 80.4958 39.6155C80.4887 38.7715 80.4817 37.9275 80.4746 37.0835L80.4946 37.0882C80.6559 37.0858 80.8172 37.0835 80.9784 37.0823Z"
        fill={fill}
      />
      <path
        d="M6.9526 72.9611C6.94789 72.156 6.94319 71.3508 6.93848 70.5457L6.95849 70.548C7.23158 70.5492 7.50468 70.5492 7.77777 70.5504C7.77659 71.352 7.77542 72.1536 7.77542 72.9552C7.50114 72.9564 7.22687 72.9588 6.9526 72.9611Z"
        fill={fill}
      />
      <path
        d="M37.8967 72.9599C37.892 72.1547 37.8873 71.3496 37.8838 70.5444L37.9038 70.5468C38.1745 70.5468 38.4453 70.5468 38.7172 70.5468C38.7172 71.3508 38.7172 72.1536 38.7184 72.9575C38.4441 72.9575 38.171 72.9587 37.8967 72.9599Z"
        fill={fill}
      />
      <path
        d="M40.0801 70.5444C40.0754 71.3496 40.0707 72.1547 40.0672 72.9599C39.7929 72.9575 39.5186 72.9564 39.2443 72.954C39.2443 72.1512 39.2432 71.3496 39.2432 70.5468C39.5151 70.5468 39.787 70.5456 40.0601 70.5456C40.0601 70.5468 40.0801 70.5444 40.0801 70.5444Z"
        fill={fill}
      />
      <path
        d="M50.3821 70.5444C50.3762 71.3496 50.3703 72.1536 50.3644 72.9587C50.0913 72.9587 49.8182 72.9599 49.5439 72.9599C49.5451 72.1547 49.5463 71.3496 49.5463 70.5444C49.817 70.5444 50.0878 70.5456 50.3585 70.5468L50.3821 70.5444Z"
        fill={fill}
      />
      <path
        d="M58.5445 72.9527C58.5421 72.2547 58.5421 71.5578 58.5374 70.8598C58.5362 70.7539 58.5209 70.6491 58.5127 70.5432L58.5292 70.542H58.5457C58.8187 70.542 59.0918 70.542 59.3649 70.5432C59.3661 71.3483 59.3673 72.1546 59.3685 72.9598C59.093 72.9575 58.8187 72.9551 58.5445 72.9527Z"
        fill={fill}
      />
      <path
        d="M60.6979 70.5435C60.6897 71.2403 60.6815 71.9372 60.6744 72.634C60.6732 72.7411 60.6709 72.8471 60.6685 72.953C60.3942 72.9554 60.12 72.9577 59.8457 72.9601C59.8469 72.1549 59.8481 71.3486 59.8492 70.5435C60.1223 70.5435 60.3942 70.5435 60.6673 70.5435H60.6826H60.6979Z"
        fill={fill}
      />
      <path
        d="M68.8421 72.9577C68.8362 72.1538 68.8291 71.3486 68.8232 70.5446L68.8468 70.5458C69.1175 70.5446 69.3883 70.5446 69.659 70.5435C69.6602 71.3486 69.6614 72.1538 69.6625 72.9589C69.3883 72.9589 69.1152 72.9589 68.8421 72.9577Z"
        fill={fill}
      />
      <path
        d="M79.1379 72.9599C79.1332 72.1547 79.1285 71.3496 79.125 70.5444L79.145 70.5468C79.4169 70.5468 79.6888 70.5468 79.9608 70.548C79.9608 71.3508 79.9608 72.1536 79.9608 72.9564C79.6865 72.9564 79.4122 72.9587 79.1379 72.9599Z"
        fill={fill}
      />
      <path
        d="M81.3248 70.5444C81.3201 71.3496 81.3154 72.1547 81.3119 72.9599C81.0376 72.9587 80.7645 72.9576 80.4902 72.9564C80.4902 72.1536 80.4902 71.3496 80.4902 70.5468C80.761 70.5468 81.0329 70.5468 81.3036 70.5468L81.3248 70.5444Z"
        fill={fill}
      />
      <path
        d="M91.6268 70.5444C91.6197 71.3484 91.6127 72.1524 91.6056 72.9575C91.3325 72.9587 91.0583 72.9599 90.7852 72.9611C90.7863 72.1559 90.7875 71.3508 90.7887 70.5444C91.0594 70.5456 91.3302 70.5456 91.6009 70.5468L91.6268 70.5444Z"
        fill={fill}
      />
      <path
        d="M99.7859 72.9542C99.7765 72.1502 99.767 71.3474 99.7588 70.5435H99.787C100.059 70.5435 100.332 70.5435 100.604 70.5435C100.605 71.3486 100.606 72.1549 100.608 72.9601C100.334 72.9577 100.06 72.9566 99.7859 72.9542Z"
        fill={fill}
      />
      <path
        d="M110.082 72.9587C110.076 72.1536 110.071 71.3484 110.065 70.5444L110.088 70.5468C110.359 70.5468 110.629 70.5456 110.9 70.5456C110.901 71.3508 110.901 72.1547 110.902 72.9599C110.628 72.9587 110.355 72.9587 110.082 72.9587Z"
        fill={fill}
      />
      <path
        d="M112.271 70.5444C112.266 71.3496 112.262 72.1547 112.258 72.9599C111.984 72.9575 111.708 72.9552 111.434 72.9528C111.433 72.1512 111.432 71.3508 111.431 70.5491C111.704 70.548 111.977 70.5468 112.251 70.5456L112.271 70.5444Z"
        fill={fill}
      />
      <path
        d="M120.378 72.9599C120.373 72.1547 120.369 71.3496 120.365 70.5444L120.385 70.5468C120.658 70.548 120.93 70.548 121.203 70.5491C121.202 71.3508 121.202 72.1524 121.201 72.954C120.928 72.9564 120.652 72.9587 120.378 72.9599Z"
        fill={fill}
      />
      <path
        d="M122.566 70.5444C122.561 71.3496 122.557 72.1547 122.552 72.9599C122.279 72.9587 122.006 72.9587 121.731 72.9575C121.733 72.1536 121.733 71.3496 121.734 70.5456C122.005 70.5456 122.275 70.5468 122.546 70.5468L122.566 70.5444Z"
        fill={fill}
      />
      <path
        d="M132.032 70.5435C132.304 70.5446 132.577 70.5458 132.849 70.547C132.849 71.3498 132.849 72.1526 132.849 72.9566C132.575 72.9577 132.302 72.9589 132.027 72.9601C132.029 72.1549 132.031 71.3498 132.032 70.5435Z"
        fill={fill}
      />
      <path
        d="M4.18669 70.5481C3.83826 70.5481 3.48983 70.5469 3.14258 70.5469C3.33327 69.7041 3.52515 68.8601 3.71584 68.0173C3.8724 68.0161 4.03013 68.0161 4.18669 68.0161C4.18669 68.8589 4.18669 69.7029 4.18669 70.5481Z"
        fill="#B3D6DD"
      />
      <path
        d="M89.4307 29.3228C89.4318 28.6471 89.4318 27.9714 89.4365 27.2969C89.4377 27.1804 89.4566 27.065 89.4672 26.9485C89.7485 27.0874 90.031 27.2263 90.3123 27.3664C90.3029 28.0197 90.2935 28.673 90.2841 29.3263C90.0063 29.3239 89.7273 29.3216 89.4483 29.3204L89.4307 29.3228Z"
        fill={fill}
      />
      <path
        d="M132.851 72.9565C132.851 72.1537 132.851 71.3509 132.851 70.5469L132.867 70.5516C133.034 70.5504 133.201 70.5492 133.369 70.5469C133.54 71.3379 133.712 72.1289 133.892 72.9553C133.523 72.9565 133.186 72.9565 132.851 72.9565Z"
        fill="#F1EFEF"
      />
      <path
        d="M73.8399 34.3879C73.0336 34.3832 72.2272 34.3773 71.4209 34.3726C71.5986 34.0806 71.7752 33.7887 71.953 33.4956C72.0154 33.5144 72.0777 33.5497 72.1401 33.5509C72.7063 33.5521 73.2737 33.5474 73.8399 33.545C73.8599 33.5509 73.8799 33.558 73.8999 33.5639C73.8999 33.8334 73.8999 34.103 73.8999 34.3726C73.8799 34.3773 73.8599 34.3832 73.8399 34.3879Z"
        fill={fill}
      />
      <path
        d="M119.049 42.5524C119.452 42.7961 119.854 43.0398 120.257 43.2822C120.157 43.3117 120.057 43.367 119.957 43.367C119.174 43.3693 118.391 43.3611 117.608 43.3576C117.611 43.0798 117.613 42.802 117.615 42.5242L117.614 42.4971C118.064 42.4971 118.514 42.4971 118.963 42.4971L118.966 42.4912C118.993 42.5112 119.021 42.5312 119.049 42.5524Z"
        fill={fill}
      />
      <path
        d="M4.85028 63.1442C5.54714 63.1383 6.24282 63.1336 6.93968 63.1277L6.95734 63.1453C6.95263 63.4184 6.94792 63.6904 6.94439 63.9634C6.18161 63.9634 5.42001 63.9623 4.65723 63.9623C4.72197 63.6903 4.78553 63.4172 4.85028 63.1442Z"
        fill={fill}
      />
      <path
        d="M76.373 32.1951C77.0193 32.1986 77.6655 32.2021 78.3118 32.2045C78.4542 32.4729 78.5966 32.7413 78.7403 33.0096C77.9528 33.0167 77.1653 33.0238 76.3778 33.0308C76.3778 32.7589 76.3766 32.4858 76.3766 32.2139L76.373 32.1951Z"
        fill={fill}
      />
      <path
        d="M48.9452 39.6167C48.6992 39.6155 48.4543 39.6132 48.2083 39.612L48.1895 39.6144C48.1965 38.7715 48.2036 37.9287 48.2106 37.0859C48.4166 37.0859 48.6215 37.0859 48.8275 37.0847C48.8675 37.9287 48.9063 38.7727 48.9452 39.6167Z"
        fill={fill}
      />
      <path
        d="M34.125 33.558C34.4758 33.3767 34.8266 33.1954 35.1774 33.0142C35.2845 33.0212 35.3916 33.0342 35.4987 33.0342C36.2933 33.0377 37.0867 33.0389 37.8812 33.0412C37.8824 33.2096 37.8824 33.3791 37.8836 33.5474C36.9666 33.5509 36.0496 33.5556 35.1314 33.5592C34.796 33.5592 34.4605 33.558 34.125 33.558Z"
        fill="#E1EAEC"
      />
      <path
        d="M87.4454 42.4866C88.107 42.4901 88.7697 42.4936 89.4312 42.4983L89.4536 42.5172C89.4477 42.7997 89.443 43.0822 89.4371 43.3647C88.7497 43.3706 88.0634 43.3765 87.376 43.3824C87.3995 43.0834 87.4231 42.7856 87.4454 42.4866Z"
        fill={fill}
      />
      <path
        d="M94.1588 29.3157C93.3148 29.3193 92.4708 29.324 91.6268 29.3275C91.6209 28.8955 91.6151 28.4635 91.6104 28.0315C92.4591 28.46 93.3089 28.8884 94.1588 29.3157Z"
        fill="#CFE2E5"
      />
      <path
        d="M89.423 44.6819C88.7403 44.6796 88.0587 44.676 87.376 44.6737C87.3807 44.3959 87.3854 44.1169 87.3913 43.8391C88.0728 43.8438 88.7556 43.8485 89.4371 43.8532C89.4395 44.1228 89.443 44.3912 89.4454 44.6607C89.4371 44.6678 89.4301 44.6749 89.423 44.6819Z"
        fill={fill}
      />
      <path
        d="M11.9995 45.8826C12.0007 46.3993 12.0019 46.9161 12.003 47.4317C11.3533 47.4317 10.7035 47.4305 10.0537 47.4305C10.2091 47.2728 10.348 47.095 10.521 46.9632C11.0072 46.5924 11.5063 46.2416 11.9995 45.8826Z"
        fill="#F1EFEF"
      />
      <path
        d="M37.8787 33.0412C37.0841 33.0389 36.2907 33.0377 35.4962 33.0342C35.389 33.0342 35.2819 33.0212 35.1748 33.0142C35.548 32.8117 35.9211 32.6092 36.2943 32.4079C36.4555 32.3208 36.6168 32.2361 36.7792 32.1501C37.1489 32.1654 37.5173 32.1819 37.8869 32.1972L37.9046 32.2149C37.9034 32.4844 37.9022 32.754 37.901 33.0236L37.8787 33.0412Z"
        fill={fill}
      />
      <path
        d="M48.8298 37.0859C48.6238 37.0859 48.419 37.0859 48.213 37.0871L48.1895 37.0883C48.1918 36.1854 48.193 35.2825 48.1953 34.3809C48.3684 34.3832 48.5414 34.3867 48.7156 34.3891C48.7521 35.2872 48.791 36.1866 48.8298 37.0859Z"
        fill={fill}
      />
      <path
        d="M55.7775 21.8999C56.3096 21.9046 56.8417 21.9105 57.3726 21.9152C57.5326 22.1812 57.6927 22.4484 57.8516 22.7145C57.1595 22.7204 56.4685 22.7262 55.7764 22.7321C55.7775 22.4626 55.7775 22.1918 55.7787 21.9223C55.7799 21.9223 55.7775 21.8999 55.7775 21.8999Z"
        fill={fill}
      />
      <path
        d="M58.5257 34.3983C58.036 34.3854 57.5463 34.3736 57.0566 34.3607C57.2026 34.0935 57.3474 33.8251 57.4934 33.5579C57.8135 33.5579 58.1325 33.5579 58.4904 33.5579C58.4904 33.3742 58.4904 33.2306 58.4904 33.087C58.508 33.0682 58.5269 33.0494 58.5445 33.0305C58.8212 33.0329 59.0978 33.0352 59.3744 33.0376C59.3732 33.2094 59.3732 33.3825 59.3721 33.5543C58.5139 33.5673 58.5139 33.5673 58.5469 34.3795C58.541 34.3854 58.5339 34.3913 58.5257 34.3983Z"
        fill={fill}
      />
      <path
        d="M51.6501 21.8525C51.8267 21.8726 52.0032 21.9067 52.1798 21.909C52.5353 21.9149 52.892 21.9032 53.2487 21.8984L53.2463 21.9208C53.2475 22.1916 53.2475 22.4611 53.2487 22.7319C52.5612 22.733 51.8749 22.7354 51.1875 22.7366C51.3417 22.4423 51.4959 22.1468 51.6501 21.8525Z"
        fill={fill}
      />
      <path
        d="M34.1256 33.5579C34.4611 33.559 34.7966 33.559 35.1321 33.5602C35.1321 33.831 35.1333 34.1017 35.1333 34.3724C34.2904 34.3783 33.4464 34.3842 32.6036 34.3901C32.5824 34.3842 32.5612 34.3783 32.54 34.3713C33.0674 34.0993 33.5959 33.8286 34.1256 33.5579Z"
        fill={fill}
      />
      <path
        d="M110.07 39.6179C110.074 39.0694 110.075 38.5209 110.082 37.9723C110.083 37.8664 110.101 37.7593 110.112 37.6533C110.399 37.7922 110.686 37.9311 110.973 38.07C110.951 38.1689 110.912 38.2678 110.91 38.3678C110.899 38.7834 110.9 39.2001 110.897 39.6156C110.627 39.6144 110.356 39.6144 110.087 39.6132L110.07 39.6179Z"
        fill={fill}
      />
      <path
        d="M50.3642 26.7966C50.0935 26.7966 49.8239 26.7966 49.5532 26.7966C49.5485 26.4269 49.5438 26.0562 49.5391 25.6865C49.7168 25.3875 49.8946 25.0886 50.0711 24.7896C50.1653 24.6318 50.2583 24.4729 50.3513 24.3152C50.356 25.1427 50.3607 25.969 50.3642 26.7966Z"
        fill={fill}
      />
      <path
        d="M103.97 34.3714C103.301 34.3749 102.633 34.3796 101.965 34.3831L101.946 34.3643C101.951 34.1701 101.947 33.9747 101.962 33.7804C101.976 33.5933 101.887 33.5462 101.719 33.5532C101.505 33.5627 101.291 33.5532 101.075 33.5521C101.078 33.3967 101.08 33.2425 101.082 33.0871C101.159 33.0694 101.236 33.0518 101.313 33.033C101.533 33.1518 101.75 33.2802 101.976 33.3861C102.128 33.4579 102.303 33.4826 102.451 33.5591C102.962 33.824 103.465 34.1006 103.97 34.3714Z"
        fill={fill}
      />
      <path
        d="M68.8248 39.6191C68.8107 39.2848 68.7954 38.9505 68.7812 38.6162C68.999 38.2607 69.2133 37.9029 69.4357 37.5509C69.4911 37.4638 69.5687 37.3908 69.637 37.3108C69.6429 38.0795 69.6488 38.8481 69.6547 39.6168C69.3839 39.6168 69.1132 39.6156 68.8436 39.6156L68.8248 39.6191Z"
        fill={fill}
      />
      <path
        d="M86.034 24.0704C85.4207 24.0775 84.8086 24.0834 84.1953 24.0904L84.1989 24.0704C84.1953 23.8008 84.193 23.5313 84.1895 23.2605C84.193 23.2464 84.1953 23.2311 84.1989 23.2158C84.6615 23.2087 85.1241 23.2029 85.5867 23.1958C85.735 23.4877 85.8845 23.7785 86.034 24.0704Z"
        fill={fill}
      />
      <path
        d="M58.5437 26.7977C58.8168 26.7977 59.0899 26.7977 59.363 26.7977L59.3783 26.7942C59.376 27.1108 59.3736 27.4263 59.3713 27.743C59.1076 28.2103 58.8439 28.6776 58.5814 29.1449C58.5673 28.9154 58.5426 28.687 58.5414 28.4575C58.5355 27.9042 58.5426 27.351 58.5437 26.7977Z"
        fill={fill}
      />
      <path
        d="M61.9585 29.3228C61.5335 29.3252 61.1086 29.3263 60.6836 29.3287C60.6777 29.2239 60.6695 29.118 60.666 29.0132C60.6542 28.6201 60.6436 28.2281 60.6318 27.8349C60.6777 27.709 60.7237 27.583 60.7955 27.3853C61.2075 28.0703 61.583 28.6966 61.9585 29.3228Z"
        fill="#D5DBDB"
      />
      <path
        d="M86.7652 33.5462C85.9082 33.5521 85.0513 33.5579 84.1943 33.5638L84.1967 33.5391C84.1967 33.3767 84.1967 33.2154 84.1967 33.053L84.1955 33.0259C85.0548 33.0294 85.9141 33.0329 86.7746 33.0365C86.7711 33.206 86.7687 33.3755 86.7652 33.5462Z"
        fill="#CFE2E5"
      />
      <path
        d="M76.3742 33.0317C77.1617 33.0246 77.9492 33.0176 78.7367 33.0105C78.8332 33.1718 78.9286 33.333 79.0251 33.4943C78.9239 33.5143 78.8227 33.5496 78.7214 33.5508C77.9386 33.5567 77.1558 33.5567 76.373 33.5579L76.3778 33.539C76.3778 33.3766 76.3789 33.2153 76.3789 33.0529L76.3742 33.0317Z"
        fill="#F1EFEF"
      />
      <path
        d="M49.9401 37.0953C49.926 37.06 49.9013 37.0247 49.9013 36.9894C49.8766 36.1195 49.8554 35.2508 49.833 34.3809C50.0131 34.382 50.192 34.3844 50.3721 34.3856C50.3757 35.2873 50.3804 36.1878 50.3839 37.0894L50.3604 37.0871C50.2215 37.0894 50.0814 37.0918 49.9401 37.0953Z"
        fill={fill}
      />
      <path
        d="M53.2531 44.6949C52.6457 44.6879 52.0371 44.6808 51.4297 44.6737C51.5839 44.3783 51.7393 44.0828 51.8935 43.7874C51.9818 43.8085 52.07 43.8439 52.1595 43.8462C52.5244 43.8556 52.8893 43.8544 53.2542 43.8568C53.2542 44.1275 53.2531 44.3983 53.2531 44.6702C53.2519 44.669 53.2531 44.6949 53.2531 44.6949Z"
        fill={fill}
      />
      <path
        d="M117.608 43.3564C118.391 43.3611 119.174 43.3693 119.957 43.367C120.057 43.367 120.157 43.3117 120.257 43.2822C120.293 43.2987 120.329 43.3164 120.365 43.3328C120.366 43.5023 120.369 43.6719 120.37 43.8414C119.451 43.8402 118.532 43.839 117.613 43.8378C117.613 43.6848 117.613 43.5318 117.613 43.3787C117.612 43.3787 117.608 43.3564 117.608 43.3564Z"
        fill="#F1F1F1"
      />
      <path
        d="M69.6554 39.6156C69.6495 38.8469 69.6436 38.0783 69.6377 37.3096C69.786 37.0412 69.9343 36.7728 70.0827 36.5056C70.1097 36.701 70.1368 36.8964 70.1627 37.0918C70.1545 37.9323 70.1474 38.7716 70.1392 39.6121C69.9849 39.6132 69.8296 39.6132 69.6754 39.6144L69.6554 39.6156Z"
        fill="#CFE3E7"
      />
      <path
        d="M89.4262 34.3855C88.8965 34.382 88.3656 34.3796 87.8359 34.3761C87.843 34.1007 87.8501 33.824 87.8571 33.5486C88.3786 33.5498 88.9012 33.5509 89.4227 33.5521C89.4298 33.824 89.4368 34.0948 89.4439 34.3667L89.4262 34.3855Z"
        fill={fill}
      />
      <path
        d="M132.795 68.0172C132.542 68.0172 132.29 68.016 132.037 68.016L132.017 68.0184C132.018 67.119 132.018 66.2197 132.019 65.3204C132.028 65.3121 132.037 65.3039 132.046 65.2957C132.104 65.3463 132.2 65.3875 132.214 65.4487C132.414 66.3033 132.603 67.1602 132.795 68.0172Z"
        fill={fill}
      />
      <path
        d="M39.2461 70.5481C39.2461 71.3509 39.2473 72.1525 39.2473 72.9553C39.0719 72.9565 38.8953 72.9565 38.7199 72.9576C38.7199 72.1537 38.7199 71.3509 38.7188 70.5469L38.7376 70.5516C38.9 70.5516 39.0625 70.5528 39.2237 70.5528L39.2461 70.5481Z"
        fill="#F1F1F1"
      />
      <path
        d="M7.77832 72.954C7.7795 72.1524 7.78067 71.3508 7.78067 70.5491L7.80304 70.5515C7.96548 70.5503 8.12793 70.5503 8.29037 70.5491L8.30803 70.5444C8.30685 71.3484 8.30685 72.1536 8.30567 72.9575C8.13028 72.9575 7.95371 72.9552 7.77832 72.954Z"
        fill="#F1EFEF"
      />
      <path
        d="M80.4873 70.5469C80.4873 71.3497 80.4873 72.1537 80.4873 72.9565C80.3119 72.9565 80.1354 72.9553 79.96 72.9553C79.96 72.1525 79.96 71.3497 79.96 70.5469L79.9811 70.5504C80.1436 70.5504 80.306 70.5504 80.4685 70.5504C80.4673 70.5504 80.4873 70.5469 80.4873 70.5469Z"
        fill="#F1F1F1"
      />
      <path
        d="M111.426 70.5504C111.427 71.352 111.428 72.1524 111.429 72.9541C111.254 72.9564 111.077 72.9576 110.902 72.9599C110.901 72.1548 110.901 71.3508 110.899 70.5457L110.916 70.5504C111.078 70.5515 111.24 70.5527 111.402 70.5527L111.426 70.5504Z"
        fill="#F1EFEF"
      />
      <path
        d="M121.731 70.5457C121.73 71.3496 121.73 72.1536 121.729 72.9576C121.553 72.9564 121.377 72.9552 121.201 72.9541C121.202 72.1524 121.202 71.3508 121.204 70.5492L121.226 70.5515C121.388 70.5504 121.551 70.5504 121.713 70.5492L121.731 70.5457Z"
        fill="#F1EFEF"
      />
      <path
        d="M24.8227 38.4656C24.8262 38.8481 24.8298 39.2307 24.8321 39.6133C24.1247 39.6133 23.4172 39.6121 22.7109 39.6121C23.4149 39.2295 24.1188 38.8481 24.8227 38.4656Z"
        fill="#B3D6DD"
      />
      <path
        d="M91.6079 28.0326C91.6138 28.4646 91.6197 28.8966 91.6244 29.3286L91.6068 29.3263C91.336 29.3263 91.0653 29.3263 90.7946 29.3263C90.7934 28.7553 90.7922 28.1844 90.791 27.6135C91.0629 27.7524 91.336 27.8925 91.6079 28.0326Z"
        fill={fill}
      />
      <path
        d="M87.9182 32.1973C88.422 32.1984 88.9258 32.1996 89.4296 32.202L89.4473 32.222C89.4414 32.4927 89.4367 32.7635 89.4308 33.033C88.9223 33.0319 88.4138 33.0319 87.9053 33.0307C87.9088 32.7517 87.9135 32.4751 87.9182 32.1973Z"
        fill={fill}
      />
      <path
        d="M40.0589 30.488C40.066 31.0578 40.0742 31.6275 40.0813 32.1984L40.0636 32.2161C39.7905 32.2102 39.5163 32.2043 39.2432 32.1984C39.2455 31.7699 39.2467 31.3403 39.249 30.9118C39.5198 30.7694 39.7894 30.6293 40.0589 30.488Z"
        fill={fill}
      />
      <path
        d="M4.66028 63.9622C5.42306 63.9622 6.18466 63.9633 6.94744 63.9633V63.9622C6.94626 64.1352 6.94509 64.3071 6.94273 64.4801H6.94156C6.14229 64.4813 5.34419 64.4813 4.54492 64.4824C4.58377 64.3094 4.62261 64.1364 4.66028 63.9622Z"
        fill="#F1EFEF"
      />
      <path
        d="M129.464 54.9711C128.964 54.9864 128.464 55.0017 127.965 55.017V54.9876C127.963 54.7121 127.96 54.4367 127.958 54.1601C128.376 54.1589 128.794 54.1589 129.212 54.1577C129.295 54.4296 129.38 54.7004 129.464 54.9711Z"
        fill={fill}
      />
      <path
        d="M59.3525 30.136C59.515 29.8417 59.6762 29.5462 59.8387 29.252C59.841 29.2767 59.8434 29.3002 59.8446 29.3249C59.8399 30.2819 59.8363 31.2401 59.8316 32.1971C59.6774 32.1995 59.5232 32.2018 59.3702 32.2042C59.3643 31.5156 59.3584 30.8258 59.3525 30.136Z"
        fill="#F1F0F0"
      />
      <path
        d="M70.1633 37.092C70.1362 36.8966 70.1091 36.7012 70.082 36.5058C70.3751 36.0608 70.6671 35.6159 70.9602 35.1709C70.9778 35.4099 71.0049 35.65 71.0108 35.889C71.0214 36.288 71.0179 36.687 71.0202 37.0861L70.9955 37.0849C70.7177 37.0884 70.4411 37.0896 70.1633 37.092Z"
        fill={fill}
      />
      <path
        d="M79.1266 29.3228C79.1301 29.9349 79.1337 30.547 79.1337 31.1591C79.1337 31.212 79.1019 31.2638 79.0854 31.3168C78.7311 30.6529 78.3768 29.989 78.0225 29.3251C78.3897 29.3251 78.7582 29.3239 79.1266 29.3228Z"
        fill="#F1EFEF"
      />
      <path
        d="M72.2559 33.0318C72.4242 32.7564 72.5925 32.4809 72.7608 32.2043C73.1399 32.2019 73.5189 32.1984 73.8991 32.196L73.8968 32.2161C73.898 32.4856 73.8991 32.7552 73.8991 33.0259C73.8791 33.033 73.8591 33.04 73.8391 33.0459C73.3117 33.0412 72.7844 33.0365 72.2559 33.0318Z"
        fill={fill}
      />
      <path
        d="M59.3529 30.1362C59.3588 30.826 59.3646 31.5146 59.3705 32.2044C59.0974 32.2068 58.8232 32.208 58.5501 32.2103L58.5359 32.1939C58.5206 32.022 58.5065 31.8513 58.4912 31.6795C58.7773 31.165 59.0645 30.6506 59.3529 30.1362Z"
        fill={fill}
      />
      <path
        d="M59.8483 70.5435C59.8471 71.3486 59.8459 72.1549 59.8447 72.9601C59.6858 72.9601 59.5269 72.9601 59.3668 72.9601C59.3656 72.1549 59.3645 71.3486 59.3633 70.5435L59.3786 70.547C59.5304 70.547 59.6823 70.547 59.8341 70.547L59.8483 70.5435Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.6079 70.5434C18.6067 71.3485 18.6055 72.1549 18.6043 72.96C18.4431 72.9612 18.283 72.9624 18.1217 72.9635C18.1182 72.156 18.1147 71.3485 18.1123 70.541L18.1311 70.5445C18.2853 70.5457 18.4395 70.5469 18.5926 70.5469C18.5926 70.5481 18.6079 70.5434 18.6079 70.5434Z"
        fill="#F1F1F1"
      />
      <path
        d="M90.7907 70.5433C90.7895 71.3485 90.7884 72.1536 90.7872 72.96C90.6259 72.9611 90.4635 72.9635 90.3022 72.9647C90.2975 72.156 90.2928 71.3485 90.2881 70.5398L90.3105 70.5422C90.4658 70.5433 90.6212 70.5457 90.7754 70.5469L90.7907 70.5433Z"
        fill="#F1F1F1"
      />
      <path
        d="M100.608 72.9601C100.607 72.1549 100.606 71.3486 100.604 70.5435L100.62 70.547C100.772 70.547 100.923 70.547 101.075 70.547L101.091 70.5435C101.089 71.3486 101.088 72.1549 101.087 72.9601C100.926 72.9601 100.767 72.9601 100.608 72.9601Z"
        fill="#F1F1F1"
      />
      <path
        d="M49.5472 70.5445C49.546 71.3497 49.5448 72.1549 49.5448 72.96C49.3824 72.9624 49.2211 72.9647 49.0587 72.9671C49.0528 72.1584 49.0469 71.3497 49.041 70.541L49.0669 70.5422C49.2223 70.5445 49.3765 70.5469 49.5319 70.5492C49.5307 70.5492 49.5472 70.5445 49.5472 70.5445Z"
        fill="#F1F0F0"
      />
      <path
        d="M132.032 70.5434C132.031 71.3485 132.03 72.1537 132.029 72.96C131.867 72.9612 131.706 72.9624 131.545 72.9635C131.541 72.156 131.538 71.3485 131.534 70.541L131.554 70.5445C131.708 70.5457 131.863 70.5469 132.017 70.5481L132.032 70.5434Z"
        fill="#F1F1F1"
      />
      <path
        d="M69.6627 72.96C69.6615 72.1549 69.6604 71.3497 69.6592 70.5445L69.6745 70.5492C69.8299 70.5469 69.9852 70.5457 70.1394 70.5434L70.163 70.541C70.1583 71.3497 70.1524 72.1584 70.1477 72.9671C69.9864 72.9635 69.8252 72.9624 69.6627 72.96Z"
        fill="#F1F0F0"
      />
      <path
        d="M28.4215 72.96C28.4203 72.1548 28.4191 71.3485 28.418 70.5433L28.4333 70.5469C28.5875 70.5457 28.7429 70.5445 28.8971 70.5433L28.9182 70.5398C28.9135 71.3473 28.91 72.156 28.9053 72.9635C28.744 72.9635 28.5828 72.9611 28.4215 72.96Z"
        fill="#F1F1F1"
      />
      <path
        d="M127.963 52.8216C127.965 52.0211 127.966 51.2218 127.969 50.4214C128.251 51.2159 128.533 52.0093 128.815 52.8039C128.531 52.8086 128.247 52.8145 127.963 52.8216Z"
        fill="#F1EFEF"
      />
      <path
        d="M73.8971 32.196C73.518 32.1983 73.139 32.2019 72.7588 32.2042C73.1366 31.5945 73.5157 30.9835 73.8935 30.3738C73.8947 30.9812 73.8959 31.5886 73.8971 32.196Z"
        fill="#F1EFEF"
      />
      <path
        d="M65.0858 34.3704C64.5726 34.3763 64.0593 34.3833 63.5449 34.3892L63.5484 34.3739C63.5473 34.1032 63.5473 33.8324 63.5461 33.5617C63.8816 33.5393 64.2182 33.5158 64.5537 33.4934C64.7315 33.7865 64.9092 34.0784 65.0858 34.3704Z"
        fill={fill}
      />
      <path
        d="M55.7799 22.732C56.4721 22.7261 57.163 22.7202 57.8552 22.7144C57.9564 22.8556 58.0576 22.998 58.1589 23.1393C58.0518 23.1652 57.9458 23.2123 57.8375 23.2146C57.1501 23.2288 56.4626 23.2335 55.7764 23.2405V23.2135C55.7787 23.0581 55.7811 22.9027 55.7846 22.7473C55.7846 22.7485 55.7799 22.732 55.7799 22.732Z"
        fill="#F1EFEF"
      />
      <path
        d="M48.473 29.3263C48.5153 30.2857 48.5577 31.245 48.5989 32.2044C48.4624 32.2056 48.327 32.2068 48.1905 32.2079C48.1881 31.2462 48.1857 30.2857 48.1846 29.324C48.1846 29.324 48.2093 29.3263 48.2081 29.3263C48.2976 29.3263 48.3859 29.3263 48.473 29.3263Z"
        fill={fill}
      />
      <path
        d="M51.193 22.7366C51.8804 22.7355 52.5667 22.7331 53.2541 22.7319L53.2494 22.7484C53.2518 22.9038 53.2541 23.058 53.2565 23.2134L53.2577 23.2393C52.5867 23.2322 51.9169 23.2251 51.246 23.2169C51.1388 23.2157 51.0317 23.2098 50.9258 23.2063C51.0141 23.0509 51.1035 22.8944 51.193 22.7366Z"
        fill="#F1EFEF"
      />
      <path
        d="M81.3215 39.6167C81.3192 38.9834 81.3168 38.3513 81.3145 37.718C81.6641 38.3501 82.0125 38.9834 82.3621 39.6155C82.0148 39.6167 81.6676 39.6167 81.3215 39.6167Z"
        fill="#CFE2E5"
      />
      <path
        d="M53.2549 37.0895C53.6021 37.0883 53.9494 37.0871 54.2966 37.0859C53.9506 37.7169 53.6033 38.3478 53.2572 38.9799C53.2572 38.3502 53.2561 37.7192 53.2549 37.0895Z"
        fill="#B3D6DD"
      />
      <path
        d="M49.5428 48.1415C49.5463 48.7301 49.5498 49.3186 49.5522 49.9072L49.5298 49.906C49.3744 49.9048 49.2191 49.9025 49.0625 49.9013C49.0637 49.0797 49.0649 48.2592 49.066 47.4376C49.1425 47.4364 49.2191 47.4352 49.2967 47.4329C49.3191 47.7271 49.3403 48.0214 49.365 48.3534C49.4415 48.2651 49.4922 48.2027 49.5428 48.1415Z"
        fill="#CFE2E5"
      />
      <path
        d="M79.1302 24.0963C78.6806 24.094 78.2309 24.0905 77.7812 24.0881C77.9743 23.7738 78.1685 23.4583 78.3616 23.144C78.6217 23.1688 78.8819 23.1923 79.142 23.217C79.1444 23.5042 79.1479 23.7926 79.1502 24.0799L79.1302 24.0963Z"
        fill={fill}
      />
      <path
        d="M89.4361 43.8533C88.7546 43.8485 88.0718 43.8438 87.3903 43.8391C87.3867 43.6873 87.3832 43.5343 87.3809 43.3824C88.0683 43.3765 88.7546 43.3706 89.442 43.3647L89.4479 43.3695C89.4444 43.5307 89.4408 43.6908 89.4361 43.8533Z"
        fill="#F1F1F1"
      />
      <path
        d="M80.4907 19.7375C80.4883 20.4603 80.486 21.1819 80.4836 21.9046V21.907C80.3153 21.9035 80.147 21.8999 79.9786 21.8964C79.9692 21.4679 79.9598 21.0406 79.9492 20.6122C80.1305 20.3214 80.3106 20.0295 80.4907 19.7375Z"
        fill="#F1EFEF"
      />
      <path
        d="M49.9414 37.0954C50.0815 37.093 50.2216 37.0895 50.3616 37.0872C50.3687 37.9312 50.3758 38.7752 50.3828 39.618L50.364 39.6145C50.2651 39.6145 50.1662 39.6145 50.0674 39.6145C50.0521 39.4909 50.0262 39.3673 50.0215 39.2425C49.9932 38.5268 49.9685 37.8111 49.9414 37.0954Z"
        fill={fill}
      />
      <path
        d="M72.2527 33.032C72.7812 33.0367 73.3086 33.0414 73.8371 33.0461C73.8371 33.2121 73.8371 33.3792 73.8371 33.5452C73.2709 33.5476 72.7036 33.5534 72.1374 33.5511C72.075 33.5511 72.0126 33.5158 71.9502 33.4958C72.0514 33.3416 72.1527 33.1862 72.2527 33.032Z"
        fill="#F1EFEF"
      />
      <path
        d="M6.90256 55.3843C6.91786 55.4961 6.94729 55.6079 6.94729 55.7198C6.94846 56.3884 6.94258 57.0582 6.94022 57.7268C6.70715 57.7268 6.47526 57.7256 6.24219 57.7256C6.45054 56.9922 6.65771 56.2577 6.86607 55.5243C6.87784 55.4773 6.88961 55.4314 6.90256 55.3843Z"
        fill="#F1EFEF"
      />
      <path
        d="M28.9149 37.0893C28.8843 36.828 28.8536 36.5667 28.8242 36.3065C29.1185 36.1629 29.414 36.0193 29.7082 35.8745C29.7283 36.1711 29.7494 36.4678 29.7671 36.7656C29.773 36.8727 29.7718 36.9798 29.773 37.087H29.7459C29.4681 37.087 29.1915 37.0881 28.9149 37.0893Z"
        fill={fill}
      />
      <path
        d="M107.318 37.0857C107.32 36.769 107.321 36.4524 107.321 36.1357C107.913 36.4512 108.504 36.7679 109.096 37.0833C108.504 37.0833 107.91 37.0845 107.318 37.0857Z"
        fill="#F1EFEF"
      />
      <path
        d="M111.454 38.3677C111.723 38.503 111.991 38.6396 112.26 38.775C112.262 39.0563 112.264 39.3365 112.267 39.6178L112.251 39.6131C111.979 39.6131 111.707 39.6143 111.436 39.6143C111.441 39.1987 111.448 38.7832 111.454 38.3677Z"
        fill={fill}
      />
      <path
        d="M90.7919 27.6134C90.7931 28.1843 90.7943 28.7552 90.7954 29.3261L90.7754 29.3238C90.6224 29.325 90.4682 29.325 90.3152 29.3261H90.2881C90.2975 28.6728 90.3069 28.0195 90.3163 27.3662C90.4741 27.4486 90.633 27.531 90.7919 27.6134Z"
        fill="#CFE3E7"
      />
      <path
        d="M127.964 52.8216C128.248 52.8157 128.531 52.8098 128.816 52.804C128.905 53.0935 128.993 53.3819 129.081 53.6715C128.708 53.668 128.336 53.6644 127.963 53.6609C127.963 53.3902 127.964 53.1194 127.964 52.8475V52.8216Z"
        fill={fill}
      />
      <path
        d="M87.9022 33.0295C88.4107 33.0307 88.9192 33.0307 89.4277 33.0319V33.0307C89.4265 33.2049 89.4254 33.378 89.4242 33.5522H89.423C88.9015 33.551 88.3789 33.5498 87.8574 33.5487C87.8727 33.3756 87.8869 33.2026 87.9022 33.0295Z"
        fill="#F1EFEF"
      />
      <path
        d="M55.7811 32.196C56.1601 32.2066 56.5403 32.2184 56.9194 32.229C56.7557 32.5151 56.5933 32.8011 56.4297 33.0871C56.2143 33.0871 55.9977 33.0871 55.7823 33.0871C55.7787 33.0718 55.7775 33.0554 55.7764 33.0401C55.7787 32.7658 55.7799 32.4903 55.7823 32.2161L55.7811 32.196Z"
        fill={fill}
      />
      <path
        d="M85.1904 42.4996C85.5801 42.4961 85.9709 42.4925 86.3605 42.489C86.3428 42.7868 86.324 43.0846 86.3063 43.3825C86.0945 43.3813 85.8826 43.3801 85.6707 43.3789C85.5094 43.0858 85.3493 42.7927 85.1904 42.4996Z"
        fill={fill}
      />
      <path
        d="M48.2037 42.5029C48.4992 42.5065 48.7946 42.51 49.0901 42.5135C49.083 42.8031 49.076 43.0927 49.0689 43.3822C48.7829 43.3752 48.4968 43.3681 48.2108 43.3622C48.2073 43.0786 48.2037 42.7937 48.2002 42.51L48.2037 42.5029Z"
        fill={outline}
      />
      <path
        d="M49.0795 43.7283C49.1148 43.8319 49.1796 43.9366 49.1807 44.0402C49.1831 44.2474 49.1525 44.4557 49.1348 44.6629C49.116 44.67 49.0972 44.6735 49.0772 44.6747C48.7852 44.67 48.4921 44.6664 48.2002 44.6617C48.2014 44.3945 48.2025 44.1273 48.2037 43.8601C48.3862 43.8554 48.571 43.8648 48.7523 43.8424C48.8641 43.8295 48.97 43.7683 49.0795 43.7283Z"
        fill={outline}
      />
      <path
        d="M52.1895 43.3104C52.3284 43.0385 52.4673 42.7666 52.605 42.4958C52.8192 42.497 53.0346 42.497 53.2489 42.4982L53.2477 42.5253C53.25 42.8019 53.2524 43.0785 53.2559 43.3552C52.9004 43.3399 52.5449 43.3257 52.1895 43.3104Z"
        fill={fill}
      />
      <path
        d="M17.2524 43.8569C16.6945 43.8545 16.1365 43.8545 15.5786 43.8475C15.4879 43.8463 15.3973 43.811 15.3066 43.7922C15.5574 43.6485 15.8081 43.5049 16.0588 43.3613C16.4579 43.3672 16.8557 43.3719 17.2548 43.3778C17.2548 43.5367 17.2548 43.6968 17.2548 43.8557L17.2524 43.8569Z"
        fill="#F1EFEF"
      />
      <path
        d="M111.452 38.3677C111.447 38.7832 111.44 39.1987 111.434 39.6143C111.424 39.6143 111.414 39.6143 111.404 39.6154C111.242 39.6154 111.079 39.6154 110.917 39.6154L110.895 39.6166C110.898 39.2011 110.897 38.7844 110.907 38.3689C110.91 38.2688 110.949 38.1711 110.971 38.071C111.132 38.1699 111.292 38.2688 111.452 38.3677Z"
        fill="#D5DBDB"
      />
      <path
        d="M84.8828 21.9033C85.0276 22.1799 85.1724 22.4565 85.3171 22.732C84.9428 22.7308 84.5673 22.7296 84.193 22.7284C84.193 22.4589 84.1942 22.1881 84.1942 21.9186L84.1895 21.9021C84.4202 21.9033 84.6509 21.9033 84.8828 21.9033Z"
        fill={fill}
      />
      <path
        d="M87.0666 26.7954C87.0277 27.6394 86.9901 28.4822 86.9512 29.3262C86.8759 29.3251 86.8005 29.3239 86.724 29.3227C86.7229 28.4822 86.7229 27.6418 86.7217 26.8013L86.7264 26.7966C86.8394 26.7954 86.9524 26.7954 87.0666 26.7954Z"
        fill="#CFE2E5"
      />
      <path
        d="M79.96 37.0859C79.9635 36.4997 79.9682 35.9135 79.9717 35.3284C79.9859 35.3273 80 35.3261 80.0141 35.3237C80.1789 35.6333 80.3437 35.9417 80.5073 36.2513C80.5014 36.5303 80.4967 36.8093 80.4908 37.0871L80.4708 37.0824C80.3072 37.0824 80.1448 37.0824 79.9811 37.0824L79.96 37.0859Z"
        fill="#F1EFEF"
      />
      <path
        d="M50.0645 39.6143C50.1633 39.6143 50.2622 39.6143 50.3611 39.6143C50.3646 40.5724 50.3693 41.5318 50.3729 42.49L50.3505 42.5076C50.2963 42.5041 50.241 42.5018 50.1869 42.4982C50.1457 41.5377 50.1057 40.576 50.0645 39.6143Z"
        fill={fill}
      />
      <path
        d="M48.4743 29.3262C48.386 29.3262 48.2977 29.3262 48.2106 29.3262C48.2036 28.4834 48.1965 27.6406 48.1895 26.7966C48.1895 26.6506 48.1895 26.5058 48.1895 26.3599C48.2377 26.3387 48.2872 26.3163 48.3672 26.281C48.4037 27.3181 48.439 28.3222 48.4743 29.3262Z"
        fill={fill}
      />
      <path
        d="M59.8457 29.3249C59.8434 29.3002 59.841 29.2767 59.8398 29.2519C60.1059 28.7787 60.3707 28.3067 60.6368 27.8335C60.6474 28.2267 60.6591 28.6186 60.6709 29.0118C60.6744 29.1177 60.6827 29.2225 60.6886 29.3273L60.6697 29.3261C60.3943 29.3273 60.12 29.3261 59.8457 29.3249Z"
        fill={fill}
      />
      <path
        d="M17.3027 42.6748C17.3957 42.6147 17.4899 42.5559 17.5829 42.4958C17.7606 42.4982 17.9384 42.5017 18.1161 42.5041L18.1197 42.5088C18.1161 42.7937 18.1126 43.0774 18.1079 43.3622C17.843 43.3658 17.5794 43.3693 17.3145 43.374C17.3098 43.1409 17.3063 42.9078 17.3027 42.6748Z"
        fill={outline}
      />
      <path
        d="M112.267 39.6168C112.264 39.3354 112.262 39.0553 112.26 38.7739C112.774 39.0517 113.29 39.3295 113.804 39.6073C113.292 39.6109 112.779 39.6144 112.267 39.6168Z"
        fill="#CFE2E5"
      />
      <path
        d="M37.8957 31.5967C38.1653 31.4625 38.4349 31.3283 38.7044 31.1941C38.7115 31.5296 38.7185 31.8651 38.7256 32.2005C38.4525 32.2052 38.1794 32.2111 37.9063 32.2158L37.8887 32.1982C37.8922 31.9969 37.8934 31.7968 37.8957 31.5967Z"
        fill={fill}
      />
      <path
        d="M19.4013 41.479C19.4095 41.8168 19.4177 42.1547 19.426 42.4925L19.4071 42.5113C19.1435 42.5113 18.8786 42.5113 18.6149 42.5102L18.5961 42.4925C18.5949 42.3006 18.5938 42.1088 18.5938 41.9169C18.8621 41.7709 19.1317 41.625 19.4013 41.479Z"
        fill={fill}
      />
      <path
        d="M50.3749 42.49C50.6927 42.4994 51.0106 42.51 51.3272 42.5194C51.1742 42.8055 51.0211 43.0927 50.8681 43.3787C50.701 43.3775 50.5338 43.3775 50.3667 43.3764C50.362 43.0868 50.3572 42.7972 50.3525 42.5077L50.3749 42.49Z"
        fill={fill}
      />
      <path
        d="M133.369 70.5471C133.201 70.5483 133.034 70.5495 132.867 70.5518C132.877 69.8291 132.886 69.1063 132.895 68.3835C133.053 69.1051 133.211 69.8267 133.369 70.5471Z"
        fill="#D5DBDB"
      />
      <path
        d="M120.37 43.8413C120.369 43.6718 120.366 43.5023 120.365 43.3328C120.822 43.6011 121.28 43.8695 121.737 44.1379C121.735 44.3145 121.735 44.4911 121.734 44.6688C121.727 44.677 121.72 44.6841 121.713 44.6923C121.548 44.69 121.383 44.6876 121.219 44.6853C121.207 44.4251 121.294 44.059 121.159 43.9331C121.008 43.7942 120.654 43.8742 120.389 43.8589L120.37 43.8413Z"
        fill={fill}
      />
      <path
        d="M38.7233 32.1998C38.7163 31.8644 38.7092 31.5289 38.7021 31.1934C38.8834 31.0992 39.0647 31.0051 39.2472 30.9109C39.2448 31.3394 39.2436 31.769 39.2413 32.1975V32.1987C39.0682 32.1998 38.8964 32.201 38.7233 32.1998Z"
        fill="#F1EFEF"
      />
      <path
        d="M80.7854 34.382C80.6512 34.1383 80.517 33.8958 80.3828 33.6522C80.4134 33.618 80.444 33.5827 80.4746 33.5486C80.7548 33.5509 81.0361 33.5521 81.3163 33.5545L81.3175 33.5533C81.3163 33.8299 81.3139 34.1065 81.3127 34.3832V34.382C81.1362 34.382 80.9608 34.382 80.7854 34.382Z"
        fill={outline}
      />
      <path
        d="M59.3633 26.7978C59.3656 26.2457 59.3692 25.6925 59.3715 25.1404C59.5316 25.3958 59.6929 25.6513 59.853 25.9067C59.8577 26.2069 59.8624 26.5082 59.8671 26.8084L59.8518 26.8025C59.6941 26.8001 59.5363 26.7966 59.3786 26.7943C59.3774 26.7943 59.3633 26.7978 59.3633 26.7978Z"
        fill="#F1EFEF"
      />
      <path
        d="M8.25049 51.1465C8.26697 51.4443 8.28934 51.7421 8.29758 52.0411C8.30464 52.3048 8.29522 52.5696 8.29287 52.8333L8.29169 52.8357C8.12454 52.8333 7.95738 52.831 7.79023 52.8286C7.7608 52.8192 7.73255 52.8086 7.70312 52.7992C7.7149 52.7591 7.72667 52.7203 7.73844 52.6803C7.73491 52.6544 7.73138 52.6285 7.72667 52.6026C7.90088 52.1164 8.07627 51.6315 8.25049 51.1465Z"
        fill="#F1EFEF"
      />
      <path
        d="M84.1943 22.7297C84.5687 22.7309 84.9442 22.7321 85.3185 22.7333C85.408 22.8875 85.4974 23.0429 85.5869 23.1971C85.1243 23.2041 84.6617 23.21 84.199 23.2171C84.1979 23.0617 84.1967 22.9063 84.1955 22.7521C84.1967 22.7521 84.1943 22.7297 84.1943 22.7297Z"
        fill="#CFE2E5"
      />
      <path
        d="M52.1875 43.3105C52.543 43.3258 52.8984 43.34 53.2539 43.3553L53.2504 43.3765C53.2492 43.5318 53.2481 43.6861 53.2469 43.8414L53.2504 43.8567C52.8855 43.8544 52.5206 43.8556 52.1557 43.8461C52.0662 43.8438 51.9779 43.8073 51.8896 43.7873C51.9897 43.6284 52.0886 43.4695 52.1875 43.3105Z"
        fill="#F1F0F0"
      />
      <path
        d="M79.9468 20.6118C79.9562 21.0403 79.9656 21.4676 79.9762 21.8961C79.9692 21.9043 79.9633 21.9114 79.9562 21.9184C79.6831 21.9172 79.41 21.9149 79.1357 21.9137L79.1393 21.9161C79.4088 21.4817 79.6772 21.0474 79.9468 20.6118Z"
        fill={fill}
      />
      <path
        d="M85.0876 44.6597C84.7886 44.6702 84.4884 44.6797 84.1895 44.6903L84.193 44.6714C84.1942 44.3995 84.1942 44.1288 84.1953 43.8568L84.1918 43.8416C84.3472 43.8427 84.5026 43.8427 84.658 43.8439C84.8016 44.1158 84.9452 44.3877 85.0876 44.6597Z"
        fill={fill}
      />
      <path
        d="M127.962 53.6599C128.335 53.6634 128.707 53.667 129.08 53.6705C129.123 53.8329 129.168 53.9954 129.212 54.1578C128.794 54.159 128.376 54.159 127.958 54.1602L127.96 54.1402C127.962 53.9848 127.963 53.8306 127.964 53.6752L127.962 53.6599Z"
        fill="#F1F0F0"
      />
      <path
        d="M118.963 42.496C118.514 42.496 118.064 42.496 117.614 42.496C117.614 42.2393 117.614 41.9839 117.614 41.7273C118.064 41.9839 118.514 42.2405 118.963 42.496Z"
        fill="#F1EFEF"
      />
      <path
        d="M7.77001 55.0197C7.53105 55.0126 7.29092 55.0055 7.05078 54.9985C7.132 54.7124 7.2144 54.4252 7.29562 54.1392C7.45218 54.1415 7.60756 54.1451 7.76412 54.1474C7.76648 54.4382 7.76883 54.7289 7.77001 55.0197Z"
        fill={outline}
      />
      <path
        d="M4.1857 68.0148C4.02914 68.016 3.8714 68.016 3.71484 68.016C3.86669 67.358 4.01972 66.6988 4.17157 66.0408C4.17628 66.6988 4.18099 67.3568 4.1857 68.0148Z"
        fill="#CFE2E5"
      />
      <path
        d="M49.7266 32.1997C49.942 32.1997 50.1562 32.2009 50.3716 32.2009C50.3693 32.4752 50.3657 32.7494 50.3634 33.0249C50.168 33.0261 49.9726 33.0272 49.7772 33.0284C49.7595 32.753 49.743 32.4763 49.7266 32.1997Z"
        fill={outline}
      />
      <path
        d="M126.456 47.4292C126.116 47.4304 125.776 47.4327 125.437 47.4339C125.439 47.1373 125.44 46.8418 125.442 46.5452C125.779 46.8394 126.117 47.1337 126.456 47.4292Z"
        fill="#CFE2E5"
      />
      <path
        d="M99.7741 32.1983C100.054 32.3396 100.333 32.482 100.613 32.6233C100.615 32.761 100.615 32.8987 100.616 33.0353H100.615C100.338 33.0329 100.061 33.0306 99.7847 33.0282C99.7741 32.7481 99.7635 32.4679 99.7529 32.1877L99.7741 32.1983Z"
        fill={outline}
      />
      <path
        d="M58.5433 33.0294C58.5256 33.0482 58.5068 33.067 58.4891 33.0859C58.2502 33.0835 58.0124 33.0812 57.7734 33.08C57.9182 32.7857 58.0618 32.4926 58.2066 32.1983C58.3161 32.1971 58.4244 32.1948 58.5339 32.1936L58.548 32.2101C58.5456 32.4832 58.5445 32.7563 58.5433 33.0294Z"
        fill={fill}
      />
      <path
        d="M86.7217 29.3218C86.797 29.323 86.8724 29.3241 86.9489 29.3253C86.9077 30.2823 86.8676 31.2393 86.8264 32.1963C86.7911 32.1975 86.7558 32.1987 86.7217 32.201C86.7217 31.2417 86.7217 30.2823 86.7217 29.3218Z"
        fill="#F1EFEF"
      />
      <path
        d="M49.0787 44.6761C49.0987 44.6749 49.1175 44.6714 49.1363 44.6643C49.1599 44.8315 49.1975 44.9986 49.2058 45.1669C49.2423 45.9227 49.2694 46.6784 49.3 47.4341C49.2234 47.4353 49.1469 47.4364 49.0692 47.4388L49.0469 47.4411C49.0528 47.3258 49.0634 47.2093 49.0645 47.0939C49.0704 46.2876 49.0739 45.4812 49.0787 44.6761Z"
        fill="#F1EFEF"
      />
      <path
        d="M17.3022 42.675C17.3058 42.9081 17.3093 43.1412 17.314 43.3743C17.2928 43.3754 17.2728 43.3754 17.2516 43.3766C16.8526 43.3707 16.4547 43.366 16.0557 43.3601C16.4712 43.1318 16.8867 42.9034 17.3022 42.675Z"
        fill={fill}
      />
      <path
        d="M50.369 34.3857C50.1889 34.3845 50.01 34.3821 49.8299 34.3809C49.8146 34.1043 49.8005 33.8289 49.7852 33.5522C49.977 33.5558 50.1677 33.5605 50.3596 33.564C50.3631 33.8371 50.3655 34.1114 50.369 34.3857Z"
        fill={outline}
      />
      <path
        d="M84.8828 21.9032C84.6521 21.9032 84.4202 21.902 84.1895 21.902C84.1942 21.4853 84.1989 21.0698 84.2048 20.6531C84.4296 21.0698 84.6556 21.4865 84.8828 21.9032Z"
        fill="#CFE2E5"
      />
      <path
        d="M64.5525 33.4944C64.2171 33.5168 63.8804 33.5403 63.5449 33.5627L63.5461 33.5368C63.5461 33.3767 63.5461 33.2166 63.5461 33.0565L63.5449 33.0283C63.7674 33.0189 63.9887 33.0106 64.2112 33.0012C64.3254 33.166 64.4395 33.3296 64.5525 33.4944Z"
        fill="#CFE2E5"
      />
      <path
        d="M87.0677 26.7954C86.9547 26.7954 86.8417 26.7954 86.7275 26.7954C86.7287 26.3174 86.7311 25.8407 86.7322 25.3628C86.8394 25.4817 86.9559 25.5935 87.0501 25.7218C87.0948 25.783 87.1172 25.876 87.1148 25.9537C87.1077 26.235 87.0842 26.514 87.0677 26.7954Z"
        fill="#F1EFEF"
      />
      <path
        d="M80.0681 33.0916C80.0269 32.9763 79.9857 32.8609 79.9434 32.7455C79.9457 32.5678 79.9492 32.3901 79.9516 32.2123C79.9587 32.2052 79.9645 32.1982 79.9716 32.1899C80.1411 32.1935 80.3118 32.197 80.4813 32.2005C80.4837 32.476 80.486 32.7514 80.4895 33.0269C80.4813 33.0339 80.4731 33.041 80.4648 33.0481C80.3318 33.0622 80.2 33.0763 80.0681 33.0916Z"
        fill={fill}
      />
      <path
        d="M48.7156 34.3877C48.5426 34.3854 48.3695 34.3819 48.1953 34.3795V34.3783C48.1977 34.1088 48.2012 33.838 48.2036 33.5685C48.3566 33.5649 48.5096 33.5614 48.6626 33.5579C48.6803 33.8345 48.6979 34.1111 48.7156 34.3877Z"
        fill={outline}
      />
      <path
        d="M57.7765 33.0801C58.0154 33.0824 58.2532 33.0848 58.4921 33.086C58.4921 33.2296 58.4921 33.3732 58.4921 33.5568C58.1343 33.5568 57.8153 33.5568 57.4951 33.5568C57.5893 33.3991 57.6835 33.239 57.7765 33.0801Z"
        fill="#F1EFEF"
      />
      <path
        d="M66.7691 37.0857C66.5372 37.0857 66.3053 37.0857 66.0734 37.0857C66.0734 36.7149 66.0734 36.343 66.0723 35.9722C66.3053 36.343 66.5372 36.7149 66.7691 37.0857Z"
        fill="#F1EFEF"
      />
      <path
        d="M49.078 43.7284C48.9685 43.7684 48.8626 43.8296 48.7508 43.8437C48.5695 43.8661 48.3859 43.8579 48.2022 43.8614L48.1846 43.8437C48.1857 43.6884 48.1881 43.533 48.1893 43.3788L48.2081 43.3623C48.4942 43.3694 48.7802 43.3764 49.0662 43.3835C49.0698 43.4977 49.0733 43.613 49.078 43.7284Z"
        fill={fill}
      />
      <path
        d="M53.2503 42.4981C53.0361 42.4969 52.8207 42.4969 52.6064 42.4957C52.8219 42.1061 53.0373 41.7153 53.2527 41.3257C53.2515 41.7153 53.2515 42.1061 53.2503 42.4981Z"
        fill="#F1EFEF"
      />
      <path
        d="M131.968 64.4884C131.995 64.758 132.021 65.0263 132.048 65.2959C132.038 65.3041 132.029 65.3124 132.021 65.3206C131.865 65.3171 131.71 65.3124 131.556 65.3089C131.558 65.0346 131.562 64.7591 131.564 64.4849C131.698 64.4849 131.832 64.4872 131.968 64.4884Z"
        fill={fill}
      />
      <path
        d="M64.2124 33.0013C63.9899 33.0108 63.7686 33.019 63.5461 33.0284C63.5461 32.7565 63.5449 32.4846 63.5449 32.2127C63.6108 32.2103 63.6768 32.2091 63.7415 32.2068C63.8981 32.4728 64.0546 32.7377 64.2124 33.0013Z"
        fill={fill}
      />
      <path
        d="M48.1953 32.2079C48.3319 32.2067 48.4672 32.2055 48.6038 32.2043C48.6203 32.4821 48.6367 32.76 48.6532 33.0378C48.5037 33.0319 48.353 33.026 48.2036 33.0201C48.2 32.7494 48.1977 32.4786 48.1953 32.2079Z"
        fill={outline}
      />
      <path
        d="M37.895 31.5972C37.8927 31.7973 37.8903 31.9986 37.888 32.1987C37.5183 32.1834 37.1499 32.1669 36.7803 32.1516C37.1522 31.9656 37.5242 31.7808 37.895 31.5972Z"
        fill="#F1EFEF"
      />
      <path
        d="M50.3511 42.5087C50.3558 42.7983 50.3605 43.0878 50.3652 43.3774C50.4253 43.5481 50.1569 43.8812 50.6042 43.8588C50.5065 44.0543 50.4076 44.2508 50.3099 44.4462C50.2864 44.4415 50.2628 44.4368 50.2393 44.4309C50.2216 43.787 50.204 43.1432 50.1875 42.4993C50.2416 42.5016 50.297 42.5052 50.3511 42.5087Z"
        fill={outline}
      />
      <path
        d="M83.6221 39.6165C83.8116 39.6165 84.0023 39.6165 84.1918 39.6165C84.1906 39.9578 84.1883 40.2992 84.1871 40.6394C83.9988 40.2992 83.8104 39.9578 83.6221 39.6165Z"
        fill="#F1EFEF"
      />
      <path
        d="M79.1398 23.2159C78.8797 23.1911 78.6195 23.1676 78.3594 23.1429C78.4547 23.0004 78.5501 22.858 78.6466 22.7156C78.809 22.7238 78.9703 22.7309 79.1327 22.7391H79.1316C79.1351 22.8969 79.1386 23.0546 79.141 23.2123L79.1398 23.2159Z"
        fill="#F1EFEF"
      />
      <path
        d="M50.3606 33.5629C50.1688 33.5593 49.9781 33.5546 49.7862 33.5511C49.7827 33.3769 49.7791 33.2026 49.7744 33.0284C49.9698 33.0273 50.1652 33.0261 50.3606 33.0249C50.3689 33.032 50.3771 33.0402 50.3853 33.0473C50.3842 33.2121 50.383 33.3769 50.3818 33.5417C50.3759 33.5487 50.3689 33.5558 50.3606 33.5629Z"
        fill={fill}
      />
      <path
        d="M28.4109 36.543C28.4121 36.7242 28.4132 36.9055 28.4144 37.088C28.1448 37.088 27.8741 37.0892 27.6045 37.0892C27.601 37.0515 27.5963 37.0138 27.5928 36.975C27.8659 36.8314 28.1378 36.6878 28.4109 36.543Z"
        fill={fill}
      />
      <path
        d="M80.7852 34.3821C80.9605 34.3821 81.1359 34.3821 81.3125 34.3833C81.3078 34.6999 81.3019 35.0166 81.2972 35.3332C81.1253 35.0154 80.9558 34.6987 80.7852 34.3821Z"
        fill={fill}
      />
      <path
        d="M55.7822 33.0884C55.9976 33.0884 56.2142 33.0884 56.4296 33.0884C56.3531 33.2485 56.2754 33.4086 56.1989 33.5686C56.06 33.5604 55.9211 33.551 55.7822 33.5427C55.7822 33.3909 55.7822 33.2391 55.7822 33.0884Z"
        fill="#F1EFEF"
      />
      <path
        d="M59.3752 26.7942C59.533 26.7965 59.6907 26.8001 59.8484 26.8024C59.6883 27.1155 59.5283 27.4287 59.3682 27.743C59.3717 27.4263 59.3741 27.1097 59.3752 26.7942Z"
        fill="#CFE2E5"
      />
      <path
        d="M89.158 26.7894C88.826 26.7906 88.4941 26.793 88.1621 26.7942C88.1621 26.6423 88.1621 26.4893 88.1621 26.2656C88.5353 26.4622 88.8472 26.6258 89.158 26.7894Z"
        fill="#F1EFEF"
      />
      <path
        d="M121.731 44.6678C121.733 44.4913 121.733 44.3147 121.734 44.137C121.99 44.31 122.247 44.4842 122.504 44.6573C122.246 44.662 121.989 44.6643 121.731 44.6678Z"
        fill={outline}
      />
      <path
        d="M48.2011 33.0188C48.3506 33.0247 48.5012 33.0306 48.6507 33.0365C48.6543 33.2095 48.6578 33.3825 48.6613 33.5567C48.5083 33.5603 48.3553 33.5638 48.2023 33.5673C48.1952 33.5603 48.1881 33.5532 48.1811 33.5462C48.1799 33.3778 48.1799 33.2095 48.1787 33.0412C48.1858 33.0341 48.194 33.027 48.2011 33.0188Z"
        fill={fill}
      />
      <path
        d="M85.6719 43.3787C85.8838 43.3798 86.0956 43.381 86.3075 43.3822C86.3052 43.534 86.304 43.6859 86.3016 43.8389C86.1839 43.8483 86.0674 43.8578 85.9497 43.8672C85.8579 43.7036 85.7649 43.5411 85.6719 43.3787Z"
        fill="#CFE2E5"
      />
      <path
        d="M79.1346 22.7402C78.9721 22.7319 78.8109 22.7249 78.6484 22.7166C78.8121 22.4494 78.9757 22.1834 79.1393 21.9162L79.1358 21.9138C79.1358 22.1893 79.1346 22.4647 79.1346 22.7402Z"
        fill={fill}
      />
      <path
        d="M80.4902 37.087C80.4961 36.808 80.5008 36.529 80.5067 36.2512C80.6621 36.5278 80.8187 36.8056 80.974 37.0823C80.8128 37.0835 80.6515 37.0858 80.4902 37.087Z"
        fill={fill}
      />
      <path
        d="M18.5914 41.9167C18.5926 42.1086 18.5937 42.3005 18.5937 42.4924C18.4348 42.4971 18.2771 42.503 18.1182 42.5077L18.1147 42.503C18.1135 42.3982 18.1135 42.2934 18.1123 42.1887C18.2724 42.0992 18.4313 42.0074 18.5914 41.9167Z"
        fill="#F1EFEF"
      />
      <path
        d="M131.966 64.4884C131.831 64.4872 131.697 64.486 131.562 64.4837C131.559 64.3083 131.558 64.1341 131.556 63.9587V63.9575C131.655 63.9575 131.753 63.9575 131.851 63.9575C131.89 64.1353 131.928 64.3118 131.966 64.4884Z"
        fill="#F1EFEF"
      />
      <path
        d="M7.7642 54.1471C7.60881 54.1448 7.45226 54.1412 7.29688 54.1389C7.33925 53.9835 7.38281 53.8281 7.42518 53.6727C7.53936 53.6692 7.65472 53.6669 7.7689 53.6633C7.77597 53.6716 7.78303 53.6786 7.79009 53.6869C7.79009 53.8328 7.79009 53.9788 7.78891 54.1248C7.78185 54.1318 7.77244 54.1401 7.7642 54.1471Z"
        fill={fill}
      />
      <path
        d="M48.1889 26.3608C48.1889 26.5068 48.1889 26.6516 48.1889 26.7976C47.9087 26.7952 47.6298 26.7928 47.3496 26.7905C47.6298 26.6469 47.9099 26.5044 48.1889 26.3608Z"
        fill="#F1EFEF"
      />
      <path
        d="M7.76853 53.6633C7.65435 53.6669 7.53899 53.6692 7.4248 53.6727C7.5178 53.382 7.61079 53.0912 7.70378 52.7993C7.73321 52.8087 7.76146 52.8182 7.79089 52.8287C7.78265 53.1065 7.77559 53.3855 7.76853 53.6633Z"
        fill={outline}
      />
      <path
        d="M49.5386 25.6868C49.5433 26.0564 49.548 26.4272 49.5527 26.7968C49.5351 27.0852 49.5162 27.3736 49.4986 27.6632C49.4727 27.0805 49.4421 26.4978 49.4268 25.9151C49.4256 25.8398 49.4998 25.7633 49.5386 25.6868Z"
        fill="#E4D4CD"
      />
      <path
        d="M131.852 63.9585C131.753 63.9585 131.654 63.9585 131.557 63.9585C131.553 63.6865 131.55 63.4158 131.545 63.1439C131.571 63.118 131.597 63.0933 131.623 63.0674C131.699 63.364 131.776 63.6618 131.852 63.9585Z"
        fill={fill}
      />
      <path
        d="M80.0723 33.0919C80.2041 33.0778 80.3359 33.0625 80.4678 33.0483C80.4713 33.2155 80.4748 33.3815 80.4772 33.5486C80.4466 33.5828 80.416 33.6181 80.3854 33.6522C80.2818 33.465 80.177 33.2779 80.0723 33.0919Z"
        fill="#F1EFEF"
      />
      <path
        d="M50.6077 43.8591C50.1604 43.8815 50.4288 43.5484 50.3687 43.3777C50.5359 43.3789 50.703 43.3789 50.8702 43.38C50.7831 43.5389 50.6948 43.699 50.6077 43.8591Z"
        fill="#F1EFEF"
      />
      <path
        d="M59.8647 26.8082C59.86 26.508 59.8553 26.2067 59.8506 25.9065C60.192 26.3538 60.1931 26.4362 59.8647 26.8082Z"
        fill={fill}
      />
      <path
        d="M84.6605 43.8437C84.5051 43.8425 84.3497 43.8425 84.1943 43.8413C84.1943 43.686 84.1943 43.5318 84.1943 43.3764C84.2579 43.3693 84.3203 43.3611 84.3839 43.354C84.4757 43.5176 84.5675 43.6801 84.6605 43.8437Z"
        fill="#CFE2E5"
      />
      <path
        d="M100.618 33.0353C100.616 32.8976 100.616 32.7598 100.615 32.6233C100.772 32.7175 100.927 32.8105 101.084 32.9046C101.079 32.9529 101.074 33.0011 101.071 33.0494C100.919 33.0447 100.768 33.04 100.618 33.0353Z"
        fill={fill}
      />
      <path
        d="M85.9512 43.8674C86.0689 43.8579 86.1854 43.8485 86.3031 43.8391C86.3031 44.011 86.3031 44.1817 86.3031 44.3535C86.2713 44.3629 86.2396 44.3723 86.2078 44.3818C86.1219 44.2099 86.0371 44.0392 85.9512 43.8674Z"
        fill="#C98E6A"
      />
      <path
        d="M79.4961 34.3739C79.3796 34.3727 79.263 34.3727 79.1477 34.3715C79.1477 34.1573 79.1465 33.9442 79.1465 33.73C79.263 33.9454 79.3796 34.1596 79.4961 34.3739Z"
        fill={outline}
      />
      <path
        d="M79.9547 32.2124C79.9523 32.3901 79.95 32.5679 79.9465 32.7456C79.8311 32.5679 79.7157 32.3901 79.6016 32.2124C79.7193 32.2124 79.837 32.2124 79.9547 32.2124Z"
        fill={outline}
      />
      <path
        d="M58.5343 32.1938C58.4248 32.195 58.3165 32.1974 58.207 32.1986C58.3012 32.0255 58.3954 31.8525 58.4895 31.6794C58.5048 31.8513 58.519 32.022 58.5343 32.1938Z"
        fill="#E4D4CD"
      />
      <path
        d="M18.1119 42.1897C18.1131 42.2945 18.1131 42.3992 18.1143 42.504C17.9365 42.5016 17.7588 42.4981 17.5811 42.4957C17.7588 42.3933 17.9354 42.2909 18.1119 42.1897Z"
        fill={fill}
      />
      <path
        d="M55.7784 37.0882C55.7171 37.0635 55.6559 37.0399 55.5947 37.0152C55.6559 36.8999 55.7172 36.7833 55.7772 36.668C55.7772 36.808 55.7772 36.9481 55.7784 37.0882Z"
        fill="#CFE3E7"
      />
      <path
        d="M101.07 33.0496C101.075 33.0013 101.08 32.953 101.083 32.9048C101.16 32.9483 101.236 32.9907 101.314 33.0343C101.237 33.0519 101.16 33.0696 101.083 33.0884C101.077 33.0755 101.073 33.0625 101.07 33.0496Z"
        fill={fill}
      />
      <path
        d="M7.72461 52.6028C7.72814 52.6287 7.73167 52.6546 7.73638 52.6805C7.73285 52.6546 7.72932 52.6287 7.72461 52.6028Z"
        fill={fill}
      />
      <path
        d="M80.0131 35.3237C79.999 35.3249 79.9848 35.3273 79.9707 35.3284C79.9825 35.3096 79.9942 35.2896 80.006 35.2708C80.0154 35.2872 80.0178 35.3049 80.0131 35.3237Z"
        fill="#E4D4CD"
      />
      <path
        d="M119.052 42.5524C119.024 42.5324 118.996 42.5124 118.969 42.4912C118.996 42.5112 119.024 42.5312 119.052 42.5524Z"
        fill="#E2BBAC"
      />
      <path
        d="M73.8408 65.3193C73.8408 66.1221 73.8326 66.9261 73.8479 67.7289C73.8526 67.969 73.7714 68.0255 73.5454 68.0232C72.7025 68.0114 71.8597 68.0196 71.0181 68.0196L70.998 68.0232C71.0063 67.1215 71.0145 66.2198 71.0228 65.3181C71.9621 65.3169 72.9015 65.3181 73.8408 65.3193Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.3754 68.0161C76.3754 67.118 76.3766 66.2198 76.3766 65.3217L76.373 65.3064C77.2924 65.3111 78.2117 65.3158 79.1299 65.3205C79.1346 66.2199 79.1405 67.1204 79.1452 68.0197L79.1299 68.0161C78.2117 68.015 77.2936 68.0161 76.3754 68.0161Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.3728 70.5469C75.6488 70.5469 74.9261 70.5351 74.2021 70.5516C73.9514 70.5575 73.889 70.4727 73.8949 70.2338C73.9102 69.5993 73.9102 68.9637 73.8949 68.328C73.889 68.0902 73.9514 68.0055 74.2021 68.0102C74.9249 68.0255 75.6488 68.0149 76.3728 68.0149C76.3728 68.8589 76.3728 69.7029 76.3728 70.5469Z"
        fill="#B3D6DD"
      />
      <path
        d="M73.841 65.3191C72.9016 65.3179 71.9623 65.3179 71.0218 65.3167L71.0029 65.2979C71.01 65.026 71.0159 64.7552 71.0229 64.4833C71.9611 64.4786 72.9005 64.4727 73.8386 64.468C73.8586 64.4751 73.8787 64.4833 73.8987 64.4904C73.8987 64.7611 73.8987 65.0319 73.8998 65.3026C73.881 65.3073 73.861 65.3132 73.841 65.3191Z"
        fill={fill}
      />
      <path
        d="M70.9964 70.5483C70.7186 70.546 70.442 70.5436 70.1642 70.5401L70.1406 70.5424C70.15 69.6996 70.1595 68.8568 70.1677 68.0151C70.4443 68.0175 70.7221 68.0199 70.9988 68.0222L71.0188 68.0187C71.0117 68.8615 71.0035 69.7043 70.9964 70.5483Z"
        fill={fill}
      />
      <path
        d="M73.9006 65.303C73.9006 65.0322 73.9006 64.7615 73.8994 64.4908C74.7234 64.4884 75.5462 64.4872 76.3702 64.4849C76.3702 64.758 76.3702 65.0322 76.3714 65.3053L76.3749 65.3206C75.5498 65.3148 74.7258 65.3089 73.9006 65.303Z"
        fill={fill}
      />
      <path
        d="M91.6208 32.1936C92.5778 32.1948 93.5336 32.196 94.4906 32.196L94.4883 32.216C94.4883 32.4879 94.4871 32.7598 94.4871 33.0317C93.5325 33.0341 92.5766 33.0376 91.622 33.04C91.6149 32.7645 91.6078 32.4879 91.5996 32.2124C91.6008 32.2124 91.6208 32.1936 91.6208 32.1936Z"
        fill={fill}
      />
      <path
        d="M90.7954 29.3251C91.0661 29.3251 91.3369 29.3251 91.6076 29.3251C91.6123 30.2809 91.617 31.2379 91.6217 32.1938L91.6017 32.2126C91.3286 32.2102 91.0567 32.2067 90.7836 32.2044C90.7813 31.2438 90.7777 30.2833 90.7754 29.3228L90.7954 29.3251Z"
        fill={fill}
      />
      <path
        d="M112.272 42.5417C113.225 42.5441 114.18 42.5465 115.133 42.5488C115.134 42.8148 115.137 43.0821 115.138 43.3481L115.136 43.3752C114.175 43.3752 113.214 43.374 112.254 43.374C112.26 43.0962 112.266 42.8184 112.272 42.5417Z"
        fill={fill}
      />
      <path
        d="M111.433 39.6145C111.705 39.6145 111.977 39.6133 112.248 39.6133C112.25 40.575 112.25 41.5379 112.251 42.4996C111.977 42.4972 111.701 42.4949 111.427 42.4914C111.419 41.532 111.412 40.5738 111.403 39.6145C111.413 39.6145 111.422 39.6145 111.433 39.6145Z"
        fill={fill}
      />
      <path
        d="M115.14 43.3481C115.139 43.0821 115.137 42.8149 115.136 42.5488C115.139 42.5335 115.142 42.5182 115.144 42.5029C115.968 42.51 116.792 42.5159 117.616 42.5229C117.614 42.8007 117.611 43.0797 117.609 43.3575L117.612 43.3787C117.505 43.3764 117.399 43.374 117.292 43.3728C116.575 43.3634 115.859 43.3564 115.14 43.3481Z"
        fill={fill}
      />
      <path
        d="M111.427 42.4912C111.701 42.4936 111.976 42.4959 112.251 42.4995C112.26 42.5124 112.266 42.5265 112.271 42.5418C112.265 42.8196 112.259 43.0963 112.253 43.3741L112.252 43.3752C111.976 43.3776 111.701 43.3811 111.427 43.3835C111.41 43.3764 111.396 43.3682 111.382 43.3576C111.383 43.0774 111.384 42.7973 111.387 42.5183C111.398 42.5077 111.411 42.4995 111.427 42.4912Z"
        fill={outline}
      />
      <path
        d="M50.3584 29.3252C50.3655 28.4812 50.3725 27.636 50.3796 26.792C51.3354 26.7932 52.2901 26.7932 53.2459 26.7943L53.2494 26.7979C53.2494 27.6395 53.2494 28.4812 53.2494 29.3228L53.2459 29.3264C52.2912 29.3252 51.3366 29.324 50.3819 29.3228L50.3584 29.3252Z"
        fill="#CFE3E7"
      />
      <path
        d="M53.249 26.793C53.2502 25.8936 53.2502 24.9943 53.2514 24.0938L53.249 24.0691C54.093 24.0691 54.9382 24.0691 55.7822 24.0691L55.7799 24.0926C55.7799 24.9931 55.781 25.8936 55.781 26.7941L55.7775 26.7977C54.9359 26.7977 54.0942 26.7965 53.2526 26.7965L53.249 26.793Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1936 21.9198C84.1936 22.1894 84.1924 22.4601 84.1924 22.7297L84.1947 22.7521C83.2342 22.7485 82.2748 22.745 81.3143 22.7415C81.3108 22.4684 81.3072 22.1965 81.3037 21.9234L81.3225 21.9045C82.2796 21.9092 83.2366 21.914 84.1936 21.9198Z"
        fill={fill}
      />
      <path
        d="M71.0216 37.0872C71.9621 37.0872 72.9038 37.0872 73.8443 37.0883L73.8502 37.0942C73.8679 37.4038 73.8938 37.7134 73.8997 38.023C73.9079 38.462 73.9126 38.9011 73.8973 39.339C73.8891 39.5591 73.9609 39.6239 74.1798 39.6203C74.912 39.6086 75.643 39.6168 76.3752 39.6168C76.374 40.5773 76.374 41.5379 76.3728 42.4984C76.208 42.5008 76.0432 42.5019 75.8784 42.5043C75.2204 42.5137 74.5624 42.5231 73.9044 42.5325C73.8855 42.5243 73.8655 42.5149 73.8467 42.5067C73.8467 41.6474 73.8373 40.7869 73.8502 39.9276C73.8538 39.6886 73.7902 39.6074 73.5418 39.6121C72.7014 39.6262 71.8609 39.6168 71.0204 39.6168C71.0133 38.774 71.0051 37.9312 70.998 37.0883L71.0216 37.0872Z"
        fill="#CFE3E7"
      />
      <path
        d="M73.8408 34.3878C73.8608 34.3819 73.8808 34.3772 73.8997 34.3713C74.7237 34.3713 75.5488 34.3713 76.3728 34.3713L76.3705 34.3913C76.3705 35.2895 76.3705 36.1876 76.3705 37.0858C75.5288 37.0882 74.6884 37.0905 73.8467 37.0929L73.8408 37.087C73.842 36.1876 73.8408 35.2883 73.8408 34.3878Z"
        fill="#CFE3E7"
      />
      <path
        d="M101.956 37.0847C102.9 37.0859 103.843 37.0859 104.787 37.0871L104.793 37.093C104.792 37.9334 104.79 38.7739 104.788 39.6144C103.844 39.6132 102.9 39.612 101.956 39.6108C101.955 39.4943 101.956 39.3778 101.954 39.2624C101.946 38.5373 101.936 37.811 101.927 37.0859L101.942 37.0847H101.956Z"
        fill="#CFE3E7"
      />
      <path
        d="M101.966 34.383C101.964 35.2835 101.96 36.1841 101.958 37.0846L101.943 37.0834C101.943 37.0834 101.927 37.0846 101.929 37.0846C101.65 37.0857 101.369 37.0869 101.09 37.0881C101.087 36.1864 101.083 35.2835 101.081 34.3819C101.369 34.376 101.659 34.3689 101.947 34.363C101.947 34.3642 101.966 34.383 101.966 34.383Z"
        fill={fill}
      />
      <path
        d="M4.18652 70.5471C4.18652 69.7031 4.18652 68.8591 4.18652 68.0151C5.10468 68.0163 6.02167 68.0175 6.93983 68.0175L6.95984 68.0151C6.95984 68.8591 6.95984 69.7031 6.95984 70.546L6.93983 70.5436C6.02167 70.546 5.10468 70.5471 4.18652 70.5471Z"
        fill="#CFE3E7"
      />
      <path
        d="M6.93848 68.0171C6.93965 67.1178 6.93965 66.2185 6.94083 65.3192L6.95849 65.3015C7.23276 65.3086 7.50703 65.3145 7.7813 65.3215C7.78954 66.2208 7.7966 67.119 7.80484 68.0183C7.79543 68.0195 7.78483 68.0195 7.77542 68.0183C7.5035 68.0171 7.23158 68.016 6.95849 68.0148L6.93848 68.0171Z"
        fill={fill}
      />
      <path
        d="M125.434 49.9084C125.432 50.8807 125.432 51.8518 125.431 52.8241L125.432 52.8441C124.478 52.8394 123.522 52.8335 122.567 52.8288C122.56 51.8542 122.552 50.8807 122.545 49.906L122.561 49.9095C123.52 49.9084 124.477 49.9084 125.434 49.9084Z"
        fill="#F1F1F1"
      />
      <path
        d="M127.963 52.8475C127.963 53.1183 127.961 53.389 127.961 53.6609L127.965 53.6762C127.121 53.6703 126.277 53.6644 125.433 53.6586C125.433 53.3866 125.433 53.1159 125.432 52.844L125.431 52.824C126.275 52.831 127.119 52.8393 127.963 52.8475Z"
        fill={fill}
      />
      <path
        d="M53.2537 22.7332C53.2526 22.4624 53.2526 22.1929 53.2514 21.9221C54.0954 21.9221 54.9382 21.9221 55.7822 21.9221C55.781 22.1917 55.781 22.4624 55.7799 22.732L55.7846 22.7485C54.9394 22.7485 54.0942 22.7485 53.249 22.7496L53.2537 22.7332Z"
        fill={fill}
      />
      <path
        d="M24.8383 39.6167C25.7529 39.6167 26.6676 39.6178 27.5822 39.6178L27.601 39.6155C27.5975 40.5725 27.5952 41.5295 27.5916 42.4853C27.4645 42.4912 27.3374 42.5006 27.2102 42.5018C26.4168 42.5089 25.6235 42.5136 24.8301 42.5195L24.8336 42.4983C24.8348 41.5377 24.836 40.5772 24.8383 39.6167Z"
        fill="#F1F0F0"
      />
      <path
        d="M22.3072 42.4993C23.1489 42.4993 23.9905 42.4993 24.8322 42.4993L24.8287 42.5205C24.831 42.7971 24.8334 43.0749 24.8357 43.3527C23.9917 43.3527 23.1477 43.3527 22.3037 43.3527C22.3061 43.0749 22.3084 42.7983 22.3108 42.5205L22.3072 42.4993Z"
        fill={fill}
      />
      <path
        d="M50.3809 37.0894C50.3774 36.1877 50.3727 35.2872 50.3691 34.3856C51.3297 34.382 52.289 34.3785 53.2496 34.3738L53.246 34.3891C53.246 35.2872 53.2472 36.1866 53.2472 37.0847C52.2914 37.0871 51.3367 37.0882 50.3809 37.0894Z"
        fill="#F1F1F1"
      />
      <path
        d="M42.9553 29.3263C43.7793 29.3252 44.6033 29.3252 45.4273 29.324L45.432 29.3287C45.4308 30.2833 45.4296 31.2392 45.4284 32.1938L45.4308 32.2138C44.6056 32.215 43.7793 32.215 42.9541 32.2162L42.9565 32.195C42.9565 31.2392 42.9553 30.2822 42.9553 29.3263Z"
        fill="#CFE3E7"
      />
      <path
        d="M40.0802 32.1974C41.0383 32.1962 41.9965 32.1962 42.9547 32.1951L42.9523 32.2163C42.9523 32.487 42.9523 32.7577 42.9523 33.0285C41.9953 33.0308 41.0372 33.0332 40.0802 33.0355C40.0743 32.7624 40.0684 32.4882 40.0625 32.2151L40.0802 32.1974Z"
        fill={fill}
      />
      <path
        d="M81.3145 34.3833C81.3156 34.1067 81.318 33.8301 81.3192 33.5534C82.2785 33.5487 83.2379 33.544 84.1972 33.5393L84.1949 33.564C84.1961 33.8336 84.1961 34.1043 84.1972 34.3739C83.2355 34.3762 82.275 34.3798 81.3145 34.3833Z"
        fill={fill}
      />
      <path
        d="M55.7834 26.794C55.7834 25.8935 55.7822 24.993 55.7822 24.0925C56.6874 24.0925 57.5926 24.0925 58.5132 24.0925C58.5132 25.0119 58.5132 25.9041 58.5132 26.7976C57.6021 26.7964 56.6933 26.7952 55.7834 26.794Z"
        fill="#F1F0F0"
      />
      <path
        d="M53.249 26.7976C54.0907 26.7976 54.9323 26.7988 55.774 26.7988C55.7751 27.6404 55.7751 28.4821 55.7763 29.3237C54.9335 29.3237 54.0918 29.3226 53.249 29.3226C53.249 28.4809 53.249 27.6393 53.249 26.7976Z"
        fill="#B3D6DD"
      />
      <path
        d="M50.3584 49.9071C50.3666 49.082 50.3737 48.258 50.3819 47.4328C51.3366 47.4328 52.2912 47.4316 53.2459 47.4316L53.2506 47.4363C53.2494 48.2603 53.2483 49.0831 53.2483 49.9071C52.2936 49.9071 51.3378 49.906 50.3831 49.906L50.3584 49.9071Z"
        fill="#CFE3E7"
      />
      <path
        d="M53.249 47.4317C53.2502 46.5194 53.2526 45.6072 53.2537 44.6937C53.2537 44.6937 53.2526 44.6678 53.2526 44.669C54.0966 44.676 54.9417 44.6831 55.7857 44.6902C55.7846 45.6048 55.7834 46.5194 55.7834 47.4341C54.9406 47.4341 54.0966 47.4352 53.2537 47.4352L53.249 47.4317Z"
        fill="#CFE3E7"
      />
      <path
        d="M94.4894 70.5482C93.536 70.547 92.5825 70.5459 91.6302 70.5447L91.6055 70.5459C91.6125 69.7019 91.6196 68.8567 91.6267 68.0127C92.5813 68.0139 93.536 68.015 94.4918 68.0174C94.493 68.8602 94.493 69.7019 94.4941 70.5447L94.4894 70.5482Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1936 70.5483C83.2366 70.5471 82.2795 70.546 81.3237 70.5448L81.3037 70.5471C81.3096 69.7031 81.3155 68.8591 81.3214 68.0151C82.2795 68.0151 83.2377 68.0163 84.1947 68.0163C84.1959 68.8591 84.1959 69.702 84.1971 70.5448C84.1983 70.5448 84.1936 70.5483 84.1936 70.5483Z"
        fill="#CFE3E7"
      />
      <path
        d="M63.5421 70.5482C62.5922 70.547 61.6434 70.5459 60.6947 70.5447H60.6794H60.6641C60.6735 69.7007 60.6817 68.8567 60.6911 68.0127C61.6423 68.015 62.5934 68.0162 63.5445 68.0186C63.5457 68.8614 63.5457 69.703 63.5468 70.5459L63.5421 70.5482Z"
        fill="#CFE3E7"
      />
      <path
        d="M53.2459 70.548C52.2912 70.5469 51.3366 70.5457 50.3819 70.5445L50.3584 70.5469C50.3655 69.7029 50.3725 68.8589 50.3784 68.0137C51.3342 68.0148 52.2901 68.016 53.2471 68.0172C53.2483 68.86 53.2482 69.7017 53.2494 70.5445L53.2459 70.548Z"
        fill="#CFE3E7"
      />
      <path
        d="M115.138 70.5495C114.182 70.5483 113.225 70.546 112.269 70.5448L112.249 70.5471C112.255 69.7031 112.261 68.8591 112.267 68.0151C113.224 68.0151 114.182 68.0151 115.139 68.0151C115.14 68.858 115.141 69.702 115.142 70.5448L115.138 70.5495Z"
        fill="#CFE3E7"
      />
      <path
        d="M42.9523 70.5495C41.9953 70.5483 41.0395 70.5471 40.0825 70.5448L40.0625 70.5471C40.0684 69.7031 40.0743 68.8591 40.0802 68.0151C41.0383 68.0151 41.9953 68.0151 42.9535 68.0151C42.9547 68.858 42.9547 69.7008 42.9559 70.5448L42.9523 70.5495Z"
        fill="#CFE3E7"
      />
      <path
        d="M125.435 70.5483C124.479 70.5471 123.522 70.546 122.566 70.5448L122.545 70.5471C122.551 69.7031 122.558 68.8591 122.564 68.0151C123.522 68.0163 124.479 68.0163 125.437 68.0175C125.438 68.8603 125.438 69.702 125.439 70.5448L125.435 70.5483Z"
        fill="#CFE3E7"
      />
      <path
        d="M12.0059 70.5483C11.05 70.5471 10.0942 70.546 9.13838 70.5448L9.11719 70.5471C9.12307 69.7031 9.13014 68.8591 9.13602 68.0151C10.093 68.0163 11.05 68.0163 12.007 68.0175C12.0082 68.8603 12.0082 69.702 12.0094 70.5448L12.0059 70.5483Z"
        fill="#CFE3E7"
      />
      <path
        d="M22.3043 70.5482C21.3531 70.547 20.402 70.5458 19.4509 70.5446H19.4238C19.4321 69.7006 19.4403 68.8555 19.4485 68.0115C20.4008 68.0138 21.3543 68.015 22.3066 68.0174C22.3078 68.8602 22.3078 69.7018 22.309 70.5446L22.3043 70.5482Z"
        fill="#CFE3E7"
      />
      <path
        d="M32.602 70.5456C31.6603 70.5456 30.7198 70.5456 29.7781 70.5456L29.751 70.5468C29.7592 69.704 29.7675 68.8611 29.7769 68.0183C30.7198 68.0183 31.6615 68.0183 32.6043 68.0183C32.6055 68.8588 32.6055 69.7004 32.6067 70.5409L32.602 70.5456Z"
        fill="#CFE3E7"
      />
      <path
        d="M104.785 70.547C103.842 70.547 102.9 70.5482 101.957 70.5482L101.942 70.5493L101.927 70.5482C101.935 70.4422 101.951 70.3375 101.951 70.2315C101.955 69.4946 101.954 68.7578 101.955 68.0209C102.899 68.0197 103.842 68.0185 104.786 68.0173C104.787 68.859 104.787 69.7006 104.788 70.5411L104.785 70.547Z"
        fill="#CFE3E7"
      />
      <path
        d="M73.9018 33.0259C73.9006 32.7563 73.8994 32.4868 73.8994 32.216C74.7246 32.216 75.5509 32.2148 76.3761 32.2148C76.3761 32.4868 76.3773 32.7599 76.3773 33.0318L76.3808 33.053C75.5545 33.0435 74.7281 33.0353 73.9018 33.0259Z"
        fill={fill}
      />
      <path
        d="M107.318 39.6154C108.237 39.6166 109.154 39.6178 110.072 39.6178L110.088 39.6143C110.085 40.5736 110.08 41.5318 110.076 42.4912C109.157 42.4923 108.238 42.4947 107.32 42.4959C107.318 41.5353 107.318 40.5748 107.318 39.6154Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.786 39.6143C104.787 38.7739 104.79 37.9334 104.791 37.0929C105.631 37.0918 106.472 37.0906 107.312 37.0906C107.313 37.9322 107.315 38.7751 107.316 39.6167C106.473 39.6155 105.629 39.6143 104.786 39.6143Z"
        fill="#B3D6DD"
      />
      <path
        d="M27.574 70.5447C26.6605 70.5459 25.7471 70.547 24.8336 70.5482L24.8301 70.5447C24.8313 69.7019 24.8313 68.8602 24.8324 68.0174C25.7471 68.0162 26.6629 68.0139 27.5775 68.0127C27.5846 68.8567 27.5928 69.7019 27.5999 70.5459L27.574 70.5447Z"
        fill="#CFE3E7"
      />
      <path
        d="M37.8875 70.5446C36.9705 70.5458 36.0524 70.5469 35.1354 70.5481L35.1318 70.5446C35.133 69.7018 35.133 68.8589 35.1342 68.0173C36.0535 68.0173 36.9717 68.0161 37.891 68.0161C37.8969 68.8601 37.9028 69.7041 37.9087 70.5481L37.8875 70.5446Z"
        fill="#CFE3E7"
      />
      <path
        d="M48.1895 70.5457C47.2701 70.5469 46.3508 70.548 45.4315 70.5492L45.4268 70.5445C45.4279 69.7005 45.4291 68.8577 45.4303 68.0137C46.3508 68.0148 47.2713 68.0149 48.1907 68.016C48.1977 68.86 48.206 69.7029 48.213 70.5469L48.1895 70.5457Z"
        fill="#CFE3E7"
      />
      <path
        d="M58.5075 70.5434C57.5988 70.5446 56.6888 70.5458 55.7801 70.547C55.7801 70.547 55.7754 70.5423 55.7766 70.5423C55.7777 69.7006 55.7777 68.859 55.7789 68.0173C56.69 68.015 57.6011 68.0126 58.5122 68.0103C58.5204 68.1162 58.5334 68.2221 58.5346 68.3281C58.5381 69.0661 58.5393 69.8042 58.5416 70.5423H58.5252L58.5075 70.5434Z"
        fill="#CFE3E7"
      />
      <path
        d="M68.8197 70.5448C67.9051 70.546 66.9904 70.5471 66.0758 70.5483L66.0723 70.5448C66.0723 69.7031 66.0734 68.8603 66.0734 68.0187C66.9904 68.0175 67.9062 68.0163 68.8232 68.0151C68.8303 68.8591 68.8373 69.7031 68.8432 70.5483L68.8197 70.5448Z"
        fill="#CFE3E7"
      />
      <path
        d="M76.373 70.5471C76.373 69.7031 76.373 68.8603 76.373 68.0163C77.2912 68.0163 78.2105 68.0163 79.1287 68.0151C79.1346 68.8591 79.1405 69.7031 79.1464 70.5471L79.1264 70.5448C78.2082 70.546 77.29 70.546 76.373 70.5471Z"
        fill="#CFE3E7"
      />
      <path
        d="M99.7544 70.5434C98.8433 70.5446 97.9322 70.5458 97.0211 70.547L97.0176 70.5434C97.0188 69.7006 97.0188 68.859 97.0199 68.0161C97.9322 68.0138 98.8457 68.0126 99.7579 68.0103C99.7662 68.8543 99.7744 69.6983 99.7838 70.5434H99.7544Z"
        fill="#CFE3E7"
      />
      <path
        d="M110.066 70.5448C109.15 70.546 108.233 70.5471 107.317 70.5483L107.313 70.5448C107.315 69.702 107.315 68.8603 107.316 68.0175C108.234 68.0163 109.151 68.0151 110.069 68.0151C110.076 68.8591 110.082 69.7031 110.089 70.5471C110.088 70.5471 110.066 70.5448 110.066 70.5448Z"
        fill="#CFE3E7"
      />
      <path
        d="M120.364 70.5448C119.447 70.546 118.529 70.5471 117.612 70.5495L117.608 70.5448C117.61 69.702 117.611 68.858 117.611 68.0151C118.529 68.0151 119.447 68.0151 120.366 68.0151C120.372 68.8591 120.378 69.7031 120.384 70.5471L120.364 70.5448Z"
        fill="#CFE3E7"
      />
      <path
        d="M130.682 60.253C130.681 61.2148 130.68 62.1777 130.679 63.1394L130.677 63.1405C129.773 63.1347 128.869 63.13 127.966 63.1241C127.965 62.1671 127.964 61.2089 127.963 60.2519L127.964 60.2495C128.87 60.2507 129.776 60.2519 130.682 60.253Z"
        fill="#F1F1F1"
      />
      <path
        d="M127.968 57.7278C127.966 58.5683 127.966 59.4087 127.965 60.2504L127.964 60.2527C127.124 60.2527 126.283 60.2527 125.443 60.2527C125.443 59.4111 125.441 58.5694 125.441 57.7289C126.283 57.7278 127.125 57.7278 127.968 57.7278Z"
        fill="#B3D6DD"
      />
      <path
        d="M130.675 70.547C129.772 70.547 128.87 70.547 127.968 70.5458L127.963 70.5411C127.964 69.6995 127.964 68.859 127.965 68.0173C128.869 68.0173 129.772 68.0185 130.676 68.0185C130.686 68.8613 130.694 69.7042 130.703 70.547H130.675Z"
        fill="#CFE3E7"
      />
      <path
        d="M17.2496 70.548C16.3468 70.548 15.4439 70.5468 14.5399 70.5468L14.5352 70.5421C14.5363 69.7004 14.5363 68.86 14.5375 68.0183C15.4415 68.0195 16.3468 68.0195 17.2508 68.0207C17.252 68.1278 17.2531 68.2337 17.2543 68.3408C17.2626 69.0765 17.2708 69.8123 17.279 70.548L17.2637 70.5491L17.2496 70.548Z"
        fill="#CFE3E7"
      />
      <path
        d="M89.4303 70.5468C88.5286 70.5468 87.6269 70.5468 86.7264 70.5468L86.7217 70.5421C86.7229 69.7016 86.7229 68.86 86.724 68.0195C87.6269 68.0195 88.5298 68.0195 89.4326 68.0183C89.4409 68.8611 89.4491 69.7051 89.4573 70.548L89.4303 70.5468Z"
        fill="#CFE3E7"
      />
      <path
        d="M55.7762 42.4994C55.7774 41.5377 55.7785 40.576 55.7785 39.6143C56.6908 39.6143 57.6019 39.6143 58.5142 39.6143C58.5224 40.5736 58.5307 41.5318 58.5377 42.4912C58.5213 42.4982 58.5071 42.5076 58.4954 42.5206C57.5878 42.5206 56.6791 42.5218 55.7715 42.5218L55.7762 42.4994Z"
        fill="#F1F1F1"
      />
      <path
        d="M53.2573 43.3553C53.2549 43.0787 53.2526 42.8021 53.249 42.5254C54.0918 42.5172 54.9347 42.509 55.7775 42.5007C55.7775 42.5007 55.774 42.5231 55.774 42.5219C55.7763 42.7985 55.7787 43.0752 55.7822 43.3518C54.9394 43.36 54.0966 43.3683 53.2537 43.3765L53.2573 43.3553Z"
        fill={fill}
      />
      <path
        d="M9.13281 52.8359C9.13399 51.8613 9.13399 50.8854 9.13517 49.9108C10.0922 49.9096 11.048 49.9084 12.005 49.9072C12.0062 50.8784 12.0062 51.8483 12.0074 52.8194C11.0492 52.8253 10.091 52.8312 9.13281 52.8371V52.8359Z"
        fill="#F1F1F1"
      />
      <path
        d="M12.0102 47.4365C12.853 47.4365 13.697 47.4353 14.5398 47.4353C14.5386 48.2581 14.5375 49.0809 14.5375 49.9037C13.6946 49.9049 12.8518 49.9073 12.0078 49.9085C12.009 49.0833 12.009 48.2605 12.0102 47.4365Z"
        fill="#B3D6DD"
      />
      <path
        d="M84.1974 24.0906C84.1974 24.9922 84.1962 25.8939 84.1962 26.7956C83.2392 26.7956 82.2822 26.7968 81.324 26.7968C81.3229 25.8963 81.3217 24.997 81.3193 24.0965C81.4265 24.0929 81.5324 24.0882 81.6395 24.087C82.4929 24.0812 83.3475 24.0764 84.2009 24.0706L84.1974 24.0906Z"
        fill="#F1F1F1"
      />
      <path
        d="M86.7204 26.8001C86.7216 27.6405 86.7216 28.481 86.7228 29.3215V29.3227C85.8812 29.3227 85.0383 29.3227 84.1967 29.3227C84.1955 28.4798 84.1955 27.637 84.1943 26.7942C85.036 26.7965 85.8788 26.7977 86.7204 26.8001Z"
        fill="#B3D6DD"
      />
      <path
        d="M86.7222 49.9047C87.6262 49.9047 88.5291 49.9035 89.4331 49.9035L89.4567 49.9011C89.4496 50.0377 89.4378 50.1742 89.4367 50.3096C89.4284 51.1501 89.4237 51.9917 89.4178 52.8322C88.5197 52.8286 87.6204 52.8239 86.7222 52.8204C86.721 51.8481 86.7222 50.877 86.7222 49.9047Z"
        fill="#F1F1F1"
      />
      <path
        d="M89.4354 49.9035C89.4342 49.0806 89.4318 48.2578 89.4307 47.435L89.4519 47.4386C89.7308 47.4374 90.0098 47.435 90.2876 47.4338C90.2947 48.2567 90.3006 49.0795 90.3076 49.9035C90.2923 49.9058 90.277 49.9093 90.2617 49.9117C89.9933 49.9082 89.7261 49.9046 89.4577 49.9011C89.4589 49.9011 89.4354 49.9035 89.4354 49.9035Z"
        fill={fill}
      />
      <path
        d="M63.5443 32.2123C63.5443 32.4842 63.5455 32.7561 63.5455 33.0281L63.5467 33.0563C62.6097 33.0492 61.6715 33.041 60.7345 33.0339C60.711 33.0328 60.6862 33.0304 60.6627 33.0292C60.6615 32.7561 60.6604 32.4831 60.6592 32.21C60.6662 32.2029 60.6745 32.1958 60.6815 32.1899C61.635 32.197 62.5897 32.2052 63.5443 32.2123Z"
        fill={fill}
      />
      <path
        d="M59.8421 29.325C60.1163 29.3261 60.3906 29.3261 60.6649 29.3273C60.6696 30.2808 60.6743 31.2354 60.679 32.1889C60.6708 32.196 60.6637 32.2019 60.6566 32.2089C60.3871 32.2113 60.1163 32.2124 59.8468 32.2148L59.8291 32.1971C59.8326 31.2401 59.8373 30.2831 59.8421 29.325Z"
        fill={fill}
      />
      <path
        d="M86.7238 49.9048C86.7238 50.8771 86.7226 51.8482 86.7226 52.8205L86.7215 52.8476C85.8775 52.8405 85.0335 52.8323 84.1895 52.8252C84.1895 51.8541 84.1895 50.8818 84.1895 49.9107L84.1942 49.906C85.0382 49.9048 85.881 49.9048 86.7238 49.9048Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1939 47.4365C84.1939 48.2594 84.1939 49.0822 84.1939 49.905L84.1892 49.9097C83.2322 49.9097 82.2752 49.9085 81.3193 49.9085C81.3193 49.0834 81.3205 48.2582 81.3205 47.4318C82.2763 47.4318 83.2333 47.4307 84.1892 47.4307L84.1939 47.4365Z"
        fill="#CFE3E7"
      />
      <path
        d="M45.4268 32.1938C45.4279 31.2392 45.4291 30.2833 45.4303 29.3287C46.3496 29.3275 47.269 29.3263 48.1883 29.324C48.1907 30.2857 48.193 31.2462 48.1942 32.2079V32.2091C47.2713 32.2044 46.3496 32.1985 45.4268 32.1938Z"
        fill="#F1F1F1"
      />
      <path
        d="M24.8345 68.0173C24.8334 68.8602 24.8334 69.7018 24.8322 70.5446C23.9905 70.5446 23.1477 70.5446 22.3061 70.5446C22.3049 69.7018 22.3049 68.8602 22.3037 68.0173C23.1477 68.0173 23.9917 68.0173 24.8345 68.0173Z"
        fill="#B3D6DD"
      />
      <path
        d="M127.966 68.0185C127.965 68.8602 127.965 69.7006 127.964 70.5423C127.122 70.5423 126.281 70.5434 125.439 70.5446C125.438 69.7018 125.438 68.8602 125.437 68.0173C126.279 68.0173 127.122 68.0173 127.966 68.0185Z"
        fill="#B3D6DD"
      />
      <path
        d="M14.5375 68.0185C14.5363 68.8601 14.5363 69.7006 14.5351 70.5422C13.6935 70.5422 12.8518 70.5434 12.0102 70.5434C12.009 69.7006 12.009 68.8589 12.0078 68.0161C12.8506 68.0173 13.6935 68.0173 14.5375 68.0185C14.5375 68.0185 14.5363 68.0185 14.5375 68.0185Z"
        fill="#B3D6DD"
      />
      <path
        d="M107.316 68.0173C107.315 68.8602 107.315 69.7018 107.313 70.5446C106.472 70.5446 105.63 70.5435 104.788 70.5435C104.787 69.7018 104.787 68.8602 104.786 68.0197C105.629 68.0173 106.472 68.0173 107.316 68.0173Z"
        fill="#B3D6DD"
      />
      <path
        d="M35.1293 68.0161C35.1281 68.8589 35.1281 69.7018 35.1269 70.5434C34.2853 70.5422 33.4436 70.5422 32.602 70.5411C32.6008 69.7006 32.6008 68.8589 32.5996 68.0185C33.4436 68.0173 34.2864 68.0173 35.1293 68.0161Z"
        fill="#B3D6DD"
      />
      <path
        d="M97.022 68.0173C97.0209 68.8602 97.0209 69.7018 97.0197 70.5446C96.178 70.5446 95.3352 70.5446 94.4936 70.5446C94.4924 69.7018 94.4924 68.8602 94.4912 68.0173C95.3352 68.0173 96.1792 68.0173 97.022 68.0173Z"
        fill="#B3D6DD"
      />
      <path
        d="M55.7787 68.0185C55.7775 68.8602 55.7775 69.7018 55.7763 70.5435C54.9347 70.5435 54.093 70.5446 53.2514 70.5446C53.2502 69.7018 53.2502 68.8602 53.249 68.0173C54.093 68.0173 54.9358 68.0173 55.7787 68.0185Z"
        fill="#B3D6DD"
      />
      <path
        d="M86.724 68.0196C86.7228 68.8601 86.7228 69.7018 86.7216 70.5422C85.88 70.5434 85.0383 70.5434 84.1967 70.5446C84.1955 69.7018 84.1955 68.8589 84.1943 68.0161C85.0383 68.0173 85.8812 68.0173 86.724 68.0196C86.724 68.0196 86.724 68.0185 86.724 68.0196Z"
        fill="#B3D6DD"
      />
      <path
        d="M66.0746 68.0173C66.0746 68.8601 66.0734 69.7018 66.0734 70.5434C65.2318 70.5434 64.3889 70.5434 63.5473 70.5434C63.5461 69.7006 63.5461 68.8589 63.5449 68.0161C64.3877 68.0173 65.2318 68.0173 66.0746 68.0173Z"
        fill="#B3D6DD"
      />
      <path
        d="M63.5423 34.3891C63.5434 35.2884 63.5446 36.1877 63.5458 37.0871C62.5947 37.0871 61.6424 37.0871 60.6913 37.0871C60.6877 36.1901 60.6842 35.2943 60.6807 34.3973C61.6365 34.3891 62.5911 34.382 63.547 34.3738L63.5423 34.3891Z"
        fill="#F1F1F1"
      />
      <path
        d="M66.071 37.0893C66.0722 37.931 66.0734 38.7726 66.0746 39.6154C65.2317 39.6143 64.3889 39.6143 63.5461 39.6131C63.5461 38.7714 63.5461 37.9298 63.5449 37.0881C64.3866 37.0881 65.2282 37.0893 66.071 37.0893Z"
        fill="#B3D6DD"
      />
      <path
        d="M58.5132 39.6143C57.6009 39.6143 56.6898 39.6143 55.7775 39.6143C55.7775 38.7726 55.7764 37.931 55.7764 37.0893C56.6886 37.0893 57.6009 37.0881 58.5132 37.0881L58.5403 37.0905C58.5403 37.9321 58.5403 38.7726 58.5403 39.6143H58.5132Z"
        fill="#CFE3E7"
      />
      <path
        d="M58.5127 37.0872C58.5162 36.1902 58.5198 35.2944 58.5233 34.3975C58.5315 34.3904 58.5386 34.3845 58.5468 34.3774C58.8211 34.3786 59.0942 34.381 59.3685 34.3821C59.3649 35.2838 59.3626 36.1867 59.3591 37.0884C59.086 37.0884 58.814 37.0884 58.5409 37.0895L58.5127 37.0872Z"
        fill={fill}
      />
      <path
        d="M45.4296 68.0151C45.4284 68.8591 45.4272 69.702 45.4261 70.546C44.6033 70.546 43.7793 70.546 42.9565 70.546C42.9553 69.7031 42.9553 68.8603 42.9541 68.0163C43.7793 68.0151 44.6044 68.0151 45.4296 68.0151Z"
        fill="#B3D6DD"
      />
      <path
        d="M117.616 68.0151C117.615 68.858 117.615 69.702 117.614 70.5448C116.791 70.5448 115.967 70.5448 115.144 70.5448C115.143 69.702 115.142 68.858 115.141 68.0151C115.967 68.0151 116.791 68.0151 117.616 68.0151Z"
        fill="#B3D6DD"
      />
      <path
        d="M90.2863 47.434C90.0073 47.4351 89.7283 47.4375 89.4505 47.4387C89.4458 46.637 89.4423 45.8342 89.4364 45.0326C89.4352 44.9161 89.4258 44.7984 89.4199 44.6818C89.427 44.6748 89.4352 44.6677 89.4423 44.6606C89.733 44.6642 90.0238 44.6689 90.3134 44.6724C90.3134 45.5929 90.3134 46.5123 90.3134 47.4328L90.2863 47.434Z"
        fill={fill}
      />
      <path
        d="M14.5424 44.6914C15.4441 44.6843 16.3458 44.6773 17.2463 44.6714C17.2463 45.5919 17.2474 46.5124 17.2474 47.4318C16.3446 47.4329 15.4429 47.4341 14.54 47.4341C14.5412 46.5207 14.5412 45.606 14.5424 44.6914Z"
        fill="#F1F1F1"
      />
      <path
        d="M79.125 26.7966C79.1262 25.8961 79.1274 24.9956 79.1285 24.0963L79.1485 24.0798C79.4205 24.0857 79.6912 24.0904 79.9631 24.0963C79.9619 24.9956 79.9619 25.895 79.9608 26.7955C79.6888 26.7955 79.4169 26.7955 79.145 26.7966H79.125Z"
        fill={fill}
      />
      <path
        d="M29.7732 37.0859C30.7149 37.0859 31.6566 37.0871 32.5995 37.0871L32.6053 37.093C32.6042 37.9335 32.6018 38.7728 32.6006 39.6132C31.6589 39.6144 30.716 39.6156 29.7743 39.6168L29.7461 39.6179C29.7461 38.7739 29.7461 37.9299 29.7473 37.0859C29.7461 37.0859 29.7732 37.0859 29.7732 37.0859Z"
        fill="#CFE3E7"
      />
      <path
        d="M32.602 34.389C33.4448 34.3831 34.2888 34.3772 35.1316 34.3713L35.1293 34.3913C35.1293 35.2895 35.1293 36.1876 35.1293 37.0858C34.2876 37.0882 33.4471 37.0893 32.6055 37.0917L32.5996 37.0858C32.602 36.1876 32.602 35.2883 32.602 34.389Z"
        fill="#CFE3E7"
      />
      <path
        d="M53.2514 29.3228C54.0942 29.3228 54.9358 29.3239 55.7787 29.3239C55.7787 30.2821 55.7787 31.2391 55.7787 32.1973L55.781 32.2173C54.937 32.2114 54.093 32.2044 53.249 32.1985C53.249 31.2415 53.249 30.2845 53.249 29.3275L53.2514 29.3228Z"
        fill="#CFE3E7"
      />
      <path
        d="M89.433 42.4981C89.4318 41.5376 89.4318 40.5771 89.4307 39.6165L89.4577 39.6177C89.7344 39.6154 90.011 39.6142 90.2876 39.6118C90.29 40.5759 90.2923 41.54 90.2947 42.5028C90.0145 42.5076 89.7355 42.5123 89.4554 42.517L89.433 42.4981Z"
        fill={fill}
      />
      <path
        d="M125.434 49.9072C124.477 49.9072 123.52 49.9084 122.563 49.9084C122.557 49.0832 122.551 48.258 122.545 47.4329L122.565 47.4352C123.521 47.4352 124.477 47.434 125.432 47.434C125.434 48.258 125.434 49.0832 125.434 49.9072Z"
        fill="#CFE3E7"
      />
      <path
        d="M22.3112 42.5204C22.3088 42.7982 22.3065 43.0749 22.3041 43.3527V43.3786C21.3636 43.3727 20.4231 43.3668 19.4826 43.3609C19.4626 43.3468 19.4425 43.3338 19.4225 43.3197C19.4178 43.0501 19.4119 42.7806 19.4072 42.511L19.4261 42.4922C20.2818 42.4957 21.1364 42.4992 21.9922 42.504C22.0981 42.5051 22.2041 42.5146 22.3112 42.5204Z"
        fill={fill}
      />
      <path
        d="M80.4947 39.6145C80.7654 39.6133 81.0361 39.6133 81.3069 39.6133C81.3104 40.5738 81.3139 41.5332 81.3186 42.4937L81.2998 42.5114C81.0291 42.5043 80.7583 42.4984 80.4864 42.4914C80.4805 41.532 80.4746 40.5726 80.4688 39.6133L80.4947 39.6145Z"
        fill={fill}
      />
      <path
        d="M94.4877 33.0319C94.4877 32.76 94.4889 32.4881 94.4889 32.2161C95.3329 32.2103 96.1769 32.2044 97.0221 32.1985L97.0185 32.2138C97.0185 32.4857 97.0197 32.7576 97.0197 33.0295C96.1745 33.0378 95.3294 33.046 94.4854 33.0543L94.4877 33.0319Z"
        fill={fill}
      />
      <path
        d="M27.6007 37.0893C27.8703 37.0893 28.141 37.0881 28.4106 37.0881C28.4106 37.9298 28.4117 38.7726 28.4117 39.6143C28.1398 39.6143 27.8679 39.6154 27.596 39.6154L27.5771 39.6178C27.5866 38.775 27.5936 37.9321 27.6007 37.0893Z"
        fill={fill}
      />
      <path
        d="M127.967 57.7267C127.125 57.7267 126.283 57.7267 125.44 57.7279L125.437 57.7232C125.439 56.8203 125.441 55.9175 125.442 55.0146C126.285 55.0052 127.127 54.9958 127.97 54.9875V55.017C127.969 55.9198 127.969 56.8239 127.967 57.7267Z"
        fill="#CFE3E7"
      />
      <path
        d="M6.94336 63.1275C6.94336 62.1693 6.94454 61.2112 6.94454 60.2542L6.96455 60.2553C7.23411 60.2553 7.50367 60.2542 7.77324 60.2542C7.77677 61.2112 7.78147 62.1682 7.78501 63.1252C7.51074 63.1322 7.23529 63.1393 6.96102 63.1463C6.96102 63.1452 6.94336 63.1275 6.94336 63.1275Z"
        fill={fill}
      />
      <path
        d="M84.1926 47.4318C83.2367 47.4318 82.2797 47.4329 81.3239 47.4329L81.3086 47.4365C81.3157 46.5195 81.3227 45.6025 81.3298 44.6855C82.2856 44.6808 83.2414 44.6761 84.1961 44.6714L84.1926 44.6902C84.1914 45.6037 84.1926 46.5183 84.1926 47.4318Z"
        fill="#F1F0F0"
      />
      <path
        d="M79.1465 26.7943C79.4184 26.7943 79.6903 26.7943 79.9622 26.7931L79.9834 26.7896C79.9834 27.6359 79.9834 28.4834 79.9834 29.3298L79.9622 29.3263C79.6903 29.3263 79.4184 29.3263 79.1465 29.3263C79.1465 28.4823 79.1465 27.6383 79.1465 26.7943Z"
        fill={fill}
      />
      <path
        d="M90.2911 39.6121C90.0145 39.6144 89.7379 39.6156 89.4612 39.6179C89.453 38.7751 89.4448 37.9323 89.4365 37.0895L89.4565 37.093C89.7332 37.0906 90.011 37.0883 90.2876 37.0859C90.2958 37.9276 90.3041 38.7704 90.3123 39.6121H90.2911Z"
        fill={fill}
      />
      <path
        d="M90.2839 37.0859C90.0073 37.0882 89.7295 37.0906 89.4529 37.0929C89.447 36.2972 89.4423 35.5015 89.4364 34.7057C89.4352 34.5986 89.4293 34.4927 89.4258 34.3855L89.4446 34.3667C89.7318 34.3702 90.0191 34.3738 90.3063 34.3773C90.3075 35.2802 90.3086 36.183 90.3098 37.0859H90.2839Z"
        fill={fill}
      />
      <path
        d="M55.7822 24.0691C54.9382 24.0691 54.093 24.0691 53.249 24.0691C53.2514 23.7925 53.2537 23.5147 53.2561 23.2381L53.2549 23.2122C54.0954 23.2122 54.9347 23.2122 55.7751 23.2133C55.7751 23.2133 55.7751 23.2392 55.7751 23.2404C55.7775 23.517 55.7799 23.7937 55.7822 24.0691Z"
        fill={fill}
      />
      <path
        d="M89.4493 29.3193C89.7283 29.3217 90.0061 29.3241 90.2851 29.3252H90.3122C90.311 30.2869 90.3086 31.2475 90.3074 32.2092C90.0191 32.2127 89.7307 32.2174 89.4434 32.221L89.4258 32.201C89.4328 31.2404 89.4411 30.2799 89.4493 29.3193Z"
        fill={fill}
      />
      <path
        d="M66.0771 39.6155C66.9941 39.6167 67.9099 39.6178 68.8269 39.619L68.8446 39.6155C68.841 40.5737 68.8387 41.5307 68.8352 42.4888C67.9158 42.4924 66.9965 42.4947 66.0771 42.4983C66.0771 41.5366 66.0771 40.576 66.0771 39.6155Z"
        fill="#F1F0F0"
      />
      <path
        d="M28.8936 42.4984C28.9006 41.5367 28.9077 40.575 28.9147 39.6133C29.1914 39.6145 29.468 39.6156 29.7446 39.618L29.7729 39.6168C29.767 40.5797 29.7623 41.5426 29.7564 42.5055C29.4762 42.5102 29.1961 42.5137 28.9159 42.5184L28.8936 42.4984Z"
        fill={fill}
      />
      <path
        d="M27.601 39.6154C27.8729 39.6154 28.1448 39.6143 28.4168 39.6143C28.4203 40.5736 28.425 41.5342 28.4285 42.4935C28.4285 42.4935 28.4085 42.51 28.4097 42.51C28.1448 42.51 27.8788 42.5088 27.614 42.5088C27.6069 42.5018 27.5998 42.4935 27.5928 42.4865C27.5951 41.5294 27.5975 40.5724 27.601 39.6154Z"
        fill={fill}
      />
      <path
        d="M29.7449 39.6179C29.4683 39.6168 29.1917 39.6156 28.915 39.6132C28.915 38.7716 28.915 37.9311 28.915 37.0895C29.1917 37.0883 29.4695 37.0871 29.7461 37.0859C29.7449 37.9299 29.7449 38.7739 29.7449 39.6179Z"
        fill={fill}
      />
      <path
        d="M28.4261 42.4937C28.5826 42.496 28.7392 42.4972 28.8957 42.4995L28.9169 42.5184C28.911 42.8009 28.9063 43.0822 28.9004 43.3647C28.7404 43.3683 28.5803 43.3718 28.4202 43.3753C28.4155 43.0869 28.4119 42.7985 28.4072 42.5113L28.4261 42.4937Z"
        fill={fill}
      />
      <path
        d="M7.771 60.254C7.50144 60.254 7.23188 60.2552 6.96232 60.2552C6.96114 59.4112 6.96114 58.5684 6.95996 57.7244C7.23305 57.7232 7.50615 57.722 7.77924 57.722L7.79808 57.7185C7.79455 58.566 7.79219 59.4124 7.78866 60.2599L7.771 60.254Z"
        fill={fill}
      />
      <path
        d="M84.1937 43.3764C84.1937 43.5318 84.1937 43.686 84.1937 43.8413L84.1973 43.8566C83.2391 43.8519 82.2797 43.8461 81.3215 43.8413C81.3168 43.686 81.3133 43.5306 81.3086 43.3752L81.3098 43.374C82.2703 43.3752 83.232 43.3752 84.1937 43.3764Z"
        fill="#F1F1F1"
      />
      <path
        d="M80.4854 42.4912C80.7561 42.4983 81.0268 42.5042 81.2987 42.5112C81.3023 42.7984 81.307 43.0868 81.3117 43.3741L81.3105 43.3752C81.0398 43.3729 80.7702 43.3705 80.4995 43.3694C80.4948 43.0762 80.4901 42.7843 80.4854 42.4912Z"
        fill={outline}
      />
      <path
        d="M48.2071 39.6118C48.2048 40.5759 48.2024 41.5388 48.2013 42.5028L48.1977 42.5087C47.2737 42.504 46.3508 42.4993 45.4268 42.4946C45.4268 41.5364 45.4279 40.5771 45.4279 39.6189C46.3485 39.6177 47.269 39.6154 48.1883 39.6142L48.2071 39.6118Z"
        fill="#F1F1F1"
      />
      <path
        d="M81.3035 21.9234C81.307 22.1965 81.3105 22.4684 81.3141 22.7415C81.0386 22.7415 80.7632 22.7415 80.4866 22.7415C80.4842 22.4637 80.4818 22.1859 80.4795 21.9069V21.9045C80.7538 21.9116 81.0292 21.9175 81.3035 21.9234Z"
        fill={outline}
      />
      <path
        d="M8.29297 52.8333C8.57313 52.8344 8.85328 52.8344 9.13462 52.8356L9.13579 52.8368C9.12991 53.1111 9.12402 53.3853 9.11814 53.6596C8.84504 53.6643 8.57195 53.6678 8.29885 53.6725H8.30003C8.29768 53.3936 8.29532 53.1146 8.29297 52.8368V52.8333Z"
        fill={outline}
      />
      <path
        d="M122.547 47.4327C122.553 48.2579 122.559 49.0831 122.565 49.9082L122.548 49.9047C122.279 49.9059 122.009 49.9059 121.74 49.9071C121.731 49.0807 121.723 48.2555 121.715 47.4292L121.733 47.4327C122.004 47.4339 122.275 47.4327 122.547 47.4327Z"
        fill={fill}
      />
      <path
        d="M121.215 44.6843C121.38 44.6867 121.545 44.689 121.71 44.6914C121.716 45.606 121.723 46.5195 121.729 47.4329C121.729 47.4329 121.711 47.4282 121.711 47.4294C121.55 47.4317 121.388 47.4341 121.227 47.4353C121.223 46.5195 121.217 45.6037 121.212 44.689L121.215 44.6843Z"
        fill="#F1EFEF"
      />
      <path
        d="M76.373 37.086C76.373 36.1878 76.373 35.2897 76.373 34.3915C77.2924 34.3903 78.2105 34.3892 79.1299 34.3892C79.1358 35.2897 79.1405 36.189 79.1464 37.0883L79.1311 37.0848C78.2117 37.086 77.2924 37.086 76.373 37.086Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.3726 34.3727C75.5486 34.3727 74.7234 34.3727 73.8994 34.3727C73.8994 34.1032 73.8994 33.8336 73.8994 33.564C74.7258 33.5558 75.5509 33.5475 76.3773 33.5393L76.3726 33.5581C76.3726 33.8301 76.3726 34.1008 76.3726 34.3727Z"
        fill={fill}
      />
      <path
        d="M53.2531 34.3738C52.2926 34.3773 51.3332 34.3809 50.3727 34.3856C50.3692 34.1113 50.3668 33.837 50.3633 33.5628C50.3715 33.5557 50.3786 33.5486 50.3868 33.5416C51.3427 33.5404 52.2985 33.5392 53.2543 33.5369L53.252 33.5616C53.252 33.8335 53.2531 34.1031 53.2531 34.3738Z"
        fill={fill}
      />
      <path
        d="M55.7787 33.0884C55.7787 33.2402 55.7787 33.3909 55.7787 33.5427C54.9358 33.5498 54.0918 33.5557 53.249 33.5627L53.2514 33.538C53.2514 33.3768 53.2514 33.2167 53.2514 33.0554L53.2502 33.0283C54.0918 33.0319 54.9323 33.0366 55.774 33.0401C55.774 33.0566 55.7751 33.0719 55.7787 33.0884Z"
        fill="#CFE2E5"
      />
      <path
        d="M17.2441 44.6712C17.2453 44.3993 17.2465 44.1273 17.2477 43.8566L17.25 43.8542C17.5372 43.8566 17.8245 43.859 18.1117 43.8613C18.1129 44.1285 18.114 44.3957 18.1152 44.6629C17.8256 44.6653 17.5349 44.6688 17.2441 44.6712Z"
        fill={outline}
      />
      <path
        d="M7.777 57.7219C7.77346 56.8214 7.77111 55.9197 7.76758 55.0192L7.76876 55.0181C7.94415 55.0216 8.11954 55.0239 8.29375 55.0275C8.2914 55.9268 8.28905 56.8273 8.28551 57.7266C8.12189 57.7243 7.95827 57.7207 7.79465 57.7184L7.777 57.7219Z"
        fill="#F1EFEF"
      />
      <path
        d="M80.4814 32.2008C80.3119 32.1973 80.1412 32.1938 79.9717 32.1902C79.9682 31.2356 79.9635 30.2809 79.96 29.3263L79.9811 29.3298C80.1424 29.3275 80.3037 29.3251 80.4649 29.3228C80.4697 30.2821 80.4755 31.2403 80.4814 32.2008C80.4814 32.2008 80.4814 32.1997 80.4814 32.2008Z"
        fill="#F1F1F1"
      />
      <path
        d="M84.1967 29.3228C85.0383 29.3228 85.8812 29.3228 86.7228 29.3228C86.7228 30.2821 86.7228 31.2415 86.7228 32.2008C85.88 32.2067 85.0372 32.2114 84.1943 32.2173C84.1943 32.2173 84.1955 32.1961 84.1967 32.1961C84.1955 31.2403 84.1943 30.2833 84.1943 29.3275L84.1967 29.3228Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1947 32.2172C84.1947 32.4868 84.1959 32.7564 84.1959 33.0271L84.1971 33.0542C83.2413 33.0506 82.2854 33.0471 81.3296 33.0424L81.3072 33.0247C81.3061 32.7552 81.3049 32.4856 81.3037 32.2161L81.3214 32.1984C82.2795 32.1972 83.2377 32.1972 84.1959 32.196C84.1971 32.196 84.1947 32.2172 84.1947 32.2172Z"
        fill={fill}
      />
      <path
        d="M130.705 70.548C130.695 69.7051 130.687 68.8623 130.678 68.0195L130.7 68.023C130.979 68.023 131.257 68.0218 131.536 68.0218L131.556 68.0183C131.556 68.86 131.556 69.7028 131.556 70.5444L131.536 70.5409C131.259 70.5433 130.981 70.5456 130.705 70.548Z"
        fill={fill}
      />
      <path
        d="M101.954 68.022C101.953 68.7589 101.953 69.4958 101.951 70.2327C101.951 70.3386 101.934 70.4434 101.926 70.5493C101.646 70.5481 101.366 70.5469 101.086 70.5446L101.07 70.5481C101.076 69.7041 101.082 68.8601 101.088 68.0161C101.368 68.0185 101.648 68.0208 101.93 68.0232L101.954 68.022Z"
        fill={fill}
      />
      <path
        d="M89.4554 70.5483C89.4471 69.7055 89.4389 68.8615 89.4307 68.0187L89.4519 68.0222C89.7297 68.0199 90.0063 68.0175 90.2841 68.0151C90.2923 68.858 90.3017 69.7008 90.31 70.5436L90.2876 70.5413C90.011 70.5436 89.7332 70.546 89.4554 70.5483Z"
        fill={fill}
      />
      <path
        d="M48.2118 70.5481C48.2048 69.7041 48.1965 68.8613 48.1895 68.0173L48.2083 68.022C48.4849 68.0197 48.7615 68.0173 49.0393 68.0161C49.0476 68.1221 49.0629 68.2268 49.0641 68.3328C49.0676 69.0697 49.0676 69.8054 49.0688 70.5422L49.0429 70.5411C48.7651 70.5434 48.4884 70.5458 48.2118 70.5481Z"
        fill={fill}
      />
      <path
        d="M29.7729 68.0196C29.7646 68.8625 29.7564 69.7053 29.747 70.5481C29.4692 70.5458 29.1914 70.5434 28.9147 70.5411L28.8936 70.5446C28.9018 69.7018 28.91 68.8589 28.9183 68.0161C29.1961 68.0185 29.4739 68.0208 29.7505 68.0232C29.7517 68.0232 29.7729 68.0196 29.7729 68.0196Z"
        fill={fill}
      />
      <path
        d="M17.2782 70.5483C17.27 69.8126 17.2618 69.0769 17.2535 68.3412C17.2524 68.2341 17.2512 68.1281 17.25 68.021L17.2747 68.0234C17.5513 68.021 17.8291 68.0187 18.1058 68.0151C18.1128 68.858 18.1211 69.702 18.1281 70.5448L18.1093 70.5413C17.8315 70.5436 17.5549 70.546 17.2782 70.5483Z"
        fill={fill}
      />
      <path
        d="M49.5533 49.9072C49.8217 49.9072 50.0913 49.9072 50.3597 49.9072L50.3832 49.906C50.3809 50.8818 50.3797 51.8577 50.3773 52.8335C50.116 52.8453 49.7464 52.7582 49.6216 52.8947C49.4804 53.0489 49.5592 53.4044 49.5416 53.6716C49.3838 53.6681 49.2261 53.6658 49.0684 53.6622C49.0684 53.3915 49.0695 53.1207 49.0695 52.85C49.219 52.8182 49.3685 52.7864 49.531 52.7511C49.531 51.7988 49.531 50.8536 49.531 49.9072H49.5533Z"
        fill={fill}
      />
      <path
        d="M131.556 70.5446C131.556 69.7029 131.556 68.8601 131.556 68.0185C131.709 68.0185 131.863 68.0185 132.017 68.0185L132.037 68.0161C132.031 68.8601 132.025 69.7041 132.019 70.5481C131.865 70.5469 131.711 70.5458 131.556 70.5446Z"
        fill="#CFE3E7"
      />
      <path
        d="M7.78501 65.3228C7.51074 65.3158 7.23646 65.3099 6.96219 65.3028C6.95631 65.0286 6.94925 64.7555 6.94336 64.4812H6.94454C7.22116 64.4847 7.49661 64.4883 7.77324 64.4918C7.77677 64.7684 7.78147 65.0439 7.78501 65.3205V65.3228Z"
        fill={outline}
      />
      <path
        d="M53.246 29.3265C53.246 30.2835 53.246 31.2405 53.246 32.1975L53.2496 32.2128C52.289 32.2093 51.3285 32.2046 50.3691 32.201C50.3738 31.2417 50.3774 30.2811 50.3821 29.3218C51.3367 29.3241 52.2914 29.3253 53.246 29.3265Z"
        fill="#F1F1F1"
      />
      <path
        d="M79.1473 37.0893C79.4193 37.0882 79.6912 37.087 79.9631 37.0858L79.9843 37.0823C79.9843 37.9286 79.9855 38.7738 79.9855 39.6202L79.9643 39.6166C79.6912 39.6155 79.4193 39.6143 79.1462 39.6131L79.1309 39.6178C79.1309 38.7738 79.1309 37.9298 79.132 37.0858L79.1473 37.0893Z"
        fill={fill}
      />
      <path
        d="M97.0187 33.0282C97.0187 32.7563 97.0176 32.4844 97.0176 32.2125C97.9299 32.2042 98.8421 32.196 99.7544 32.1877C99.765 32.4679 99.7756 32.7481 99.7862 33.0282C99.7626 33.0306 99.7379 33.0317 99.7144 33.0341C98.8162 33.0412 97.9169 33.0494 97.0187 33.0565C97.0176 33.0565 97.0187 33.0282 97.0187 33.0282Z"
        fill={fill}
      />
      <path
        d="M131.545 63.1441C131.549 63.416 131.552 63.6868 131.557 63.9587V63.9599C131.267 63.9552 130.979 63.9516 130.69 63.9469C130.686 63.6785 130.682 63.409 130.678 63.1406L130.679 63.1394C130.968 63.1406 131.257 63.1429 131.545 63.1441Z"
        fill={outline}
      />
      <path
        d="M27.5995 70.5459C27.5925 69.7019 27.5842 68.8567 27.5771 68.0127L27.5972 68.0162C27.8679 68.0162 28.1398 68.0162 28.4106 68.0162C28.4164 68.8602 28.4223 69.7042 28.4282 70.5482L28.4129 70.5447C28.1422 70.5447 27.8703 70.5447 27.5995 70.5459Z"
        fill={fill}
      />
      <path
        d="M19.4495 68.0115C19.4413 68.8555 19.433 69.7006 19.4248 70.5446C19.1529 70.5446 18.881 70.5447 18.6091 70.5435L18.5938 70.547C18.5996 69.703 18.6055 68.859 18.6114 68.015C18.8833 68.015 19.1552 68.0138 19.4272 68.0138L19.4495 68.0115Z"
        fill={fill}
      />
      <path
        d="M9.13582 68.0137C9.12993 68.8577 9.12287 69.7017 9.11699 70.5457C8.84625 70.5457 8.57551 70.5445 8.30477 70.5445L8.28711 70.5492C8.28711 69.704 8.28711 68.8589 8.28711 68.0137L8.30477 68.0172C8.57668 68.0172 8.8486 68.0172 9.12052 68.0184C9.11934 68.0184 9.13582 68.0137 9.13582 68.0137Z"
        fill={fill}
      />
      <path
        d="M79.9826 39.6202C79.9826 38.7738 79.9814 37.9286 79.9814 37.0823C80.1451 37.0823 80.3087 37.0823 80.4711 37.0823C80.4782 37.9263 80.4853 38.7703 80.4923 39.6143L80.4664 39.6119C80.3052 39.6155 80.1439 39.6178 79.9826 39.6202Z"
        fill="#CFE3E7"
      />
      <path
        d="M6.95996 68.0161C7.23188 68.0173 7.50379 68.0185 7.77689 68.0196C7.78513 68.8636 7.79455 69.7088 7.80279 70.5528L7.78042 70.5505C7.50733 70.5493 7.23423 70.5493 6.96114 70.5481C6.95996 69.7029 6.95996 68.8589 6.95996 68.0161Z"
        fill={fill}
      />
      <path
        d="M37.9063 70.5471C37.9004 69.7031 37.8946 68.8591 37.8887 68.0151L37.904 68.0187C38.1747 68.0187 38.4455 68.0175 38.7162 68.0175C38.7233 68.8615 38.7315 69.7067 38.7386 70.5507L38.7197 70.546C38.4478 70.5471 38.1771 70.5471 37.9063 70.5471Z"
        fill={fill}
      />
      <path
        d="M40.0784 68.0151C40.0725 68.8591 40.0667 69.7031 40.0608 70.5471C39.7889 70.5471 39.5169 70.5483 39.2438 70.5483L39.2227 70.5519C39.2309 69.7079 39.2391 68.8627 39.2474 68.0187C39.5193 68.0187 39.7912 68.0187 40.0631 68.0198L40.0784 68.0151Z"
        fill={fill}
      />
      <path
        d="M50.3819 68.0137C50.3748 68.8577 50.3678 69.7017 50.3619 70.5469C50.0912 70.5457 49.8204 70.5457 49.5497 70.5445L49.5332 70.5492C49.5391 69.7052 49.5462 68.8612 49.552 68.016C49.8228 68.016 50.0935 68.0172 50.3643 68.0172L50.3819 68.0137Z"
        fill={fill}
      />
      <path
        d="M58.5421 70.5435C58.5398 69.8054 58.5386 69.0674 58.5351 68.3293C58.5351 68.2234 58.5209 68.1174 58.5127 68.0115L58.5398 68.0127C58.8129 68.0138 59.086 68.015 59.3591 68.0162C59.3649 68.8602 59.3708 69.7042 59.3767 70.5482L59.3614 70.5446C59.0883 70.5435 58.8152 70.5435 58.5421 70.5435Z"
        fill={fill}
      />
      <path
        d="M60.6896 68.0115C60.6802 68.8555 60.6719 69.6995 60.6625 70.5435C60.3894 70.5435 60.1175 70.5435 59.8444 70.5435L59.8291 70.547C59.835 69.703 59.8409 68.859 59.8468 68.015C60.1199 68.0138 60.3918 68.0138 60.6649 68.0127L60.6896 68.0115Z"
        fill={fill}
      />
      <path
        d="M68.8433 70.5459C68.8362 69.7019 68.8291 68.8579 68.8232 68.0127L68.8409 68.0162C69.1116 68.0162 69.3824 68.015 69.6531 68.015C69.659 68.859 69.6661 69.703 69.6719 70.547L69.6567 70.5423C69.3847 70.5447 69.114 70.5459 68.8433 70.5459Z"
        fill={fill}
      />
      <path
        d="M79.1485 70.5471C79.1426 69.7031 79.1367 68.8591 79.1309 68.0151L79.1462 68.0187C79.4181 68.0187 79.69 68.0175 79.9619 68.0175C79.9702 68.8615 79.9784 69.7067 79.9855 70.5507L79.9643 70.5471C79.6924 70.5471 79.4204 70.5471 79.1485 70.5471Z"
        fill={fill}
      />
      <path
        d="M81.3198 68.0151C81.3139 68.8591 81.308 69.7031 81.3022 70.5471C81.0314 70.5471 80.7595 70.5471 80.4888 70.5471L80.4688 70.5519C80.4758 69.7079 80.4841 68.8627 80.4911 68.0187C80.7619 68.0187 81.0338 68.0198 81.3045 68.0198L81.3198 68.0151Z"
        fill={fill}
      />
      <path
        d="M91.6241 68.0127C91.617 68.8567 91.61 69.7019 91.6029 70.5459C91.3322 70.5447 91.0614 70.5447 90.7907 70.5435L90.7754 70.547C90.7813 69.703 90.7872 68.859 90.7931 68.015C91.0638 68.015 91.3345 68.015 91.6064 68.015L91.6241 68.0127Z"
        fill={fill}
      />
      <path
        d="M99.7847 70.5446C99.7764 69.7006 99.7682 68.8567 99.7588 68.0115L99.7823 68.0138C100.054 68.015 100.327 68.015 100.599 68.0162C100.605 68.8602 100.611 69.7042 100.617 70.5482L100.602 70.5446C100.33 70.5435 100.058 70.5446 99.7847 70.5446Z"
        fill={fill}
      />
      <path
        d="M110.09 70.5471C110.083 69.7031 110.077 68.8591 110.07 68.0151L110.087 68.0187C110.358 68.0187 110.628 68.0175 110.899 68.0175C110.906 68.8615 110.912 69.7055 110.919 70.5507L110.903 70.546C110.632 70.546 110.361 70.546 110.09 70.5471Z"
        fill={fill}
      />
      <path
        d="M112.265 68.0151C112.259 68.8591 112.253 69.7031 112.247 70.5471C111.974 70.5483 111.701 70.5495 111.427 70.5507L111.403 70.553C111.413 69.709 111.421 68.865 111.429 68.0198C111.702 68.0198 111.975 68.0198 112.25 68.0198C112.25 68.0187 112.265 68.0151 112.265 68.0151Z"
        fill={fill}
      />
      <path
        d="M120.389 70.5471C120.383 69.7031 120.377 68.8591 120.371 68.0151L120.386 68.0187C120.659 68.0187 120.931 68.0187 121.205 68.0187C121.213 68.8627 121.221 69.7079 121.229 70.5519C121.229 70.5519 121.207 70.5483 121.207 70.5495C120.935 70.5483 120.662 70.5483 120.389 70.5471Z"
        fill={fill}
      />
      <path
        d="M122.564 68.0151C122.558 68.8591 122.552 69.7031 122.545 70.5471C122.274 70.5471 122.003 70.546 121.733 70.546L121.715 70.5507C121.722 69.7067 121.729 68.8615 121.735 68.0175C122.006 68.0187 122.276 68.0187 122.547 68.0198L122.564 68.0151Z"
        fill={fill}
      />
      <path
        d="M76.3787 33.5391C75.5524 33.5473 74.7272 33.5556 73.9009 33.5638C73.8808 33.5579 73.8608 33.5521 73.8408 33.545C73.8408 33.379 73.8408 33.2119 73.8408 33.0459C73.8608 33.0388 73.8808 33.0329 73.9009 33.0259C74.7272 33.0353 75.5535 33.0447 76.3799 33.0541C76.3787 33.2154 76.3787 33.3778 76.3787 33.5391Z"
        fill="#CFE2E5"
      />
      <path
        d="M6.95631 63.1452C7.23058 63.1381 7.50603 63.1311 7.7803 63.124V63.1264C7.77559 63.403 7.77088 63.6784 7.76617 63.9551C7.4919 63.9574 7.21763 63.9598 6.94336 63.9621V63.9633C6.94807 63.6914 6.9516 63.4183 6.95631 63.1452Z"
        fill={outline}
      />
      <path
        d="M48.1918 39.6144C47.2713 39.6156 46.3508 39.6179 45.4315 39.6191L45.4268 39.6144C45.4268 38.7716 45.4279 37.9288 45.4279 37.0859C46.3485 37.0859 47.269 37.0871 48.1895 37.0871L48.213 37.0859C48.2071 37.9288 48.2001 38.7716 48.1918 39.6144Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.133 34.3716C35.133 34.1009 35.1318 33.8301 35.1318 33.5594C36.0488 33.5558 36.9658 33.5511 37.884 33.5476L37.9052 33.5641C37.9028 33.8372 37.8993 34.1091 37.8969 34.3822C36.9752 34.3857 36.0535 34.3881 35.1318 34.3916L35.133 34.3716Z"
        fill={fill}
      />
      <path
        d="M37.8803 33.5475C37.8791 33.3792 37.8791 33.2097 37.8779 33.0413L37.8991 33.0237C38.171 33.0249 38.4418 33.0249 38.7137 33.026C38.7219 33.0343 38.7302 33.0425 38.7384 33.0508C38.7349 33.2156 38.7302 33.3815 38.7266 33.5463C38.4512 33.5522 38.1757 33.5581 37.9015 33.564L37.8803 33.5475Z"
        fill={fill}
      />
      <path
        d="M89.453 42.5171C89.7332 42.5124 90.0121 42.5076 90.2923 42.5029L90.3005 42.5123C90.2958 42.796 90.2923 43.0786 90.2876 43.3622C90.0063 43.3646 89.7237 43.3669 89.4424 43.3693L89.4365 43.3646C89.4424 43.0821 89.4483 42.7996 89.453 42.5171Z"
        fill={outline}
      />
      <path
        d="M90.3158 44.6723C90.0251 44.6687 89.7343 44.664 89.4448 44.6605C89.4424 44.3909 89.4389 44.1225 89.4365 43.853L89.4377 43.8518C89.7249 43.8553 90.0133 43.8589 90.3005 43.8624C90.3052 44.1331 90.3111 44.4027 90.3158 44.6723Z"
        fill={outline}
      />
      <path
        d="M38.714 33.0261C38.4421 33.0249 38.1713 33.0249 37.8994 33.0237C37.9006 32.7541 37.9018 32.4846 37.9029 32.215C38.176 32.2103 38.4491 32.2044 38.7222 32.1997V32.2009C38.7199 32.4763 38.7175 32.7506 38.714 33.0261Z"
        fill={outline}
      />
      <path
        d="M48.1883 37.0873C47.2678 37.0873 46.3473 37.0861 45.4268 37.0861C45.4268 36.1891 45.4268 35.291 45.4268 34.394C46.3484 34.3893 47.2713 34.3846 48.193 34.3799V34.3811C48.1918 35.2816 48.1907 36.1844 48.1883 37.0873Z"
        fill="#F1F1F1"
      />
      <path
        d="M58.5449 33.0295C58.5461 32.7564 58.5473 32.4833 58.5485 32.2102C58.8227 32.2091 59.0958 32.2067 59.3689 32.2043C59.3713 32.481 59.3736 32.7588 59.376 33.0354H59.3748C59.0982 33.0342 58.8215 33.0319 58.5449 33.0295Z"
        fill={outline}
      />
      <path
        d="M59.3711 34.3821C59.0968 34.3809 58.8237 34.3786 58.5495 34.3774C58.5153 33.5664 58.5153 33.5664 59.3746 33.5522C59.3735 33.83 59.3723 34.1067 59.3711 34.3821Z"
        fill={outline}
      />
      <path
        d="M59.374 33.5534C59.374 33.3815 59.3752 33.2085 59.3764 33.0366H59.3776C59.5294 33.0366 59.6813 33.0366 59.8331 33.0366H59.8343C59.8319 33.2073 59.8307 33.3768 59.8284 33.5475C59.6754 33.5487 59.5247 33.551 59.374 33.5534Z"
        fill="#F1EFEF"
      />
      <path
        d="M110.076 42.4902C110.08 41.5308 110.083 40.5726 110.088 39.6133C110.358 39.6145 110.628 39.6145 110.898 39.6156L110.92 39.6145C110.918 40.5726 110.917 41.5308 110.914 42.489C110.914 42.489 110.892 42.5078 110.893 42.5078C110.628 42.5078 110.363 42.5078 110.099 42.5078C110.097 42.509 110.076 42.4902 110.076 42.4902Z"
        fill={fill}
      />
      <path
        d="M101.946 34.3645C101.658 34.3704 101.368 34.3774 101.08 34.3833C101.079 34.1067 101.078 33.83 101.075 33.5522C101.289 33.5534 101.505 33.5628 101.719 33.5534C101.889 33.5464 101.976 33.5934 101.962 33.7806C101.947 33.9748 101.95 34.1691 101.946 34.3645Z"
        fill={outline}
      />
      <path
        d="M101.067 33.0493C101.07 33.0634 101.073 33.0752 101.08 33.0881C101.078 33.2435 101.075 33.3977 101.073 33.5531C100.922 33.5507 100.772 33.5484 100.621 33.546C100.619 33.3753 100.618 33.2058 100.615 33.0352H100.616C100.766 33.0399 100.917 33.0446 101.067 33.0493Z"
        fill="#F1EFEF"
      />
      <path
        d="M68.834 42.4888C68.8375 41.5306 68.8399 40.5724 68.8434 39.6154C69.1141 39.6154 69.3849 39.6166 69.6544 39.6166L69.6756 39.6143C69.6709 40.576 69.665 41.5377 69.6603 42.5006C69.3908 42.5041 69.1224 42.5088 68.8528 42.5123C68.8469 42.5041 68.841 42.4959 68.834 42.4888Z"
        fill={fill}
      />
      <path
        d="M84.1981 24.0706C83.3447 24.0764 82.4901 24.0812 81.6367 24.087C81.5296 24.0882 81.4236 24.0929 81.3165 24.0965L81.2977 24.0788C81.2965 23.7939 81.2953 23.5102 81.293 23.2254L81.313 23.2065C82.2712 23.2242 83.2305 23.243 84.1887 23.2607C84.1922 23.5314 84.1958 23.801 84.1981 24.0706Z"
        fill={fill}
      />
      <path
        d="M84.1902 23.2603C83.232 23.2426 82.2726 23.2238 81.3145 23.2061C81.3145 23.0507 81.3145 22.8954 81.3145 22.74C82.275 22.7435 83.2344 22.747 84.1949 22.7506C84.1961 22.906 84.1972 23.0613 84.1984 23.2155C84.1972 23.232 84.1937 23.2462 84.1902 23.2603Z"
        fill="#F1F0F0"
      />
      <path
        d="M81.3311 33.0413C82.2869 33.0448 83.2428 33.0483 84.1986 33.053C84.1986 33.2155 84.1986 33.3767 84.1986 33.5392C83.2392 33.5439 82.2799 33.5486 81.3205 33.5533L81.3193 33.5545C81.3229 33.3826 81.3264 33.2119 81.3311 33.0413Z"
        fill="#F1EFEF"
      />
      <path
        d="M55.7846 44.6911C54.9406 44.6841 54.0954 44.677 53.2514 44.6688C53.2514 44.398 53.2526 44.1273 53.2526 43.8554L53.249 43.8401C54.093 43.846 54.937 43.8519 55.781 43.8589C55.781 44.1297 55.781 44.4004 55.781 44.6711L55.7846 44.6911Z"
        fill={fill}
      />
      <path
        d="M117.614 43.8379C118.534 43.8391 119.452 43.8402 120.371 43.8414L120.39 43.8579C120.389 44.1275 120.388 44.3959 120.385 44.6654L120.364 44.6866C119.448 44.6819 118.532 44.6784 117.617 44.6736C117.617 44.4017 117.617 44.1298 117.615 43.8579L117.614 43.8379Z"
        fill={fill}
      />
      <path
        d="M115.139 43.3481C115.856 43.3564 116.574 43.3634 117.291 43.3717C117.398 43.3729 117.504 43.3752 117.611 43.3776C117.611 43.5306 117.611 43.6836 117.611 43.8366L117.614 43.8567C116.788 43.8508 115.962 43.8449 115.137 43.839C115.137 43.6836 115.137 43.5294 115.136 43.374L115.139 43.3481Z"
        fill="#CFE3E7"
      />
      <path
        d="M70.9964 37.0859C71.0035 37.9288 71.0117 38.7716 71.0188 39.6144L70.9988 39.6109C70.721 39.6109 70.4431 39.6097 70.1642 39.6097L70.1406 39.6121C70.1489 38.7716 70.1559 37.9323 70.1642 37.0918C70.442 37.0895 70.7186 37.0883 70.9964 37.0859Z"
        fill={fill}
      />
      <path
        d="M69.6592 42.4997C69.6639 41.538 69.6698 40.5762 69.6745 39.6133C69.8287 39.6122 69.9841 39.6122 70.1383 39.611L70.1618 39.6086C70.1548 40.5727 70.1477 41.5368 70.1395 42.5008C69.9794 42.5008 69.8204 42.5008 69.6604 42.4997H69.6592Z"
        fill="#F1F0F0"
      />
      <path
        d="M90.3086 34.3773C90.0214 34.3738 89.7342 34.3703 89.447 34.3667C89.4399 34.0948 89.4328 33.8241 89.4258 33.5522H89.427C89.7071 33.551 89.9861 33.551 90.2662 33.5498C90.2815 33.5545 90.2969 33.5604 90.311 33.5651C90.311 33.8358 90.311 34.1054 90.311 34.3762L90.3086 34.3773Z"
        fill={outline}
      />
      <path
        d="M132.016 68.0185C131.861 68.0185 131.708 68.0185 131.554 68.0185L131.534 68.0221C131.54 67.118 131.545 66.214 131.551 65.3088L131.552 65.3076C131.707 65.3111 131.863 65.3159 132.017 65.3194C132.017 66.2199 132.017 67.1192 132.016 68.0185Z"
        fill="#F1F1F1"
      />
      <path
        d="M39.2473 68.0185C39.2391 68.8625 39.2308 69.7077 39.2226 70.5517C39.0601 70.5517 38.8977 70.5505 38.7353 70.5505C38.7282 69.7065 38.72 68.8613 38.7129 68.0173L38.7388 68.0197C38.8989 68.0197 39.059 68.0197 39.2191 68.0197L39.2473 68.0185Z"
        fill="#CFE3E7"
      />
      <path
        d="M7.79933 70.5518C7.79109 69.7078 7.78168 68.8626 7.77344 68.0186C7.78285 68.0197 7.79345 68.0197 7.80287 68.0186C7.96413 68.0162 8.1254 68.015 8.28667 68.0127C8.28667 68.8579 8.28667 69.703 8.28667 70.5482C8.12422 70.5506 7.96178 70.5518 7.79933 70.5518Z"
        fill="#CFE2E5"
      />
      <path
        d="M80.4932 68.0173C80.4861 68.8613 80.4779 69.7065 80.4708 70.5505C80.3084 70.5505 80.1459 70.5505 79.9835 70.5505C79.9753 69.7065 79.9682 68.8613 79.96 68.0173L79.987 68.0185C80.1471 68.0185 80.3072 68.0185 80.4673 68.0185L80.4932 68.0173Z"
        fill="#CFE3E7"
      />
      <path
        d="M111.431 68.0197C111.423 68.8637 111.414 69.7077 111.406 70.5529C111.243 70.5517 111.081 70.5505 110.919 70.5505C110.912 69.7065 110.906 68.8625 110.899 68.0173L110.922 68.0197C111.082 68.0197 111.242 68.0197 111.402 68.0197L111.417 68.0209L111.431 68.0197Z"
        fill="#CFE2E5"
      />
      <path
        d="M121.739 68.0161C121.732 68.8601 121.725 69.7053 121.719 70.5493C121.557 70.5505 121.394 70.5505 121.232 70.5517C121.224 69.7077 121.215 68.8625 121.207 68.0185H121.235C121.395 68.0185 121.555 68.0185 121.717 68.0185L121.739 68.0161Z"
        fill="#CFE2E5"
      />
      <path
        d="M89.4423 32.2208C89.7307 32.2172 90.0191 32.2125 90.3063 32.209C90.3063 32.209 90.3074 32.2113 90.3074 32.2102C90.3098 32.4833 90.311 32.7575 90.3133 33.0306L90.3122 33.0294C90.0167 33.0294 89.7212 33.0306 89.4258 33.0306V33.0318C89.4305 32.7622 89.4364 32.4915 89.4423 32.2208Z"
        fill={outline}
      />
      <path
        d="M40.0598 32.215C40.0657 32.4881 40.0715 32.7623 40.0774 33.0354H40.0762C39.7949 33.039 39.5136 33.0413 39.2322 33.0448L39.2275 33.0437C39.2311 32.7623 39.2358 32.481 39.2393 32.1997V32.1985C39.5136 32.2032 39.7867 32.2091 40.0598 32.215Z"
        fill={outline}
      />
      <path
        d="M6.94807 63.9631C7.22234 63.9608 7.49661 63.9584 7.77088 63.9561C7.77794 63.9631 7.78618 63.9714 7.79325 63.9784C7.79325 64.142 7.79325 64.3068 7.79442 64.4705C7.78736 64.4775 7.7803 64.4846 7.77206 64.4928C7.49543 64.4893 7.21998 64.4858 6.94336 64.4822C6.94571 64.308 6.94689 64.135 6.94807 63.9631Z"
        fill={fill}
      />
      <path
        d="M127.97 54.9877C127.127 54.9971 126.285 55.0065 125.442 55.0147L125.445 54.99C125.442 54.7158 125.439 54.4403 125.437 54.166C126.279 54.1578 127.122 54.1484 127.966 54.1401L127.964 54.1602C127.965 54.4368 127.967 54.7122 127.97 54.9877Z"
        fill={fill}
      />
      <path
        d="M59.8308 33.0354C59.6789 33.0354 59.5271 33.0354 59.3752 33.0354C59.3729 32.7588 59.3705 32.481 59.3682 32.2043C59.5224 32.202 59.6766 32.1996 59.8296 32.1973L59.8473 32.2149C59.8425 32.4892 59.8367 32.7623 59.8308 33.0354Z"
        fill={fill}
      />
      <path
        d="M59.8483 68.0161C59.8424 68.8601 59.8365 69.7041 59.8306 70.5481C59.6788 70.5481 59.5269 70.5481 59.3751 70.5481C59.3692 69.7041 59.3633 68.8601 59.3574 68.0161L59.3774 68.0185C59.5281 68.0185 59.6776 68.0185 59.8283 68.0185L59.8483 68.0161Z"
        fill="#CFE3E7"
      />
      <path
        d="M18.6079 68.0161C18.602 68.8601 18.5961 69.7041 18.5902 70.5481C18.436 70.5469 18.2818 70.5458 18.1288 70.5458C18.1217 69.7029 18.1135 68.8589 18.1064 68.0161L18.1312 68.0173C18.2842 68.0173 18.436 68.0185 18.5891 68.0185L18.6079 68.0161Z"
        fill="#CFE3E7"
      />
      <path
        d="M90.7966 68.0163C90.7907 68.8603 90.7848 69.7043 90.7789 70.5483C90.6236 70.5471 90.4682 70.5448 90.314 70.5436C90.3057 69.7008 90.2963 68.858 90.2881 68.0151L90.3152 68.0163C90.4694 68.0175 90.6224 68.0175 90.7766 68.0187L90.7966 68.0163Z"
        fill="#CFE3E7"
      />
      <path
        d="M100.617 70.5481C100.611 69.7041 100.605 68.8601 100.6 68.0161L100.62 68.0185C100.77 68.0185 100.92 68.0185 101.07 68.0185L101.09 68.0161C101.085 68.8601 101.079 69.7041 101.073 70.5481C100.921 70.5481 100.769 70.5481 100.617 70.5481Z"
        fill="#CFE3E7"
      />
      <path
        d="M49.5531 68.0163C49.5472 68.8603 49.5401 69.7043 49.5342 70.5495C49.3789 70.5471 49.2246 70.5448 49.0693 70.5424C49.0681 69.8056 49.0681 69.0699 49.0646 68.333C49.0646 68.227 49.0493 68.1211 49.041 68.0163L49.0563 68.0151L49.0716 68.0163C49.2246 68.0175 49.3789 68.0187 49.5319 68.0198L49.5531 68.0163Z"
        fill="#CFE2E5"
      />
      <path
        d="M69.6731 70.5483C69.6672 69.7043 69.6602 68.8603 69.6543 68.0163L69.6743 68.0187C69.8285 68.0175 69.9827 68.0163 70.1369 68.0151H70.1663C70.1569 68.858 70.1475 69.7008 70.1381 70.5424C69.9827 70.5448 69.8273 70.546 69.6731 70.5483Z"
        fill="#CFE3E7"
      />
      <path
        d="M28.4298 70.5483C28.4239 69.7043 28.418 68.8603 28.4121 68.0163L28.4321 68.0187C28.5851 68.0175 28.7394 68.0175 28.8924 68.0163L28.9183 68.0151C28.91 68.858 28.9018 69.7008 28.8936 70.5436C28.7394 70.546 28.5851 70.5471 28.4298 70.5483Z"
        fill="#CFE3E7"
      />
      <path
        d="M63.5479 34.3736C62.592 34.3818 61.6374 34.3889 60.6815 34.3971C60.6733 34.3901 60.6662 34.3842 60.6592 34.3771C60.6592 34.104 60.6604 33.8321 60.6604 33.559C60.6839 33.5579 60.7074 33.5567 60.731 33.5555C61.6703 33.5496 62.6085 33.5437 63.5479 33.5378L63.5467 33.5637C63.5467 33.8333 63.5467 34.1029 63.5479 34.3736Z"
        fill={fill}
      />
      <path
        d="M55.7763 23.2146C54.9358 23.2146 54.0966 23.2146 53.2561 23.2135C53.2537 23.0581 53.2514 22.9039 53.249 22.7485C54.0942 22.7485 54.9394 22.7485 55.7846 22.7473C55.781 22.9039 55.7787 23.0593 55.7763 23.2146Z"
        fill="#CFE2E5"
      />
      <path
        d="M49.0691 47.4388C49.0679 48.2605 49.0667 49.0809 49.0655 49.9026C49.0502 49.9061 49.0361 49.9084 49.0208 49.912C48.7548 49.9108 48.4876 49.9108 48.2215 49.9096C48.218 49.0845 48.2145 48.2593 48.2109 47.4353C48.4899 47.4377 48.7677 47.44 49.0467 47.4424L49.0691 47.4388Z"
        fill={fill}
      />
      <path
        d="M49.0195 49.9105C49.0348 49.907 49.049 49.9047 49.0643 49.9011C49.2196 49.9023 49.375 49.9047 49.5316 49.9058C49.5316 50.8522 49.5316 51.7987 49.5316 52.7498C49.3691 52.7851 49.2196 52.8169 49.0701 52.8487V52.8475C49.0525 51.8693 49.036 50.8899 49.0195 49.9105Z"
        fill="#F1F0F0"
      />
      <path
        d="M79.9644 24.0953C79.6925 24.0894 79.4218 24.0847 79.1498 24.0788C79.1475 23.7916 79.144 23.5032 79.1416 23.216L79.144 23.2136C79.4123 23.216 79.6807 23.2183 79.9491 23.2195C79.9538 23.5114 79.9585 23.8034 79.9644 24.0953C79.9644 24.0953 79.9632 24.0941 79.9644 24.0953Z"
        fill={outline}
      />
      <path
        d="M90.2994 43.8626C90.0121 43.8591 89.7237 43.8555 89.4365 43.852C89.4401 43.6907 89.4436 43.5306 89.4459 43.3694C89.7285 43.367 90.0098 43.3647 90.2923 43.3623L90.3135 43.3776C90.3147 43.5342 90.3158 43.6895 90.3182 43.8461L90.2994 43.8626Z"
        fill={fill}
      />
      <path
        d="M80.4815 21.9067C80.4838 22.1845 80.4862 22.4623 80.4885 22.7413C80.4873 22.7648 80.485 22.7872 80.4838 22.8107C80.3131 22.7907 80.1413 22.7707 79.9706 22.7507L79.9541 22.7318C79.9553 22.4611 79.9553 22.1915 79.9565 21.9208C79.9635 21.9137 79.9706 21.9055 79.9765 21.8984C80.1448 21.8996 80.3131 21.9031 80.4815 21.9067Z"
        fill={fill}
      />
      <path
        d="M90.3096 32.2091C90.3107 31.2474 90.3131 30.2868 90.3143 29.3251C90.4673 29.3239 90.6215 29.3239 90.7745 29.3228C90.7769 30.2833 90.7804 31.2438 90.7828 32.2044C90.625 32.2067 90.4673 32.2091 90.3096 32.2114C90.3107 32.2114 90.3096 32.2091 90.3096 32.2091Z"
        fill="#F1F1F1"
      />
      <path
        d="M89.4293 33.0317C89.7248 33.0317 90.0202 33.0305 90.3157 33.0305C90.2992 33.2036 90.2816 33.3766 90.2651 33.5496C89.9849 33.5508 89.7059 33.5508 89.4258 33.552C89.4281 33.3789 89.4281 33.2047 89.4293 33.0317Z"
        fill={fill}
      />
      <path
        d="M55.7751 33.0401C54.9335 33.0366 54.093 33.0319 53.2514 33.0284C53.2514 32.7564 53.2526 32.4845 53.2526 32.2138L53.249 32.1985C54.093 32.2044 54.937 32.2114 55.781 32.2173C55.7799 32.4916 55.7775 32.7659 55.7751 33.0401Z"
        fill={fill}
      />
      <path
        d="M45.4266 42.4946C46.3506 42.4993 47.2735 42.504 48.1975 42.5088C48.2011 42.7924 48.2046 43.0773 48.2081 43.361L48.1893 43.3775C47.2664 43.3704 46.3447 43.3633 45.4219 43.3575C45.4242 43.0785 45.4266 42.8007 45.4289 42.5217L45.4266 42.4946Z"
        fill={fill}
      />
      <path
        d="M49.0463 47.4398C48.7673 47.4375 48.4895 47.4351 48.2105 47.4328H48.1858C48.1834 46.5158 48.1811 45.6 48.1787 44.683C48.1858 44.6759 48.1928 44.6677 48.1999 44.6606C48.4918 44.6654 48.7849 44.6689 49.0769 44.6736C49.0722 45.4799 49.0686 46.2851 49.0627 47.0902C49.0627 47.2091 49.0521 47.3245 49.0463 47.4398Z"
        fill={fill}
      />
      <path
        d="M48.2036 43.8614C48.2024 44.1286 48.2012 44.3958 48.2001 44.663C48.193 44.6701 48.1859 44.6772 48.1789 44.6854C47.2631 44.6819 46.3461 44.6783 45.4303 44.6748C45.4291 44.4017 45.4279 44.1286 45.4268 43.8555C46.3461 43.852 47.2666 43.8485 48.1859 43.8438L48.2036 43.8614Z"
        fill={fill}
      />
      <path
        d="M18.1165 43.8614C17.8293 43.8591 17.5421 43.8567 17.2549 43.8543C17.2549 43.6954 17.2549 43.5353 17.2549 43.3764C17.2761 43.3753 17.2961 43.3753 17.3173 43.3741C17.5821 43.3705 17.847 43.367 18.1107 43.3623L18.1307 43.3788C18.1318 43.5342 18.1342 43.6884 18.1354 43.8437L18.1165 43.8614Z"
        fill={fill}
      />
      <path
        d="M110.91 42.49C110.913 41.5318 110.914 40.5737 110.916 39.6155C111.078 39.6155 111.241 39.6155 111.403 39.6155C111.412 40.5748 111.419 41.533 111.427 42.4924C111.413 42.4994 111.399 42.5089 111.386 42.5183C111.228 42.5077 111.069 42.4994 110.91 42.49Z"
        fill="#F1EFEF"
      />
      <path
        d="M18.1182 42.509C18.2771 42.5042 18.4349 42.4984 18.5938 42.4937L18.6126 42.5113C18.6079 42.7985 18.6044 43.0869 18.5997 43.3741C18.4419 43.3753 18.2842 43.3765 18.1265 43.3788L18.1064 43.3624C18.1112 43.0775 18.1147 42.7938 18.1182 42.509Z"
        fill={fill}
      />
      <path
        d="M18.6045 43.3743C18.6092 43.0871 18.6127 42.7987 18.6174 42.5115C18.8811 42.5115 19.146 42.5115 19.4096 42.5127C19.4144 42.7822 19.4202 43.0518 19.425 43.3213C19.425 43.3414 19.4261 43.3614 19.4261 43.3802L19.4202 43.3767C19.1483 43.3767 18.8764 43.3767 18.6057 43.3767L18.6045 43.3743Z"
        fill={outline}
      />
      <path
        d="M120.382 44.6652C120.383 44.3956 120.384 44.1272 120.387 43.8577C120.651 43.873 121.006 43.7929 121.156 43.9318C121.292 44.0578 121.206 44.4239 121.216 44.684L121.213 44.6887C120.936 44.6805 120.658 44.6734 120.382 44.6652Z"
        fill={outline}
      />
      <path
        d="M39.2391 32.1985C39.2355 32.4798 39.2308 32.7612 39.2273 33.0425C39.0649 33.0448 38.9012 33.0472 38.7376 33.0495C38.7294 33.0413 38.7211 33.0331 38.7129 33.0248C38.7152 32.7494 38.7176 32.4751 38.7211 32.1997C38.8942 32.2008 39.066 32.1997 39.2391 32.1985Z"
        fill={fill}
      />
      <path
        d="M81.3279 33.0413C81.3243 33.212 81.3208 33.3827 81.3161 33.5533C81.036 33.551 80.7546 33.5498 80.4745 33.5475C80.4709 33.3803 80.4674 33.2143 80.4639 33.0472C80.4721 33.0401 80.4803 33.0342 80.4886 33.026C80.7605 33.0248 81.0324 33.0236 81.3043 33.0225L81.3279 33.0413Z"
        fill={fill}
      />
      <path
        d="M8.2914 52.8359C8.29375 53.1149 8.29611 53.3938 8.29846 53.6716C8.12896 53.6763 7.95827 53.6811 7.78877 53.6869C7.7817 53.6787 7.77464 53.6716 7.76758 53.6634C7.77464 53.3856 7.7817 53.1066 7.78877 52.8276C7.9571 52.8312 8.12425 52.8335 8.2914 52.8359Z"
        fill={fill}
      />
      <path
        d="M55.781 43.8591C54.937 43.8532 54.093 43.8473 53.249 43.8403C53.2502 43.6849 53.2514 43.5307 53.2526 43.3753C54.0954 43.3671 54.9382 43.3588 55.781 43.3506V43.3765C55.7799 43.5307 55.7798 43.6849 55.7787 43.8379C55.7787 43.8403 55.781 43.8591 55.781 43.8591Z"
        fill="#CFE3E7"
      />
      <path
        d="M79.9574 21.9198C79.9562 22.1905 79.9562 22.4601 79.955 22.7308C79.6819 22.7344 79.4088 22.7379 79.1357 22.7414H79.1369C79.1369 22.466 79.1381 22.1905 79.1381 21.9163C79.41 21.9163 79.6831 21.9174 79.9574 21.9198Z"
        fill={outline}
      />
      <path
        d="M81.3214 43.8416C82.2795 43.8463 83.2389 43.8521 84.1971 43.8568C84.1959 44.1288 84.1959 44.3995 84.1947 44.6714C83.2389 44.6761 82.2831 44.6808 81.3284 44.6856L81.3072 44.6667C81.3061 44.3972 81.3049 44.1288 81.3037 43.8592L81.3214 43.8416Z"
        fill={fill}
      />
      <path
        d="M127.96 54.1399C127.117 54.1481 126.275 54.1576 125.431 54.1658L125.432 54.1387C125.433 53.9857 125.433 53.8315 125.434 53.6785L125.432 53.6584C126.276 53.6643 127.12 53.6702 127.964 53.6761C127.963 53.8303 127.961 53.9857 127.96 54.1399Z"
        fill="#CFE3E7"
      />
      <path
        d="M8.29476 55.0276C8.11936 55.0241 7.94397 55.0217 7.76976 55.0182C7.7674 54.7275 7.76505 54.4379 7.7627 54.1471C7.77094 54.1401 7.77918 54.1318 7.78741 54.1248C7.95574 54.1271 8.12407 54.1295 8.2924 54.1318L8.31359 54.1507C8.31477 54.4367 8.31595 54.7216 8.31712 55.0076C8.31006 55.0135 8.303 55.0206 8.29476 55.0276Z"
        fill={fill}
      />
      <path
        d="M53.252 32.2139C53.252 32.4858 53.2508 32.7577 53.2508 33.0285L53.252 33.0556C52.2973 33.0532 51.3427 33.0509 50.388 33.0485C50.3798 33.0414 50.3715 33.0332 50.3633 33.0261C50.3656 32.7519 50.3692 32.4764 50.3715 32.2021C51.3321 32.2057 52.2926 32.2092 53.252 32.2139Z"
        fill={fill}
      />
      <path
        d="M100.618 33.0354C100.62 33.2061 100.621 33.3756 100.623 33.5463L100.603 33.5651C100.328 33.558 100.051 33.5498 99.7759 33.5427C99.7558 33.3732 99.7358 33.2037 99.7158 33.0342C99.7394 33.0319 99.7641 33.0307 99.7876 33.0283C100.065 33.0307 100.342 33.033 100.618 33.0354Z"
        fill={fill}
      />
      <path
        d="M63.5454 33.5368C62.606 33.5427 61.6679 33.5485 60.7285 33.5544C60.7297 33.3802 60.7309 33.2072 60.7332 33.033C61.6702 33.04 62.6084 33.0483 63.5454 33.0553C63.5454 33.2166 63.5454 33.3767 63.5454 33.5368Z"
        fill="#F1F1F1"
      />
      <path
        d="M81.3093 33.0237C81.0374 33.0249 80.7655 33.026 80.4936 33.0272C80.4912 32.7518 80.4889 32.4763 80.4854 32.2009V32.1997C80.7584 32.2056 81.0327 32.2103 81.3058 32.2162C81.3082 32.4846 81.3093 32.7541 81.3093 33.0237Z"
        fill={outline}
      />
      <path
        d="M48.193 34.3784C47.2713 34.3831 46.3484 34.3878 45.4268 34.3925L45.4291 34.3725C45.4291 34.1006 45.4291 33.8286 45.4303 33.5567C46.3473 33.5532 47.2643 33.5497 48.1812 33.5461C48.1883 33.5532 48.1954 33.5603 48.2024 33.5673C48.1989 33.8381 48.1954 34.1088 48.193 34.3784Z"
        fill={fill}
      />
      <path
        d="M48.1846 43.8436C47.2653 43.8472 46.3447 43.8507 45.4254 43.8554L45.4289 43.8401C45.4278 43.6871 45.4266 43.5329 45.4254 43.3798L45.4219 43.3586C46.3447 43.3657 47.2664 43.3728 48.1893 43.3787C48.1881 43.5329 48.1869 43.6882 48.1846 43.8436Z"
        fill="#F1F1F1"
      />
      <path
        d="M131.562 64.4834C131.559 64.7577 131.556 65.0331 131.554 65.3074L131.552 65.3086C131.262 65.3086 130.971 65.3074 130.68 65.3074L130.678 65.3062C130.68 65.0366 130.682 64.7683 130.685 64.4987C130.977 64.494 131.27 64.4881 131.562 64.4834Z"
        fill={outline}
      />
      <path
        d="M45.4268 32.1936C46.3484 32.1983 47.2713 32.203 48.193 32.2077C48.1954 32.4785 48.1977 32.748 48.2012 33.0188C48.193 33.0258 48.1859 33.0341 48.1777 33.0411C47.2619 33.0388 46.3473 33.0353 45.4315 33.0329C45.4303 32.7598 45.4291 32.4867 45.4291 32.2136C45.4291 32.2148 45.4268 32.1936 45.4268 32.1936Z"
        fill={fill}
      />
      <path
        d="M79.1357 22.7403C79.4088 22.7368 79.6819 22.7333 79.955 22.7297L79.9715 22.7486C79.9703 22.8992 79.9703 23.0499 79.9691 23.2006L79.9503 23.2194C79.6819 23.2171 79.4135 23.2147 79.1452 23.2135C79.1428 23.0558 79.1393 22.8981 79.1357 22.7403Z"
        fill={fill}
      />
      <path
        d="M50.3883 33.0483C51.3429 33.0507 52.2976 33.053 53.2522 33.0554C53.2522 33.2167 53.2522 33.3768 53.2522 33.538C52.2964 33.5392 51.3406 33.5404 50.3848 33.5427C50.3871 33.3779 50.3883 33.2131 50.3883 33.0483Z"
        fill="#F1EFEF"
      />
      <path
        d="M45.4291 33.033C46.3449 33.0353 47.2607 33.0388 48.1754 33.0412C48.1765 33.2095 48.1765 33.3779 48.1777 33.5462C47.2607 33.5497 46.3437 33.5532 45.4268 33.5568L45.4303 33.5379C45.4303 33.3767 45.4315 33.2154 45.4315 33.0541L45.4291 33.033Z"
        fill="#F1EFEF"
      />
      <path
        d="M131.558 64.4835C131.266 64.4882 130.973 64.4941 130.681 64.4988C130.673 64.4906 130.664 64.4824 130.656 64.4741C130.659 64.3046 130.661 64.1351 130.664 63.9656L130.686 63.9468C130.975 63.9515 131.264 63.955 131.553 63.9597C131.554 64.1339 131.556 64.3093 131.558 64.4835Z"
        fill={fill}
      />
      <path
        d="M8.29405 54.1319C8.12572 54.1295 7.95739 54.1272 7.78906 54.1248C7.78906 53.9789 7.79024 53.8329 7.79024 53.6869C7.95975 53.6822 8.13043 53.6775 8.29994 53.6716H8.29876C8.29758 53.8258 8.29641 53.9789 8.29405 54.1319Z"
        fill="#F1EFEF"
      />
      <path
        d="M70.9999 68.0222C70.7221 68.0199 70.4455 68.0175 70.1689 68.0151H70.1406C70.143 67.4066 70.1453 66.798 70.1477 66.1906C70.1465 66.1141 70.1453 66.0388 70.1442 65.9622C70.1442 65.7645 70.1442 65.5679 70.1442 65.3701C70.1618 65.3501 70.1795 65.3313 70.1971 65.3113C70.4667 65.3066 70.7363 65.303 71.0058 65.2983L71.0246 65.3172C71.0152 66.2189 71.0082 67.1205 70.9999 68.0222Z"
        fill={fill}
      />
      <path
        d="M76.3693 65.3052C76.3693 65.0321 76.3693 64.7578 76.3682 64.4848V64.4553C77.2863 64.4636 78.2057 64.4718 79.1238 64.4801C79.1309 64.7543 79.1368 65.0274 79.1438 65.3017L79.1262 65.3193C78.208 65.3146 77.2887 65.3099 76.3693 65.3052Z"
        fill={fill}
      />
      <path
        d="M79.9561 68.0186C79.6841 68.0186 79.4122 68.0198 79.1403 68.0198C79.1356 67.1205 79.1297 66.22 79.125 65.3206L79.1427 65.303C79.4158 65.3089 79.69 65.3148 79.9631 65.3206C79.9702 66.22 79.9761 67.1205 79.9831 68.0198L79.9561 68.0186Z"
        fill={fill}
      />
      <path
        d="M73.8401 64.4681C72.9019 64.4728 71.9626 64.4786 71.0244 64.4834C71.0256 64.3115 71.0268 64.1396 71.0268 63.9678C71.9649 63.969 72.9031 63.969 73.8425 63.9701C73.8401 64.1361 73.8401 64.3021 73.8401 64.4681Z"
        fill="#F1EFEF"
      />
      <path
        d="M73.8408 64.4685C73.8408 64.3025 73.842 64.1365 73.842 63.9705C73.862 63.9647 73.882 63.9588 73.902 63.9529C74.7272 63.9599 75.5524 63.967 76.3775 63.9753C76.3764 64.1353 76.374 64.2954 76.3728 64.4567V64.4861C75.5488 64.4885 74.726 64.4897 73.902 64.492C73.8808 64.4838 73.8608 64.4755 73.8408 64.4685Z"
        fill="#CFE2E5"
      />
      <path
        d="M71.001 65.2982C70.7314 65.3029 70.4618 65.3064 70.1923 65.3111C70.1711 65.2699 70.1511 65.2299 70.1299 65.1887L70.1311 65.1616C70.184 64.938 70.1676 64.6131 70.3088 64.5177C70.4771 64.4035 70.7785 64.4859 71.0221 64.4836C71.0151 64.7555 71.008 65.0263 71.001 65.2982Z"
        fill={outline}
      />
      <path
        d="M91.6235 33.0402C92.5781 33.0379 93.5339 33.0343 94.4886 33.032L94.485 33.0532C94.4874 33.2144 94.4898 33.3757 94.4921 33.537C93.5375 33.5393 92.584 33.5405 91.6293 33.5429C91.6258 33.3757 91.6234 33.2097 91.6211 33.0426L91.6235 33.0402Z"
        fill="#F1F1F1"
      />
      <path
        d="M90.7825 32.2043C91.0555 32.2067 91.3275 32.2102 91.6006 32.2126C91.6076 32.488 91.6147 32.7647 91.6229 33.0401L91.6194 33.0425C91.3381 33.0401 91.0579 33.0378 90.7766 33.0366H90.7754C90.7789 32.7588 90.7801 32.4821 90.7825 32.2043Z"
        fill={outline}
      />
      <path
        d="M115.136 43.3753C115.136 43.5307 115.136 43.6849 115.137 43.8402L115.14 43.8567C114.182 43.852 113.224 43.8461 112.266 43.8414C112.262 43.686 112.257 43.5307 112.254 43.3765L112.255 43.3753C113.214 43.3741 114.175 43.3753 115.136 43.3753Z"
        fill="#F1F1F1"
      />
      <path
        d="M110.911 42.49C111.07 42.4994 111.228 42.5088 111.387 42.5182C111.385 42.7984 111.384 43.0786 111.382 43.3587C111.222 43.3658 111.063 43.3717 110.903 43.3787C110.898 43.0891 110.893 42.7996 110.889 42.51L110.911 42.49Z"
        fill={fill}
      />
      <path
        d="M112.254 43.3752C112.257 43.5306 112.262 43.686 112.265 43.8402L112.248 43.8579C111.973 43.8508 111.699 43.8437 111.425 43.8379C111.426 43.686 111.426 43.5353 111.427 43.3835C111.703 43.3811 111.978 43.3776 112.254 43.3752Z"
        fill={fill}
      />
      <path
        d="M111.43 43.3833C111.429 43.5351 111.429 43.6858 111.428 43.8377L111.427 43.84C111.257 43.8388 111.087 43.8388 110.917 43.8377C110.914 43.6834 110.909 43.5304 110.905 43.3762H110.906C111.067 43.3692 111.225 43.3633 111.386 43.3562C111.4 43.368 111.415 43.3762 111.43 43.3833Z"
        fill="#F1EFEF"
      />
      <path
        d="M71.0192 39.6145C71.8597 39.6145 72.7002 39.6239 73.5406 39.6098C73.7902 39.6051 73.8526 39.6863 73.849 39.9253C73.8361 40.7846 73.8443 41.6451 73.8455 42.5044C72.9026 42.502 71.9598 42.4997 71.0169 42.4985C71.011 41.5356 71.0039 40.5727 70.998 39.6098L71.0192 39.6145Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.3717 42.4984C76.3729 41.5379 76.3729 40.5774 76.374 39.6168C77.2922 39.6168 78.2115 39.618 79.1297 39.618L79.145 39.6133C79.1415 40.5726 79.1379 41.5332 79.1344 42.4925C79.0273 42.4961 78.9214 42.502 78.8142 42.5031C77.9985 42.509 77.1839 42.5137 76.3682 42.5196L76.3717 42.4984Z"
        fill="#F1F1F1"
      />
      <path
        d="M73.8457 37.093C74.6874 37.0906 75.5278 37.0883 76.3695 37.0859C76.3695 37.9288 76.3706 38.7728 76.3706 39.6156C75.6385 39.6156 74.9075 39.6073 74.1753 39.6191C73.9575 39.6226 73.8857 39.5579 73.8928 39.3378C73.9081 38.8999 73.9034 38.4596 73.8951 38.0218C73.8893 37.7122 73.8634 37.4026 73.8457 37.093Z"
        fill="#B3D6DD"
      />
      <path
        d="M71.0181 42.4983C71.9609 42.5006 72.9038 42.503 73.8467 42.5042C73.8655 42.5136 73.8855 42.5218 73.9044 42.5301C73.9044 42.8032 73.9044 43.0763 73.9032 43.3494C73.8844 43.3564 73.8655 43.3635 73.8455 43.3717C72.9015 43.3694 71.9562 43.367 71.0122 43.3647C71.0075 43.0821 71.0028 42.8008 70.998 42.5183L71.0181 42.4983Z"
        fill={fill}
      />
      <path
        d="M73.8994 43.3494C73.8994 43.0763 73.8994 42.8032 73.9006 42.5313C74.5586 42.5218 75.2166 42.5124 75.8746 42.5042C76.0394 42.5018 76.2042 42.5006 76.369 42.4983L76.3655 42.5195C76.3679 42.7973 76.3702 43.0751 76.3714 43.3541C75.5474 43.3517 74.7234 43.3505 73.8994 43.3494Z"
        fill={fill}
      />
      <path
        d="M101.957 39.6098C102.901 39.611 103.845 39.6122 104.79 39.6133C104.788 40.5774 104.787 41.5415 104.785 42.5067C103.835 42.5056 102.885 42.5032 101.935 42.502C101.934 41.538 101.934 40.5727 101.933 39.6086L101.957 39.6098Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.09 37.0895C101.369 37.0883 101.65 37.0871 101.929 37.0859C101.937 37.811 101.946 38.5373 101.956 39.2624C101.957 39.379 101.957 39.4955 101.958 39.6109L101.933 39.6097C101.653 39.6121 101.373 39.6144 101.093 39.6168C101.087 38.7728 101.081 37.9299 101.075 37.0859L101.09 37.0895Z"
        fill={fill}
      />
      <path
        d="M101.079 34.3831C101.082 35.2847 101.086 36.1876 101.088 37.0893L101.073 37.0857C100.921 37.0869 100.77 37.0869 100.619 37.0881C100.616 36.1864 100.614 35.2847 100.61 34.3831C100.767 34.3831 100.923 34.3831 101.079 34.3831Z"
        fill="#F1F1F1"
      />
      <path
        d="M8.29152 68.0136C8.13026 68.0159 7.96899 68.0171 7.80772 68.0195C7.79948 67.1201 7.79242 66.222 7.78418 65.3227V65.3203C7.95486 65.3215 8.12437 65.3227 8.29505 65.3227C8.29976 66.2208 8.30447 67.119 8.308 68.0171C8.30918 68.0171 8.29152 68.0136 8.29152 68.0136Z"
        fill="#F1EFEF"
      />
      <path
        d="M121.738 49.9071C122.008 49.906 122.278 49.906 122.547 49.9048C122.554 50.8794 122.562 51.8541 122.569 52.8276C122.562 52.8347 122.556 52.8429 122.549 52.85C122.273 52.8441 121.997 52.8382 121.721 52.8311C121.718 51.8553 121.716 50.8806 121.715 49.9048L121.738 49.9071Z"
        fill={fill}
      />
      <path
        d="M125.436 52.8441C125.436 53.116 125.436 53.3868 125.437 53.6587L125.439 53.6787C124.479 53.6764 123.518 53.6728 122.558 53.6705C122.555 53.3974 122.553 53.1243 122.551 52.85C122.558 52.8429 122.565 52.8359 122.571 52.8276C123.525 52.8335 124.481 52.8394 125.436 52.8441Z"
        fill={fill}
      />
      <path
        d="M24.8371 43.3529C24.8348 43.0751 24.8324 42.7985 24.8301 42.5207C25.6235 42.5148 26.4168 42.5101 27.2102 42.503C27.3374 42.5019 27.4645 42.4925 27.5916 42.4866C27.5987 42.4936 27.6057 42.5019 27.6128 42.5089C27.6081 42.7997 27.6034 43.0893 27.5999 43.38C26.6793 43.38 25.7577 43.3788 24.8371 43.3788V43.3529Z"
        fill={fill}
      />
      <path
        d="M22.3037 43.353C23.1477 43.353 23.9917 43.353 24.8357 43.353V43.3789C24.8357 43.5331 24.8357 43.6873 24.8369 43.8415C23.9929 43.8415 23.1477 43.8415 22.3037 43.8415C22.3037 43.6873 22.3037 43.5331 22.3049 43.3789L22.3037 43.353Z"
        fill="#CFE3E7"
      />
      <path
        d="M45.4306 32.2148C45.4318 32.4879 45.433 32.761 45.433 33.0341L45.4353 33.0553C44.6066 33.053 43.7779 33.0506 42.9492 33.0494L42.9539 33.0294C42.9539 32.7587 42.9539 32.4879 42.9539 32.2172C43.7791 32.216 44.6054 32.2148 45.4306 32.2148Z"
        fill={fill}
      />
      <path
        d="M40.0793 33.0366C41.0363 33.0342 41.9945 33.0319 42.9515 33.0295L42.9468 33.0496C42.9468 33.2143 42.9468 33.3791 42.948 33.5439L42.9527 33.5616C41.9968 33.5569 41.0398 33.5522 40.084 33.5475C40.0817 33.3768 40.0805 33.2073 40.0781 33.0366C40.0781 33.0354 40.0793 33.0366 40.0793 33.0366Z"
        fill="#F1EFEF"
      />
      <path
        d="M50.3799 52.8335C50.3822 51.8577 50.3834 50.8818 50.3858 49.906C51.3404 49.906 52.2962 49.9072 53.2509 49.9072C53.2521 50.8783 53.2533 51.8483 53.2533 52.8194C52.2962 52.8241 51.3381 52.83 50.3811 52.8347L50.3799 52.8335Z"
        fill="#F1F0F0"
      />
      <path
        d="M53.2514 47.4365C54.0942 47.4365 54.9382 47.4353 55.781 47.4353C55.7799 48.2581 55.7787 49.0809 55.7787 49.9037C54.9358 49.9049 54.0918 49.9061 53.249 49.9085C53.2502 49.0833 53.2502 48.2605 53.2514 47.4365Z"
        fill="#B3D6DD"
      />
      <path
        d="M55.7834 47.4353C55.7846 46.5207 55.7858 45.606 55.7858 44.6914L55.7822 44.6714C56.6945 44.6784 57.608 44.6855 58.5202 44.6926C58.5191 45.6072 58.5179 46.5207 58.5167 47.4353C57.6056 47.4353 56.6945 47.4353 55.7834 47.4353Z"
        fill="#F1F1F1"
      />
      <path
        d="M94.4894 68.0174C93.5348 68.0162 92.5801 68.0151 91.6243 68.0127L91.6055 68.0162C91.6102 67.1193 91.6137 66.2223 91.6184 65.3253C92.5754 65.3241 93.5324 65.323 94.4894 65.3218C94.4894 66.2199 94.4894 67.1193 94.4894 68.0174Z"
        fill="#F1F1F1"
      />
      <path
        d="M84.1924 68.0161C83.2342 68.0161 82.276 68.0149 81.319 68.0149L81.3037 68.0185C81.3084 67.1192 81.3143 66.2198 81.319 65.3193C82.2772 65.3205 83.2354 65.3205 84.1936 65.3217C84.1924 66.2198 84.1924 67.118 84.1924 68.0161Z"
        fill="#F1F1F1"
      />
      <path
        d="M63.548 68.0172C62.5969 68.0148 61.6458 68.0137 60.6946 68.0113L60.6699 68.0137C60.6735 67.1191 60.677 66.2256 60.6805 65.331C61.6363 65.3286 62.5922 65.3251 63.548 65.3228C63.5492 66.2197 63.548 67.1191 63.548 68.0172Z"
        fill="#F1F1F1"
      />
      <path
        d="M53.2496 68.0174C52.2938 68.0162 51.3379 68.015 50.3809 68.0139L50.3633 68.0174C50.368 67.1193 50.3727 66.2223 50.3774 65.3241C51.3344 65.323 52.2926 65.323 53.2496 65.3218C53.2496 66.2199 53.2496 67.1181 53.2496 68.0174Z"
        fill="#F1F1F1"
      />
      <path
        d="M115.137 68.0149C114.18 68.0149 113.221 68.0149 112.264 68.0149L112.249 68.0185C112.254 67.1192 112.26 66.2198 112.264 65.3193C113.223 65.3205 114.181 65.3205 115.139 65.3217C115.138 66.2198 115.138 67.1168 115.137 68.0149Z"
        fill="#F1F1F1"
      />
      <path
        d="M42.9512 68.0149C41.993 68.0149 41.036 68.0149 40.0778 68.0149L40.0625 68.0185C40.0672 67.1192 40.0731 66.2198 40.0778 65.3193C41.036 65.3205 41.9942 65.3205 42.9524 65.3217C42.9524 66.2198 42.9524 67.118 42.9512 68.0149Z"
        fill="#F1F1F1"
      />
      <path
        d="M125.434 68.0161C124.475 68.015 123.518 68.0149 122.56 68.0138L122.545 68.0173C122.55 67.118 122.556 66.2187 122.56 65.3193C123.518 65.3193 124.477 65.3205 125.435 65.3205C125.435 66.2198 125.435 67.118 125.434 68.0161Z"
        fill="#F1F1F1"
      />
      <path
        d="M12.0096 68.0159C11.0526 68.0147 10.0956 68.0147 9.13855 68.0136L9.12207 68.0171C9.12678 67.1178 9.13149 66.2196 9.1362 65.3203C10.0944 65.3203 11.0526 65.3203 12.0107 65.3203C12.0107 66.2196 12.0107 67.1178 12.0096 68.0159Z"
        fill="#F1F1F1"
      />
      <path
        d="M22.3031 68.0172C21.3508 68.0148 20.3973 68.0137 19.445 68.0113L19.4238 68.0148C19.4274 67.1191 19.4321 66.2244 19.4356 65.3286C20.3914 65.3263 21.3484 65.3239 22.3054 65.3228C22.3031 66.2197 22.3031 67.1191 22.3031 68.0172Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.6055 68.0195C31.6626 68.0195 30.7209 68.0195 29.778 68.0195L29.7568 68.0231C29.7627 67.9171 29.7721 67.81 29.7721 67.7041C29.7768 66.9083 29.7804 66.1126 29.7839 65.3157C30.7244 65.3169 31.665 65.318 32.6055 65.3204C32.6055 66.2197 32.6055 67.119 32.6055 68.0195Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.788 68.0186C103.844 68.0197 102.901 68.0209 101.957 68.0221L101.933 68.0244C101.94 67.9079 101.953 67.7925 101.953 67.676C101.959 66.8885 101.961 66.101 101.966 65.3147C102.907 65.3171 103.848 65.3194 104.79 65.3218C104.788 66.2199 104.788 67.1192 104.788 68.0186Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.786 42.5067C104.787 41.5426 104.788 40.5785 104.791 39.6133C105.634 39.6133 106.476 39.6145 107.32 39.6145C107.32 40.575 107.32 41.5344 107.32 42.4949L107.322 42.522C106.534 42.5161 105.745 42.509 104.958 42.5067C104.903 42.5067 104.847 42.5384 104.792 42.5561C104.788 42.5396 104.786 42.5231 104.786 42.5067Z"
        fill="#CFE3E7"
      />
      <path
        d="M107.318 42.4959C108.238 42.4947 109.157 42.4924 110.075 42.4912L110.096 42.51C110.096 42.7961 110.095 43.081 110.095 43.367L110.075 43.3858C109.968 43.3823 109.86 43.3752 109.752 43.3741C108.939 43.3682 108.127 43.3635 107.313 43.3588C107.316 43.081 107.317 42.802 107.319 42.5242L107.318 42.4959Z"
        fill={fill}
      />
      <path
        d="M27.5822 68.0125C26.6675 68.0137 25.7517 68.016 24.8371 68.0172C24.8371 67.1191 24.8359 66.2209 24.8359 65.3228C25.7541 65.3239 26.6711 65.3263 27.5892 65.3275C27.594 66.2244 27.5975 67.1202 27.6022 68.0172L27.5822 68.0125Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.8898 68.0149C36.9705 68.0149 36.0523 68.0161 35.133 68.0161C35.133 67.118 35.1318 66.2198 35.1318 65.3217C36.0512 65.3205 36.9705 65.3205 37.8898 65.3193C37.8946 66.2187 37.9004 67.118 37.9052 68.0173L37.8898 68.0149Z"
        fill="#F1F1F1"
      />
      <path
        d="M48.1895 68.0173C47.269 68.0161 46.3484 68.0161 45.4291 68.0149C45.4291 68.0149 45.4291 68.0149 45.4279 68.0149C45.4279 67.1179 45.4268 66.221 45.4268 65.324C46.3461 65.3216 47.2666 65.3193 48.1859 65.3181C48.193 66.2198 48.2012 67.1215 48.2083 68.0232C48.2095 68.022 48.1895 68.0173 48.1895 68.0173Z"
        fill="#F1F1F1"
      />
      <path
        d="M58.5155 68.0115C57.6044 68.0139 56.6933 68.0162 55.7822 68.0186C55.7822 67.1193 55.7822 66.2211 55.7822 65.3218C56.6992 65.3253 57.615 65.3289 58.532 65.3324C58.5355 66.2258 58.5391 67.1204 58.5426 68.0139L58.5155 68.0115Z"
        fill="#F1F1F1"
      />
      <path
        d="M68.8269 68.0136C67.9099 68.0148 66.9941 68.016 66.0771 68.0172C66.0771 67.1179 66.0771 66.2185 66.0771 65.3192C66.1737 65.318 66.2702 65.3169 66.3667 65.3157C66.3632 65.404 66.3597 65.4911 66.3573 65.5793C66.3314 66.5458 66.9647 67.3568 67.917 67.5169C68.216 67.5675 68.5338 67.5028 68.8422 67.491C68.8434 67.6664 68.8446 67.843 68.8446 68.0184L68.8269 68.0136Z"
        fill="#F1EFEF"
      />
      <path
        d="M99.7568 68.0113C98.8445 68.0137 97.931 68.0148 97.0188 68.0172C97.0188 67.1191 97.0188 66.2209 97.0176 65.3228C97.9346 65.3251 98.8516 65.3275 99.7685 65.3298C99.7721 66.2244 99.7768 67.1202 99.7803 68.0148C99.7803 68.0137 99.7568 68.0113 99.7568 68.0113Z"
        fill="#F1F1F1"
      />
      <path
        d="M110.068 68.0139C109.15 68.015 108.233 68.0162 107.315 68.0162C107.315 67.1181 107.313 66.2199 107.313 65.3218C108.232 65.3218 109.151 65.3218 110.069 65.3218C110.074 66.2199 110.079 67.1193 110.083 68.0174L110.068 68.0139Z"
        fill="#F1F1F1"
      />
      <path
        d="M120.371 68.0147C119.453 68.0147 118.535 68.0147 117.615 68.0147C117.615 67.1178 117.614 66.2196 117.614 65.3227C118.534 65.3215 119.452 65.3203 120.371 65.3203C120.376 66.2196 120.382 67.119 120.386 68.0195L120.371 68.0147Z"
        fill="#F1F1F1"
      />
      <path
        d="M125.437 60.252C126.277 60.252 127.117 60.252 127.958 60.252C127.959 61.209 127.96 62.1671 127.961 63.1242L127.963 63.1453C127.119 63.1383 126.275 63.1324 125.431 63.1253C125.431 62.1683 125.432 61.2125 125.432 60.2555L125.437 60.252Z"
        fill="#CFE3E7"
      />
      <path
        d="M130.674 63.1405C130.677 63.4089 130.681 63.6785 130.686 63.9469L130.664 63.9657C129.764 63.9622 128.863 63.9586 127.963 63.9551C127.963 63.6855 127.964 63.416 127.964 63.1464L127.963 63.1252C128.866 63.13 129.77 63.1347 130.674 63.1405Z"
        fill={fill}
      />
      <path
        d="M125.438 57.7279C125.438 58.5695 125.439 59.4111 125.439 60.2516L125.436 60.2551C124.478 60.2551 123.52 60.2551 122.561 60.2551C122.556 59.4111 122.551 58.5683 122.545 57.7243L122.566 57.7267C123.522 57.7255 124.479 57.7243 125.435 57.7231L125.438 57.7279Z"
        fill="#CFE3E7"
      />
      <path
        d="M130.674 68.0197C129.77 68.0197 128.867 68.0185 127.963 68.0185C127.963 67.1192 127.963 66.2199 127.963 65.3217C128.867 65.317 129.771 65.3123 130.675 65.3076L130.677 65.3088C130.684 66.214 130.69 67.1192 130.697 68.0244L130.674 68.0197Z"
        fill="#F1F1F1"
      />
      <path
        d="M17.2484 68.0209C16.3444 68.0197 15.4392 68.0197 14.5352 68.0186C14.5352 67.1192 14.5352 66.2199 14.5352 65.3218C15.4368 65.3194 16.3385 65.3171 17.2414 65.3147C17.2449 65.4407 17.2508 65.5666 17.252 65.6926C17.259 66.4695 17.2661 67.2464 17.2732 68.0233L17.2484 68.0209Z"
        fill="#F1F1F1"
      />
      <path
        d="M89.4303 68.0184C88.5274 68.0184 87.6245 68.0184 86.7217 68.0196C86.7217 67.1203 86.7217 66.2209 86.7217 65.3216C87.6234 65.3204 88.5239 65.3181 89.4255 65.3169C89.4338 66.2186 89.442 67.1214 89.4514 68.0231L89.4303 68.0184Z"
        fill="#F1F1F1"
      />
      <path
        d="M55.7797 43.3518C55.7774 43.0752 55.775 42.7986 55.7715 42.5219C56.6791 42.5219 57.5878 42.5208 58.4954 42.5208C58.4942 42.7997 58.493 43.0775 58.4918 43.3565C57.5878 43.3636 56.6838 43.3706 55.7785 43.3789L55.7797 43.3518Z"
        fill={fill}
      />
      <path
        d="M58.5411 42.4914C58.5329 41.532 58.5258 40.5738 58.5176 39.6145L58.5447 39.6133C58.8177 39.6133 59.0908 39.6133 59.3639 39.6133C59.3651 40.575 59.3651 41.5379 59.3663 42.4996C59.0908 42.4972 58.8154 42.4937 58.5411 42.4914Z"
        fill={fill}
      />
      <path
        d="M58.5408 42.4912C58.8163 42.4936 59.0905 42.4971 59.366 42.4995L59.3672 42.5006C59.3636 42.789 59.3601 43.0762 59.3566 43.3646C59.0847 43.3705 58.8127 43.3776 58.5408 43.3835C58.5243 43.3764 58.509 43.367 58.4961 43.3552C58.4973 43.0762 58.4984 42.7984 58.4996 42.5195C58.5102 42.5077 58.5243 42.4971 58.5408 42.4912Z"
        fill={outline}
      />
      <path
        d="M12.0078 49.9085C12.8506 49.9073 13.6935 49.905 14.5375 49.9038L14.541 49.9073C14.541 50.8796 14.541 51.852 14.5422 52.8243C13.6982 52.8325 12.8542 52.8396 12.0102 52.8466V52.8196C12.009 51.8496 12.009 50.8785 12.0078 49.9085Z"
        fill="#CFE3E7"
      />
      <path
        d="M9.11719 53.6598C9.12307 53.3855 9.12896 53.1113 9.13484 52.837C10.093 52.8311 11.0512 52.8252 12.0094 52.8193V52.8464C12.0094 53.1183 12.0106 53.3891 12.0106 53.661C11.0524 53.6669 10.0942 53.6728 9.13602 53.6786L9.11719 53.6598Z"
        fill={fill}
      />
      <path
        d="M14.5412 47.4352C15.4441 47.434 16.3458 47.4328 17.2486 47.4328L17.2639 47.4316H17.2792C17.271 48.2545 17.2639 49.0784 17.2569 49.9013C16.3528 49.9036 15.4476 49.9048 14.5436 49.9071L14.54 49.9036C14.54 49.0808 14.54 48.258 14.5412 47.4352Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1947 26.7942C84.1959 27.637 84.1959 28.4798 84.1971 29.3227C84.1971 29.3227 84.1924 29.3274 84.1936 29.3274C83.2366 29.3262 82.2795 29.325 81.3237 29.3238L81.3037 29.3262C81.3037 28.4822 81.3037 27.6382 81.3037 26.7954L81.3237 26.7977C82.2795 26.7954 83.2377 26.7954 84.1947 26.7942Z"
        fill="#CFE3E7"
      />
      <path
        d="M81.3161 24.0962C81.3173 24.9967 81.3185 25.8972 81.3208 26.7966L81.3008 26.7942C81.0301 26.7942 80.7605 26.7954 80.4898 26.7954L80.4639 26.7966C80.4709 25.8961 80.4768 24.9944 80.4839 24.0939C80.7546 24.088 81.0265 24.0833 81.2973 24.0774L81.3161 24.0962Z"
        fill={fill}
      />
      <path
        d="M89.4576 49.9011C89.726 49.9047 89.9932 49.9082 90.2616 49.9117C90.2839 50.864 90.3051 51.8175 90.3275 52.7663C90.4911 52.7663 90.6241 52.7663 90.7736 52.7663C90.7736 51.7998 90.7736 50.8522 90.7736 49.9058L90.7948 49.9082C91.0644 49.9082 91.3351 49.907 91.6047 49.907C91.6094 50.8817 91.6141 51.8563 91.6188 52.831C91.3575 52.8428 90.9879 52.7568 90.8631 52.8934C90.7218 53.0476 90.8007 53.4031 90.783 53.6703C90.6253 53.6679 90.4676 53.6656 90.3098 53.6632C90.3098 53.4596 90.3051 53.2548 90.3122 53.0511C90.3169 52.9052 90.2675 52.8333 90.1121 52.8416C89.8884 52.8522 89.6648 52.8522 89.4423 52.8569C89.434 52.8498 89.427 52.8416 89.4199 52.8333C89.4258 51.9929 89.4317 51.1512 89.4388 50.3108C89.4388 50.173 89.4505 50.0377 89.4576 49.9011Z"
        fill={fill}
      />
      <path
        d="M86.7229 52.8206C87.6222 52.8241 88.5203 52.8288 89.4185 52.8323C89.4255 52.8406 89.4338 52.8476 89.4409 52.8559C89.4385 53.1254 89.4361 53.395 89.4338 53.6646C88.5298 53.6634 87.6257 53.661 86.7217 53.6598C86.7217 53.3891 86.7217 53.1184 86.7229 52.8476V52.8206Z"
        fill={fill}
      />
      <path
        d="M90.7738 49.9062C90.7738 50.8526 90.7738 51.8002 90.7738 52.7666C90.6243 52.7666 90.4913 52.7666 90.3276 52.7666C90.3053 51.8166 90.2841 50.8643 90.2617 49.912C90.277 49.9085 90.2923 49.9062 90.3076 49.9038C90.463 49.9038 90.6184 49.905 90.7738 49.9062Z"
        fill="#F1F1F1"
      />
      <path
        d="M90.7742 49.906C90.6189 49.9048 90.4635 49.9036 90.3081 49.9036C90.301 49.0808 90.2951 48.258 90.2881 47.434L90.314 47.4328C90.4682 47.4328 90.6212 47.4328 90.7754 47.4316C90.7825 48.2568 90.7884 49.082 90.7954 49.9083L90.7742 49.906Z"
        fill="#CFE3E7"
      />
      <path
        d="M59.8291 33.0353C59.835 32.7622 59.8409 32.488 59.8468 32.2149C60.1163 32.2137 60.3871 32.2113 60.6566 32.209C60.6578 32.4821 60.659 32.7552 60.6602 33.0283C60.3835 33.0306 60.1069 33.033 59.8303 33.0353H59.8291Z"
        fill={outline}
      />
      <path
        d="M59.835 33.0354C60.1116 33.033 60.3882 33.0307 60.6649 33.0283C60.6884 33.0295 60.7131 33.0319 60.7367 33.033C60.7355 33.2072 60.7343 33.3803 60.7331 33.5545C60.7096 33.5557 60.6861 33.5569 60.6625 33.558C60.3918 33.5604 60.1199 33.5616 59.8491 33.5639L59.8291 33.5451C59.8303 33.3756 59.8326 33.2061 59.835 33.0354Z"
        fill={fill}
      />
      <path
        d="M81.3191 49.9084C82.2761 49.9084 83.2331 49.9095 84.1889 49.9095C84.1889 50.8818 84.1889 51.853 84.1889 52.8253L84.1913 52.8453C83.2366 52.8406 82.2808 52.8347 81.3261 52.83C81.3191 51.8553 81.3108 50.8807 81.3038 49.906C81.3026 49.9048 81.3191 49.9084 81.3191 49.9084Z"
        fill="#F1F1F1"
      />
      <path
        d="M86.7215 52.8475C86.7215 53.1183 86.7215 53.389 86.7203 53.6597L86.7238 53.675C85.8798 53.6692 85.0358 53.6633 84.193 53.6574C84.193 53.3866 84.193 53.1159 84.1918 52.844L84.1895 52.824C85.0335 52.8322 85.8775 52.8393 86.7215 52.8475Z"
        fill={fill}
      />
      <path
        d="M81.3225 47.4329C81.3225 48.258 81.3213 49.0832 81.3213 49.9095L81.3048 49.906C81.0341 49.906 80.7645 49.9072 80.4938 49.9072C80.4926 49.0832 80.4914 48.2592 80.4902 47.4352C80.7622 47.4352 81.0341 47.4352 81.306 47.4352L81.3225 47.4329Z"
        fill={fill}
      />
      <path
        d="M24.8334 65.3215C24.8334 66.2197 24.8345 67.1178 24.8345 68.016C23.9917 68.016 23.1477 68.016 22.3049 68.016C22.3049 67.1178 22.3061 66.2197 22.3061 65.3215L22.3037 65.3015C23.1477 65.3015 23.9917 65.3015 24.8357 65.3015L24.8334 65.3215Z"
        fill="#CFE3E7"
      />
      <path
        d="M127.966 65.3206C127.966 66.2199 127.966 67.1192 127.966 68.0173C127.123 68.0162 126.281 68.0162 125.438 68.015C125.438 67.1168 125.439 66.2187 125.439 65.3206L125.437 65.3005C126.281 65.3005 127.125 65.3005 127.967 65.3005L127.966 65.3206Z"
        fill="#CFE3E7"
      />
      <path
        d="M14.5375 65.3206C14.5375 66.2199 14.5375 67.1192 14.5375 68.0173C13.6946 68.0173 12.8518 68.0162 12.009 68.0162C12.009 67.118 12.0102 66.2199 12.0102 65.3217L12.0078 65.3017C12.8518 65.3017 13.6958 65.3017 14.5386 65.3005L14.5375 65.3206Z"
        fill="#CFE3E7"
      />
      <path
        d="M107.316 65.3219C107.316 66.22 107.317 67.1182 107.317 68.0163C106.474 68.0163 105.631 68.0175 104.788 68.0175C104.788 67.1182 104.788 66.2189 104.788 65.3195L104.786 65.2983C105.63 65.2995 106.474 65.2995 107.318 65.3007L107.316 65.3219Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.1281 65.3227C35.1281 66.2208 35.1293 67.119 35.1293 68.0171C34.2864 68.0183 33.4436 68.0183 32.6008 68.0195C32.6008 67.1202 32.6008 66.2197 32.6008 65.3204C32.6008 65.3204 32.5996 65.2992 32.5996 65.3003C33.4436 65.3015 34.2876 65.3027 35.1316 65.3039L35.1281 65.3227Z"
        fill="#CFE3E7"
      />
      <path
        d="M97.0209 65.3215C97.0209 66.2197 97.0209 67.1178 97.022 68.016C96.1792 68.016 95.3352 68.016 94.4924 68.016C94.4924 67.1178 94.4924 66.2197 94.4936 65.3215L94.4912 65.3015C95.3352 65.3015 96.1792 65.3015 97.0232 65.3015L97.0209 65.3215Z"
        fill="#CFE3E7"
      />
      <path
        d="M55.7787 65.3218C55.7787 66.2211 55.7787 67.1193 55.7787 68.0186C54.9358 68.0186 54.093 68.0174 53.2502 68.0174C53.2502 67.1193 53.2514 66.2211 53.2514 65.323L53.249 65.303C54.093 65.303 54.937 65.303 55.781 65.303L55.7787 65.3218Z"
        fill="#CFE3E7"
      />
      <path
        d="M86.724 65.3204C86.724 66.2197 86.724 67.119 86.724 68.0183C85.8812 68.0171 85.0383 68.016 84.1955 68.016C84.1955 67.1178 84.1967 66.2197 84.1967 65.3227L84.1943 65.3015C85.0383 65.3015 85.8823 65.3015 86.7263 65.3015L86.724 65.3204Z"
        fill="#CFE3E7"
      />
      <path
        d="M66.0757 65.3195C66.0757 66.2188 66.0757 67.1181 66.0757 68.0174C65.2329 68.0174 64.3889 68.0174 63.5461 68.0174C63.5461 67.1193 63.5461 66.2211 63.5473 65.323L63.5449 65.303C64.3889 65.3077 65.2317 65.3136 66.0757 65.3195Z"
        fill="#CFE3E7"
      />
      <path
        d="M63.5457 37.0872C63.5457 37.9288 63.5457 38.7704 63.5468 39.6121L63.5433 39.6156C62.5922 39.6156 61.6411 39.6156 60.69 39.6168C60.6817 38.774 60.6735 37.9312 60.6641 37.0883L60.6911 37.0872C61.6423 37.0883 62.5946 37.0883 63.5457 37.0872Z"
        fill="#CFE3E7"
      />
      <path
        d="M60.679 34.3972C60.6825 35.2942 60.6861 36.19 60.6896 37.087L60.6625 37.0881C60.3906 37.0881 60.1175 37.0881 59.8456 37.0881C59.8397 36.1888 59.835 35.2883 59.8291 34.389L59.8468 34.3713C60.1163 34.3737 60.3871 34.3749 60.6566 34.3772C60.6637 34.3843 60.6708 34.3913 60.679 34.3972Z"
        fill={fill}
      />
      <path
        d="M66.0757 39.6154C66.0757 40.576 66.0757 41.5365 66.0757 42.4982C65.2329 42.4982 64.3901 42.4982 63.5473 42.4982C63.5461 41.5377 63.5449 40.5783 63.5449 39.6178L63.5484 39.6143C64.3913 39.6143 65.2329 39.6143 66.0757 39.6154Z"
        fill="#CFE3E7"
      />
      <path
        d="M59.3642 39.6132C59.0911 39.6132 58.818 39.6132 58.5449 39.6132C58.5449 38.7716 58.5449 37.9311 58.5449 37.0895C58.818 37.0895 59.0899 37.0895 59.363 37.0895L59.3783 37.0859C59.3783 37.9299 59.3783 38.7739 59.3795 39.6179L59.3642 39.6132Z"
        fill={fill}
      />
      <path
        d="M59.8341 34.3901C59.84 35.2894 59.8447 36.1899 59.8506 37.0893L59.8353 37.0857C59.6835 37.0857 59.5304 37.0857 59.3786 37.0857L59.3633 37.0893C59.3668 36.1876 59.3692 35.2847 59.3727 34.3831C59.5257 34.3854 59.6799 34.3878 59.8341 34.3901Z"
        fill="#F1F1F1"
      />
      <path
        d="M45.4284 65.3239C45.4284 66.2208 45.4296 67.1178 45.4296 68.0148C44.6044 68.0148 43.7804 68.016 42.9553 68.016C42.9553 67.1178 42.9565 66.2208 42.9565 65.3227L42.9541 65.3015C43.7793 65.3027 44.6056 65.3027 45.4308 65.3039L45.4284 65.3239Z"
        fill="#CFE3E7"
      />
      <path
        d="M117.615 65.3227C117.615 66.2197 117.616 67.1178 117.616 68.0148C116.791 68.0148 115.967 68.0148 115.142 68.0148C115.142 67.1178 115.143 66.2197 115.143 65.3227L115.141 65.3015C115.966 65.3015 116.792 65.3027 117.617 65.3027L117.615 65.3227Z"
        fill="#CFE3E7"
      />
      <path
        d="M90.7759 47.4328C90.6217 47.4328 90.4687 47.4328 90.3145 47.434C90.3145 46.5134 90.3145 45.5941 90.3145 44.6736C90.4663 44.6771 90.6182 44.6818 90.77 44.6854C90.7771 45.6023 90.7841 46.5193 90.7912 47.4351L90.7759 47.4328Z"
        fill="#F1F0F0"
      />
      <path
        d="M17.2441 44.6713C17.5349 44.6678 17.8256 44.6654 18.1164 44.6619C18.1235 44.6689 18.1305 44.676 18.1376 44.6842C18.1317 44.7913 18.1223 44.8985 18.1223 45.0056C18.1176 45.8166 18.114 46.6265 18.1105 47.4375C17.8315 47.4352 17.5537 47.434 17.2747 47.4317H17.2594L17.2441 47.4328C17.2453 46.5123 17.2441 45.5918 17.2441 44.6713Z"
        fill={fill}
      />
      <path
        d="M80.485 24.094C80.4779 24.9945 80.472 25.8962 80.465 26.7967C80.3037 26.7943 80.1424 26.792 79.9811 26.7896L79.96 26.7931C79.9611 25.8938 79.9611 24.9945 79.9623 24.094H79.9611C80.1365 24.094 80.3119 24.094 80.485 24.094Z"
        fill="#F1F1F1"
      />
      <path
        d="M29.7568 42.5055C29.7627 41.5426 29.7674 40.5797 29.7733 39.6168C30.715 39.6156 31.6579 39.6145 32.5996 39.6133C32.5996 40.5773 32.5996 41.5402 32.5996 42.5043C31.6544 42.5067 30.7091 42.5102 29.7639 42.5126L29.7568 42.5055Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.608 37.093C33.4497 37.0907 34.2901 37.0895 35.1318 37.0872C35.1318 37.93 35.1306 38.7716 35.1306 39.6145C34.289 39.6145 33.4461 39.6145 32.6045 39.6145C32.6045 38.7728 32.6057 37.9323 32.608 37.093Z"
        fill="#B3D6DD"
      />
      <path
        d="M35.1318 34.3915C36.0535 34.388 36.9752 34.3856 37.8969 34.3821C37.8946 35.2838 37.8922 36.1854 37.8887 37.0871C36.9705 37.0871 36.0512 37.0859 35.133 37.0859C35.1318 36.189 35.1318 35.2896 35.1318 34.3915Z"
        fill="#F1F1F1"
      />
      <path
        d="M90.2951 42.5028C90.2928 41.5388 90.2904 40.5747 90.2881 39.6118H90.3104C90.4646 39.613 90.6189 39.613 90.7742 39.6142C90.7766 40.5735 90.7778 41.5329 90.7801 42.4923C90.6212 42.4993 90.4623 42.5052 90.3034 42.5123L90.2951 42.5028Z"
        fill="#F1F1F1"
      />
      <path
        d="M22.3055 43.379C22.3055 43.5332 22.3055 43.6874 22.3043 43.8416L22.3078 43.8569C21.3508 43.8487 20.3938 43.8404 19.4368 43.8334C19.4309 43.6803 19.4239 43.5285 19.418 43.3755L19.4239 43.379C19.4439 43.3731 19.4639 43.3672 19.4827 43.3613C20.4244 43.3672 21.3649 43.3731 22.3055 43.379Z"
        fill="#F1F0F0"
      />
      <path
        d="M19.4839 43.361C19.4639 43.3669 19.4438 43.3728 19.425 43.3787C19.425 43.3587 19.4238 43.3387 19.4238 43.3198C19.4438 43.3339 19.4639 43.3469 19.4839 43.361Z"
        fill="#E2BBAC"
      />
      <path
        d="M79.9811 39.6203C80.1424 39.618 80.3037 39.6156 80.4649 39.6133C80.4708 40.5726 80.4767 41.532 80.4826 42.4914L80.4838 42.4925C80.3119 42.4902 80.1401 42.4878 79.9682 42.4855C79.9647 41.5296 79.9623 40.5738 79.96 39.6168L79.9811 39.6203Z"
        fill="#F1F1F1"
      />
      <path
        d="M94.4924 33.5368C94.4901 33.3756 94.4877 33.2143 94.4854 33.053C95.3305 33.0448 96.1757 33.0366 97.0197 33.0283L97.0185 33.0566C97.0209 33.2178 97.0221 33.3791 97.0244 33.5392C96.1804 33.5463 95.3352 33.5533 94.4912 33.5604L94.4924 33.5368Z"
        fill="#CFE3E7"
      />
      <path
        d="M125.435 57.7233C124.479 57.7245 123.522 57.7256 122.566 57.7268C122.566 56.831 122.566 55.934 122.566 55.0123C122.726 55.0123 122.852 55.0135 122.977 55.0123C123.799 55.0053 124.621 54.9982 125.443 54.99L125.441 55.0147C125.439 55.9176 125.437 56.8204 125.435 57.7233Z"
        fill="#F1F1F1"
      />
      <path
        d="M7.78521 63.1252C7.78168 62.1682 7.77697 61.2112 7.77344 60.2542L7.79109 60.26C7.95942 60.2577 8.12775 60.2565 8.29608 60.2542C8.29491 61.2112 8.29491 62.167 8.29373 63.124C8.12422 63.1252 7.95472 63.1263 7.78521 63.1275V63.1252Z"
        fill="#F1EFEF"
      />
      <path
        d="M81.3055 47.4351C81.0336 47.4351 80.7617 47.4351 80.4898 47.4351L80.4639 47.4362C80.4686 46.5193 80.4721 45.6035 80.4768 44.6865C80.7534 44.6794 81.0289 44.6723 81.3055 44.6653L81.3267 44.6841C81.3196 45.6011 81.3126 46.5181 81.3055 47.4351Z"
        fill={fill}
      />
      <path
        d="M79.9814 26.7896C80.1427 26.7919 80.304 26.7943 80.4652 26.7966L80.4911 26.7954C80.4911 27.6383 80.4911 28.4811 80.4911 29.3239L80.4664 29.3227C80.3052 29.3251 80.1439 29.3274 79.9826 29.3298C79.9814 28.4834 79.9814 27.6371 79.9814 26.7896Z"
        fill="#CFE3E7"
      />
      <path
        d="M90.7766 39.6144C90.6224 39.6132 90.4682 39.6132 90.3128 39.6121C90.3046 38.7704 90.2963 37.9276 90.2881 37.0859H90.314C90.4694 37.0859 90.6236 37.0859 90.7789 37.0859C90.7848 37.9299 90.7907 38.7728 90.7966 39.6168L90.7766 39.6144Z"
        fill="#CFE3E7"
      />
      <path
        d="M90.7781 37.0857C90.6227 37.0857 90.4685 37.0857 90.3131 37.0857C90.3119 36.1829 90.3107 35.28 90.3096 34.3772L90.3119 34.376C90.4673 34.3807 90.6227 34.3854 90.7781 34.3889C90.784 35.2894 90.7887 36.1888 90.7945 37.0893L90.7781 37.0857Z"
        fill="#F1F1F1"
      />
      <path
        d="M63.5484 42.497C64.3913 42.497 65.2341 42.497 66.0769 42.497C66.9963 42.4934 67.9156 42.4911 68.8349 42.4875C68.8408 42.4958 68.8479 42.5029 68.8538 42.5099C68.8502 42.7983 68.8467 43.0855 68.8432 43.3739C67.9156 43.3727 66.9892 43.3739 66.0616 43.3704C65.2223 43.3669 64.3842 43.3598 63.5449 43.3539C63.5473 43.0749 63.5496 42.796 63.552 42.517L63.5484 42.497Z"
        fill={fill}
      />
      <path
        d="M28.8994 43.3647C28.9053 43.0822 28.91 42.8008 28.9159 42.5183C29.1961 42.5136 29.4762 42.5101 29.7575 42.5054L29.7646 42.5124C29.7611 42.7926 29.7587 43.0727 29.7552 43.3529C29.4715 43.3588 29.189 43.3647 28.9053 43.3706C28.9053 43.3694 28.8994 43.3647 28.8994 43.3647Z"
        fill={outline}
      />
      <path
        d="M27.5986 43.3801C27.6033 43.0894 27.608 42.7998 27.6116 42.509C27.8764 42.509 28.1425 42.5102 28.4073 42.5102C28.412 42.7986 28.4156 43.087 28.4203 43.3742H28.4191C28.146 43.3766 27.8717 43.3777 27.5986 43.3801Z"
        fill={outline}
      />
      <path
        d="M28.4203 43.3741C28.5804 43.3706 28.7405 43.3671 28.9006 43.3635L28.9065 43.3682C28.9006 43.526 28.8947 43.6849 28.8888 43.8426C28.7358 43.8414 28.5828 43.8403 28.4297 43.8391C28.4262 43.6837 28.4215 43.5283 28.418 43.3741H28.4203Z"
        fill="#F1F1F1"
      />
      <path
        d="M8.29405 60.254C8.12572 60.2564 7.95739 60.2576 7.78906 60.2599C7.79259 59.4124 7.79495 58.566 7.79848 57.7185C7.9621 57.7209 8.12572 57.7232 8.28934 57.7268L8.31171 57.7256C8.31289 58.5696 8.31524 59.4124 8.31642 60.2564L8.29405 60.254Z"
        fill="#D5DBDB"
      />
      <path
        d="M80.4983 43.3684C80.7691 43.3708 81.0386 43.3731 81.3094 43.3743C81.3141 43.5297 81.3176 43.6851 81.3223 43.8404L81.3047 43.8581C81.0316 43.8534 80.7585 43.8475 80.4854 43.8428C80.483 43.6921 80.4818 43.5414 80.4795 43.392C80.4854 43.3837 80.4913 43.3766 80.4983 43.3684Z"
        fill={fill}
      />
      <path
        d="M79.9692 42.4854C80.1411 42.4877 80.313 42.4901 80.4848 42.4924C80.4883 42.7843 80.493 43.0774 80.4978 43.3694C80.4907 43.3764 80.4836 43.3847 80.4777 43.3917C80.3082 43.3894 80.1376 43.3882 79.968 43.3859C79.9622 43.0939 79.9551 42.802 79.9492 42.5101C79.9551 42.5007 79.9622 42.4936 79.9692 42.4854Z"
        fill={fill}
      />
      <path
        d="M45.4308 39.619C45.4308 40.5771 45.4296 41.5365 45.4296 42.4947C45.4296 42.4947 45.432 42.5229 45.432 42.5218C44.608 42.5147 43.784 42.5076 42.9588 42.5006C42.9576 41.5389 42.9565 40.5772 42.9541 39.6166C43.7781 39.6154 44.6021 39.6154 45.4261 39.6143C45.4261 39.6143 45.4308 39.619 45.4308 39.619Z"
        fill="#CFE3E7"
      />
      <path
        d="M80.4842 22.8109C80.4854 22.7874 80.4877 22.765 80.4889 22.7415C80.7644 22.7415 81.0398 22.7415 81.3164 22.7415C81.3164 22.8968 81.3164 23.0522 81.3164 23.2076L81.2964 23.2264C81.0316 23.2241 80.7655 23.2229 80.5007 23.2205C80.4936 23.2135 80.4866 23.2052 80.4795 23.197C80.4807 23.0675 80.4818 22.9392 80.4842 22.8109Z"
        fill={fill}
      />
      <path
        d="M8.29297 54.1319C8.29415 53.9789 8.2965 53.8259 8.29768 53.6729C8.57077 53.6682 8.84387 53.6646 9.11696 53.6599C9.11696 53.6599 9.13579 53.6788 9.13462 53.6788C9.13108 53.833 9.12755 53.9871 9.12402 54.1402C8.85446 54.1437 8.58372 54.1472 8.31416 54.1508L8.29297 54.1319Z"
        fill={fill}
      />
      <path
        d="M121.233 47.4365C121.394 47.4342 121.555 47.4318 121.717 47.4307C121.725 48.257 121.733 49.0822 121.741 49.9085L121.718 49.9073C121.554 49.9085 121.391 49.9109 121.226 49.912C121.219 49.0881 121.213 48.2629 121.207 47.4389L121.233 47.4365Z"
        fill="#CFE2E5"
      />
      <path
        d="M120.38 44.6653C120.657 44.6735 120.934 44.6806 121.211 44.6888C121.216 45.6046 121.222 46.5204 121.227 47.4362L121.2 47.4374C120.927 47.4374 120.653 47.4362 120.38 47.4362C120.373 46.5193 120.366 45.6035 120.36 44.6865L120.38 44.6653Z"
        fill={fill}
      />
      <path
        d="M76.3742 39.6168C76.3742 38.7739 76.373 37.9299 76.373 37.0871C77.2924 37.0871 78.2117 37.0871 79.1311 37.0859C79.1311 37.9299 79.1311 38.7739 79.1299 39.6179C78.2117 39.6168 77.2924 39.6168 76.3742 39.6168Z"
        fill="#CFE3E7"
      />
      <path
        d="M18.1207 44.6617C18.1195 44.3945 18.1184 44.1273 18.1172 43.8601L18.1348 43.8424C18.2879 43.8413 18.4397 43.8413 18.5927 43.8401L18.6104 43.8577C18.6045 44.1308 18.5998 44.4039 18.5939 44.677C18.4433 44.6794 18.2926 44.6817 18.1419 44.6841C18.1348 44.677 18.1278 44.67 18.1207 44.6617Z"
        fill={fill}
      />
      <path
        d="M8.28711 57.727C8.28946 56.8277 8.29182 55.9272 8.29535 55.0278C8.30241 55.0208 8.30947 55.0149 8.31654 55.0078C8.58492 55.0113 8.85213 55.0149 9.12052 55.0184C9.12052 55.9213 9.12052 56.8241 9.12052 57.727C8.84978 57.7258 8.58021 57.7258 8.30948 57.7246L8.28711 57.727Z"
        fill={fill}
      />
      <path
        d="M81.3057 32.2162C81.0326 32.2103 80.7583 32.2056 80.4852 32.1997C80.4793 31.2415 80.4746 30.2822 80.4688 29.324L80.4935 29.3252C80.7642 29.3252 81.0338 29.3263 81.3045 29.3263L81.3245 29.324C81.3233 30.2822 81.3233 31.2403 81.3222 32.1985L81.3057 32.2162Z"
        fill={fill}
      />
      <path
        d="M81.3193 32.1973C81.3193 31.2391 81.3205 30.2809 81.3217 29.3228C82.2787 29.3239 83.2357 29.3251 84.1915 29.3263C84.1927 30.2821 84.1939 31.2391 84.1939 32.195C83.2369 32.1961 82.2787 32.1973 81.3193 32.1973Z"
        fill="#F1F1F1"
      />
      <path
        d="M130.698 68.0233C130.691 67.118 130.685 66.2128 130.678 65.3076C130.968 65.3076 131.259 65.3088 131.55 65.3088C131.544 66.2128 131.539 67.1169 131.534 68.0221C131.256 68.0221 130.977 68.0233 130.698 68.0233Z"
        fill={fill}
      />
      <path
        d="M101.965 65.3135C101.961 66.101 101.958 66.8885 101.952 67.6748C101.951 67.7914 101.939 67.9067 101.932 68.0233C101.652 68.0209 101.37 68.0186 101.09 68.0162L101.07 68.0186C101.073 67.1169 101.076 66.2152 101.079 65.3135C101.367 65.3076 101.657 65.3006 101.945 65.2947L101.965 65.3135Z"
        fill={fill}
      />
      <path
        d="M89.4517 68.0219C89.4434 67.1203 89.4352 66.2174 89.4258 65.3157L89.4446 65.2969C89.7318 65.3004 90.0191 65.3039 90.3063 65.3075C90.3075 66.2103 90.3098 67.112 90.311 68.0149L90.2839 68.0137C90.0061 68.0172 89.7295 68.0196 89.4517 68.0219Z"
        fill={fill}
      />
      <path
        d="M48.2069 68.0222C48.1999 67.1205 48.1916 66.2189 48.1846 65.3172L48.2034 65.2983C48.4906 65.3007 48.7778 65.3042 49.0651 65.3066C49.0662 66.2094 49.0686 67.1123 49.0698 68.014L49.0545 68.0128L49.0392 68.014C48.7602 68.0175 48.4836 68.0199 48.2069 68.0222Z"
        fill={fill}
      />
      <path
        d="M29.7788 65.316C29.7752 66.1117 29.7717 66.9075 29.767 67.7044C29.7658 67.8103 29.7564 67.9175 29.7517 68.0234C29.4739 68.021 29.1961 68.0187 28.9195 68.0163L28.8936 68.0175C28.8947 67.1146 28.8971 66.213 28.8983 65.3101C29.1855 65.3066 29.4727 65.3019 29.7611 65.2983L29.7788 65.316Z"
        fill={fill}
      />
      <path
        d="M17.2759 68.0231C17.2689 67.2462 17.263 66.4693 17.2547 65.6923C17.2536 65.5664 17.2477 65.4404 17.2441 65.3145L17.263 65.2957C17.5502 65.3004 17.8386 65.3051 18.1258 65.311C18.1282 66.2138 18.1293 67.1155 18.1317 68.0184L18.107 68.0172C17.8304 68.0184 17.5537 68.0207 17.2759 68.0231Z"
        fill={fill}
      />
      <path
        d="M49.0701 52.8501C49.0701 53.1208 49.0689 53.3916 49.0689 53.6623L49.0666 53.6647C48.7782 53.6611 48.4898 53.6588 48.2014 53.6552C48.2014 53.388 48.2002 53.122 48.2002 52.8548C48.4898 52.8524 48.7793 52.8501 49.0701 52.8501Z"
        fill={outline}
      />
      <path
        d="M49.5395 53.6717C49.5572 53.4033 49.4783 53.049 49.6196 52.8948C49.7444 52.7582 50.114 52.8453 50.3753 52.8335L50.3776 52.8359C50.3718 53.1113 50.3647 53.3868 50.3588 53.6611C50.0857 53.6646 49.8126 53.6681 49.5395 53.6717Z"
        fill={outline}
      />
      <path
        d="M49.0699 53.6621C49.2276 53.6656 49.3853 53.668 49.5431 53.6715C49.5419 53.8257 49.5395 53.9788 49.5384 54.133C49.383 54.1365 49.2288 54.1388 49.0734 54.1424C49.0722 53.9835 49.071 53.8246 49.0687 53.6645C49.0675 53.6633 49.0699 53.6621 49.0699 53.6621Z"
        fill="#F1F0F0"
      />
      <path
        d="M8.29022 65.3229C8.11954 65.3217 7.95003 65.3206 7.77935 65.3206C7.77582 65.0439 7.77111 64.7685 7.76758 64.4919C7.77464 64.4848 7.7817 64.4777 7.78877 64.4695C7.94886 64.4707 8.11012 64.4707 8.27021 64.4718C8.28198 64.7485 8.29493 65.0263 8.3067 65.3029L8.29022 65.3229Z"
        fill={fill}
      />
      <path
        d="M79.9644 39.6168C79.9668 40.5726 79.9703 41.5285 79.9727 42.4855C79.9656 42.4937 79.9586 42.502 79.9515 42.509C79.6855 42.5102 79.4194 42.5102 79.1546 42.5114L79.1357 42.4925C79.1393 41.5332 79.1428 40.5726 79.1463 39.6133C79.4182 39.6145 79.6913 39.6156 79.9644 39.6168Z"
        fill={fill}
      />
      <path
        d="M97.0235 33.5401C97.0211 33.3789 97.0199 33.2176 97.0176 33.0575C97.9157 33.0505 98.815 33.0422 99.7132 33.0352C99.7332 33.2047 99.7532 33.3742 99.7732 33.5437L99.7697 33.546C98.8539 33.5507 97.9369 33.5554 97.0211 33.559L97.0235 33.5401Z"
        fill="#F1F1F1"
      />
      <path
        d="M27.6008 68.0161C27.5961 67.1191 27.5926 66.2233 27.5879 65.3264L27.6067 65.3052C27.8798 65.3075 28.1529 65.3099 28.4248 65.3122C28.4272 66.2139 28.4307 67.1156 28.4331 68.0173L28.4131 68.0149C28.1435 68.0161 27.8716 68.0161 27.6008 68.0161Z"
        fill={fill}
      />
      <path
        d="M19.4354 65.3288C19.4319 66.2246 19.4272 67.1192 19.4237 68.015C19.1517 68.015 18.8798 68.0161 18.6079 68.0161L18.5879 68.0185C18.5902 67.1168 18.5938 66.2151 18.5961 65.3135C18.8692 65.3111 19.1423 65.3088 19.4154 65.3064L19.4354 65.3288Z"
        fill={fill}
      />
      <path
        d="M9.13579 65.3218C9.13108 66.2211 9.12638 67.1193 9.12167 68.0186C8.84975 68.0186 8.57783 68.0186 8.30592 68.0174C8.30121 67.1193 8.2965 66.2211 8.29297 65.323L8.31063 65.303C8.58019 65.303 8.84857 65.303 9.11814 65.303C9.11696 65.303 9.13579 65.3218 9.13579 65.3218Z"
        fill={fill}
      />
      <path
        d="M37.904 68.0186C37.8993 67.1193 37.8934 66.22 37.8887 65.3206L37.9063 65.303C38.1794 65.3077 38.4525 65.3136 38.7256 65.3183C38.7315 66.2188 38.7362 67.1193 38.7421 68.0198L38.7162 68.0174C38.4455 68.0174 38.1747 68.0186 37.904 68.0186Z"
        fill={fill}
      />
      <path
        d="M40.082 65.3206C40.0773 66.22 40.0714 67.1193 40.0667 68.0198C39.7947 68.0198 39.5228 68.0186 39.2509 68.0186L39.2227 68.0198C39.2297 67.1205 39.2368 66.2211 39.2438 65.3206C39.5169 65.3148 39.7912 65.3089 40.0643 65.303L40.082 65.3206Z"
        fill={fill}
      />
      <path
        d="M50.3759 65.324C50.3711 66.2221 50.3664 67.1203 50.3617 68.0172C50.091 68.0172 49.8202 68.0161 49.5495 68.0161L49.5283 68.0184C49.5319 67.1167 49.5354 66.2162 49.5389 65.3145C49.812 65.311 50.0851 65.3075 50.357 65.304L50.3759 65.324Z"
        fill={fill}
      />
      <path
        d="M58.5389 68.0127C58.5354 67.1192 58.5319 66.2246 58.5283 65.3312C58.5342 65.3229 58.5413 65.3159 58.5483 65.3076C58.8226 65.3088 59.0957 65.3112 59.37 65.3123C59.3723 66.214 59.3759 67.1157 59.3782 68.0174L59.3582 68.015C59.0851 68.015 58.812 68.0138 58.5389 68.0127Z"
        fill={fill}
      />
      <path
        d="M60.6778 65.331C60.6743 66.2256 60.6708 67.119 60.6672 68.0136C60.3941 68.0148 60.1222 68.0148 59.8491 68.016L59.8291 68.0183C59.8315 67.1167 59.835 66.215 59.8373 65.3133C60.1104 65.311 60.3847 65.3098 60.6578 65.3086C60.6649 65.3145 60.6719 65.3227 60.6778 65.331Z"
        fill={fill}
      />
      <path
        d="M68.8422 68.0173C68.841 67.8419 68.8398 67.6654 68.8398 67.49C69.1071 67.3275 69.3754 67.1639 69.6426 67.0015C69.6532 67.3405 69.6638 67.6795 69.6744 68.0185L69.6544 68.0161C69.3837 68.0161 69.1129 68.0173 68.8422 68.0173Z"
        fill={fill}
      />
      <path
        d="M81.3185 65.3204C81.3137 66.2198 81.3079 67.1191 81.3032 68.0196C81.0324 68.0196 80.7605 68.0184 80.4898 68.0184L80.4639 68.0208C80.4698 67.1203 80.4756 66.2198 80.4815 65.3204C80.7546 65.3146 81.0277 65.3098 81.3008 65.304L81.3185 65.3204Z"
        fill={fill}
      />
      <path
        d="M91.6217 65.3252C91.617 66.2221 91.6135 67.1191 91.6088 68.0161C91.3381 68.0161 91.0673 68.0161 90.7954 68.0161L90.7754 68.0184C90.7777 67.1168 90.7813 66.2151 90.7836 65.3134C91.0567 65.3111 91.3286 65.3075 91.6017 65.3052L91.6217 65.3252Z"
        fill={fill}
      />
      <path
        d="M99.7813 68.0138C99.7778 67.1192 99.7731 66.2234 99.7695 65.3288C99.7754 65.3217 99.7825 65.3135 99.7895 65.3064C100.063 65.3088 100.336 65.3099 100.61 65.3123C100.612 66.214 100.616 67.1156 100.618 68.0173L100.598 68.015C100.326 68.015 100.053 68.015 99.7813 68.0138Z"
        fill={fill}
      />
      <path
        d="M110.084 68.0184C110.08 67.1203 110.075 66.2209 110.07 65.3228L110.089 65.304C110.362 65.3075 110.635 65.3122 110.907 65.3157C110.911 66.2162 110.915 67.1179 110.919 68.0184L110.897 68.0161C110.626 68.0172 110.355 68.0172 110.084 68.0184Z"
        fill={fill}
      />
      <path
        d="M112.265 65.3204C112.26 66.2198 112.254 67.1191 112.249 68.0196C111.976 68.0196 111.703 68.0196 111.429 68.0196L111.414 68.0208L111.398 68.0196C111.407 67.1203 111.415 66.2221 111.423 65.324C111.697 65.3169 111.972 65.3098 112.246 65.304L112.265 65.3204Z"
        fill={fill}
      />
      <path
        d="M120.386 68.0183C120.382 67.119 120.376 66.2197 120.371 65.3192L120.389 65.3015C120.663 65.3074 120.936 65.3145 121.21 65.3204C121.217 66.2197 121.226 67.119 121.233 68.0183H121.205C120.931 68.0183 120.659 68.0183 120.386 68.0183Z"
        fill={fill}
      />
      <path
        d="M122.561 65.3204C122.556 66.2197 122.552 67.119 122.546 68.0183C122.275 68.0171 122.004 68.0171 121.734 68.016L121.71 68.0183C121.715 67.1178 121.719 66.2173 121.724 65.3156C121.997 65.3109 122.27 65.3062 122.542 65.3015L122.561 65.3204Z"
        fill={fill}
      />
      <path
        d="M7.78053 63.1276C7.95003 63.1264 8.11954 63.1252 8.28905 63.124L8.30788 63.144C8.30317 63.4183 8.29846 63.6914 8.29375 63.9657C8.12543 63.9692 7.95827 63.9739 7.78994 63.9774C7.78288 63.9704 7.77464 63.9621 7.76758 63.9551C7.77111 63.6796 7.77582 63.403 7.78053 63.1276Z"
        fill={fill}
      />
      <path
        d="M45.4261 39.6144C44.6021 39.6155 43.7781 39.6155 42.9541 39.6167C42.9553 38.7739 42.9565 37.9311 42.9576 37.0882C43.7804 37.0871 44.6044 37.0859 45.4273 37.0847C45.4273 37.9287 45.4272 38.7715 45.4261 39.6144Z"
        fill="#B3D6DD"
      />
      <path
        d="M37.904 33.5653C38.1794 33.5594 38.4548 33.5535 38.7291 33.5476L38.7303 33.55C38.7244 33.8254 38.7185 34.0997 38.7126 34.3751C38.4395 34.3775 38.1676 34.381 37.8945 34.3834C37.8981 34.1103 37.9004 33.8372 37.904 33.5653Z"
        fill={outline}
      />
      <path
        d="M38.7424 33.0508C38.9061 33.0484 39.0685 33.0461 39.2321 33.0437C39.2321 33.0437 39.2368 33.0461 39.2368 33.0449C39.2357 33.2085 39.2333 33.3721 39.2321 33.5357C39.065 33.5404 38.8978 33.544 38.7307 33.5475L38.7295 33.5452C38.7342 33.3815 38.7377 33.2167 38.7424 33.0508Z"
        fill="#F1EFEF"
      />
      <path
        d="M90.3047 42.5122C90.4636 42.5051 90.6226 42.4993 90.7815 42.4922L90.8015 42.5098C90.7968 42.7982 90.7933 43.0866 90.7885 43.375C90.6308 43.3762 90.4719 43.3762 90.3142 43.3774L90.293 43.3621C90.2965 43.0784 90.3 42.7959 90.3047 42.5122Z"
        fill={fill}
      />
      <path
        d="M90.7697 44.6855C90.6178 44.682 90.466 44.6772 90.3141 44.6737C90.3094 44.4041 90.3035 44.1334 90.2988 43.8639L90.3165 43.8462C90.4719 43.8474 90.6272 43.8474 90.7826 43.8485C90.785 44.1216 90.7873 44.3947 90.7897 44.6666L90.7697 44.6855Z"
        fill={fill}
      />
      <path
        d="M45.4273 37.0858C44.6044 37.087 43.7804 37.0881 42.9576 37.0893L42.9541 37.0858C42.9541 36.1876 42.9553 35.2907 42.9553 34.3925L42.9541 34.3713C43.7793 34.3725 44.6044 34.3725 45.4296 34.3737L45.4273 34.3937C45.4273 35.2907 45.4273 36.1876 45.4273 37.0858Z"
        fill="#CFE3E7"
      />
      <path
        d="M59.8296 34.3901C59.6754 34.3878 59.5224 34.3854 59.3682 34.3831C59.3693 34.1065 59.3705 33.8298 59.3729 33.5532C59.5235 33.5509 59.6742 33.5485 59.8261 33.5461L59.8461 33.565C59.8473 33.8345 59.8473 34.1029 59.8484 34.3725L59.8296 34.3901Z"
        fill={fill}
      />
      <path
        d="M110.098 43.366C110.098 43.0799 110.099 42.7951 110.099 42.509C110.364 42.509 110.629 42.509 110.893 42.509C110.898 42.7986 110.903 43.0882 110.908 43.3778H110.906C110.637 43.373 110.367 43.3695 110.098 43.366Z"
        fill={outline}
      />
      <path
        d="M101.076 34.3831C100.92 34.3831 100.764 34.3831 100.608 34.3831C100.605 34.11 100.602 33.8381 100.6 33.565L100.62 33.5461C100.77 33.5485 100.921 33.5509 101.072 33.5532C101.074 33.8298 101.075 34.1065 101.076 34.3831Z"
        fill={fill}
      />
      <path
        d="M68.8398 43.3751C68.8434 43.0867 68.8469 42.7983 68.8504 42.511C69.12 42.5075 69.3884 42.5028 69.6579 42.4993H69.6591C69.6556 42.7877 69.6521 43.0761 69.6485 43.3645C69.379 43.3692 69.1094 43.3727 68.8398 43.3762V43.3751Z"
        fill={outline}
      />
      <path
        d="M80.4983 23.2192C80.7632 23.2216 81.0292 23.2228 81.294 23.2251C81.2952 23.51 81.2964 23.7937 81.2987 24.0785C81.028 24.0832 80.7561 24.0891 80.4854 24.0938H80.4865C80.4901 23.8019 80.4948 23.5112 80.4983 23.2192Z"
        fill={outline}
      />
      <path
        d="M58.5167 44.6936C57.6045 44.6866 56.691 44.6795 55.7787 44.6713C55.7787 44.4005 55.7787 44.1298 55.7787 43.8591L55.7764 43.8391C56.6922 43.8367 57.608 43.8343 58.5238 43.8308C58.532 43.8379 58.5391 43.8438 58.5473 43.852C58.5462 44.1251 58.545 44.3982 58.5438 44.6713C58.5344 44.6795 58.5261 44.6866 58.5167 44.6936Z"
        fill={fill}
      />
      <path
        d="M120.362 44.6863C120.369 45.6033 120.376 46.5191 120.382 47.4361L120.366 47.4314C119.449 47.4314 118.532 47.4302 117.617 47.4302C117.617 46.5179 117.618 45.6057 117.618 44.6946L117.614 44.6746C118.53 44.6781 119.446 44.6816 120.362 44.6863Z"
        fill="#F1F1F1"
      />
      <path
        d="M115.141 43.8401C115.966 43.846 116.792 43.8519 117.617 43.8577C117.617 44.1297 117.617 44.4016 117.618 44.6735L117.622 44.6935C116.796 44.6841 115.969 44.6758 115.142 44.6664C115.142 44.3969 115.143 44.1261 115.143 43.8566L115.141 43.8401Z"
        fill={fill}
      />
      <path
        d="M70.9976 39.6098C71.0035 40.5727 71.0105 41.5356 71.0164 42.4985L70.9964 42.5185C70.7186 42.5197 70.4408 42.5197 70.163 42.5209C70.1559 42.5138 70.1477 42.5079 70.1406 42.5008C70.1477 41.5368 70.1548 40.5727 70.163 39.6086C70.442 39.6098 70.7198 39.6098 70.9976 39.6098Z"
        fill={fill}
      />
      <path
        d="M69.6484 43.3645C69.652 43.0761 69.6555 42.7877 69.659 42.4993C69.8191 42.4993 69.978 42.4993 70.1381 42.5004C70.1452 42.5063 70.1534 42.5134 70.1605 42.5205C70.1534 42.8006 70.1475 43.0808 70.1405 43.3621C69.9827 43.3692 69.825 43.3762 69.6673 43.3833C69.6673 43.3821 69.6484 43.3645 69.6484 43.3645Z"
        fill={fill}
      />
      <path
        d="M90.7757 34.389C90.6203 34.3843 90.465 34.3795 90.3096 34.376C90.3096 34.1053 90.3096 33.8357 90.3096 33.565C90.4626 33.5591 90.6168 33.552 90.7698 33.5461L90.791 33.5638C90.7922 33.8334 90.7922 34.1017 90.7934 34.3713L90.7757 34.389Z"
        fill={fill}
      />
      <path
        d="M90.7728 33.5476C90.6197 33.5535 90.4655 33.5593 90.3125 33.5664C90.2972 33.5617 90.2819 33.5558 90.2666 33.5511C90.2831 33.3781 90.3007 33.205 90.3172 33.032L90.3184 33.0332C90.4714 33.0343 90.6256 33.0367 90.7786 33.0379H90.7798C90.7775 33.2062 90.7751 33.3769 90.7728 33.5476Z"
        fill="#F1EFEF"
      />
      <path
        d="M39.2416 65.3204C39.2345 66.2198 39.2274 67.1191 39.2204 68.0196C39.0603 68.0196 38.9002 68.0196 38.7401 68.0196C38.7342 67.1191 38.7295 66.2186 38.7236 65.3181V65.3169C38.8967 65.3181 39.0685 65.3181 39.2416 65.3193V65.3204Z"
        fill="#F1F1F1"
      />
      <path
        d="M80.4828 65.3181C80.4769 66.2186 80.471 67.1179 80.4651 68.0184C80.305 68.0184 80.1449 68.0184 79.9849 68.0184C79.979 67.1191 79.9719 66.2186 79.9648 65.3193V65.3181C80.1379 65.3181 80.3109 65.3181 80.4828 65.3181Z"
        fill="#F1F1F1"
      />
      <path
        d="M111.427 65.3227C111.419 66.2209 111.41 67.1202 111.402 68.0184C111.242 68.0184 111.082 68.0184 110.922 68.0184C110.918 67.1179 110.914 66.2162 110.91 65.3157C111.082 65.318 111.254 65.3192 111.426 65.3216C111.425 65.3216 111.427 65.3227 111.427 65.3227Z"
        fill="#F1EFEF"
      />
      <path
        d="M121.725 65.3169C121.72 66.2174 121.716 67.1179 121.711 68.0196C121.551 68.0196 121.389 68.0196 121.229 68.0196C121.222 67.1203 121.214 66.2209 121.207 65.3216V65.3204C121.381 65.3181 121.553 65.3169 121.725 65.3169Z"
        fill="#F1EFEF"
      />
      <path
        d="M90.7757 33.0366C90.6227 33.0354 90.4685 33.033 90.3155 33.0319C90.3131 32.7588 90.3119 32.4845 90.3096 32.2114C90.4673 32.2091 90.625 32.2067 90.7828 32.2043C90.7792 32.4821 90.7781 32.7588 90.7757 33.0366Z"
        fill={fill}
      />
      <path
        d="M39.2275 33.5369C39.2287 33.3733 39.2311 33.2097 39.2322 33.046C39.5136 33.0425 39.7949 33.0402 40.0762 33.0366C40.0786 33.2073 40.0798 33.3768 40.0821 33.5475L40.0621 33.5663C39.7914 33.5652 39.5195 33.564 39.2487 33.5628C39.2417 33.5534 39.2346 33.5451 39.2275 33.5369Z"
        fill={fill}
      />
      <path
        d="M7.79024 63.9773C7.95857 63.9738 8.12572 63.9691 8.29405 63.9656C8.28934 64.128 8.28463 64.2916 8.27993 64.4541L8.27051 64.4717C8.11042 64.4706 7.94915 64.4706 7.78906 64.4694C7.79024 64.3058 7.79024 64.1421 7.79024 63.9773Z"
        fill="#F1EFEF"
      />
      <path
        d="M125.445 54.9913C124.623 54.9984 123.801 55.0066 122.978 55.0137C122.853 55.0149 122.728 55.0137 122.568 55.0137C122.568 55.9354 122.568 56.8323 122.568 57.7281L122.546 57.7258C122.276 57.7258 122.005 57.727 121.734 57.727C121.734 56.8323 121.734 55.9377 121.734 55.0384C121.535 55.0384 121.387 55.0384 121.207 55.0384C121.207 55.9495 121.207 56.837 121.207 57.7234C120.933 57.7258 120.66 57.7269 120.385 57.7293C120.385 56.8335 120.385 55.9365 120.385 54.996C119.426 54.996 118.517 54.996 117.608 54.996C117.61 54.717 117.61 54.4381 117.611 54.1591C118.534 54.1544 119.456 54.1497 120.381 54.145C120.379 54.3592 120.366 54.5758 120.386 54.7888C120.392 54.8536 120.484 54.9536 120.548 54.9631C121.187 55.0549 121.207 55.0337 121.207 54.4004C121.207 54.3121 121.208 54.225 121.208 54.1367C121.382 54.1379 121.558 54.1391 121.732 54.1414C121.732 54.3557 121.719 54.5711 121.738 54.7841C121.744 54.8501 121.832 54.9525 121.894 54.9631C122.521 55.0631 122.558 55.0278 122.556 54.4086C122.556 54.3215 122.555 54.2332 122.554 54.145C123.514 54.1438 124.476 54.1426 125.436 54.1426L125.435 54.1697C125.439 54.4416 125.441 54.7159 125.445 54.9913Z"
        fill={fill}
      />
      <path
        d="M59.8355 65.3132C59.8331 66.2149 59.8296 67.1166 59.8272 68.0183C59.6766 68.0183 59.5271 68.0183 59.3764 68.0183C59.3741 67.1166 59.3705 66.2149 59.3682 65.3132C59.5235 65.3132 59.6801 65.3132 59.8355 65.3132Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.6 65.3136C18.5976 66.2153 18.5941 67.117 18.5917 68.0186C18.4387 68.0186 18.2868 68.0175 18.1338 68.0175C18.1315 67.1146 18.1303 66.2129 18.1279 65.3101H18.1291C18.2857 65.3112 18.4434 65.3124 18.6 65.3136Z"
        fill="#F1F1F1"
      />
      <path
        d="M90.7839 65.3135C90.7816 66.2152 90.7781 67.1169 90.7757 68.0185C90.6215 68.0174 90.4685 68.0174 90.3143 68.0162C90.3131 67.1133 90.3107 66.2117 90.3096 65.3088L90.3119 65.3076C90.4685 65.3088 90.6262 65.3112 90.7839 65.3135Z"
        fill="#F1F1F1"
      />
      <path
        d="M100.619 68.0183C100.616 67.1166 100.613 66.2149 100.61 65.3132C100.767 65.3132 100.922 65.3132 101.079 65.3132C101.076 66.2149 101.073 67.1166 101.071 68.0183C100.919 68.0183 100.769 68.0183 100.619 68.0183Z"
        fill="#F1F1F1"
      />
      <path
        d="M49.5439 65.3146C49.5404 66.2163 49.5369 67.1168 49.5333 68.0184C49.3791 68.0173 49.2261 68.0161 49.0731 68.0149C49.0719 67.1121 49.0695 66.2092 49.0684 65.3075L49.0719 65.3052C49.2284 65.3087 49.3862 65.3111 49.5439 65.3146Z"
        fill="#F1F0F0"
      />
      <path
        d="M69.6753 68.0185C69.6647 67.6795 69.6541 67.3405 69.6436 67.0015C69.7907 66.7343 69.939 66.4659 70.0861 66.1987C70.1062 66.1963 70.1262 66.1928 70.145 66.1904C70.1427 66.799 70.1403 67.4076 70.1379 68.015C69.9837 68.0162 69.8295 68.0173 69.6753 68.0185Z"
        fill="#F1EFEF"
      />
      <path
        d="M28.4311 68.0185C28.4287 67.1169 28.4252 66.2152 28.4229 65.3135C28.5806 65.3112 28.7383 65.31 28.8961 65.3076L28.8972 65.3088C28.8961 66.2117 28.8937 67.1133 28.8925 68.0162C28.7383 68.0174 28.5853 68.0174 28.4311 68.0185Z"
        fill="#F1F1F1"
      />
      <path
        d="M59.8481 34.3713C59.8469 34.1017 59.8469 33.8333 59.8457 33.5638C60.1164 33.5614 60.3884 33.5602 60.6591 33.5579C60.6591 33.831 60.6579 34.1029 60.6579 34.376C60.3872 34.3748 60.1176 34.3736 59.8481 34.3713Z"
        fill={outline}
      />
      <path
        d="M48.2071 47.434C48.2107 48.2592 48.2142 49.0843 48.2166 49.9083H48.1883C47.2678 49.9083 46.3473 49.9083 45.4268 49.9083C45.4279 49.0831 45.4279 48.2568 45.4291 47.4316C46.3473 47.4328 47.2654 47.4328 48.1836 47.434H48.2071Z"
        fill="#CFE3E7"
      />
      <path
        d="M49.071 52.8487C48.7814 52.8511 48.4907 52.8534 48.2011 52.8558C48.194 52.8487 48.1858 52.8405 48.1787 52.8322C48.1834 51.8576 48.1881 50.8829 48.1917 49.9094H48.2199C48.4871 49.9106 48.7532 49.9106 49.0192 49.9118C49.0368 50.89 49.0533 51.8693 49.071 52.8487Z"
        fill={fill}
      />
      <path
        d="M80.5001 23.2191C80.4954 23.5111 80.4919 23.8018 80.4872 24.0937C80.313 24.0937 80.1376 24.0938 79.9633 24.0949C79.9586 23.803 79.9539 23.5122 79.9492 23.2203L79.968 23.2015C80.1387 23.2003 80.3082 23.198 80.4789 23.1968C80.486 23.2038 80.4931 23.2121 80.5001 23.2191Z"
        fill={fill}
      />
      <path
        d="M90.7853 43.8472C90.6299 43.8461 90.4745 43.8461 90.3192 43.8449C90.318 43.6883 90.3168 43.5329 90.3145 43.3764C90.4722 43.3752 90.6311 43.3752 90.7888 43.374H90.79C90.7888 43.5329 90.7877 43.6895 90.7853 43.8472Z"
        fill="#F1F1F1"
      />
      <path
        d="M80.4757 23.1971C80.305 23.1994 80.1355 23.2006 79.9648 23.2018C79.966 23.0511 79.966 22.9004 79.9672 22.7498C80.1379 22.7698 80.3097 22.7898 80.4804 22.811C80.4792 22.9393 80.4781 23.0676 80.4757 23.1971Z"
        fill="#F1EFEF"
      />
      <path
        d="M42.9588 42.502C43.7828 42.509 44.6068 42.5161 45.432 42.5231C45.4296 42.8021 45.4272 43.0811 45.4249 43.3589L45.4284 43.3801C45.2825 43.3777 45.1365 43.3754 44.9917 43.373C44.3125 43.3636 43.6333 43.3542 42.9541 43.346C42.9565 43.0729 42.96 42.7998 42.9623 42.5267L42.9588 42.502Z"
        fill={fill}
      />
      <path
        d="M48.1836 47.4338C47.2654 47.4326 46.3473 47.4326 45.4291 47.4314L45.4268 47.4302C45.4279 46.5179 45.4291 45.6069 45.4303 44.6946L45.4268 44.6746C46.3426 44.6781 47.2595 44.6816 48.1754 44.6852C48.1801 45.601 48.1812 46.5168 48.1836 47.4338Z"
        fill="#F1F1F1"
      />
      <path
        d="M45.4284 43.8544C45.4296 44.1275 45.4308 44.4006 45.432 44.6737L45.4355 44.6937C44.6091 44.6843 43.7828 44.6749 42.9553 44.6666C42.9553 44.3971 42.9553 44.1287 42.9541 43.8591C43.7804 43.8521 44.6056 43.845 45.432 43.8391L45.4284 43.8544Z"
        fill={fill}
      />
      <path
        d="M18.5905 43.8413C18.4375 43.8425 18.2857 43.8425 18.1326 43.8437C18.1315 43.6883 18.1291 43.5341 18.1279 43.3787C18.2857 43.3776 18.4434 43.3764 18.6011 43.374L18.6023 43.3752C18.5988 43.5306 18.5953 43.686 18.5905 43.8413Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.5879 43.8414C18.5926 43.686 18.5961 43.5306 18.6008 43.3752C18.8728 43.3752 19.1447 43.3752 19.4154 43.3752C19.4213 43.5283 19.4284 43.6801 19.4342 43.8331L19.4142 43.8543C19.1447 43.8555 18.8751 43.8567 18.6055 43.859L18.5879 43.8414Z"
        fill={fill}
      />
      <path
        d="M58.5238 43.8318C57.608 43.8341 56.6922 43.8377 55.7764 43.84C55.7775 43.6858 55.7775 43.5316 55.7787 43.3786C56.6828 43.3715 57.5868 43.3644 58.492 43.3562C58.505 43.368 58.5203 43.3774 58.5367 43.3845C58.5332 43.5328 58.5285 43.6823 58.5238 43.8318Z"
        fill="#F1F0F0"
      />
      <path
        d="M80.4859 43.8425C80.759 43.8472 81.0321 43.8531 81.3052 43.8578C81.3064 44.1274 81.3075 44.3958 81.3087 44.6653C81.0321 44.6724 80.7566 44.6795 80.48 44.6865C80.48 44.6865 80.4788 44.683 80.48 44.683C80.4824 44.4028 80.4847 44.1239 80.4859 43.8425Z"
        fill={outline}
      />
      <path
        d="M125.434 54.1389C124.473 54.14 123.511 54.1412 122.551 54.1412V54.14C122.552 53.9835 122.553 53.8257 122.555 53.6692C123.516 53.6715 124.477 53.6751 125.437 53.6774C125.436 53.8316 125.435 53.9858 125.434 54.1389Z"
        fill="#F1F1F1"
      />
      <path
        d="M9.12196 55.0183C8.85358 55.0148 8.58637 55.0112 8.31798 55.0077C8.31681 54.7216 8.31563 54.4368 8.31445 54.1507C8.58402 54.1472 8.85475 54.1437 9.12432 54.1401C9.12314 54.4321 9.12314 54.724 9.12196 55.0159V55.0183Z"
        fill={outline}
      />
      <path
        d="M100.602 33.5651C100.604 33.8382 100.608 34.1101 100.61 34.3832C100.337 34.3809 100.064 34.3785 99.7907 34.3774C99.7837 34.1007 99.7766 33.8229 99.7695 33.5463L99.7731 33.5439C100.051 33.5498 100.326 33.5569 100.602 33.5651Z"
        fill={outline}
      />
      <path
        d="M45.4294 34.3724C44.6043 34.3713 43.7791 34.3712 42.9539 34.3701C42.9539 34.1005 42.9539 33.8298 42.9539 33.5602L42.9492 33.5425C43.7767 33.5414 44.6054 33.5402 45.433 33.5378L45.4294 33.5567C45.4294 33.8286 45.4294 34.1005 45.4294 34.3724Z"
        fill={fill}
      />
      <path
        d="M45.4291 43.8391C44.6028 43.8461 43.7776 43.8532 42.9513 43.8591L42.9525 43.8379C42.9513 43.6837 42.9513 43.5295 42.9501 43.3753C42.9489 43.3647 42.9489 43.3541 42.9501 43.3435C43.6293 43.3529 44.3085 43.3612 44.9877 43.3706C45.1337 43.3729 45.2796 43.3753 45.4244 43.3776C45.4268 43.533 45.428 43.6861 45.4291 43.8391Z"
        fill="#CFE3E7"
      />
      <path
        d="M130.675 65.3065C129.771 65.3113 128.867 65.316 127.963 65.3207L127.964 65.3007C127.965 65.0288 127.965 64.7568 127.966 64.4837C128.863 64.4802 129.76 64.4767 130.656 64.4731C130.664 64.4814 130.673 64.4896 130.681 64.4979C130.68 64.7686 130.677 65.037 130.675 65.3065Z"
        fill={fill}
      />
      <path
        d="M45.4341 33.538C44.6066 33.5392 43.7779 33.5416 42.9504 33.5427C42.9504 33.3779 42.9504 33.2131 42.9492 33.0483C43.7779 33.0507 44.6066 33.053 45.4341 33.0542C45.4341 33.2167 45.4341 33.3768 45.4341 33.538Z"
        fill="#CFE2E5"
      />
      <path
        d="M130.656 64.4742C129.759 64.4777 128.862 64.4813 127.966 64.4848L127.97 64.4624C127.969 64.2988 127.968 64.1364 127.968 63.9727L127.963 63.9551C128.863 63.9586 129.764 63.9622 130.664 63.9657C130.661 64.1352 130.659 64.3047 130.656 64.4742Z"
        fill="#F1EFEF"
      />
      <path
        d="M70.0866 66.1987C69.9395 66.4659 69.7912 66.7343 69.644 67.0015C69.3768 67.164 69.1084 67.3276 68.8412 67.49C68.5328 67.5018 68.215 67.5665 67.916 67.5159C66.9625 67.3558 66.3292 66.5448 66.3563 65.5784C66.3587 65.4901 66.3622 65.403 66.3657 65.3147C66.4681 65.0475 66.5705 64.7791 66.673 64.5119C66.866 64.3471 67.0602 64.1823 67.2533 64.0175C67.7524 63.7185 68.288 63.6855 68.8436 63.7974C68.9813 63.8704 69.1178 63.9433 69.2556 64.0163C69.3886 64.1175 69.5216 64.2188 69.6546 64.32C69.7135 64.3812 69.7723 64.4424 69.8312 64.5036C69.9324 64.7226 70.0337 64.9415 70.1349 65.1605L70.1337 65.1876C70.1372 65.2476 70.1396 65.3076 70.1431 65.3688C70.1431 65.5666 70.1431 65.7644 70.1431 65.9609C70.1231 66.041 70.1043 66.1198 70.0866 66.1987Z"
        fill={outline}
      />
      <path
        d="M70.0869 66.1988C70.1057 66.1199 70.1234 66.041 70.1422 65.9622C70.1434 66.0387 70.1446 66.114 70.1458 66.1905C70.1258 66.1929 70.1069 66.1952 70.0869 66.1988Z"
        fill="#E2BBAC"
      />
      <path
        d="M70.1393 65.3698C70.1358 65.3097 70.1334 65.2497 70.1299 65.1885C70.1511 65.2297 70.1711 65.2697 70.1923 65.3109C70.1746 65.3309 70.157 65.3497 70.1393 65.3698Z"
        fill={fill}
      />
      <path
        d="M76.373 64.4552C76.3742 64.2951 76.3766 64.135 76.3778 63.9737L76.3754 63.9561C77.2924 63.9596 78.2105 63.9643 79.1275 63.9678C79.1287 64.1385 79.1299 64.308 79.1311 64.4787H79.1287C78.2094 64.4728 77.2912 64.4634 76.373 64.4552Z"
        fill="#F1EFEF"
      />
      <path
        d="M79.9655 65.3195C79.6924 65.3136 79.4181 65.3077 79.145 65.3019C79.1379 65.0276 79.1321 64.7545 79.125 64.4802H79.1273C79.404 64.4838 79.6818 64.4861 79.9584 64.4896C79.9608 64.7663 79.9631 65.0429 79.9655 65.3183V65.3195Z"
        fill={outline}
      />
      <path
        d="M70.1338 65.1618C70.0325 64.9428 69.9313 64.7239 69.8301 64.5049C69.989 64.4755 70.175 64.5037 70.1526 64.2283C70.1373 64.0423 70.1055 63.9364 69.9007 63.9564C69.9007 63.6856 69.9007 63.4149 69.9007 63.1442C70.0867 63.1606 70.1503 63.0818 70.1491 62.8899C70.1408 62.0129 70.1479 61.136 70.1491 60.259C70.1656 60.2578 70.182 60.2567 70.1973 60.2531C70.4516 60.2531 70.7059 60.2531 70.9601 60.252C70.9766 60.2531 70.9931 60.2543 71.0096 60.2567C71.0143 61.2148 71.019 62.1718 71.0237 63.13L71.0049 63.1489C70.8589 63.1442 70.7117 63.1359 70.5658 63.1359C70.1891 63.1347 70.1879 63.1359 70.1903 63.5197C70.1938 64.0141 70.1361 63.9576 70.6258 63.9611C70.7529 63.9623 70.8801 63.9528 71.006 63.9481L71.026 63.9681C71.0249 64.14 71.0237 64.3119 71.0237 64.4837C70.78 64.4861 70.4787 64.4037 70.3103 64.5179C70.1703 64.6132 70.1868 64.9381 70.1338 65.1618Z"
        fill={fill}
      />
      <path
        d="M73.8998 63.9527C73.8798 63.9585 73.8598 63.9644 73.8398 63.9703C72.9016 63.9691 71.9635 63.9691 71.0241 63.968L71.0041 63.948C71.0041 63.6819 71.0029 63.4159 71.0029 63.1499L71.0218 63.131C71.9611 63.1298 72.8993 63.1298 73.8386 63.1287C73.8586 63.1345 73.8787 63.1404 73.8987 63.1451C73.8998 63.4135 73.8998 63.6831 73.8998 63.9527Z"
        fill={fill}
      />
      <path
        d="M73.8994 63.9527C73.8994 63.6832 73.8994 63.4136 73.8994 63.1452C74.7234 63.1452 75.5474 63.1452 76.3714 63.144C76.3714 63.4148 76.3714 63.6867 76.3714 63.9574C76.3714 63.9574 76.3737 63.9739 76.3737 63.9751C75.5498 63.9669 74.7246 63.9598 73.8994 63.9527Z"
        fill={fill}
      />
      <path
        d="M91.6279 33.5427C92.5825 33.5404 93.536 33.5392 94.4906 33.5369L94.4895 33.5616C94.4895 33.8323 94.4906 34.1031 94.4906 34.3738C93.5336 34.3809 92.5766 34.3879 91.6196 34.395L91.5996 34.375C91.6008 34.1042 91.6008 33.8335 91.602 33.5616C91.6102 33.5545 91.6184 33.5486 91.6279 33.5427Z"
        fill={fill}
      />
      <path
        d="M90.7695 33.5475C90.7719 33.3768 90.7742 33.2061 90.7766 33.0366C91.0568 33.039 91.3381 33.0413 91.6194 33.0425C91.6229 33.2097 91.6253 33.3768 91.6288 33.5428C91.6206 33.5487 91.6124 33.5546 91.6041 33.5616C91.3334 33.5628 91.0626 33.564 90.7919 33.564L90.7695 33.5475Z"
        fill={fill}
      />
      <path
        d="M115.141 43.8568C115.141 44.1264 115.14 44.3972 115.14 44.6667L115.141 44.6926C114.183 44.6879 113.224 44.6832 112.265 44.6785C112.26 44.4054 112.255 44.1323 112.249 43.8592L112.267 43.8416C113.225 43.8463 114.183 43.851 115.141 43.8568Z"
        fill={fill}
      />
      <path
        d="M112.246 43.8579C112.252 44.131 112.257 44.404 112.263 44.6771C111.986 44.6748 111.71 44.6724 111.434 44.6701C111.431 44.3935 111.427 44.1157 111.425 43.839L111.426 43.8367C111.699 43.8449 111.972 43.852 112.246 43.8579Z"
        fill={outline}
      />
      <path
        d="M111.427 43.8402C111.43 44.1169 111.434 44.3947 111.436 44.6713C111.428 44.6807 111.419 44.6901 111.41 44.6995C111.245 44.6925 111.081 44.6866 110.916 44.6795C110.91 44.4053 110.904 44.131 110.899 43.8579L110.917 43.8379C111.087 43.8391 111.256 43.8391 111.427 43.8402Z"
        fill={fill}
      />
      <path
        d="M110.097 43.366C110.367 43.3695 110.636 43.373 110.906 43.3777C110.91 43.5319 110.913 43.685 110.918 43.8392L110.9 43.8592C110.627 43.8557 110.354 43.8509 110.081 43.8474C110.08 43.6932 110.079 43.5402 110.076 43.386C110.076 43.3848 110.097 43.366 110.097 43.366Z"
        fill={fill}
      />
      <path
        d="M76.374 43.3529C76.3717 43.0751 76.3693 42.7973 76.3682 42.5183C77.1839 42.5136 77.9985 42.5077 78.8142 42.5018C78.9214 42.5006 79.0273 42.4947 79.1344 42.4912L79.1532 42.51C79.1497 42.7973 79.145 43.0845 79.1415 43.3717C78.2198 43.3741 77.2969 43.3752 76.3752 43.3776L76.374 43.3529Z"
        fill={fill}
      />
      <path
        d="M71.0076 43.3647C71.9517 43.3671 72.8969 43.3695 73.841 43.3718C73.8398 43.5284 73.8398 43.6849 73.8386 43.8427C72.8993 43.8438 71.9599 43.8438 71.0194 43.845C71.0135 43.6873 71.0076 43.5295 71.0029 43.3718L71.0076 43.3647Z"
        fill="#F1F1F1"
      />
      <path
        d="M73.8408 43.8414C73.842 43.6848 73.842 43.5282 73.8432 43.3705C73.862 43.3634 73.8808 43.3564 73.9009 43.3481C74.7248 43.3493 75.5488 43.3505 76.3728 43.3517V43.3776C76.3728 43.5306 76.374 43.6848 76.374 43.8378C75.55 43.8437 74.7248 43.8496 73.9009 43.8567C73.8808 43.8531 73.8608 43.8472 73.8408 43.8414Z"
        fill="#CFE3E7"
      />
      <path
        d="M70.1406 43.3611C70.1477 43.0809 70.1536 42.7996 70.1606 42.5194C70.4384 42.5183 70.7162 42.5183 70.994 42.5171C70.9988 42.7996 71.0035 43.0809 71.0082 43.3634L71.0035 43.3693C70.7198 43.3682 70.4349 43.3682 70.1512 43.367L70.1406 43.3611Z"
        fill={outline}
      />
      <path
        d="M101.09 39.6157C101.37 39.6134 101.651 39.611 101.931 39.6086C101.932 40.5727 101.932 41.538 101.933 42.502C101.918 42.5009 101.904 42.502 101.888 42.5056C101.621 42.5032 101.353 42.502 101.086 42.4997C101.081 41.538 101.076 40.5762 101.07 39.6133L101.09 39.6157Z"
        fill={fill}
      />
      <path
        d="M101.89 42.5055C101.905 42.5019 101.919 42.502 101.934 42.502C102.884 42.5031 103.834 42.5055 104.784 42.5067C104.785 42.5231 104.787 42.5396 104.789 42.5561C104.789 42.8104 104.789 43.0646 104.789 43.3189C104.787 43.3354 104.785 43.3518 104.784 43.3683C103.841 43.3648 102.898 43.3601 101.956 43.3565C101.934 43.0729 101.912 42.7892 101.89 42.5055Z"
        fill={fill}
      />
      <path
        d="M100.62 37.0883C100.771 37.0871 100.922 37.0871 101.074 37.0859C101.08 37.9299 101.086 38.7728 101.092 39.6168L101.072 39.6144C100.921 39.6156 100.769 39.6168 100.618 39.6168C100.613 38.7728 100.605 37.9299 100.6 37.0859L100.62 37.0883Z"
        fill="#CFE3E7"
      />
      <path
        d="M99.7919 34.376C100.065 34.3783 100.338 34.3807 100.611 34.3819C100.614 35.2835 100.616 36.1852 100.619 37.0869L100.599 37.0857C100.327 37.0857 100.056 37.0846 99.7837 37.0846C99.7789 36.1888 99.7742 35.2941 99.7695 34.3983C99.7778 34.3913 99.7848 34.383 99.7919 34.376Z"
        fill={fill}
      />
      <path
        d="M121.221 49.9107C121.385 49.9095 121.548 49.9072 121.713 49.906C121.716 50.8818 121.718 51.8577 121.719 52.8323L121.718 52.8359C121.552 52.83 121.385 52.8241 121.219 52.8194C121.213 51.8494 121.207 50.8795 121.201 49.9095L121.221 49.9107Z"
        fill="#F1EFEF"
      />
      <path
        d="M122.551 52.8509C122.553 53.124 122.555 53.3971 122.558 53.6714C122.281 53.6725 122.004 53.6737 121.728 53.6737H121.729C121.727 53.3947 121.724 53.1158 121.721 52.8368L121.722 52.8333C121.999 52.838 122.275 52.8438 122.551 52.8509Z"
        fill={outline}
      />
      <path
        d="M24.8348 43.8413C24.8348 43.6871 24.8348 43.5329 24.8336 43.3787C25.7541 43.3787 26.6758 43.3798 27.5963 43.3798C27.5928 43.5317 27.5893 43.6824 27.5846 43.8342C26.6664 43.8413 25.7482 43.8483 24.8301 43.8566L24.8348 43.8413Z"
        fill="#F1F0F0"
      />
      <path
        d="M22.3037 43.8416C23.1477 43.8416 23.9929 43.8416 24.8369 43.8416L24.8334 43.8568C24.8334 44.1276 24.8345 44.3983 24.8345 44.6691C23.9917 44.6691 23.1489 44.6691 22.3049 44.6691C22.3049 44.3983 22.3061 44.1276 22.3061 43.8568L22.3037 43.8416Z"
        fill={fill}
      />
      <path
        d="M42.9512 33.5602C42.9512 33.8298 42.9512 34.1005 42.9512 34.3701L42.9524 34.3913C41.9918 34.3877 41.0313 34.3854 40.0707 34.3819C40.0684 34.1088 40.0649 33.8369 40.0625 33.5638L40.0825 33.5449C41.0395 33.5508 41.9953 33.5555 42.9512 33.5602Z"
        fill={fill}
      />
      <path
        d="M53.249 49.9073C54.0918 49.9062 54.9358 49.905 55.7787 49.9038L55.7834 49.9073C55.7834 50.8796 55.7834 51.8508 55.7846 52.8231C54.9406 52.8313 54.0966 52.8384 53.2526 52.8455V52.8196C53.2514 51.8496 53.2502 50.8785 53.249 49.9073Z"
        fill="#CFE3E7"
      />
      <path
        d="M50.3584 53.661C50.3643 53.3856 50.3713 53.1113 50.3772 52.8359C51.3342 52.8312 52.2924 52.8253 53.2494 52.8206V52.8465C53.2494 53.1184 53.2494 53.3903 53.2506 53.6622C52.2924 53.6681 51.3354 53.6752 50.3772 53.681C50.3784 53.6799 50.3584 53.661 50.3584 53.661Z"
        fill={fill}
      />
      <path
        d="M55.7799 47.4353C56.691 47.4353 57.6021 47.4365 58.5132 47.4365L58.5403 47.4377C58.5332 48.2616 58.5261 49.0856 58.5191 49.9096C57.6068 49.9096 56.6934 49.9085 55.7811 49.9085C55.7811 49.9085 55.7775 49.9049 55.7764 49.9049C55.7775 49.0809 55.7787 48.2581 55.7799 47.4353Z"
        fill="#CFE3E7"
      />
      <path
        d="M58.5127 47.4363C58.5139 46.5216 58.5151 45.6082 58.5162 44.6936C58.5256 44.6865 58.5351 44.6794 58.5433 44.6724C58.8199 44.6747 59.0966 44.6771 59.3732 44.6782C59.3685 45.5976 59.3649 46.5169 59.3602 47.4351C59.0871 47.4363 58.8129 47.4363 58.5398 47.4374L58.5127 47.4363Z"
        fill={fill}
      />
      <path
        d="M94.4953 65.3217C93.5383 65.3229 92.5813 65.324 91.6243 65.3252L91.6055 65.3052C91.6137 65.0286 91.6219 64.752 91.6302 64.4753C92.5837 64.4777 93.5371 64.4812 94.4918 64.4836C94.493 64.7567 94.493 65.0298 94.4941 65.3017L94.4953 65.3217Z"
        fill={fill}
      />
      <path
        d="M84.1959 65.3216C83.2377 65.3204 82.2795 65.3204 81.3214 65.3192L81.3037 65.3016C81.3108 65.0273 81.3167 64.753 81.3237 64.4788C82.2795 64.4811 83.2366 64.4823 84.1924 64.4846C84.1924 64.7566 84.1936 65.0285 84.1936 65.2992L84.1959 65.3216Z"
        fill={fill}
      />
      <path
        d="M63.5487 65.3215C62.5928 65.3239 61.637 65.3274 60.6812 65.3298C60.6753 65.3215 60.6682 65.3145 60.6612 65.3074C60.6977 64.454 60.6976 64.454 59.8466 64.4928C59.8395 64.4858 59.8313 64.4775 59.8242 64.4705C59.8289 64.301 59.8336 64.1326 59.8383 63.9631C60.1173 63.9667 60.3975 63.9702 60.6765 63.9749C60.6765 64.1185 60.6765 64.2621 60.6765 64.4834C61.6558 64.4834 62.5999 64.4834 63.5439 64.4834C63.5451 64.7565 63.5463 65.0296 63.5463 65.3015L63.5487 65.3215Z"
        fill={fill}
      />
      <path
        d="M53.2494 65.3217C52.2924 65.3229 51.3342 65.3229 50.3772 65.3241L50.3584 65.3041C50.3666 65.0286 50.3737 64.752 50.3819 64.4766C51.3366 64.4789 52.2912 64.4813 53.2459 64.4836C53.2471 64.7567 53.2471 65.0286 53.2483 65.3017L53.2494 65.3217Z"
        fill={fill}
      />
      <path
        d="M115.141 65.323C114.183 65.3219 113.225 65.3219 112.267 65.3207L112.249 65.303C112.256 65.0288 112.262 64.7545 112.269 64.4802C113.225 64.4826 114.182 64.4849 115.138 64.4873C115.138 64.7592 115.138 65.0299 115.139 65.3019L115.141 65.323Z"
        fill={fill}
      />
      <path
        d="M42.9547 65.323C41.9965 65.3219 41.0383 65.3219 40.0802 65.3207L40.0625 65.303C40.0637 65.0335 40.0649 64.7639 40.0672 64.4943C40.0754 64.4873 40.0825 64.4802 40.0907 64.4731C41.0442 64.4779 41.9977 64.4826 42.9523 64.4873C42.9523 64.7592 42.9524 65.0299 42.9535 65.3018C42.9524 65.3018 42.9547 65.323 42.9547 65.323Z"
        fill={fill}
      />
      <path
        d="M125.437 65.3216C124.479 65.3216 123.521 65.3204 122.563 65.3204L122.545 65.3027C122.546 65.0332 122.547 64.7624 122.55 64.4929C122.558 64.4858 122.565 64.4787 122.573 64.4717C123.528 64.467 124.484 64.4634 125.438 64.4587L125.437 64.487C125.436 64.7577 125.435 65.0297 125.435 65.3004L125.437 65.3216Z"
        fill={fill}
      />
      <path
        d="M12.0094 65.3217C11.0512 65.3217 10.093 65.3217 9.13484 65.3217L9.11719 65.3029C9.11836 65.0322 9.11954 64.7626 9.1219 64.4919C9.13014 64.4848 9.13838 64.4765 9.14662 64.4695C10.1001 64.4742 11.0524 64.4789 12.0059 64.4836C12.007 64.7555 12.007 65.0286 12.0082 65.3005C12.007 65.3017 12.0094 65.3217 12.0094 65.3217Z"
        fill={fill}
      />
      <path
        d="M22.3078 65.3215C21.3508 65.3239 20.395 65.3262 19.438 65.3274L19.418 65.3051C19.4274 65.0273 19.4356 64.7483 19.445 64.4705C20.3973 64.474 21.3496 64.4775 22.3019 64.4811C22.3031 64.7542 22.3031 65.0272 22.3043 65.2992L22.3078 65.3215Z"
        fill={fill}
      />
      <path
        d="M32.6021 65.3192C31.6616 65.318 30.7211 65.3168 29.7806 65.3145L29.7617 65.2956C29.7688 65.0249 29.7747 64.7541 29.7817 64.4834C30.7223 64.4858 31.6616 64.4881 32.6021 64.4916C32.6021 64.7612 32.601 65.0296 32.601 65.2992L32.6021 65.3192Z"
        fill={fill}
      />
      <path
        d="M104.786 65.3204C103.844 65.3181 102.904 65.3157 101.962 65.3134L101.943 65.2945C101.95 65.025 101.956 64.7554 101.963 64.4858C102.904 64.4882 103.846 64.4894 104.786 64.4917C104.786 64.7613 104.785 65.0309 104.785 65.2992L104.786 65.3204Z"
        fill={fill}
      />
      <path
        d="M104.791 43.3188C104.791 43.0646 104.791 42.8103 104.791 42.556C104.846 42.5384 104.902 42.5066 104.957 42.5066C105.744 42.5089 106.533 42.516 107.321 42.5219C107.318 42.8009 107.317 43.0787 107.315 43.3565L107.317 43.3753C106.588 43.3741 105.86 43.3741 105.131 43.3683C105.017 43.3683 104.904 43.3365 104.791 43.3188Z"
        fill={fill}
      />
      <path
        d="M110.075 43.3845C110.076 43.5387 110.077 43.6918 110.08 43.846C109.159 43.8436 108.238 43.8413 107.317 43.8389C107.317 43.6847 107.316 43.5305 107.316 43.3775L107.313 43.3586C108.127 43.3634 108.939 43.3681 109.752 43.3739C109.86 43.3739 109.968 43.381 110.075 43.3845Z"
        fill="#F1F1F1"
      />
      <path
        d="M27.5892 65.3264C26.6711 65.3252 25.7541 65.3228 24.8359 65.3216L24.8383 65.3016C24.8395 65.0286 24.8395 64.7554 24.8406 64.4835C25.7541 64.48 26.6687 64.4777 27.5822 64.4741C27.5904 64.7507 27.5998 65.0285 27.6081 65.3063L27.5892 65.3264Z"
        fill={fill}
      />
      <path
        d="M37.8898 65.3205C36.9705 65.3217 36.0512 65.3217 35.1318 65.3228L35.1342 65.3028C35.1354 65.0297 35.1365 64.7566 35.1365 64.4835C36.0535 64.4824 36.9705 64.4812 37.8863 64.4812C37.8934 64.7555 37.8993 65.0297 37.9063 65.304C37.9063 65.3028 37.8898 65.3205 37.8898 65.3205Z"
        fill={fill}
      />
      <path
        d="M48.1859 65.3172C47.2666 65.3195 46.3461 65.3219 45.4268 65.323L45.4291 65.303C45.4303 65.0288 45.4326 64.7545 45.4338 64.4802C46.3508 64.4814 47.2678 64.4814 48.1848 64.4826C48.1918 64.7545 48.1977 65.0264 48.2048 65.2983L48.1859 65.3172Z"
        fill={fill}
      />
      <path
        d="M58.5273 65.331C57.6103 65.3274 56.6945 65.3239 55.7775 65.3204L55.7799 65.3004C55.7811 65.0285 55.7811 64.7554 55.7823 64.4834C56.6757 64.4834 57.5703 64.4834 58.4614 64.4834C58.4614 64.2833 58.4614 64.1338 58.4614 63.9549C57.5503 63.9549 56.6639 63.9549 55.7775 63.9549C55.7775 63.6842 55.7775 63.4134 55.7764 63.1427C56.6945 63.1368 57.6115 63.1309 58.5297 63.1262C58.5414 63.3875 58.4543 63.7583 58.5909 63.8831C58.7463 64.0244 59.1018 63.9467 59.3701 63.9643C59.3749 64.1338 59.3796 64.3022 59.3843 64.4717C59.3772 64.4787 59.369 64.487 59.3619 64.494C58.5108 64.4552 58.5108 64.4552 58.5462 65.3086C58.5403 65.3157 58.5332 65.3239 58.5273 65.331Z"
        fill={fill}
      />
      <path
        d="M63.545 65.3018C63.5438 65.0287 63.5426 64.7556 63.5426 64.4837L63.5391 64.4648C64.3866 64.4648 65.2341 64.4648 66.0817 64.4648C66.2782 64.4801 66.476 64.4966 66.6726 64.5119C66.5702 64.7791 66.4678 65.0475 66.3653 65.3147C66.2688 65.3159 66.1723 65.3171 66.0758 65.3183C65.2318 65.3136 64.389 65.3077 63.545 65.3018Z"
        fill={fill}
      />
      <path
        d="M99.7685 65.33C98.8516 65.3277 97.9346 65.3253 97.0176 65.323L97.0199 65.303C97.0211 65.0299 97.0211 64.7568 97.0223 64.4849C97.9181 64.4849 98.8139 64.4849 99.7097 64.4849C99.7344 64.4872 99.7591 64.4884 99.7827 64.4896C99.785 64.7627 99.7862 65.0358 99.7885 65.3077C99.7815 65.3147 99.7756 65.3218 99.7685 65.33Z"
        fill={fill}
      />
      <path
        d="M110.074 65.3228C109.156 65.3228 108.237 65.3228 107.318 65.3228L107.321 65.3027C107.322 65.0297 107.323 64.7566 107.323 64.4835C108.239 64.4823 109.155 64.4799 110.07 64.4788C110.078 64.7542 110.085 65.0285 110.092 65.3039L110.074 65.3228Z"
        fill={fill}
      />
      <path
        d="M120.371 65.3207C119.452 65.3219 118.534 65.323 117.614 65.323L117.617 65.303C117.618 65.0288 117.619 64.7557 117.62 64.4814C118.536 64.4814 119.452 64.4802 120.369 64.4802C120.376 64.7545 120.382 65.0288 120.389 65.303L120.371 65.3207Z"
        fill={fill}
      />
      <path
        d="M122.561 60.2552C123.52 60.2552 124.478 60.2552 125.436 60.2552C125.436 61.2122 125.435 62.168 125.435 63.125L125.438 63.1415C124.48 63.1356 123.522 63.1309 122.565 63.125C122.558 62.1669 122.552 61.2087 122.545 60.2505L122.561 60.2552Z"
        fill="#F1F1F1"
      />
      <path
        d="M127.969 63.1452C127.969 63.4148 127.967 63.6844 127.967 63.9539L127.972 63.9716C127.127 63.9716 126.282 63.9728 125.437 63.9728L125.44 63.9551C125.44 63.6844 125.44 63.4125 125.441 63.1417L125.438 63.1252C126.279 63.1323 127.123 63.1394 127.969 63.1452Z"
        fill={fill}
      />
      <path
        d="M121.735 57.7268C122.006 57.7268 122.276 57.7256 122.547 57.7256C122.552 58.5696 122.558 59.4124 122.564 60.2564L122.547 60.2517C122.28 60.2529 122.013 60.2541 121.745 60.2564C121.737 59.4113 121.729 58.5673 121.721 57.7221C121.721 57.7209 121.735 57.7268 121.735 57.7268Z"
        fill={fill}
      />
      <path
        d="M17.2414 65.3145C16.3397 65.3169 15.438 65.3192 14.5352 65.3216L14.5363 65.3016C14.5375 65.0297 14.5375 64.7578 14.5387 64.4858C15.4392 64.4858 16.3397 64.4858 17.2402 64.487C17.2473 64.7566 17.2531 65.0261 17.2602 65.2969L17.2414 65.3145Z"
        fill={fill}
      />
      <path
        d="M89.4255 65.3156C88.5239 65.3168 87.6234 65.3192 86.7217 65.3203L86.7229 65.3003C86.724 65.0284 86.724 64.7565 86.7252 64.4846C87.6245 64.4846 88.525 64.4834 89.4244 64.4834C89.4314 64.7541 89.4373 65.0261 89.4444 65.2968L89.4255 65.3156Z"
        fill={fill}
      />
      <path
        d="M59.3656 42.4993C59.3645 41.5376 59.3645 40.5747 59.3633 39.613L59.3786 39.6165C59.5304 39.6165 59.6823 39.6165 59.8341 39.6165L59.8494 39.6118C59.8459 40.5712 59.8412 41.5317 59.8377 42.4911C59.6811 42.4934 59.5245 42.497 59.368 42.4993H59.3656Z"
        fill="#F1F1F1"
      />
      <path
        d="M59.3631 42.5004C59.5197 42.4981 59.6762 42.4945 59.8328 42.4922L59.8528 42.5098C59.8481 42.7982 59.8446 43.0866 59.8399 43.3739C59.6833 43.3762 59.5268 43.3786 59.3714 43.3809L59.3525 43.3633C59.3561 43.076 59.3596 42.7888 59.3631 42.5004Z"
        fill={fill}
      />
      <path
        d="M58.5234 43.8321C58.5281 43.6826 58.5317 43.5331 58.5364 43.3836C58.8083 43.3777 59.0802 43.3706 59.3521 43.3647L59.371 43.3824C59.3698 43.5378 59.3686 43.6932 59.3674 43.8474C59.0932 43.8486 58.8201 43.8509 58.5458 43.8521C58.5399 43.845 58.5317 43.838 58.5234 43.8321Z"
        fill={fill}
      />
      <path
        d="M14.5412 49.907C15.4453 49.9047 16.3505 49.9035 17.2545 49.9011C17.2698 49.9035 17.2839 49.907 17.2992 49.9094C17.2839 50.465 17.2674 51.0194 17.2557 51.575C17.2463 51.9941 17.2427 52.4131 17.2357 52.8322C16.3375 52.8357 15.4382 52.8392 14.54 52.8428L14.5424 52.8216C14.5424 51.8516 14.5412 50.8793 14.5412 49.907Z"
        fill="#F1F1F1"
      />
      <path
        d="M12.0125 53.6609C12.0125 53.389 12.0113 53.1183 12.0113 52.8463C12.8553 52.8393 13.6993 52.831 14.5433 52.824L14.541 52.8452C14.541 53.1159 14.541 53.3878 14.5398 53.6586C13.6958 53.6644 12.8518 53.6715 12.0078 53.6774C12.009 53.6762 12.0125 53.6609 12.0125 53.6609Z"
        fill={fill}
      />
      <path
        d="M9.12207 54.14C9.1256 53.9858 9.12913 53.8316 9.13266 53.6785C10.0908 53.6727 11.049 53.6668 12.0072 53.6609L12.0037 53.6762C12.0037 53.8304 12.0049 53.9834 12.0049 54.1376C11.0443 54.1388 10.0838 54.14 9.12207 54.14Z"
        fill="#F1F1F1"
      />
      <path
        d="M17.2996 49.9107C17.2843 49.9072 17.2702 49.9048 17.2549 49.9025C17.2619 49.0797 17.2702 48.2557 17.2772 47.4329C17.5562 47.4352 17.834 47.4364 18.113 47.4388L18.1318 47.4352C18.1295 47.5423 18.126 47.6483 18.1248 47.7554C18.1165 48.4734 18.1095 49.1903 18.1012 49.9084C17.834 49.9084 17.5668 49.9095 17.2996 49.9107Z"
        fill={fill}
      />
      <path
        d="M81.3013 29.3262C81.0305 29.3262 80.761 29.3251 80.4902 29.3251C80.4902 28.4822 80.4902 27.6394 80.4902 26.7966C80.761 26.7966 81.0305 26.7954 81.3013 26.7954C81.3013 27.6382 81.3013 28.4822 81.3013 29.3262Z"
        fill={fill}
      />
      <path
        d="M91.6196 52.8312C91.6149 51.8566 91.6102 50.8819 91.6055 49.9072L91.6243 49.9119C92.579 49.9108 93.5336 49.9108 94.4883 49.9096C94.4894 50.8795 94.4906 51.8495 94.493 52.8194C93.536 52.8242 92.5801 52.8289 91.6231 52.8336L91.6196 52.8312Z"
        fill="#F1F1F1"
      />
      <path
        d="M90.7954 49.9083C90.7883 49.0831 90.7825 48.258 90.7754 47.4316L90.7907 47.4352C91.0626 47.4352 91.3333 47.4352 91.6053 47.4352C91.6112 48.2603 91.617 49.0867 91.6241 49.9118L91.6053 49.9071C91.3357 49.9071 91.0661 49.9083 90.7954 49.9083Z"
        fill={fill}
      />
      <path
        d="M89.4318 53.6646C89.4342 53.395 89.4366 53.1255 89.4389 52.8559C89.6626 52.8512 89.8862 52.8512 90.1087 52.8418C90.2641 52.8347 90.3135 52.9054 90.3088 53.0513C90.3017 53.255 90.3064 53.4598 90.3064 53.6634L90.3053 53.6646C90.0133 53.6646 89.7226 53.6646 89.4307 53.6658L89.4318 53.6646Z"
        fill={outline}
      />
      <path
        d="M90.7817 53.6705C90.7994 53.4033 90.7205 53.0478 90.8618 52.8936C90.9865 52.757 91.3562 52.8429 91.6175 52.8312L91.6198 52.8347C91.6128 53.1101 91.6057 53.3868 91.5998 53.6622C91.3279 53.6646 91.0548 53.6669 90.7817 53.6705Z"
        fill={outline}
      />
      <path
        d="M90.3096 53.6633C90.4673 53.6657 90.625 53.668 90.7828 53.6704C90.7816 53.8246 90.7792 53.98 90.7781 54.1342C90.6227 54.1365 90.4673 54.1377 90.3131 54.1401C90.3119 53.9823 90.3107 53.8234 90.3096 53.6657V53.6633Z"
        fill="#F1F1F1"
      />
      <path
        d="M86.7217 53.6599C87.6257 53.6611 88.5298 53.6634 89.4338 53.6646V53.6658C89.4326 53.8235 89.4314 53.9813 89.4303 54.139C88.5274 54.139 87.6257 54.1378 86.7229 54.1378C86.7229 53.9836 86.7229 53.8294 86.7229 53.6752L86.7217 53.6599Z"
        fill="#F1F1F1"
      />
      <path
        d="M80.4947 49.9072C80.7654 49.9072 81.0349 49.906 81.3057 49.906C81.3127 50.8807 81.321 51.8553 81.3281 52.83C81.321 52.8371 81.3151 52.8441 81.308 52.8512C81.0314 52.8441 80.7548 52.8371 80.4782 52.83C80.4746 51.8553 80.4723 50.8807 80.4688 49.906L80.4947 49.9072Z"
        fill={fill}
      />
      <path
        d="M84.1949 52.8452C84.1949 53.1159 84.1949 53.3867 84.1961 53.6586L84.1973 53.6798C83.2367 53.6774 82.2762 53.6739 81.3157 53.6715C81.3133 53.3984 81.3109 53.1253 81.3086 52.8522C81.3157 52.8452 81.3227 52.8381 81.3286 52.8311C82.2844 52.8346 83.2391 52.8393 84.1949 52.8452Z"
        fill={fill}
      />
      <path
        d="M86.7252 53.6751C86.7252 53.8293 86.7252 53.9835 86.7252 54.1377L86.7263 54.1624C85.8835 54.1554 85.0407 54.1471 84.1967 54.14C84.1967 53.9858 84.1955 53.8316 84.1955 53.6774L84.1943 53.6562C85.0372 53.6633 85.8812 53.6692 86.7252 53.6751Z"
        fill="#CFE3E7"
      />
      <path
        d="M80.4876 47.4352C80.4888 48.2592 80.49 49.0832 80.4912 49.9072L80.4653 49.906C80.3016 49.9072 80.1392 49.9095 79.9756 49.9107C79.9768 49.0844 79.9791 48.258 79.9815 47.4329C80.1416 47.434 80.3017 47.4352 80.4617 47.4376L80.4876 47.4352Z"
        fill="#CFE3E7"
      />
      <path
        d="M24.8379 64.4833C24.8367 64.7564 24.8367 65.0295 24.8355 65.3014C23.9915 65.3014 23.1475 65.3014 22.3035 65.3014C22.3024 65.0283 22.3024 64.7552 22.3012 64.4833L22.2988 64.4609C23.1464 64.4609 23.9939 64.4609 24.8414 64.4609L24.8379 64.4833Z"
        fill={fill}
      />
      <path
        d="M125.437 65.3017C125.438 65.031 125.439 64.759 125.439 64.4883C126.284 64.4801 127.128 64.4706 127.973 64.4624L127.97 64.4848C127.969 64.7567 127.969 65.0286 127.967 65.3017C127.125 65.3017 126.281 65.3017 125.437 65.3017Z"
        fill={fill}
      />
      <path
        d="M14.542 64.4846C14.5408 64.7565 14.5408 65.0284 14.5396 65.3004C13.6956 65.3004 12.8516 65.3004 12.0088 65.3015C12.0076 65.0296 12.0076 64.7565 12.0065 64.4846C12.0065 64.4846 12.0029 64.4622 12.0029 64.4634C12.8505 64.4634 13.6968 64.4634 14.5444 64.4634L14.542 64.4846Z"
        fill={fill}
      />
      <path
        d="M107.319 64.4835C107.318 64.7566 107.317 65.0297 107.317 65.3028C106.473 65.3016 105.629 65.3016 104.785 65.3004C104.785 65.0308 104.786 64.7613 104.786 64.4929L104.78 64.4752C105.628 64.4717 106.475 64.4694 107.323 64.4658L107.319 64.4835Z"
        fill={fill}
      />
      <path
        d="M35.1316 64.4823C35.1305 64.7554 35.1293 65.0285 35.1293 65.3016C34.2853 65.3004 33.4413 65.2992 32.5973 65.298C32.5973 65.0285 32.5985 64.7601 32.5985 64.4905L32.5938 64.4693C33.4401 64.4658 34.2876 64.4623 35.134 64.4587L35.1316 64.4823Z"
        fill={fill}
      />
      <path
        d="M97.0244 64.4836C97.0232 64.7567 97.0232 65.0298 97.0221 65.3029C96.1781 65.3029 95.3341 65.3029 94.4901 65.3029C94.4889 65.0298 94.4889 64.7567 94.4877 64.4848L94.4854 64.4624C95.3329 64.4624 96.1804 64.4624 97.0279 64.4624L97.0244 64.4836Z"
        fill={fill}
      />
      <path
        d="M55.7832 64.4835C55.782 64.7554 55.782 65.0285 55.7809 65.3004C54.9369 65.3004 54.0929 65.3004 53.2489 65.3004C53.2477 65.0273 53.2477 64.7554 53.2465 64.4823L53.2441 64.46C54.0917 64.46 54.9392 64.46 55.7856 64.46L55.7832 64.4835Z"
        fill={fill}
      />
      <path
        d="M86.7285 64.4848C86.7273 64.7567 86.7273 65.0286 86.7262 65.3005C85.8822 65.3005 85.0382 65.3005 84.1942 65.3005C84.1942 65.0286 84.193 64.7567 84.193 64.4859L84.1895 64.4648C85.037 64.4636 85.8833 64.4636 86.7309 64.4624C86.732 64.4624 86.7285 64.4848 86.7285 64.4848Z"
        fill={fill}
      />
      <path
        d="M63.5421 39.6165C63.5433 40.577 63.5445 41.5363 63.5445 42.4969L63.548 42.5181C63.3821 42.5134 63.2161 42.5051 63.0501 42.5028C62.2591 42.4945 61.468 42.4886 60.6758 42.4828C60.6723 41.5281 60.6676 40.5735 60.6641 39.6176L60.6864 39.6165C61.6399 39.6176 62.591 39.6165 63.5421 39.6165Z"
        fill="#F1F1F1"
      />
      <path
        d="M59.8503 37.0895C60.1222 37.0895 60.3953 37.0895 60.6672 37.0895C60.6754 37.9323 60.6837 38.7752 60.6931 39.618L60.6707 39.6192C60.3976 39.6168 60.1234 39.6156 59.8503 39.6145L59.835 39.6192C59.835 38.7752 59.835 37.9312 59.8361 37.0872L59.8503 37.0895Z"
        fill={fill}
      />
      <path
        d="M59.8319 37.0859C59.8319 37.9299 59.8319 38.7739 59.8307 39.6179C59.6789 39.6179 59.5271 39.6179 59.3752 39.6179C59.3752 38.7739 59.3752 37.9299 59.374 37.0859C59.5282 37.0859 59.6801 37.0859 59.8319 37.0859Z"
        fill="#CFE3E7"
      />
      <path
        d="M45.4353 64.4813C45.4341 64.7556 45.4318 65.0299 45.4306 65.3041C44.6054 65.3029 43.7791 65.3029 42.9539 65.3018C42.9539 65.0299 42.9539 64.7591 42.9528 64.4872L42.9492 64.466C43.7779 64.4637 44.6066 64.4613 45.4353 64.4578V64.4813Z"
        fill={fill}
      />
      <path
        d="M117.616 64.4811C117.615 64.7554 117.614 65.0285 117.611 65.3027C116.786 65.3027 115.96 65.3016 115.135 65.3016C115.135 65.0297 115.135 64.7589 115.133 64.487L115.13 64.467C115.959 64.4646 116.787 64.4611 117.616 64.4587V64.4811Z"
        fill={fill}
      />
      <path
        d="M91.6053 47.4351C91.3334 47.4351 91.0626 47.4351 90.7907 47.4351C90.7837 46.5181 90.7766 45.6011 90.7695 44.6841L90.7907 44.6653C91.0673 44.6712 91.3428 44.6782 91.6194 44.6841C91.6229 45.6011 91.6277 46.5181 91.6312 47.4351H91.6053Z"
        fill={fill}
      />
      <path
        d="M18.1406 44.6841C18.2912 44.6817 18.4419 44.6794 18.5926 44.677C18.5914 45.5963 18.589 46.5157 18.5879 47.4338C18.436 47.4338 18.283 47.4327 18.1311 47.4327L18.1123 47.4362C18.1158 46.6252 18.1194 45.8153 18.1241 45.0042C18.1264 44.8983 18.1358 44.7912 18.1406 44.6841Z"
        fill="#F1F0F0"
      />
      <path
        d="M32.6045 39.6133C33.4461 39.6133 34.289 39.6133 35.1306 39.6133L35.1353 39.618C35.1341 40.5785 35.133 41.5391 35.1306 42.4984C35.0035 42.4996 34.8763 42.502 34.748 42.5031C34.0535 42.5125 33.3579 42.5208 32.6633 42.5302C32.6433 42.522 32.6233 42.5125 32.6045 42.5043C32.6045 41.5402 32.6045 40.5773 32.6045 39.6133Z"
        fill="#CFE3E7"
      />
      <path
        d="M32.6008 42.5044C32.6208 42.5126 32.6408 42.5221 32.6608 42.5303C32.6608 42.8034 32.6596 43.0765 32.6596 43.3496C32.6408 43.3566 32.6208 43.3649 32.602 43.3719C31.6591 43.3731 30.7174 43.3743 29.7745 43.3767C29.7686 43.3684 29.7627 43.3602 29.7568 43.3519C29.7604 43.0718 29.7627 42.7916 29.7663 42.5115C30.7103 42.5091 31.6555 42.5067 32.6008 42.5044Z"
        fill={fill}
      />
      <path
        d="M35.1283 37.0872C36.0465 37.0872 36.9658 37.0883 37.884 37.0883L37.904 37.0872C37.8981 37.9312 37.8911 38.774 37.8852 39.618C36.967 39.618 36.0488 39.618 35.1307 39.6192L35.126 39.6145C35.1272 38.7716 35.1283 37.9288 35.1283 37.0872Z"
        fill="#CFE3E7"
      />
      <path
        d="M37.892 34.382C38.1651 34.3797 38.437 34.3761 38.7101 34.3738L38.729 34.395C38.7243 35.2919 38.7196 36.1901 38.7148 37.0871C38.4441 37.0871 38.1745 37.0871 37.9038 37.0859L37.8838 37.0871C37.8873 36.1866 37.8897 35.2849 37.892 34.382Z"
        fill={fill}
      />
      <path
        d="M90.7813 42.4923C90.7789 41.533 90.7777 40.5736 90.7754 39.6143L90.7954 39.6166C91.0661 39.6166 91.3369 39.6154 91.6076 39.6154C91.6076 40.576 91.6088 41.5365 91.6088 42.4959C91.3392 42.5006 91.0709 42.5053 90.8013 42.51L90.7813 42.4923Z"
        fill={fill}
      />
      <path
        d="M22.3066 43.8565C22.3066 44.1273 22.3055 44.398 22.3055 44.6688L22.3078 44.6947C21.3543 44.6947 20.4009 44.6947 19.4474 44.6958C19.4392 44.6876 19.4297 44.6782 19.4215 44.6699C19.4203 44.398 19.4191 44.1261 19.418 43.8542L19.438 43.833C20.3926 43.8401 21.3496 43.8483 22.3066 43.8565Z"
        fill={fill}
      />
      <path
        d="M94.4947 34.3737C94.4947 34.1029 94.4936 33.8322 94.4936 33.5615C95.3376 33.5544 96.1827 33.5473 97.0268 33.5403L97.0244 33.5591C97.0232 33.831 97.0232 34.1029 97.022 34.3749L97.0256 34.3902C96.1804 34.3902 95.3364 34.3902 94.4912 34.3902L94.4947 34.3737Z"
        fill={fill}
      />
      <path
        d="M8.29297 63.1241C8.29415 62.1671 8.29415 61.2113 8.29532 60.2543L8.31651 60.2555C8.58372 60.2543 8.85093 60.2531 9.11814 60.252C9.12284 61.2125 9.12638 62.173 9.13108 63.1324C8.85799 63.1359 8.58372 63.1406 8.31063 63.1442L8.29297 63.1241Z"
        fill={fill}
      />
      <path
        d="M80.4663 47.4364C80.3062 47.4352 80.1461 47.4341 79.986 47.4317H79.9648C79.9707 46.5183 79.9778 45.606 79.9837 44.6925C80.1485 44.689 80.3133 44.6866 80.4792 44.6831L80.4804 44.6866C80.4745 45.6036 80.471 46.5194 80.4663 47.4364Z"
        fill="#F1F1F1"
      />
      <path
        d="M91.6053 39.6155C91.3345 39.6155 91.0638 39.6166 90.7931 39.6166C90.7872 38.7726 90.7813 37.9298 90.7754 37.0858L90.7907 37.0893C91.0614 37.0882 91.3333 37.0882 91.6041 37.087L91.6229 37.0823C91.6229 37.9275 91.6229 38.7738 91.6241 39.619L91.6053 39.6155Z"
        fill={fill}
      />
      <path
        d="M91.6053 37.087C91.3345 37.0882 91.0626 37.0881 90.7919 37.0893C90.786 36.1888 90.7813 35.2895 90.7754 34.389L90.7931 34.3713C91.0626 34.3725 91.331 34.3725 91.6006 34.3737L91.6206 34.3937C91.6159 35.2919 91.6112 36.19 91.6053 37.087Z"
        fill={fill}
      />
      <path
        d="M60.6769 42.4829C61.4679 42.49 62.2589 42.4959 63.0511 42.5041C63.2171 42.5053 63.3831 42.5135 63.5491 42.5194C63.5467 42.7984 63.5444 43.0774 63.542 43.3563L63.5443 43.3822C62.5862 43.3834 61.6268 43.3846 60.6686 43.3858C60.6639 43.0927 60.658 42.8007 60.6533 42.5076C60.6592 42.4982 60.6674 42.49 60.6769 42.4829Z"
        fill={fill}
      />
      <path
        d="M63.5402 43.3552C64.3795 43.3611 65.2176 43.3693 66.0569 43.3717C66.9845 43.3752 67.9109 43.3741 68.8385 43.3752V43.3764C68.835 43.5294 68.8303 43.6825 68.8267 43.8367C67.0646 43.8367 65.3012 43.8378 63.5391 43.8378C63.5402 43.6848 63.5402 43.5318 63.5414 43.3799L63.5402 43.3552Z"
        fill="#E1EAEC"
      />
      <path
        d="M28.8887 43.8436C28.8946 43.6859 28.9004 43.527 28.9063 43.3692C29.19 43.3633 29.4725 43.3574 29.7562 43.3516C29.7621 43.3598 29.768 43.368 29.7739 43.3763C29.7727 43.5352 29.7715 43.6929 29.7715 43.8518C29.4831 43.8554 29.1947 43.8601 28.9063 43.8636L28.8887 43.8436Z"
        fill={fill}
      />
      <path
        d="M27.5879 43.8343C27.5914 43.6825 27.595 43.5318 27.5997 43.38C27.8728 43.3788 28.147 43.3764 28.4201 43.3752C28.4237 43.5306 28.4284 43.686 28.4319 43.8402L28.4142 43.8579C28.1447 43.8567 27.8751 43.8555 27.6067 43.8543L27.5879 43.8343Z"
        fill={fill}
      />
      <path
        d="M28.4286 43.8401C28.5816 43.8413 28.7346 43.8424 28.8877 43.8436L28.9053 43.8636C28.9006 44.1332 28.8959 44.4028 28.8912 44.6735C28.737 44.6747 28.5828 44.677 28.4286 44.6782C28.4227 44.4051 28.418 44.132 28.4121 43.8589C28.4121 43.8577 28.4286 43.8401 28.4286 43.8401Z"
        fill={fill}
      />
      <path
        d="M9.11493 60.2518C8.84772 60.253 8.58051 60.2542 8.3133 60.2554C8.31213 59.4113 8.30977 58.5685 8.30859 57.7245C8.57933 57.7257 8.8489 57.7257 9.11964 57.7269L9.13612 57.7222C9.13494 58.5662 9.13376 59.4113 9.13258 60.2554L9.11493 60.2518Z"
        fill={fill}
      />
      <path
        d="M79.9648 43.3857C80.1344 43.3881 80.305 43.3893 80.4745 43.3916C80.4769 43.5423 80.4781 43.693 80.4804 43.8425L80.4816 43.8436C80.3121 43.8401 80.1414 43.8378 79.9707 43.8342C79.9684 43.6847 79.966 43.5352 79.9648 43.3857Z"
        fill="#F1EFEF"
      />
      <path
        d="M79.1416 43.374C79.1451 43.0868 79.1498 42.7996 79.1534 42.5124C79.4194 42.5112 79.6854 42.5112 79.9503 42.51C79.9562 42.8019 79.9632 43.0939 79.9691 43.3858V43.387C79.6937 43.3834 79.4182 43.3799 79.1428 43.3752L79.1416 43.374Z"
        fill={outline}
      />
      <path
        d="M42.9513 39.6168C42.9525 40.5785 42.9537 41.5402 42.956 42.5008L42.9584 42.5243C42.8419 42.5173 42.7265 42.5043 42.61 42.5031C41.7648 42.4984 40.9184 42.4949 40.0732 42.4914C40.0756 41.532 40.078 40.5726 40.0803 39.6133C41.0373 39.6156 41.9943 39.6156 42.9513 39.6168Z"
        fill="#F1F1F1"
      />
      <path
        d="M120.382 47.4354C120.655 47.4354 120.928 47.4365 121.201 47.4365C121.207 48.2605 121.214 49.0857 121.22 49.9097L121.2 49.9085C120.928 49.9085 120.657 49.9073 120.385 49.9073C120.378 49.0822 120.372 48.257 120.365 47.4307L120.382 47.4354Z"
        fill={fill}
      />
      <path
        d="M19.4177 43.8542C19.4189 44.1262 19.4201 44.3981 19.4213 44.67C19.1458 44.6724 18.8692 44.6747 18.5938 44.6782C18.5996 44.4051 18.6043 44.132 18.6102 43.859C18.8774 43.8566 19.147 43.8554 19.4177 43.8542Z"
        fill={outline}
      />
      <path
        d="M9.12207 57.7268C9.12207 56.824 9.12207 55.9211 9.12207 55.0183L9.12325 55.0171C10.085 55.0171 11.0455 55.0171 12.0072 55.0183C12.0072 55.9199 12.0072 56.8228 12.0072 57.7245C11.0514 57.7245 10.0944 57.7233 9.13855 57.7233L9.12207 57.7268Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.967 64.4858C101.96 64.7554 101.954 65.025 101.947 65.2945C101.658 65.3004 101.369 65.3063 101.081 65.3134C101.083 65.0403 101.085 64.766 101.087 64.4929C101.38 64.4906 101.674 64.4882 101.967 64.4858C101.967 64.4858 101.967 64.487 101.967 64.4858Z"
        fill={outline}
      />
      <path
        d="M89.4458 65.2968C89.4387 65.0261 89.4328 64.7541 89.4258 64.4834C89.7189 64.4881 90.0108 64.494 90.3039 64.4987C90.3063 64.7683 90.3074 65.0366 90.3098 65.3062L90.3074 65.3074C90.0202 65.3039 89.733 65.3003 89.4458 65.2968Z"
        fill={outline}
      />
      <path
        d="M48.2046 65.2992C48.1975 65.0272 48.1916 64.7553 48.1846 64.4834L48.1857 64.4846C48.48 64.4893 48.7743 64.494 49.0686 64.4999C49.0686 64.7683 49.0686 65.0378 49.0686 65.3062L49.0651 65.3086C48.779 65.3039 48.4918 65.3015 48.2046 65.2992Z"
        fill={outline}
      />
      <path
        d="M29.7776 64.4834C29.7705 64.7541 29.7646 65.0249 29.7576 65.2956C29.4703 65.2992 29.1831 65.3039 28.8947 65.3074L28.8936 65.3062C28.8959 65.0366 28.8971 64.7671 28.8994 64.4975C29.1925 64.494 29.4856 64.4893 29.7776 64.4834Z"
        fill={outline}
      />
      <path
        d="M17.2642 65.2947C17.2571 65.0252 17.2512 64.7556 17.2441 64.4849C17.5361 64.4884 17.8292 64.4919 18.1211 64.4955C18.1235 64.7662 18.1246 65.0369 18.127 65.3077H18.1258C17.8398 65.3053 17.5514 65.3006 17.2642 65.2947Z"
        fill={outline}
      />
      <path
        d="M48.2001 52.8546C48.2001 53.1218 48.2012 53.3879 48.2012 53.6551L48.1859 53.6751C47.2666 53.6716 46.3461 53.6669 45.4268 53.6633C45.4279 53.3891 45.4303 53.116 45.4315 52.8417C46.3473 52.8382 47.2619 52.8346 48.1777 52.8323C48.1859 52.8393 48.193 52.8476 48.2001 52.8546Z"
        fill={fill}
      />
      <path
        d="M49.0651 53.6632C49.0662 53.8221 49.0674 53.9811 49.0698 54.1411C49.0627 54.1482 49.0556 54.1553 49.0486 54.1623C48.7649 54.1565 48.4812 54.1506 48.1987 54.1447C48.194 53.9881 48.1893 53.8316 48.1846 53.6738L48.1999 53.6538C48.4883 53.6573 48.7767 53.6609 49.0651 53.6632Z"
        fill={fill}
      />
      <path
        d="M49.5391 54.1329C49.5402 53.9787 49.5426 53.8257 49.5438 53.6715C49.8169 53.6679 50.09 53.6644 50.3619 53.6609L50.3807 53.6809C50.3772 53.8339 50.3736 53.9869 50.3689 54.14C50.0982 54.1435 49.8286 54.147 49.5579 54.1518L49.5391 54.1329Z"
        fill={fill}
      />
      <path
        d="M49.0729 54.1415C49.2283 54.1391 49.3825 54.1356 49.5379 54.1321L49.5591 54.1497C49.5556 54.4381 49.552 54.7277 49.5485 55.0161C49.3884 55.0102 49.2271 55.0032 49.0671 54.9973C49.0623 54.7183 49.0565 54.4393 49.0518 54.1603C49.06 54.1556 49.0671 54.1486 49.0729 54.1415Z"
        fill={fill}
      />
      <path
        d="M9.12019 64.493C9.11902 64.7637 9.11784 65.0333 9.11549 65.304C8.84592 65.304 8.57754 65.304 8.30798 65.304C8.2962 65.0274 8.28326 64.7496 8.27148 64.473L8.2809 64.4553C8.56106 64.4683 8.84004 64.4801 9.12019 64.493Z"
        fill={outline}
      />
      <path
        d="M97.0176 34.3736C97.0188 34.1017 97.0188 33.8298 97.0199 33.5579C97.9357 33.5532 98.8527 33.5485 99.7685 33.5449C99.7756 33.8215 99.7827 34.0993 99.7897 34.376C99.7827 34.383 99.7756 34.3913 99.7674 34.3983C98.8504 34.3901 97.9334 34.3819 97.0176 34.3736Z"
        fill={fill}
      />
      <path
        d="M27.603 65.3051C27.5948 65.0273 27.5854 64.7506 27.5771 64.4728L27.583 64.4705C27.8608 64.4775 28.1375 64.4846 28.4153 64.4917C28.4176 64.7647 28.42 65.0378 28.4211 65.3109C28.1492 65.3109 27.8761 65.3074 27.603 65.3051Z"
        fill={outline}
      />
      <path
        d="M19.445 64.4718C19.4356 64.7496 19.4273 65.0286 19.4179 65.3064C19.1448 65.3088 18.8717 65.3111 18.5986 65.3123C18.601 65.0392 18.6033 64.7661 18.6045 64.493C18.8823 64.4848 19.1601 64.4777 19.4379 64.4695C19.4367 64.4695 19.445 64.4718 19.445 64.4718Z"
        fill={outline}
      />
      <path
        d="M37.9038 65.303C37.8967 65.0288 37.8909 64.7545 37.8838 64.4802H37.8861C38.1616 64.4849 38.437 64.4896 38.7125 64.4943C38.716 64.7686 38.7196 65.0429 38.7231 65.3172V65.3183C38.4512 65.3136 38.1781 65.3077 37.9038 65.303Z"
        fill={outline}
      />
      <path
        d="M40.0696 64.4929C40.0684 64.7624 40.0672 65.032 40.0649 65.3015C39.7906 65.3074 39.5175 65.3133 39.2432 65.3192V65.318C39.2526 65.0579 39.1632 64.6906 39.2974 64.5658C39.4492 64.4281 39.8035 64.5082 40.0696 64.4929Z"
        fill={outline}
      />
      <path
        d="M50.3807 64.4765C50.3725 64.752 50.3654 65.0286 50.3572 65.304C50.0841 65.3076 49.811 65.3111 49.5391 65.3146C49.5391 65.0392 49.5402 64.7626 49.5402 64.4871C49.8192 64.4836 50.097 64.4801 50.376 64.4753L50.3807 64.4765Z"
        fill={outline}
      />
      <path
        d="M58.5505 65.3087C58.514 64.4541 58.514 64.4542 59.3663 64.4942C59.3686 64.7673 59.3698 65.0404 59.3721 65.3146C59.0979 65.3111 58.8236 65.3099 58.5505 65.3087Z"
        fill={outline}
      />
      <path
        d="M59.8457 64.4929C60.698 64.4541 60.698 64.4541 60.6603 65.3075C60.3872 65.3087 60.1129 65.311 59.8398 65.3122C59.8422 65.0403 59.8446 64.766 59.8457 64.4929Z"
        fill={outline}
      />
      <path
        d="M81.3246 64.4802C81.3176 64.7545 81.3117 65.0288 81.3046 65.303C81.0315 65.3089 80.7584 65.3136 80.4854 65.3195V65.3183C80.4877 65.0429 80.4901 64.7674 80.4924 64.4908C80.769 64.4873 81.0457 64.4838 81.3223 64.4802H81.3246Z"
        fill={outline}
      />
      <path
        d="M91.628 64.4755C91.6197 64.7521 91.6115 65.0288 91.6033 65.3054C91.3302 65.3077 91.0583 65.3113 90.7852 65.3136C90.7875 65.0405 90.7899 64.7674 90.791 64.4932C91.0677 64.4861 91.3455 64.4802 91.6221 64.4731C91.6233 64.4731 91.628 64.4755 91.628 64.4755Z"
        fill={outline}
      />
      <path
        d="M99.791 65.3076C99.7887 65.0345 99.7875 64.7614 99.7852 64.4895C100.058 64.4907 100.331 64.493 100.604 64.4942C100.607 64.7673 100.609 65.0404 100.61 65.3135C100.338 65.3111 100.064 65.3088 99.791 65.3076Z"
        fill={outline}
      />
      <path
        d="M110.091 65.3039C110.084 65.0285 110.077 64.7542 110.07 64.4788H110.073C110.348 64.4846 110.625 64.4905 110.9 64.4952C110.904 64.7683 110.907 65.0426 110.91 65.3157C110.637 65.311 110.363 65.3075 110.091 65.3039Z"
        fill={outline}
      />
      <path
        d="M112.269 64.4802C112.262 64.7545 112.256 65.0288 112.249 65.303C111.975 65.3101 111.7 65.3172 111.426 65.323L111.425 65.3219C111.427 65.0441 111.43 64.7663 111.432 64.4885C111.71 64.4861 111.989 64.4838 112.266 64.4814L112.269 64.4802Z"
        fill={outline}
      />
      <path
        d="M120.385 65.303C120.378 65.0288 120.372 64.7545 120.365 64.4802H120.368C120.645 64.4826 120.922 64.4861 121.2 64.4885C121.202 64.7651 121.205 65.0429 121.207 65.3195V65.3207C120.933 65.316 120.658 65.3089 120.385 65.303Z"
        fill={outline}
      />
      <path
        d="M122.548 64.4931C122.547 64.7626 122.546 65.0334 122.544 65.3029C122.271 65.3077 121.998 65.3124 121.726 65.3171H121.727C121.737 64.4601 121.737 64.4601 122.548 64.4931Z"
        fill={outline}
      />
      <path
        d="M8.3108 63.1441C8.58389 63.1406 8.85817 63.1359 9.13126 63.1323C9.13244 63.4101 9.13244 63.6868 9.13361 63.9646C8.85463 63.9646 8.57683 63.9657 8.29785 63.9657C8.30138 63.6926 8.30609 63.4184 8.3108 63.1441Z"
        fill={outline}
      />
      <path
        d="M42.9535 39.6167C41.9965 39.6155 41.0395 39.6155 40.0825 39.6144L40.0625 39.6167C40.0684 38.7727 40.0743 37.9299 40.0802 37.0859C41.0383 37.0859 41.9965 37.0847 42.9535 37.0847L42.9571 37.0882C42.9559 37.9311 42.9547 38.7739 42.9535 39.6167Z"
        fill="#CFE3E7"
      />
      <path
        d="M38.7294 33.5486C38.8965 33.5451 39.0637 33.5404 39.2308 33.5369C39.2379 33.5451 39.2438 33.5533 39.2508 33.5616C39.2473 33.837 39.2438 34.1137 39.2414 34.3891C39.0719 34.3915 38.9012 34.3938 38.7317 34.3962L38.7129 34.375C38.7176 34.0984 38.7235 33.8241 38.7294 33.5486Z"
        fill={fill}
      />
      <path
        d="M90.7993 42.51C91.0688 42.5053 91.3372 42.5006 91.6068 42.4958C91.6021 42.7866 91.5986 43.0762 91.5938 43.3669C91.3243 43.3693 91.0559 43.3728 90.7863 43.3752H90.7852C90.7899 43.0868 90.7946 42.7984 90.7993 42.51Z"
        fill={outline}
      />
      <path
        d="M91.6209 44.6853C91.3443 44.6794 91.0688 44.6724 90.7922 44.6665C90.7899 44.3934 90.7875 44.1203 90.7852 43.8484C91.0583 43.8507 91.3302 43.8543 91.6033 43.8566C91.6091 44.1321 91.6162 44.4075 91.6221 44.6841C91.6221 44.683 91.6209 44.6853 91.6209 44.6853Z"
        fill={outline}
      />
      <path
        d="M42.9512 37.0848C41.993 37.0848 41.0348 37.0859 40.0778 37.0859L40.0625 37.0895C40.066 36.1866 40.0684 35.2849 40.0719 34.3821C41.0325 34.3856 41.993 34.388 42.9535 34.3915C42.9524 35.2896 42.9512 36.1866 42.9512 37.0848Z"
        fill="#F1F1F1"
      />
      <path
        d="M68.8291 43.838C68.8326 43.685 68.8373 43.5319 68.8409 43.3777C69.1104 43.3742 69.38 43.3695 69.6496 43.366L69.6684 43.3836C69.6672 43.539 69.666 43.6932 69.6649 43.8486C69.3918 43.8521 69.1187 43.8557 68.8456 43.8592L68.8291 43.838Z"
        fill={fill}
      />
      <path
        d="M58.5485 43.8519C58.8227 43.8507 59.0958 43.8483 59.3701 43.8472C59.3713 44.1238 59.3736 44.4004 59.3748 44.677C59.0982 44.6747 58.8215 44.6723 58.5449 44.6712C58.5461 44.3992 58.5473 44.125 58.5485 43.8519Z"
        fill={outline}
      />
      <path
        d="M115.141 44.6667C115.967 44.6762 116.793 44.6844 117.621 44.6938C117.621 45.6061 117.62 46.5184 117.62 47.4295L117.615 47.4354C116.79 47.4342 115.966 47.433 115.141 47.4307C115.142 46.5172 115.143 45.6049 115.143 44.6915C115.142 44.6926 115.141 44.6667 115.141 44.6667Z"
        fill="#CFE3E7"
      />
      <path
        d="M120.37 47.4318C120.377 48.257 120.383 49.0822 120.39 49.9085L120.369 49.9073C119.452 49.9085 118.535 49.9085 117.618 49.9097C117.617 49.0857 117.615 48.2617 117.614 47.4365L117.619 47.4307C118.536 47.4307 119.453 47.4307 120.37 47.4318Z"
        fill="#CFE3E7"
      />
      <path
        d="M69.665 43.8475C69.6662 43.6921 69.6674 43.5379 69.6686 43.3825C69.8263 43.3755 69.984 43.3684 70.1418 43.3613C70.1418 43.3613 70.1524 43.3672 70.1512 43.3672C70.1441 43.5261 70.1382 43.6862 70.1312 43.8451C69.9758 43.8463 69.8204 43.8475 69.665 43.8475Z"
        fill="#F1F0F0"
      />
      <path
        d="M91.6009 34.375C91.3313 34.3738 91.0629 34.3738 90.7934 34.3726C90.7922 34.103 90.7922 33.8347 90.791 33.5651C91.0618 33.5639 91.3325 33.5627 91.6032 33.5627C91.6032 33.8323 91.6021 34.103 91.6009 34.375Z"
        fill={outline}
      />
      <path
        d="M40.0678 64.493C39.8017 64.5083 39.4474 64.4271 39.2967 64.5672C39.1626 64.6919 39.252 65.0592 39.2426 65.3194C39.0696 65.3182 38.8977 65.3182 38.7247 65.317C38.7211 65.0427 38.7176 64.7685 38.7141 64.4942L38.7341 64.4742C39.2073 64.5142 39.272 64.4353 39.1402 63.9762C39.006 63.9762 38.8706 63.9762 38.7353 63.9762C38.7282 63.9692 38.7211 63.9621 38.7129 63.9551C38.7164 63.6808 38.7211 63.4053 38.7247 63.1311C38.8953 63.1311 39.0672 63.1299 39.2379 63.1299C39.2485 63.3912 39.1614 63.7608 39.2967 63.8844C39.4509 64.0257 39.8064 63.9468 40.0737 63.9645C40.0784 64.134 40.0831 64.3047 40.089 64.4742C40.0831 64.4789 40.076 64.4859 40.0678 64.493Z"
        fill={fill}
      />
      <path
        d="M80.492 64.4907C80.4897 64.7661 80.4873 65.0416 80.485 65.3182C80.3119 65.3182 80.1401 65.3194 79.967 65.3194C79.9647 65.0427 79.9623 64.7661 79.96 64.4907C79.9694 64.4812 79.9788 64.4718 79.987 64.4624C80.1459 64.4636 80.3049 64.4636 80.4649 64.4648C80.4744 64.473 80.4838 64.4812 80.492 64.4907Z"
        fill={fill}
      />
      <path
        d="M111.431 64.4881C111.429 64.7659 111.427 65.0437 111.424 65.3215C111.253 65.3192 111.081 65.318 110.909 65.3157C110.905 65.0426 110.903 64.7683 110.899 64.4952L110.919 64.4776C111.072 64.4622 111.224 64.4469 111.377 64.4316C111.394 64.4493 111.413 64.4681 111.431 64.4881Z"
        fill={fill}
      />
      <path
        d="M122.549 64.4929C121.738 64.4599 121.738 64.4599 121.726 65.3157C121.553 65.3169 121.381 65.3181 121.208 65.3192C121.206 65.0426 121.204 64.7648 121.201 64.4882C121.211 64.4788 121.22 64.4693 121.231 64.4588C121.387 64.4446 121.544 64.4293 121.724 64.4128C121.724 64.2504 121.724 64.1092 121.724 63.9667C121.998 63.962 122.272 63.9573 122.547 63.9514L122.567 63.9691C122.569 64.1362 122.571 64.3034 122.574 64.4693C122.564 64.4788 122.556 64.4858 122.549 64.4929Z"
        fill={fill}
      />
      <path
        d="M39.2432 34.3878C39.2467 34.1124 39.2502 33.8358 39.2526 33.5603C39.5233 33.5615 39.7952 33.5627 40.066 33.5638C40.0683 33.8369 40.0719 34.1088 40.0742 34.3819C39.7976 34.3843 39.5198 34.3867 39.2432 34.3878C39.2432 34.3878 39.2432 34.389 39.2432 34.3878Z"
        fill={outline}
      />
      <path
        d="M8.29518 63.9668C8.57415 63.9668 8.85196 63.9656 9.13094 63.9656C9.13564 64.1339 9.14035 64.3022 9.14624 64.4717C9.138 64.4788 9.12976 64.4859 9.12152 64.4941C8.84136 64.4812 8.56238 64.4694 8.28223 64.4564C8.28694 64.2916 8.29047 64.1292 8.29518 63.9668Z"
        fill={fill}
      />
      <path
        d="M117.608 54.9946C118.517 54.9946 119.425 54.9946 120.385 54.9946C120.385 55.9352 120.385 56.8321 120.385 57.7279L120.37 57.7244C119.452 57.7244 118.535 57.7232 117.617 57.7232C117.614 56.8215 117.613 55.921 117.612 55.0194L117.608 54.9946Z"
        fill="#F1F1F1"
      />
      <path
        d="M117.61 54.1567C117.609 54.4357 117.609 54.7147 117.608 54.9937L117.61 55.0184C116.788 55.016 115.966 55.0148 115.144 55.0125C115.142 54.9972 115.138 54.9819 115.136 54.9666C115.137 54.7006 115.138 54.4334 115.139 54.1673C115.245 54.1591 115.351 54.145 115.457 54.145C116.176 54.1402 116.894 54.1391 117.614 54.1367C117.614 54.1379 117.61 54.1567 117.61 54.1567Z"
        fill={fill}
      />
      <path
        d="M120.385 57.7279C120.659 57.7256 120.933 57.7244 121.207 57.722L121.225 57.7185C121.219 57.8244 121.208 57.9316 121.208 58.0375C121.202 58.7767 121.199 59.5148 121.194 60.254C120.927 60.254 120.658 60.254 120.391 60.254C120.384 59.41 120.377 58.566 120.371 57.7232L120.385 57.7279Z"
        fill={fill}
      />
      <path
        d="M121.207 57.7221C121.207 56.8358 121.207 55.9482 121.207 55.0371C121.387 55.0371 121.535 55.0371 121.734 55.0371C121.734 55.9364 121.734 56.8311 121.734 57.7257L121.719 57.721C121.554 57.7198 121.389 57.7198 121.225 57.7186L121.207 57.7221Z"
        fill="#F1EFEF"
      />
      <path
        d="M120.378 54.1426C119.455 54.1473 118.532 54.152 117.608 54.1567L117.612 54.1367C117.612 53.9837 117.612 53.8319 117.611 53.6788C118.53 53.6777 119.448 53.6765 120.368 53.6753C120.371 53.8319 120.375 53.9872 120.378 54.1426Z"
        fill="#F1F1F1"
      />
      <path
        d="M121.203 54.1343C121.203 54.2226 121.202 54.3097 121.202 54.398C121.202 55.0301 121.182 55.0524 120.543 54.9606C120.48 54.9512 120.388 54.8511 120.382 54.7864C120.362 54.5733 120.376 54.3579 120.376 54.1425L120.377 54.1413C120.653 54.139 120.928 54.1366 121.203 54.1343Z"
        fill={outline}
      />
      <path
        d="M122.552 54.1427C122.554 54.231 122.555 54.3181 122.555 54.4064C122.556 55.0255 122.518 55.0609 121.893 54.9608C121.831 54.9514 121.743 54.8478 121.737 54.7819C121.717 54.5688 121.73 54.3534 121.731 54.1392C122.004 54.1403 122.278 54.1403 122.552 54.1427Z"
        fill={outline}
      />
      <path
        d="M121.731 54.1389C121.557 54.1378 121.381 54.1366 121.207 54.1342C121.211 53.9848 121.214 53.8353 121.219 53.6846C121.388 53.6799 121.559 53.6763 121.729 53.6716H121.727C121.727 53.8282 121.729 53.9836 121.731 54.1389Z"
        fill="#F1EFEF"
      />
      <path
        d="M59.8435 64.4928C59.8412 64.7659 59.84 65.039 59.8377 65.3133C59.6811 65.3133 59.5257 65.3133 59.3692 65.3133C59.3668 65.0402 59.3656 64.7671 59.3633 64.4928C59.3703 64.4858 59.3786 64.4775 59.3856 64.4705C59.5304 64.4705 59.6752 64.4705 59.82 64.4705C59.8294 64.4787 59.8365 64.4858 59.8435 64.4928Z"
        fill={fill}
      />
      <path
        d="M18.6068 64.4929C18.6045 64.766 18.6021 65.0391 18.601 65.3122C18.4432 65.311 18.2867 65.3098 18.1289 65.3086C18.1266 65.0379 18.1254 64.7671 18.123 64.4964C18.1313 64.4882 18.1383 64.4799 18.1466 64.4729C18.2926 64.4729 18.4385 64.4717 18.5845 64.4717C18.5915 64.4787 18.5986 64.4858 18.6068 64.4929Z"
        fill={fill}
      />
      <path
        d="M90.7887 64.4929C90.7863 64.766 90.784 65.0391 90.7828 65.3133C90.6251 65.311 90.4673 65.3086 90.3096 65.3063C90.3072 65.0367 90.3061 64.7683 90.3037 64.4988C90.312 64.4905 90.319 64.4823 90.3273 64.474C90.4732 64.4729 90.6192 64.4729 90.7651 64.4717C90.7722 64.4787 90.7804 64.4858 90.7887 64.4929Z"
        fill={fill}
      />
      <path
        d="M100.61 65.3133C100.608 65.0402 100.606 64.7671 100.604 64.4941C100.613 64.487 100.62 64.4799 100.628 64.4729C100.773 64.4729 100.918 64.4717 101.062 64.4717C101.069 64.4787 101.078 64.4858 101.085 64.4941C101.082 64.7671 101.081 65.0414 101.079 65.3145C100.922 65.3133 100.766 65.3133 100.61 65.3133Z"
        fill={fill}
      />
      <path
        d="M49.5427 64.4871C49.5427 64.7625 49.5416 65.0391 49.5416 65.3146C49.3838 65.311 49.2261 65.3087 49.0684 65.3052C49.0684 65.0368 49.0684 64.7672 49.0684 64.4988C49.0707 64.48 49.0731 64.4612 49.0731 64.4423C49.2284 64.4353 49.385 64.4282 49.5404 64.4211C49.5392 64.4423 49.5416 64.4647 49.5427 64.4871Z"
        fill={fill}
      />
      <path
        d="M28.4239 65.3136C28.4215 65.0405 28.4191 64.7674 28.418 64.4943C28.4262 64.4873 28.4333 64.4802 28.4415 64.4731C28.5875 64.4731 28.7334 64.4743 28.8794 64.4743C28.8876 64.4826 28.8947 64.4908 28.9029 64.499C28.9006 64.7686 28.8994 65.0382 28.8971 65.3077C28.7381 65.3101 28.5816 65.3113 28.4239 65.3136Z"
        fill={fill}
      />
      <path
        d="M48.1765 52.8312C47.2607 52.8347 46.3461 52.8382 45.4303 52.8406L45.4326 52.8182C45.4303 51.8483 45.4291 50.8783 45.4268 49.9072L45.4279 49.906C46.3485 49.906 47.269 49.906 48.1895 49.906C48.1859 50.883 48.1812 51.8577 48.1765 52.8312Z"
        fill="#F1F1F1"
      />
      <path
        d="M45.4308 47.4316C45.4296 48.2568 45.4296 49.082 45.4284 49.9083L45.4273 49.9095C44.6033 49.9083 43.7781 49.9071 42.9541 49.906C42.9541 49.0831 42.9541 48.2603 42.9541 47.4375C43.7793 47.4352 44.6033 47.434 45.4284 47.4316H45.4308Z"
        fill="#B3D6DD"
      />
      <path
        d="M91.6033 43.8555C91.3302 43.8531 91.0583 43.8496 90.7852 43.8472C90.7875 43.6895 90.7887 43.5317 90.791 43.3752C91.0606 43.3728 91.329 43.3693 91.5986 43.3669C91.6056 43.374 91.6127 43.3799 91.6197 43.387C91.6209 43.5364 91.6221 43.6859 91.6233 43.8354L91.6033 43.8555Z"
        fill={fill}
      />
      <path
        d="M40.0743 42.4922C40.9195 42.4957 41.7658 42.4981 42.611 42.504C42.7275 42.5051 42.8429 42.5169 42.9594 42.5251C42.9571 42.7982 42.9536 43.0713 42.9512 43.3444C42.95 43.355 42.95 43.3656 42.9512 43.375C41.9907 43.3739 41.0289 43.3739 40.0684 43.3727C40.0649 43.0855 40.0602 42.7982 40.0566 42.511L40.0743 42.4922Z"
        fill={fill}
      />
      <path
        d="M45.4283 47.4304C44.6031 47.4328 43.7791 47.434 42.9539 47.4363L42.9492 47.4316C42.9504 46.5194 42.9527 45.6059 42.9539 44.6936L42.9527 44.6677C43.7791 44.6771 44.6054 44.6854 45.433 44.6948C45.4306 45.6059 45.4294 46.5182 45.4283 47.4304Z"
        fill="#CFE3E7"
      />
      <path
        d="M42.9537 43.8603C42.9537 44.1299 42.9537 44.3982 42.9549 44.6678L42.956 44.6937C41.9967 44.689 41.0385 44.6831 40.0791 44.6784C40.0768 44.4018 40.0756 44.1252 40.0732 43.8485C41.0338 43.845 41.9943 43.8426 42.9549 43.8391L42.9537 43.8603Z"
        fill={fill}
      />
      <path
        d="M79.9729 43.8345C80.1436 43.838 80.3131 43.8404 80.4838 43.8439C80.4815 44.124 80.4791 44.403 80.4767 44.6832C80.3119 44.6867 80.1471 44.6891 79.9812 44.6926C79.9729 44.6855 79.9647 44.6785 79.9576 44.6702C79.9565 44.3983 79.9553 44.1276 79.9541 43.8557L79.9729 43.8345Z"
        fill={fill}
      />
      <path
        d="M121.729 54.1391C121.728 53.9838 121.727 53.8284 121.726 53.673C122.002 53.6718 122.279 53.6707 122.555 53.6707C122.554 53.8272 122.553 53.9849 122.551 54.1415C122.276 54.1403 122.002 54.1403 121.729 54.1391Z"
        fill={fill}
      />
      <path
        d="M12.006 55.017C11.0443 55.017 10.0838 55.017 9.12207 55.0158C9.12325 54.7239 9.12325 54.432 9.12442 54.14C10.085 54.1389 11.0467 54.1377 12.0072 54.1377L12.0049 54.1648C12.0049 54.439 12.0049 54.7133 12.0049 54.9876C12.0049 54.997 12.0049 55.0076 12.006 55.017Z"
        fill={fill}
      />
      <path
        d="M42.9549 43.839C41.9943 43.8425 41.0338 43.8449 40.0733 43.8484C40.0709 43.6907 40.0697 43.5329 40.0674 43.3752L40.0686 43.374C41.0291 43.3752 41.9908 43.3752 42.9513 43.3764C42.9537 43.5306 42.9537 43.6848 42.9549 43.839Z"
        fill="#F1F1F1"
      />
      <path
        d="M127.969 64.4621C127.123 64.4703 126.279 64.4798 125.434 64.488L125.435 64.4597C125.434 64.2973 125.432 64.136 125.431 63.9736C126.276 63.9736 127.121 63.9724 127.966 63.9724C127.967 64.1349 127.967 64.2985 127.969 64.4621Z"
        fill="#CFE2E5"
      />
      <path
        d="M68.8409 63.7986C68.2853 63.6867 67.7497 63.7197 67.2506 64.0187C66.8597 64.0034 66.4689 63.9869 66.0781 63.9716C65.2318 63.9716 64.3854 63.9716 63.5391 63.9716L63.5438 63.9575C63.5438 63.6867 63.5426 63.4148 63.5426 63.1441C64.3866 63.1382 65.2318 63.1311 66.0758 63.1252C66.9951 63.1276 67.9145 63.1288 68.8326 63.1311C68.8361 63.3536 68.8385 63.5761 68.8409 63.7986Z"
        fill={fill}
      />
      <path
        d="M68.841 63.7985C68.8387 63.576 68.8363 63.3535 68.834 63.1311V63.1299C69.1118 63.1311 69.3884 63.1322 69.6662 63.1334C69.6662 63.41 69.6674 63.6867 69.6674 63.9645V63.9633C69.5297 63.981 69.3908 63.9986 69.253 64.0163C69.1153 63.9445 68.9788 63.8715 68.841 63.7985Z"
        fill={outline}
      />
      <path
        d="M66.0771 63.9714C66.468 63.9867 66.8588 64.0032 67.2496 64.0185C67.0565 64.1833 66.8623 64.3481 66.6692 64.5129C66.4727 64.4976 66.2749 64.4811 66.0783 64.4658C66.0783 64.301 66.0783 64.1362 66.0771 63.9714Z"
        fill="#F1EFEF"
      />
      <path
        d="M69.9015 63.9548C70.1063 63.9348 70.1393 64.0407 70.1534 64.2267C70.1758 64.5022 69.9898 64.4739 69.8309 64.5033C69.772 64.4421 69.7132 64.3809 69.6543 64.3197C69.659 64.2008 69.6649 64.0819 69.6696 63.9619V63.963C69.7473 63.9607 69.8238 63.9572 69.9015 63.9548Z"
        fill="#F1EFEF"
      />
      <path
        d="M69.6663 63.9631C69.6616 64.082 69.6557 64.2009 69.651 64.321C69.518 64.2197 69.385 64.1185 69.252 64.0173C69.3897 63.9984 69.5286 63.9808 69.6663 63.9631Z"
        fill={fill}
      />
      <path
        d="M76.3742 63.9574C76.3742 63.6866 76.3742 63.4147 76.3742 63.144L76.373 63.1228C77.2936 63.1263 78.2153 63.131 79.1358 63.1346C79.1393 63.4077 79.1428 63.6796 79.1464 63.9527L79.1264 63.9692C78.2094 63.9656 77.2924 63.9609 76.3742 63.9574Z"
        fill={fill}
      />
      <path
        d="M79.9596 64.4897C79.683 64.4861 79.4052 64.4838 79.1285 64.4802C79.1274 64.3096 79.1262 64.14 79.125 63.9694L79.145 63.9529C79.4193 63.9588 79.6947 63.9647 79.969 63.9717C79.9749 64.1353 79.9808 64.299 79.9867 64.4626C79.9784 64.4708 79.969 64.4802 79.9596 64.4897Z"
        fill={fill}
      />
      <path
        d="M71.0094 60.2576C70.9929 60.2564 70.9764 60.2541 70.96 60.2529C70.9776 60.1399 71.0094 60.0269 71.0106 59.9127C71.0165 59.184 71.0165 58.4554 71.0188 57.7268C71.8593 57.7268 72.7009 57.7173 73.5414 57.7315C73.7921 57.7362 73.8522 57.6514 73.8486 57.4136C73.8357 56.6132 73.8451 55.8116 73.8451 55.0099C73.8639 55.0005 73.8839 54.9911 73.9028 54.9817C74.0075 54.9911 74.1123 55.0099 74.2183 55.0099C74.9351 55.0135 75.6532 55.0147 76.37 55.0158C76.3712 55.9187 76.3724 56.8204 76.3736 57.7232C75.652 57.7232 74.9292 57.7338 74.2077 57.7197C73.9652 57.715 73.8945 57.7868 73.8945 58.0305C73.8945 58.7697 73.8663 59.5077 73.8498 60.247L73.8439 60.2529C72.8987 60.2552 71.9546 60.2564 71.0094 60.2576Z"
        fill="#CFE3E7"
      />
      <path
        d="M71.0088 60.2577C71.9528 60.2565 72.8981 60.2553 73.8421 60.2542C73.841 61.2123 73.841 62.1705 73.8398 63.1275C72.9004 63.1287 71.9611 63.1287 71.0229 63.1299C71.0182 62.1729 71.0135 61.2147 71.0088 60.2577Z"
        fill="#F1F1F1"
      />
      <path
        d="M71.0164 57.727C71.014 58.4556 71.0152 59.1842 71.0081 59.9129C71.007 60.0259 70.9752 60.1401 70.9575 60.2531C70.7033 60.2531 70.449 60.2531 70.1947 60.2543C70.1783 60.2083 70.1465 60.1636 70.1465 60.1177C70.15 59.3196 70.1583 58.5227 70.1641 57.7246C70.4408 57.727 70.7186 57.7293 70.9964 57.7317L71.0164 57.727Z"
        fill={fill}
      />
      <path
        d="M70.1465 60.2589C70.1453 61.1358 70.1382 62.0128 70.1465 62.8897C70.1477 63.0804 70.0853 63.1605 69.8981 63.144C69.8204 63.1405 69.7427 63.1381 69.665 63.1346C69.6674 62.174 69.6686 61.2147 69.6709 60.2542C69.8298 60.2553 69.9876 60.2565 70.1465 60.2589Z"
        fill="#F1F0F0"
      />
      <path
        d="M70.1499 60.2587C69.9921 60.2563 69.8332 60.2551 69.6755 60.2528L69.6543 60.254C69.6614 59.41 69.6684 58.566 69.6755 57.7231C69.8297 57.7231 69.9851 57.7231 70.1393 57.7243H70.1687C70.1616 58.5224 70.1546 59.3193 70.151 60.1174C70.151 60.1633 70.1828 60.2081 70.1993 60.254C70.1817 60.2563 70.1664 60.2575 70.1499 60.2587Z"
        fill="#CFE3E7"
      />
      <path
        d="M71.005 63.15C71.005 63.416 71.0061 63.682 71.0061 63.9481C70.879 63.9528 70.7519 63.9622 70.6259 63.961C70.1362 63.9587 70.1927 64.0152 70.1904 63.5196C70.188 63.1359 70.1904 63.1347 70.5659 63.1359C70.7119 63.137 70.859 63.1453 71.005 63.15Z"
        fill={outline}
      />
      <path
        d="M69.665 63.1333C69.7427 63.1368 69.8204 63.1392 69.8981 63.1427C69.8981 63.4135 69.8981 63.6842 69.8981 63.9549C69.8216 63.9585 69.7439 63.9608 69.6674 63.9644C69.6662 63.6866 69.6662 63.4099 69.665 63.1333Z"
        fill={fill}
      />
      <path
        d="M73.8408 63.1276C73.842 62.1694 73.842 61.2112 73.8432 60.2542L73.8491 60.2483C74.6895 60.2506 75.5312 60.253 76.3716 60.2542C76.3716 61.21 76.3716 62.1658 76.3716 63.1217L76.3728 63.1429C75.5488 63.1429 74.7248 63.1428 73.9009 63.144C73.8808 63.1393 73.8608 63.1334 73.8408 63.1276Z"
        fill="#CFE3E7"
      />
      <path
        d="M91.6055 37.0871C91.6102 36.1901 91.6161 35.2919 91.6208 34.395C92.5778 34.3879 93.5348 34.3808 94.4918 34.3738L94.4883 34.3891C94.4883 35.2872 94.4894 36.1866 94.4894 37.0847C93.5348 37.0835 92.579 37.0835 91.6243 37.0824L91.6055 37.0871Z"
        fill="#F1F0F0"
      />
      <path
        d="M115.14 44.6926C115.139 45.606 115.138 46.5183 115.138 47.4318L115.137 47.4329C114.181 47.4341 113.225 47.4341 112.269 47.4353C112.268 46.516 112.266 45.5966 112.265 44.6785C113.224 44.6832 114.182 44.6879 115.14 44.6926Z"
        fill="#F1F1F1"
      />
      <path
        d="M112.265 44.6784C112.266 45.5978 112.268 46.5171 112.27 47.4353L112.25 47.4329C111.975 47.4317 111.701 47.4294 111.427 47.4282C111.421 46.5183 111.415 45.6096 111.409 44.6996C111.417 44.6902 111.427 44.6808 111.435 44.6714C111.712 44.6737 111.988 44.6761 112.265 44.6784Z"
        fill={fill}
      />
      <path
        d="M111.41 44.6997C111.416 45.6096 111.422 46.5184 111.428 47.4283L111.403 47.4271C111.243 47.4295 111.083 47.433 110.924 47.4353C110.922 46.5172 110.918 45.599 110.916 44.6809L110.917 44.6797C111.081 44.6868 111.246 44.6938 111.41 44.6997Z"
        fill="#F1EFEF"
      />
      <path
        d="M110.081 43.8462C110.354 43.8497 110.627 43.8544 110.9 43.858C110.906 44.1322 110.911 44.4065 110.917 44.6796L110.916 44.6808C110.64 44.6761 110.365 44.6714 110.089 44.6666C110.087 44.3936 110.083 44.1193 110.081 43.8462Z"
        fill={outline}
      />
      <path
        d="M76.3729 43.8402C76.3729 43.6871 76.3717 43.5329 76.3717 43.3799C77.2934 43.3776 78.2163 43.3764 79.138 43.374L79.1391 43.3752C79.1368 43.5329 79.1356 43.6907 79.1332 43.8484C78.2116 43.8508 77.2899 43.8531 76.3682 43.8566L76.3729 43.8402Z"
        fill="#F1F1F1"
      />
      <path
        d="M73.8398 43.8416C73.8598 43.8474 73.8798 43.8521 73.8987 43.858C73.8987 44.1276 73.8987 44.3972 73.8987 44.6667C73.8787 44.6738 73.8586 44.6797 73.8386 44.6867C72.8981 44.6832 71.9588 44.6785 71.0182 44.675C71.0135 44.4042 71.0076 44.1335 71.0029 43.8627L71.0206 43.8439C71.9611 43.8439 72.9005 43.8427 73.8398 43.8416Z"
        fill={fill}
      />
      <path
        d="M70.1299 43.8463C70.1369 43.6874 70.1428 43.5273 70.1499 43.3684C70.4336 43.3696 70.7185 43.3696 71.0021 43.3708C71.008 43.5285 71.0139 43.6862 71.0186 43.844L71.001 43.8628C70.7161 43.864 70.4324 43.864 70.1475 43.8652L70.1299 43.8463Z"
        fill={fill}
      />
      <path
        d="M73.8994 44.6679C73.8994 44.3983 73.8994 44.1288 73.8994 43.8592C74.7234 43.8533 75.5486 43.8474 76.3726 43.8416L76.369 43.8568C76.369 44.1288 76.369 44.3995 76.3702 44.6714C75.5474 44.6691 74.7234 44.6679 73.8994 44.6679Z"
        fill={fill}
      />
      <path
        d="M100.619 39.6169C100.769 39.6157 100.921 39.6145 101.072 39.6145C101.077 40.5762 101.081 41.5379 101.087 42.5008L101.086 42.502C100.929 42.4996 100.773 42.4961 100.616 42.4938C100.613 41.5344 100.608 40.5739 100.605 39.6145C100.603 39.6133 100.619 39.6169 100.619 39.6169Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.886 42.5052C101.909 42.7888 101.931 43.0725 101.953 43.3574L101.939 43.3656C101.657 43.3656 101.374 43.3645 101.092 43.3645C101.088 43.0761 101.085 42.7888 101.081 42.5004L101.082 42.4993C101.351 42.5016 101.619 42.5028 101.886 42.5052Z"
        fill={outline}
      />
      <path
        d="M101.956 43.3577C102.899 43.3612 103.842 43.3659 104.785 43.3694C104.786 43.5272 104.787 43.6837 104.79 43.8415C103.849 43.8438 102.907 43.8462 101.967 43.8474C101.959 43.6873 101.952 43.5272 101.943 43.3671L101.956 43.3577Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.785 43.8403C104.784 43.6838 104.783 43.526 104.78 43.3683C104.781 43.3518 104.783 43.3353 104.785 43.3188C104.898 43.3365 105.012 43.3683 105.125 43.3695C105.854 43.3753 106.582 43.3753 107.311 43.3765C107.311 43.5307 107.312 43.6838 107.312 43.838L107.315 43.858C106.471 43.8591 105.627 43.8591 104.783 43.8603C104.784 43.8615 104.785 43.8403 104.785 43.8403Z"
        fill="#CFE3E7"
      />
      <path
        d="M99.7812 37.0846C100.053 37.0846 100.325 37.0858 100.597 37.0858C100.603 37.9298 100.61 38.7726 100.616 39.6166L100.6 39.6131C100.329 39.6131 100.057 39.6131 99.7835 39.6142C99.7753 38.7702 99.767 37.9262 99.7588 37.0811L99.7812 37.0846Z"
        fill={fill}
      />
      <path
        d="M97.0176 34.3738C97.9346 34.382 98.8504 34.3903 99.7674 34.3985C99.7721 35.2943 99.7768 36.1889 99.7815 37.0847L99.7603 37.0812C98.8468 37.0824 97.9346 37.0835 97.0211 37.0847C97.0211 36.1866 97.0223 35.2872 97.0223 34.3891L97.0176 34.3738Z"
        fill="#F1F1F1"
      />
      <path
        d="M120.385 49.9072C120.657 49.9072 120.928 49.9084 121.2 49.9084C121.206 50.8783 121.211 51.8483 121.217 52.8182C121.211 52.8276 121.204 52.8371 121.198 52.8453C120.925 52.8465 120.653 52.8488 120.38 52.85C120.373 52.8429 120.366 52.8359 120.36 52.8288C120.362 51.8542 120.364 50.8807 120.365 49.906L120.385 49.9072Z"
        fill={fill}
      />
      <path
        d="M121.727 53.6728C121.558 53.6775 121.387 53.681 121.217 53.6857C121.21 53.6786 121.203 53.6716 121.196 53.6645C121.197 53.3914 121.199 53.1195 121.201 52.8464C121.208 52.8382 121.214 52.8288 121.22 52.8193C121.386 52.8252 121.553 52.8299 121.719 52.8358C121.722 53.1148 121.725 53.3938 121.727 53.6728Z"
        fill={fill}
      />
      <path
        d="M24.8324 44.6691C24.8324 44.3983 24.8313 44.1276 24.8313 43.8568C25.7494 43.8498 26.6676 43.8427 27.5857 43.8345L27.6046 43.8557C27.5975 44.1323 27.5904 44.4077 27.5834 44.6844C26.6652 44.6879 25.7482 44.6914 24.8301 44.6961C24.8301 44.6949 24.8324 44.6691 24.8324 44.6691Z"
        fill={fill}
      />
      <path
        d="M22.3061 44.6689C23.1489 44.6689 23.9917 44.6689 24.8357 44.6689L24.8334 44.6948C24.8345 45.6071 24.8357 46.5206 24.8369 47.4328C23.9929 47.4328 23.1477 47.4328 22.3037 47.4328C22.3049 46.5206 22.3061 45.6071 22.3072 44.6948L22.3061 44.6689Z"
        fill="#CFE3E7"
      />
      <path
        d="M55.7822 49.9072C56.6945 49.9072 57.608 49.9084 58.5202 49.9084H58.5426C58.5367 50.8772 58.5296 51.8471 58.5238 52.8159C58.4178 52.823 58.3107 52.8359 58.2048 52.8359C57.3972 52.8395 56.5897 52.8406 55.7822 52.8418L55.7834 52.8206C55.7822 51.8518 55.7822 50.8795 55.7822 49.9072Z"
        fill="#F1F1F1"
      />
      <path
        d="M53.2526 53.6609C53.2526 53.389 53.2526 53.1171 53.2514 52.8463C54.0954 52.8393 54.9394 52.831 55.7834 52.824L55.7822 52.8452C55.7822 53.1159 55.7822 53.3878 55.781 53.6586C54.937 53.6644 54.093 53.6715 53.249 53.6774L53.2526 53.6609Z"
        fill={fill}
      />
      <path
        d="M50.3691 54.1388C50.3727 53.9858 50.3762 53.8328 50.3809 53.6797C51.3391 53.6738 52.2961 53.6668 53.2543 53.6609L53.2508 53.6762C53.2519 53.8292 53.2519 53.9834 53.2531 54.1365C52.2902 54.1376 51.3297 54.1388 50.3691 54.1388Z"
        fill="#F1F1F1"
      />
      <path
        d="M58.5399 47.4375C58.813 47.4363 59.0873 47.4363 59.3604 47.4352L59.3757 47.4316C59.3686 48.2568 59.3628 49.082 59.3557 49.9071C59.0838 49.9083 58.8119 49.9083 58.5399 49.9095H58.5176C58.5258 49.0855 58.5329 48.2615 58.5399 47.4375Z"
        fill={fill}
      />
      <path
        d="M59.3633 47.4353C59.368 46.516 59.3715 45.5966 59.3762 44.6785C59.5257 44.6808 59.6764 44.6832 59.8259 44.6855C59.8271 45.6025 59.8282 46.5195 59.8294 47.4353C59.6788 47.4341 59.5293 47.4329 59.3786 47.4318L59.3633 47.4353Z"
        fill="#F1F0F0"
      />
      <path
        d="M94.4874 64.4835C93.5339 64.4811 92.5805 64.4776 91.6258 64.4753L91.6211 64.4741C91.6211 64.3069 91.6211 64.1398 91.6211 63.9714C92.5781 63.9726 93.5351 63.975 94.4921 63.9761C94.4898 64.1374 94.4874 64.2987 94.485 64.4611L94.4874 64.4835Z"
        fill="#F1EFEF"
      />
      <path
        d="M84.1904 64.4858C83.2345 64.4834 82.2775 64.4823 81.3217 64.4799H81.3193C81.3205 64.3104 81.3217 64.1397 81.3217 63.9702C82.2787 63.9726 83.2369 63.9738 84.1939 63.9761C84.1915 64.1397 84.1892 64.3022 84.1868 64.4658L84.1904 64.4858Z"
        fill="#F1EFEF"
      />
      <path
        d="M63.5423 64.4837C62.5982 64.4837 61.653 64.4837 60.6748 64.4837C60.6748 64.2624 60.6748 64.1188 60.6748 63.9752L60.6783 63.9716C61.6342 63.9669 62.59 63.9622 63.5458 63.9575L63.5411 63.9716C63.5399 64.1364 63.5399 64.3001 63.5388 64.4649L63.5423 64.4837Z"
        fill="#F1EFEF"
      />
      <path
        d="M60.6731 63.975C60.3941 63.9714 60.1139 63.9679 59.835 63.9632C59.8397 63.6901 59.8432 63.417 59.8479 63.1451C60.1187 63.1439 60.3882 63.1416 60.659 63.1404C60.6648 63.417 60.6707 63.6948 60.6766 63.9714L60.6731 63.975Z"
        fill={outline}
      />
      <path
        d="M59.8225 64.4705C59.6777 64.4705 59.5329 64.4705 59.3881 64.4705C59.3834 64.301 59.3787 64.1326 59.374 63.9631C59.5282 63.9631 59.6824 63.9631 59.8366 63.9631C59.8319 64.1326 59.8272 64.3021 59.8225 64.4705Z"
        fill="#F1EFEF"
      />
      <path
        d="M53.2474 64.4834C52.2927 64.4811 51.3381 64.4787 50.3834 64.4764L50.3799 64.4752C50.3811 64.308 50.3822 64.1409 50.3834 63.9737C51.3392 63.9678 52.2962 63.9619 53.2521 63.9561L53.2474 63.9725C53.2462 64.135 53.2462 64.2974 53.245 64.4599L53.2474 64.4834Z"
        fill="#F1EFEF"
      />
      <path
        d="M115.136 64.487C114.18 64.4846 113.223 64.4823 112.267 64.4799H112.265C112.266 64.3104 112.267 64.1397 112.267 63.9702C113.224 63.9714 114.181 63.9738 115.138 63.9749C115.136 64.1385 115.133 64.3034 115.131 64.467C115.132 64.467 115.136 64.487 115.136 64.487Z"
        fill="#F1EFEF"
      />
      <path
        d="M40.0885 64.4718C40.0838 64.3023 40.0791 64.1317 40.0732 63.9622V63.9633C41.0326 63.9669 41.9931 63.9716 42.9525 63.9751C42.9501 64.1387 42.9478 64.3024 42.9454 64.466L42.949 64.4872C41.9955 64.4824 41.042 64.4766 40.0885 64.4718Z"
        fill="#F1EFEF"
      />
      <path
        d="M125.434 63.9727C125.435 64.1352 125.437 64.2964 125.439 64.4589C124.484 64.4624 123.528 64.4671 122.573 64.4707C122.571 64.3035 122.569 64.1364 122.566 63.9704C123.523 63.9657 124.48 63.961 125.437 63.9551L125.434 63.9727Z"
        fill="#F1EFEF"
      />
      <path
        d="M9.14812 64.4705C9.14341 64.3022 9.1387 64.1339 9.13281 63.9644C10.0922 63.9679 11.0515 63.9726 12.0109 63.9761C12.0085 64.1386 12.0062 64.2998 12.0038 64.4623L12.0074 64.4846C11.0539 64.4799 10.1004 64.4752 9.14812 64.4705Z"
        fill="#F1EFEF"
      />
      <path
        d="M22.3009 64.4833C21.3486 64.4798 20.3963 64.4762 19.444 64.4727L19.4369 64.4703C19.4357 64.3044 19.4357 64.1384 19.4346 63.9724C20.3916 63.9736 21.3486 63.9748 22.3056 63.9771C22.3032 64.1384 22.3009 64.2997 22.2985 64.4621L22.3009 64.4833Z"
        fill="#F1EFEF"
      />
      <path
        d="M32.6036 64.4917C31.6631 64.4894 30.7237 64.487 29.7832 64.4835C29.7844 64.3105 29.7844 64.1386 29.7856 63.9656C30.7249 63.9668 31.6654 63.9679 32.6048 63.9691C32.6024 64.1351 32.6012 64.3022 32.5989 64.4682C32.5989 64.4706 32.6036 64.4917 32.6036 64.4917Z"
        fill="#F1EFEF"
      />
      <path
        d="M104.788 64.4917C103.847 64.4894 102.905 64.4882 101.965 64.4858C101.966 64.3116 101.967 64.1386 101.967 63.9644C102.907 63.9655 103.847 63.9667 104.786 63.9679C104.784 64.1362 104.783 64.3045 104.781 64.4729L104.788 64.4917Z"
        fill="#F1EFEF"
      />
      <path
        d="M110.077 43.8462C110.08 44.1193 110.083 44.3935 110.086 44.6666C110.079 44.6737 110.071 44.6808 110.063 44.689C109.147 44.6831 108.232 44.6784 107.316 44.6725C107.316 44.4018 107.316 44.1299 107.316 43.8591L107.313 43.8391C108.235 43.8415 109.157 43.8438 110.077 43.8462Z"
        fill={fill}
      />
      <path
        d="M27.5822 64.474C26.6687 64.4775 25.7541 64.4799 24.8406 64.4834L24.843 64.4611C24.8406 64.2998 24.8383 64.1385 24.8359 63.9761C25.7529 63.9761 26.6687 63.9761 27.5857 63.9773C27.5869 64.1421 27.5881 64.308 27.5892 64.4728L27.5822 64.474Z"
        fill="#F1EFEF"
      />
      <path
        d="M37.8875 64.4801C36.9705 64.4813 36.0535 64.4824 35.1377 64.4824L35.1401 64.4601C35.1377 64.2988 35.1354 64.1375 35.1318 63.9763C36.0524 63.9716 36.9729 63.968 37.8934 63.9633V63.9622C37.8922 64.134 37.8898 64.3071 37.8887 64.4789L37.8875 64.4801Z"
        fill="#F1EFEF"
      />
      <path
        d="M48.1848 64.4823C47.2678 64.4811 46.3508 64.4812 45.4338 64.48L45.435 64.4564C45.4326 64.2963 45.4303 64.1363 45.4268 63.9762C46.3449 63.9726 47.2643 63.9691 48.1824 63.9656C48.1836 64.1398 48.1848 64.3116 48.1848 64.4823Z"
        fill="#F1EFEF"
      />
      <path
        d="M58.5297 63.1263C57.6115 63.1322 56.6945 63.1381 55.7764 63.1428L55.7811 63.1263C55.7799 62.1693 55.7799 61.2111 55.7787 60.2541C56.6934 60.2541 57.608 60.2529 58.5226 60.2529C58.5261 61.2099 58.5297 62.1669 58.5332 63.1239L58.5297 63.1263Z"
        fill="#F1F1F1"
      />
      <path
        d="M55.7799 63.1427C55.7799 63.4134 55.7799 63.6842 55.781 63.9549L55.7857 63.9726C54.9406 63.9726 54.0942 63.9726 53.249 63.9726L53.2537 63.9561C53.2537 63.6853 53.2526 63.4158 53.2526 63.145C54.0966 63.1392 54.9406 63.1321 55.7857 63.1262L55.7799 63.1427Z"
        fill={fill}
      />
      <path
        d="M55.7822 63.9551C56.6686 63.9551 57.555 63.9551 58.4661 63.9551C58.4661 64.134 58.4661 64.2835 58.4661 64.4836C57.575 64.4836 56.6804 64.4836 55.7869 64.4836C55.7869 64.4836 55.7905 64.4612 55.7893 64.4612C55.7881 64.2988 55.7869 64.1352 55.7869 63.9727L55.7822 63.9551Z"
        fill="#F1EFEF"
      />
      <path
        d="M59.3747 63.9633C59.1063 63.9456 58.7508 64.0245 58.5954 63.882C58.4589 63.7573 58.546 63.3877 58.5342 63.1252L58.5366 63.1228C58.812 63.1299 59.0875 63.1369 59.3629 63.144C59.3665 63.4183 59.37 63.6914 59.3747 63.9633Z"
        fill={outline}
      />
      <path
        d="M63.5391 64.4647C63.5402 64.2999 63.5402 64.1362 63.5414 63.9714C64.3878 63.9714 65.2341 63.9714 66.0805 63.9714C66.0805 64.1362 66.0817 64.301 66.0817 64.4658C65.2341 64.4647 64.3866 64.4647 63.5391 64.4647Z"
        fill="#D5DBDB"
      />
      <path
        d="M99.7097 64.4835C98.8139 64.4835 97.9181 64.4835 97.0223 64.4835L97.0246 64.4611C97.0223 64.2999 97.0199 64.1386 97.0176 63.9762C97.9157 63.9726 98.8139 63.9691 99.712 63.9656C99.7109 64.1374 99.7109 64.3105 99.7097 64.4835Z"
        fill="#F1EFEF"
      />
      <path
        d="M99.71 64.4833C99.7111 64.3103 99.7111 64.1384 99.7123 63.9654C99.7335 63.9642 99.7559 63.963 99.7771 63.9607C100.055 63.9619 100.333 63.9619 100.61 63.963C100.615 64.1326 100.62 64.3032 100.626 64.4727C100.618 64.4798 100.61 64.4869 100.602 64.4939C100.329 64.4928 100.056 64.4904 99.7829 64.4892C99.7594 64.4869 99.7347 64.4845 99.71 64.4833Z"
        fill={fill}
      />
      <path
        d="M110.07 64.4774C109.155 64.4786 108.239 64.4809 107.323 64.4821C107.323 64.4821 107.327 64.4633 107.327 64.4645C107.324 64.3008 107.322 64.1372 107.318 63.9736C108.235 63.9724 109.154 63.9724 110.07 63.9724C110.072 64.1407 110.073 64.3091 110.074 64.4774H110.07Z"
        fill="#F1EFEF"
      />
      <path
        d="M120.364 64.4799C119.448 64.4799 118.532 64.4811 117.615 64.4811C117.615 64.4811 117.617 64.4575 117.617 64.4587C117.614 64.2986 117.611 64.1386 117.608 63.9773C118.527 63.9749 119.445 63.9726 120.362 63.9702C120.363 64.1397 120.364 64.3104 120.364 64.4799Z"
        fill="#F1EFEF"
      />
      <path
        d="M121.743 60.2552C122.01 60.254 122.277 60.2528 122.545 60.2505C122.552 61.2087 122.558 62.1669 122.565 63.125L122.546 63.1439C122.273 63.1392 121.998 63.1344 121.725 63.1297C121.724 62.1704 121.723 61.2122 121.721 60.2528L121.743 60.2552Z"
        fill={fill}
      />
      <path
        d="M125.436 63.9564C124.479 63.9611 123.522 63.9658 122.565 63.9717L122.545 63.954C122.545 63.6845 122.545 63.4161 122.545 63.1465L122.564 63.1277C123.522 63.1336 124.48 63.1383 125.437 63.1442C125.436 63.4137 125.436 63.6845 125.436 63.9564Z"
        fill={fill}
      />
      <path
        d="M121.227 57.7185C121.392 57.7197 121.557 57.7197 121.721 57.7209C121.73 58.566 121.738 59.41 121.746 60.2552L121.724 60.254C121.557 60.254 121.388 60.254 121.221 60.254L121.196 60.2552C121.201 59.516 121.205 58.7779 121.21 58.0387C121.21 57.9316 121.221 57.8256 121.227 57.7185Z"
        fill="#D5DBDB"
      />
      <path
        d="M17.2402 64.4858C16.3397 64.4858 15.4392 64.4858 14.5387 64.4847L14.5422 64.4623C14.5399 64.2999 14.5375 64.1374 14.5352 63.975C15.4345 63.9738 16.3326 63.9726 17.232 63.9714C17.2343 64.1433 17.2378 64.3152 17.2402 64.4858Z"
        fill="#F1EFEF"
      />
      <path
        d="M89.4255 64.4835C88.5262 64.4835 87.6257 64.4847 86.7264 64.4847L86.7287 64.4624C86.7264 64.2999 86.724 64.1375 86.7217 63.9739C87.6222 63.9715 88.5227 63.9692 89.4232 63.9668C89.4244 64.1398 89.4255 64.3117 89.4255 64.4835C89.4255 64.4835 89.4267 64.4835 89.4255 64.4835Z"
        fill="#F1EFEF"
      />
      <path
        d="M59.8467 39.6133C60.1198 39.6145 60.3941 39.6168 60.6672 39.618C60.6707 40.5726 60.6754 41.5273 60.679 42.4831C60.6707 42.4902 60.6613 42.4984 60.6531 42.5055C60.387 42.5067 60.121 42.5078 59.855 42.5102L59.835 42.4925C59.8385 41.5332 59.842 40.5726 59.8467 39.6133Z"
        fill={fill}
      />
      <path
        d="M59.8575 42.5101C60.1235 42.5089 60.3895 42.5065 60.6556 42.5054C60.6603 42.7985 60.6662 43.0904 60.6709 43.3835C60.3966 43.3812 60.1212 43.3776 59.8469 43.3753H59.8457C59.8492 43.0869 59.8528 42.7985 59.8575 42.5101Z"
        fill={outline}
      />
      <path
        d="M59.3682 43.8473C59.3693 43.6919 59.3705 43.5365 59.3717 43.3823C59.5283 43.38 59.6848 43.3776 59.8402 43.3752H59.8414C59.8367 43.5306 59.8331 43.686 59.8284 43.8414C59.6754 43.8426 59.5212 43.8449 59.3682 43.8473Z"
        fill="#F1F1F1"
      />
      <path
        d="M17.297 49.9108C17.5642 49.9096 17.8314 49.9084 18.0986 49.9072L18.1257 49.9084C18.1268 50.8854 18.1292 51.8636 18.1304 52.8406C17.8384 52.8465 17.5477 52.8524 17.2558 52.8583C17.2475 52.85 17.2405 52.8418 17.2334 52.8336C17.2393 52.4145 17.244 51.9955 17.2534 51.5764C17.2652 51.0208 17.2817 50.4664 17.297 49.9108Z"
        fill={fill}
      />
      <path
        d="M14.5375 53.6572C14.5375 53.3865 14.5375 53.1146 14.5387 52.8438C15.4368 52.8403 16.3362 52.8368 17.2343 52.8333C17.2414 52.8415 17.2496 52.8497 17.2567 52.858C17.2543 53.1252 17.2508 53.3936 17.2484 53.6608C16.3444 53.6655 15.4404 53.6714 14.5352 53.6761L14.5375 53.6572Z"
        fill={fill}
      />
      <path
        d="M12.009 54.1377C12.009 53.9835 12.0078 53.8305 12.0078 53.6763C12.8518 53.6704 13.6958 53.6634 14.5398 53.6575L14.5375 53.6775C14.5375 53.8317 14.5375 53.9859 14.5375 54.1401C13.6946 54.1483 12.8506 54.1566 12.0078 54.1648L12.009 54.1377Z"
        fill="#CFE3E7"
      />
      <path
        d="M18.1322 47.434C18.284 47.434 18.437 47.4352 18.5889 47.4352L18.6089 47.4329C18.603 48.258 18.5971 49.0832 18.5912 49.9084C18.437 49.9084 18.2828 49.9084 18.1286 49.9084L18.1016 49.9072C18.1086 49.1891 18.1169 48.4723 18.1251 47.7542C18.1263 47.6471 18.1298 47.5412 18.1322 47.434Z"
        fill="#CFE3E7"
      />
      <path
        d="M94.4901 52.8194C94.4889 51.8494 94.4877 50.8795 94.4854 49.9095L94.4889 49.9048C95.3329 49.906 96.1757 49.9071 97.0197 49.9071C97.0197 50.8783 97.0209 51.8506 97.0209 52.8217C96.1769 52.83 95.3329 52.837 94.4889 52.8453C94.4901 52.8464 94.4901 52.8194 94.4901 52.8194Z"
        fill="#CFE3E7"
      />
      <path
        d="M91.6243 49.9117C91.6184 49.0865 91.6125 48.2602 91.6055 47.435L91.6302 47.4362C92.5825 47.435 93.536 47.435 94.4883 47.4338C94.4894 48.2578 94.4906 49.0806 94.4906 49.9046L94.4871 49.9093C93.5336 49.9093 92.579 49.9105 91.6243 49.9117Z"
        fill="#CFE3E7"
      />
      <path
        d="M91.5996 53.6622C91.6067 53.3868 91.6137 53.1101 91.6208 52.8347C92.5778 52.83 93.5336 52.8253 94.4906 52.8206V52.8476C94.4906 53.1195 94.4918 53.3915 94.4918 53.6634C93.5348 53.6704 92.5778 53.6775 91.6208 53.6846C91.6196 53.6822 91.5996 53.6622 91.5996 53.6622Z"
        fill={fill}
      />
      <path
        d="M89.4307 54.1404C89.4318 53.9827 89.433 53.8249 89.4342 53.6672C89.7261 53.6672 90.0169 53.6672 90.3088 53.666C90.31 53.8238 90.3112 53.9827 90.3123 54.1404C90.3053 54.1475 90.2982 54.1545 90.2911 54.1616C90.011 54.1616 89.7297 54.1616 89.4495 54.1616L89.4307 54.1404Z"
        fill={fill}
      />
      <path
        d="M90.7803 54.1341C90.7815 53.9799 90.7838 53.8245 90.785 53.6703C91.0581 53.668 91.33 53.6645 91.6031 53.6621L91.6231 53.6821C91.6196 53.834 91.616 53.9858 91.6125 54.1377C91.3418 54.1424 91.0722 54.1471 90.8015 54.1518L90.7803 54.1341Z"
        fill={fill}
      />
      <path
        d="M90.3142 54.1402C90.4695 54.1378 90.6249 54.1366 90.7791 54.1343L90.7991 54.1519C90.7956 54.4403 90.7921 54.7275 90.7885 55.0159C90.6273 55.0112 90.4672 55.0054 90.3059 55.0006C90.3012 54.7205 90.2965 54.4415 90.293 54.1613C90.3 54.1543 90.3071 54.1472 90.3142 54.1402Z"
        fill={fill}
      />
      <path
        d="M86.724 54.1377C87.6269 54.1377 88.5286 54.1389 89.4314 54.1389L89.4503 54.1601C89.4467 54.4402 89.442 54.7204 89.4385 55.0005C88.5333 54.9982 87.6281 54.9946 86.7217 54.9911C86.7229 54.7145 86.724 54.4379 86.7252 54.1612L86.724 54.1377Z"
        fill={fill}
      />
      <path
        d="M79.9788 49.9107C80.1424 49.9095 80.3049 49.9072 80.4685 49.906C80.472 50.8807 80.4744 51.8553 80.4779 52.83L80.4755 52.8335C80.3096 52.8288 80.1436 52.8241 79.9788 52.8206C79.9729 51.8494 79.9658 50.8795 79.96 49.9084L79.9788 49.9107Z"
        fill="#F1F1F1"
      />
      <path
        d="M81.3057 52.8511C81.308 53.1242 81.3104 53.3972 81.3127 53.6703C81.0396 53.668 80.7665 53.6645 80.4946 53.6621C80.4876 53.3867 80.4817 53.11 80.4746 52.8346L80.477 52.8311C80.7524 52.8369 81.029 52.844 81.3057 52.8511Z"
        fill={outline}
      />
      <path
        d="M84.1961 53.6789C84.1961 53.8331 84.1972 53.9873 84.1972 54.1415L84.2008 54.1627C84.0948 54.1568 83.9877 54.1462 83.8818 54.1462C83.0272 54.1415 82.1726 54.1392 81.318 54.1356C81.3168 53.9802 81.3156 53.826 81.3145 53.6707C82.275 53.673 83.2355 53.6765 84.1961 53.6789Z"
        fill="#F1F1F1"
      />
      <path
        d="M86.725 54.1635C86.7238 54.4402 86.7226 54.7168 86.7215 54.9934L86.7179 55.0169C85.8775 55.0169 85.0382 55.0158 84.1977 55.0158C84.1953 55.0005 84.1918 54.9863 84.1895 54.971C84.193 54.7015 84.1965 54.4331 84.1989 54.1635L84.1953 54.1423C85.0393 54.1482 85.8822 54.1553 86.725 54.1635Z"
        fill={fill}
      />
      <path
        d="M79.9858 47.4316C79.9834 48.258 79.9822 49.0843 79.9799 49.9095L79.9599 49.9071C79.6891 49.9071 79.4184 49.9071 79.1477 49.9071C79.1465 49.0831 79.1465 48.258 79.1465 47.434C79.4196 47.4328 79.6915 47.4328 79.9646 47.4316H79.9858Z"
        fill={fill}
      />
      <path
        d="M24.8344 63.9762C24.8367 64.1375 24.8391 64.2999 24.8414 64.4612C23.9939 64.4612 23.1464 64.4612 22.2988 64.4612C22.3012 64.2999 22.3035 64.1375 22.3059 63.9762L22.3047 63.9539C23.1487 63.9539 23.9915 63.9539 24.8355 63.9539L24.8344 63.9762Z"
        fill="#CFE2E5"
      />
      <path
        d="M14.5373 63.9764C14.5396 64.1389 14.542 64.3013 14.5444 64.4638C13.6968 64.4638 12.8505 64.4638 12.0029 64.4638C12.0053 64.3013 12.0076 64.1401 12.01 63.9776L12.0088 63.9541C12.8516 63.9541 13.6956 63.9541 14.5385 63.9529L14.5373 63.9764Z"
        fill="#CFE2E5"
      />
      <path
        d="M107.315 63.9739C107.317 64.1375 107.319 64.3011 107.323 64.4648C106.475 64.4683 105.628 64.4706 104.78 64.4742C104.783 64.3058 104.784 64.1375 104.786 63.9692L104.785 63.948C105.629 63.9492 106.473 63.9503 107.317 63.9527L107.315 63.9739Z"
        fill="#D5DBDB"
      />
      <path
        d="M35.1316 63.976C35.134 64.1373 35.1363 64.2986 35.1399 64.4598C34.2935 64.4634 33.446 64.4669 32.5996 64.4704C32.602 64.3033 32.6031 64.1373 32.6055 63.9713L32.6043 63.949C33.4483 63.9502 34.2911 63.9525 35.1351 63.9537L35.1316 63.976Z"
        fill="#CFE2E5"
      />
      <path
        d="M97.0209 63.9762C97.0232 64.1375 97.0256 64.2999 97.028 64.4612C96.1804 64.4612 95.3329 64.4612 94.4854 64.4612C94.4877 64.2999 94.4901 64.1375 94.4924 63.9762L94.4912 63.9539C95.3352 63.9539 96.1781 63.9539 97.0221 63.9539L97.0209 63.9762Z"
        fill="#CFE2E5"
      />
      <path
        d="M55.7832 63.9724C55.7844 64.136 55.7856 64.2985 55.7856 64.4609C54.938 64.4609 54.0905 64.4609 53.2441 64.4609C53.2453 64.2985 53.2453 64.136 53.2465 63.9724C54.0929 63.9724 54.938 63.9724 55.7832 63.9724Z"
        fill="#CFE2E5"
      />
      <path
        d="M86.7238 63.9753C86.7262 64.1377 86.7285 64.3001 86.7309 64.4638C85.8833 64.4649 85.037 64.4649 84.1895 64.4661C84.1918 64.3025 84.1942 64.1401 84.1965 63.9764L84.1942 63.9529C85.0382 63.9529 85.881 63.9529 86.725 63.9529L86.7238 63.9753Z"
        fill="#CFE2E5"
      />
      <path
        d="M45.4271 63.9773C45.4294 64.1374 45.4318 64.2975 45.4353 64.4576C44.6066 64.4599 43.7779 64.4623 42.9492 64.4658C42.9516 64.3022 42.9539 64.1386 42.9563 63.975L42.9539 63.9514C43.7791 63.9526 44.6043 63.9538 45.4294 63.9549L45.4271 63.9773Z"
        fill="#CFE2E5"
      />
      <path
        d="M117.614 63.9773C117.616 64.1374 117.618 64.2987 117.622 64.4588C116.793 64.4611 115.964 64.4646 115.136 64.467C115.138 64.3034 115.14 64.1386 115.143 63.975L115.14 63.9514C115.966 63.9526 116.791 63.9538 117.616 63.9538L117.614 63.9773Z"
        fill="#CFE2E5"
      />
      <path
        d="M94.4909 47.4341C93.5386 47.4352 92.5852 47.4352 91.6329 47.4364C91.6293 46.5194 91.6258 45.6024 91.6211 44.6855L91.6223 44.6831C92.5793 44.6878 93.5375 44.6913 94.4945 44.6961C94.4933 45.6083 94.4921 46.5206 94.4909 47.4341Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.5938 44.6782C18.8692 44.6758 19.1458 44.6735 19.4213 44.6699C19.4295 44.6782 19.439 44.6876 19.4472 44.6958C19.4401 45.6069 19.4342 46.5192 19.4272 47.4303C19.1541 47.4315 18.881 47.4315 18.6079 47.4326L18.5879 47.435C18.5902 46.5157 18.5926 45.5963 18.5938 44.6782Z"
        fill={fill}
      />
      <path
        d="M35.1342 39.618C36.0524 39.618 36.9705 39.618 37.8887 39.6168L37.904 39.6133C37.9005 40.5726 37.8958 41.5332 37.8922 42.4925C37.7851 42.4961 37.6792 42.5008 37.5721 42.502C36.7563 42.5078 35.9417 42.5125 35.126 42.5184L35.1295 42.4984C35.1307 41.5379 35.1319 40.5785 35.1342 39.618Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.6582 43.3494C32.6582 43.0763 32.6594 42.8032 32.6594 42.5301C33.3539 42.5218 34.0496 42.5124 34.7441 42.503C34.8712 42.5018 34.9995 42.4995 35.1266 42.4983L35.1231 42.5183C35.1255 42.7961 35.1278 43.0751 35.1302 43.3541C34.3062 43.3529 33.4822 43.3505 32.6582 43.3494Z"
        fill={fill}
      />
      <path
        d="M29.7725 43.8519C29.7736 43.6929 29.7748 43.5352 29.7748 43.3763C30.7177 43.3751 31.6594 43.3728 32.6023 43.3716C32.6023 43.5281 32.6023 43.6847 32.6023 43.8401C31.6594 43.8448 30.7165 43.8483 29.7736 43.853L29.7725 43.8519Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.6008 43.8415C32.6008 43.6849 32.6008 43.5283 32.6008 43.373C32.6196 43.3659 32.6396 43.3576 32.6585 43.3506C33.4825 43.3518 34.3064 43.3529 35.1304 43.3541V43.38C35.1304 43.533 35.1316 43.6872 35.1316 43.8403C34.2876 43.8473 33.4436 43.8544 32.5996 43.8615L32.6008 43.8415Z"
        fill="#CFE3E7"
      />
      <path
        d="M37.9075 37.0858C38.1782 37.0858 38.4478 37.0858 38.7185 37.087L38.7374 37.0823C38.7303 37.9263 38.7233 38.7703 38.7162 39.6143C38.4455 39.6131 38.1747 39.6131 37.904 39.6119L37.8887 39.6155C37.8957 38.7738 37.9016 37.9298 37.9075 37.0858Z"
        fill={fill}
      />
      <path
        d="M38.7282 34.3948C38.8977 34.3924 39.0684 34.39 39.2379 34.3877V34.3889C39.2402 35.2882 39.2414 36.1863 39.2438 37.0857L39.2226 37.0821C39.059 37.0821 38.8953 37.0833 38.7317 37.0833L38.7129 37.088C38.7188 36.1899 38.7235 35.2917 38.7282 34.3948Z"
        fill="#F1EFEF"
      />
      <path
        d="M91.6066 42.4959C91.6066 41.5354 91.6055 40.5748 91.6055 39.6155L91.6243 39.6202C92.579 39.619 93.5336 39.6178 94.4883 39.6167C94.4883 40.5772 94.4883 41.5366 94.4894 42.4971C93.5277 42.4971 92.5672 42.4971 91.6066 42.4959Z"
        fill="#F1F0F0"
      />
      <path
        d="M19.4287 47.4305C19.4358 46.5194 19.4417 45.6071 19.4487 44.696C20.4022 44.696 21.3557 44.696 22.3091 44.6948C22.308 45.6083 22.3068 46.5205 22.3056 47.4328C21.3545 47.4305 20.4022 47.4293 19.4511 47.4269C19.4499 47.4281 19.4287 47.4305 19.4287 47.4305Z"
        fill="#F1F1F1"
      />
      <path
        d="M97.0209 34.3892C97.0209 35.2873 97.0197 36.1866 97.0197 37.0848L97.015 37.0895C96.1734 37.0895 95.3329 37.0895 94.4912 37.0895L94.4865 37.0848C94.4865 36.1866 94.4854 35.2873 94.4854 34.3892C95.3317 34.3892 96.1757 34.3892 97.0209 34.3892Z"
        fill="#CFE3E7"
      />
      <path
        d="M9.13014 63.1334C9.12543 62.1728 9.1219 61.2123 9.11719 60.2529L9.13367 60.2565C10.0919 60.2565 11.05 60.2565 12.007 60.2565C12.0059 61.2135 12.0059 62.1705 12.0047 63.1263L12.0094 63.1428C11.05 63.1393 10.0895 63.1357 9.13014 63.1334Z"
        fill="#F1F1F1"
      />
      <path
        d="M79.9618 47.4318C79.6887 47.433 79.4168 47.433 79.1437 47.4342L79.1237 47.4354C79.1225 46.5196 79.1213 45.6026 79.1201 44.6868L79.1413 44.6667C79.4132 44.6679 79.6851 44.6691 79.9571 44.6715C79.9641 44.6797 79.9724 44.6868 79.9806 44.6938C79.9747 45.6061 79.9677 46.5184 79.9618 47.4318Z"
        fill={fill}
      />
      <path
        d="M94.4897 39.6166C93.5351 39.6178 92.5804 39.619 91.627 39.619C91.627 38.7738 91.627 37.9275 91.627 37.0823C92.5816 37.0835 93.5374 37.0835 94.4921 37.0846L94.4968 37.0893C94.4968 37.931 94.4956 38.7715 94.4956 39.6131C94.4933 39.6131 94.4897 39.6166 94.4897 39.6166Z"
        fill="#CFE3E7"
      />
      <path
        d="M63.5457 43.3811C63.5445 43.5341 63.5445 43.6872 63.5433 43.839L63.548 43.8555C63.4409 43.8531 63.3338 43.8496 63.2266 43.8496C62.3779 43.8425 61.5292 43.8367 60.6805 43.8308C60.677 43.6813 60.6735 43.533 60.6699 43.3835C61.6281 43.3823 62.5875 43.3811 63.5457 43.3811Z"
        fill="#F1F0F0"
      />
      <path
        d="M63.5391 43.8391C65.3012 43.8391 67.0646 43.8379 68.8267 43.8379L68.8432 43.8579C68.8373 44.1322 68.8314 44.4064 68.8255 44.6819C67.9086 44.6854 66.9904 44.689 66.0734 44.6925C65.2294 44.6854 64.3854 44.6784 63.5414 44.6713C63.5414 44.3994 63.5426 44.1286 63.5426 43.8567L63.5391 43.8391Z"
        fill={fill}
      />
      <path
        d="M28.8936 44.6734C28.8983 44.4039 28.903 44.1343 28.9077 43.8636C29.1961 43.8601 29.4845 43.8553 29.7729 43.8518L29.774 43.853C29.7717 44.1214 29.7693 44.3898 29.767 44.6581C29.4762 44.664 29.1843 44.6687 28.8936 44.6734Z"
        fill={outline}
      />
      <path
        d="M27.5879 44.6842C27.595 44.4075 27.602 44.1321 27.6091 43.8555C27.8786 43.8566 28.1482 43.8578 28.4166 43.859C28.4225 44.1321 28.4272 44.4052 28.4331 44.6783C28.1529 44.6806 27.8728 44.683 27.5926 44.6853L27.5879 44.6842Z"
        fill={outline}
      />
      <path
        d="M28.4287 44.6783C28.5829 44.6771 28.7371 44.6748 28.8913 44.6736C28.8913 45.5941 28.8901 46.5134 28.8901 47.434C28.7383 47.434 28.5853 47.4351 28.4334 47.4351C28.4322 46.5158 28.4299 45.5965 28.4287 44.6783Z"
        fill="#F1F0F0"
      />
      <path
        d="M12.0062 60.2563C11.048 60.2563 10.0898 60.2563 9.13281 60.2563C9.13399 59.4123 9.13517 58.5671 9.13634 57.7231C10.0922 57.7231 11.0492 57.7243 12.005 57.7243L12.0085 57.7279C12.0085 58.5695 12.0097 59.41 12.0097 60.2516L12.0062 60.2563Z"
        fill="#CFE3E7"
      />
      <path
        d="M79.1357 43.8472C79.1381 43.6895 79.1393 43.5318 79.1416 43.374C79.4171 43.3776 79.6925 43.3811 79.968 43.3858C79.9703 43.5353 79.9727 43.6848 79.975 43.8343L79.955 43.8555C79.6831 43.8531 79.41 43.8496 79.1357 43.8472Z"
        fill={fill}
      />
      <path
        d="M40.0831 39.6145C40.0808 40.5738 40.0784 41.5332 40.0761 42.4925L40.0572 42.5114C39.7865 42.5055 39.5169 42.4996 39.2462 42.4937C39.238 41.5332 39.2309 40.5726 39.2227 39.6133L39.2497 39.6145C39.5205 39.6156 39.7912 39.6156 40.0619 39.6168C40.0631 39.6168 40.0831 39.6145 40.0831 39.6145Z"
        fill={fill}
      />
      <path
        d="M12.0087 57.7244C12.0087 56.8227 12.0087 55.9198 12.0087 55.0182C12.0075 55.0076 12.0075 54.9981 12.0087 54.9875C12.1146 54.9958 12.2194 55.0123 12.3253 55.0123C13.0622 55.0146 13.7991 55.0146 14.536 55.0158C14.5372 55.9198 14.5395 56.8239 14.5407 57.7279C13.6979 57.7279 12.8562 57.7279 12.0134 57.7291L12.0087 57.7244Z"
        fill="#CFE3E7"
      />
      <path
        d="M101.966 63.9657C101.965 64.1399 101.964 64.313 101.962 64.4872C101.669 64.4895 101.375 64.4919 101.082 64.4931C101.075 64.486 101.067 64.479 101.06 64.4707C101.064 64.3012 101.069 64.1329 101.074 63.9634C101.364 63.9563 101.654 63.9504 101.945 63.9434C101.952 63.9516 101.959 63.9587 101.966 63.9657Z"
        fill={fill}
      />
      <path
        d="M89.4281 64.4835C89.427 64.3117 89.427 64.1387 89.4258 63.9668L89.4458 63.9468C89.7354 63.9503 90.0238 63.9538 90.3133 63.9574C90.3192 64.1292 90.3239 64.3011 90.3298 64.473C90.3216 64.4812 90.3145 64.4894 90.3063 64.4977C90.0132 64.4941 89.7201 64.4894 89.4281 64.4835Z"
        fill={fill}
      />
      <path
        d="M48.1881 64.4836C48.1869 64.3117 48.1857 64.1387 48.1846 63.9668L48.2058 63.948C48.4789 63.9539 48.7519 63.9598 49.0239 63.9645C49.0403 64.1234 49.058 64.2823 49.0745 64.4412C49.0745 64.46 49.0733 64.4789 49.0698 64.4977C48.7767 64.4942 48.4824 64.4883 48.1881 64.4836Z"
        fill={fill}
      />
      <path
        d="M29.782 63.967C29.7808 64.14 29.7808 64.3119 29.7796 64.4849C29.4865 64.4896 29.1946 64.4943 28.9015 64.499C28.8932 64.4908 28.8862 64.4826 28.8779 64.4743C28.8826 64.3025 28.8885 64.1306 28.8932 63.9587C29.1828 63.954 29.4712 63.9505 29.7608 63.9458L29.782 63.967Z"
        fill={fill}
      />
      <path
        d="M17.2416 64.486C17.2393 64.3142 17.2358 64.1435 17.2334 63.9716C17.2405 63.9646 17.2475 63.9575 17.2546 63.9504C17.5453 63.954 17.8373 63.9563 18.128 63.9599C18.1327 64.1305 18.1374 64.3024 18.1421 64.4731C18.1339 64.4813 18.1268 64.4896 18.1186 64.4966C17.8267 64.4943 17.5347 64.4896 17.2416 64.486Z"
        fill={fill}
      />
      <path
        d="M45.432 52.8417C45.4308 53.116 45.4284 53.3891 45.4273 53.6634L45.4308 53.6787C44.6056 53.6716 43.7793 53.6646 42.9541 53.6587C42.9541 53.3891 42.9553 53.1195 42.9553 52.85C43.0624 52.8465 43.1695 52.8417 43.2755 52.8406C43.9947 52.8335 44.7151 52.8276 45.4343 52.8206L45.432 52.8417Z"
        fill={fill}
      />
      <path
        d="M48.1859 53.6751C48.1907 53.8317 48.1954 53.9883 48.2001 54.146L48.1977 54.1495C47.2748 54.1448 46.3508 54.1401 45.4279 54.1354C45.4291 53.9836 45.4303 53.8317 45.4303 53.6799L45.4268 53.6646C46.3461 53.6669 47.2666 53.6704 48.1859 53.6751Z"
        fill="#F1F1F1"
      />
      <path
        d="M49.0524 54.1625C49.0571 54.4415 49.063 54.7204 49.0677 54.9994L49.0536 55.0088C48.7723 55.0053 48.4898 55.0018 48.2084 54.9982C48.2061 54.7157 48.2025 54.432 48.2002 54.1495L48.2025 54.146C48.4851 54.1507 48.7687 54.1566 49.0524 54.1625Z"
        fill={outline}
      />
      <path
        d="M49.5498 55.0173C49.5533 54.7277 49.5569 54.4393 49.5604 54.1509C49.8311 54.1474 50.1007 54.1439 50.3714 54.1392C50.3667 54.4287 50.362 54.7171 50.3585 55.0067C50.0901 55.0102 49.8217 55.015 49.5522 55.0185L49.5498 55.0173Z"
        fill={outline}
      />
      <path
        d="M49.0659 54.9993C49.226 55.0052 49.3872 55.0122 49.5473 55.0181H49.5485C49.5426 55.921 49.5367 56.8238 49.5309 57.7279C49.3778 57.7267 49.2236 57.7255 49.0706 57.7243C49.0647 56.8191 49.0576 55.9139 49.0518 55.0087C49.0518 55.0087 49.0659 54.9993 49.0659 54.9993Z"
        fill="#F1F0F0"
      />
      <path
        d="M27.5856 64.4718C27.5844 64.307 27.5832 64.1411 27.582 63.9763C27.5891 63.9692 27.5962 63.9621 27.6032 63.9551C27.8775 63.9574 28.1518 63.9598 28.426 63.9621C28.4307 64.1317 28.4354 64.3023 28.4413 64.4718C28.4331 64.4789 28.426 64.486 28.4178 64.493C28.1412 64.486 27.8634 64.4789 27.5856 64.4718Z"
        fill={fill}
      />
      <path
        d="M19.4376 63.9715C19.4376 64.1375 19.4388 64.3035 19.44 64.4694C19.1622 64.4777 18.8844 64.4848 18.6066 64.493C18.5983 64.4859 18.5912 64.4789 18.583 64.4718C18.5877 64.3023 18.5924 64.1316 18.5983 63.9621C18.8714 63.9598 19.1457 63.9562 19.4188 63.9539L19.4376 63.9715Z"
        fill={fill}
      />
      <path
        d="M37.8887 64.4801C37.8898 64.3082 37.8922 64.1352 37.8934 63.9633C38.1677 63.961 38.4407 63.9574 38.715 63.9551C38.7221 63.9621 38.7291 63.9692 38.7362 63.9763C38.735 64.1422 38.735 64.3082 38.7338 64.4742L38.7138 64.4942C38.4396 64.4895 38.1641 64.4848 37.8887 64.4801Z"
        fill={fill}
      />
      <path
        d="M50.3819 63.9739C50.3807 64.141 50.3795 64.3082 50.3784 64.4753C50.0994 64.4789 49.8216 64.4824 49.5426 64.4871C49.5414 64.4647 49.5402 64.4424 49.5391 64.42C49.5391 64.2682 49.5391 64.1163 49.5391 63.9645C49.8133 63.9609 50.0876 63.9574 50.3607 63.9539L50.3819 63.9739Z"
        fill={fill}
      />
      <path
        d="M81.3232 63.9705C81.322 64.14 81.3208 64.3107 81.3208 64.4802C81.0442 64.4838 80.7676 64.4873 80.4909 64.4908C80.4815 64.4814 80.4733 64.4732 80.4639 64.4638C80.4698 64.299 80.4756 64.1342 80.4815 63.9694C80.7558 63.9635 81.0301 63.9576 81.3043 63.9529L81.3232 63.9705Z"
        fill={fill}
      />
      <path
        d="M91.6192 63.9717C91.6192 64.1389 91.6192 64.306 91.6192 64.4732C91.3426 64.4802 91.0648 64.4861 90.7882 64.4932C90.7799 64.4861 90.7729 64.4791 90.7646 64.472C90.7694 64.3025 90.7741 64.133 90.7799 63.9623C91.053 63.9588 91.3261 63.9564 91.6004 63.9529L91.6192 63.9717Z"
        fill={fill}
      />
      <path
        d="M110.074 64.4777C110.073 64.3094 110.071 64.141 110.07 63.9727L110.091 63.9539C110.361 63.9539 110.632 63.9539 110.901 63.9539L110.921 63.9739C110.921 64.1422 110.92 64.3094 110.92 64.4777L110.9 64.4953C110.625 64.4895 110.349 64.4836 110.074 64.4777Z"
        fill={fill}
      />
      <path
        d="M112.27 63.9702C112.268 64.1397 112.267 64.3104 112.267 64.4799C111.989 64.4823 111.71 64.4846 111.433 64.487C111.414 64.4681 111.395 64.4493 111.376 64.4305C111.376 64.2798 111.376 64.1291 111.376 63.9726C111.19 63.9726 111.055 63.9726 110.919 63.9726L110.899 63.9526C110.903 63.6795 110.906 63.4052 110.91 63.1321C111.081 63.1297 111.251 63.1286 111.423 63.1262C111.434 63.3864 111.346 63.7536 111.48 63.8784C111.63 64.0173 111.985 63.9373 112.25 63.9526L112.27 63.9702Z"
        fill={fill}
      />
      <path
        d="M120.368 64.4802C120.366 64.3107 120.365 64.14 120.365 63.9705L120.385 63.9529C120.658 63.9576 120.933 63.9623 121.206 63.9658C121.214 64.1306 121.222 64.2954 121.229 64.4602C121.22 64.4696 121.21 64.4791 121.2 64.4897C120.922 64.4861 120.644 64.4826 120.368 64.4802Z"
        fill={fill}
      />
      <path
        d="M9.13281 63.1323C10.0933 63.1359 11.0527 63.1394 12.0132 63.1418C12.0121 63.4125 12.0121 63.682 12.0109 63.9528L12.0121 63.9763C11.0527 63.9728 10.0933 63.9681 9.13399 63.9646C9.13399 63.6879 9.13281 63.4101 9.13281 63.1323Z"
        fill={fill}
      />
      <path
        d="M40.0621 39.6166C39.7914 39.6155 39.5206 39.6155 39.2499 39.6143C39.2428 38.7703 39.2346 37.9263 39.2275 37.0823L39.2487 37.0858C39.5206 37.087 39.7926 37.0882 40.0657 37.0893L40.081 37.0858C40.0739 37.9298 40.068 38.7726 40.0621 39.6166Z"
        fill={fill}
      />
      <path
        d="M91.6077 42.4958C92.5682 42.4958 93.5287 42.4959 94.4893 42.497L94.4881 42.5241C94.4905 42.8007 94.4928 43.0785 94.4952 43.3552C94.368 43.361 94.2409 43.3693 94.1138 43.3705C93.2815 43.3775 92.4493 43.3822 91.6159 43.3869C91.6089 43.3799 91.6018 43.3728 91.5947 43.3669C91.5994 43.0762 91.603 42.7866 91.6077 42.4958Z"
        fill={fill}
      />
      <path
        d="M94.4906 44.6948C93.5336 44.6901 92.5754 44.6865 91.6184 44.6818C91.6126 44.4064 91.6055 44.1309 91.5996 43.8555L91.6196 43.8354C92.5766 43.8425 93.5336 43.8496 94.4906 43.8566C94.4906 44.1274 94.4895 44.3981 94.4895 44.67L94.4906 44.6948Z"
        fill={fill}
      />
      <path
        d="M40.066 37.0895C39.7941 37.0883 39.5221 37.0871 39.249 37.0859C39.2467 36.1866 39.2455 35.2885 39.2432 34.3891C39.521 34.3868 39.7976 34.3844 40.0754 34.3821C40.0719 35.2849 40.0683 36.1878 40.066 37.0895Z"
        fill={fill}
      />
      <path
        d="M68.8291 44.6808C68.835 44.4065 68.8409 44.1322 68.8468 43.8568C69.1199 43.8533 69.3929 43.8497 69.666 43.8462C69.6637 44.1193 69.6602 44.3924 69.6578 44.6643C69.3824 44.6702 69.1069 44.6749 68.8315 44.6808H68.8291Z"
        fill={outline}
      />
      <path
        d="M59.3682 43.8472C59.5224 43.8448 59.6754 43.8424 59.8296 43.8401L59.8473 43.8577C59.8461 44.1273 59.8449 44.3957 59.8437 44.6653L59.8225 44.6841C59.673 44.6817 59.5224 44.6794 59.3729 44.677C59.3717 44.4016 59.3705 44.1238 59.3682 43.8472Z"
        fill={fill}
      />
      <path
        d="M117.615 47.4352C117.616 48.2592 117.617 49.0832 117.618 49.9084L117.617 49.9095C116.793 49.9084 115.968 49.9072 115.144 49.906C115.143 49.082 115.142 48.258 115.141 47.434L115.142 47.4329C115.966 47.4329 116.79 47.434 117.615 47.4352Z"
        fill="#B3D6DD"
      />
      <path
        d="M120.369 49.906C120.368 50.8807 120.365 51.8542 120.364 52.8288C119.447 52.8253 118.53 52.8206 117.614 52.8171C117.615 51.8471 117.615 50.8783 117.617 49.9084L117.618 49.9072C118.535 49.9072 119.452 49.9072 120.369 49.906Z"
        fill="#F1F1F1"
      />
      <path
        d="M69.6592 44.6655C69.6615 44.3924 69.6651 44.1193 69.6674 43.8474C69.8228 43.8474 69.9782 43.8462 70.1336 43.8462L70.1512 43.8662C70.1465 44.1346 70.1406 44.4042 70.1359 44.6725C69.9841 44.6772 69.8322 44.682 69.6792 44.6867L69.6592 44.6655Z"
        fill={fill}
      />
      <path
        d="M39.2369 63.1287C39.0662 63.1299 38.8943 63.1299 38.7236 63.131V63.1299C38.7248 62.1717 38.7272 61.2123 38.7283 60.2542C38.8955 60.2542 39.0638 60.2542 39.231 60.2542C39.2333 61.2123 39.2357 62.1693 39.238 63.1275L39.2369 63.1287Z"
        fill="#F1EFEF"
      />
      <path
        d="M40.0768 63.9634C39.8096 63.9458 39.4541 64.0246 39.2999 63.8834C39.1634 63.7598 39.2516 63.3902 39.2411 63.1288L39.2422 63.1277C39.5165 63.1336 39.7908 63.1394 40.0662 63.1465C40.0698 63.4184 40.0733 63.6915 40.0768 63.9634C40.0768 63.9634 40.078 63.9634 40.0768 63.9634Z"
        fill={outline}
      />
      <path
        d="M38.7162 63.9551C38.4419 63.9574 38.1688 63.9609 37.8945 63.9633V63.9645C37.8992 63.6914 37.9028 63.4195 37.9075 63.1464C38.1817 63.1405 38.4548 63.1358 38.7291 63.1299V63.1311C38.7232 63.4053 38.7197 63.6796 38.7162 63.9551Z"
        fill={outline}
      />
      <path
        d="M38.7344 64.474C38.7356 64.308 38.7356 64.142 38.7367 63.9761C38.8721 63.9761 39.0075 63.9761 39.1417 63.9761C39.2735 64.4352 39.2076 64.514 38.7344 64.474Z"
        fill="#F1EFEF"
      />
      <path
        d="M80.4781 63.969C80.4722 64.1338 80.4663 64.2986 80.4604 64.4634C80.3015 64.4623 80.1414 64.4623 79.9825 64.4611C79.9766 64.2975 79.9707 64.1338 79.9648 63.9702L79.966 63.969C80.1367 63.969 80.3074 63.9679 80.4781 63.969Z"
        fill="#F1EFEF"
      />
      <path
        d="M110.917 63.9739C111.053 63.9739 111.188 63.9739 111.374 63.9739C111.374 64.1293 111.374 64.2811 111.374 64.4318C111.221 64.4471 111.069 64.4624 110.916 64.4777C110.916 64.3094 110.917 64.141 110.917 63.9739Z"
        fill="#F1EFEF"
      />
      <path
        d="M122.544 63.1452C122.544 63.4147 122.544 63.6843 122.544 63.9527C122.269 63.9574 121.995 63.9621 121.721 63.968V63.9668C121.722 63.6879 121.722 63.41 121.723 63.1311L121.722 63.1299C121.996 63.1346 122.269 63.1405 122.544 63.1452Z"
        fill={outline}
      />
      <path
        d="M121.231 64.46C121.222 64.2952 121.214 64.1304 121.207 63.9656C121.379 63.9656 121.552 63.9668 121.724 63.9668V63.9679C121.724 64.1104 121.724 64.2516 121.724 64.4141C121.544 64.4305 121.387 64.4447 121.231 64.46Z"
        fill="#F1EFEF"
      />
      <path
        d="M120.366 57.7245C120.373 58.5685 120.381 59.4125 120.386 60.2554L120.366 60.253C119.447 60.2542 118.528 60.2542 117.608 60.2542C117.608 59.4113 117.608 58.5685 117.608 57.7269L117.613 57.7222C118.53 57.7233 119.448 57.7233 120.366 57.7245Z"
        fill="#CFE3E7"
      />
      <path
        d="M115.147 55.0134C115.968 55.0158 116.791 55.017 117.613 55.0193C117.614 55.921 117.616 56.8215 117.617 57.7232L117.613 57.7267C116.789 57.7255 115.965 57.7244 115.141 57.7232C115.143 56.8203 115.145 55.9163 115.147 55.0134Z"
        fill="#CFE3E7"
      />
      <path
        d="M115.143 55.0134C115.14 55.9175 115.139 56.8203 115.137 57.7244C114.18 57.7255 113.224 57.7267 112.267 57.7267C112.264 56.8262 112.262 55.9245 112.26 55.024C113.218 55.0052 114.176 54.9864 115.134 54.9675C115.138 54.9828 115.14 54.9981 115.143 55.0134Z"
        fill="#F1F1F1"
      />
      <path
        d="M115.138 54.9675C114.179 54.9863 113.221 55.0052 112.263 55.024L112.244 55.0052C112.249 54.718 112.254 54.4307 112.258 54.1435C113.219 54.1435 114.179 54.1423 115.14 54.1423L115.142 54.1694C115.14 54.4343 115.139 54.7015 115.138 54.9675Z"
        fill={fill}
      />
      <path
        d="M117.611 53.6799C117.611 53.833 117.611 53.9848 117.612 54.1378C116.893 54.1402 116.175 54.1414 115.456 54.1461C115.35 54.1472 115.244 54.1614 115.138 54.1684L115.136 54.1414C115.136 53.9871 115.136 53.8318 115.136 53.6776C115.961 53.6717 116.787 53.6658 117.612 53.6599C117.614 53.6599 117.611 53.6799 117.611 53.6799Z"
        fill="#CFE3E7"
      />
      <path
        d="M120.389 60.2553C120.656 60.2553 120.924 60.2553 121.192 60.2553L121.216 60.2541C121.214 61.2111 121.212 62.1681 121.208 63.1251C120.934 63.1322 120.66 63.1381 120.384 63.1451L120.365 63.1263C120.365 62.1681 120.366 61.2099 120.366 60.2529L120.389 60.2553Z"
        fill={fill}
      />
      <path
        d="M117.61 52.8169C118.527 52.8204 119.444 52.8251 120.359 52.8287C120.366 52.8357 120.372 52.8428 120.379 52.8499C120.381 53.1194 120.382 53.389 120.383 53.6585L120.365 53.6762C119.446 53.6774 118.528 53.6786 117.608 53.6797L117.611 53.6597C117.61 53.3878 117.608 53.1171 117.608 52.8451L117.61 52.8169Z"
        fill={fill}
      />
      <path
        d="M121.214 53.6858C121.21 53.8353 121.207 53.9848 121.202 54.1355C120.927 54.1378 120.651 54.1402 120.377 54.1425C120.373 53.9872 120.37 53.833 120.365 53.6776L120.383 53.6599C120.652 53.6611 120.923 53.6623 121.193 53.6646C121.2 53.6705 121.207 53.6787 121.214 53.6858Z"
        fill={fill}
      />
      <path
        d="M18.5952 63.963C18.5905 64.1326 18.5858 64.3032 18.5799 64.4727C18.434 64.4727 18.288 64.4739 18.1421 64.4739C18.1373 64.3032 18.1326 64.1314 18.1279 63.9607C18.2845 63.9607 18.4399 63.9619 18.5952 63.963Z"
        fill="#F1EFEF"
      />
      <path
        d="M90.7792 63.9632C90.7745 64.1327 90.7698 64.3022 90.7639 64.4729C90.618 64.4741 90.472 64.4741 90.3261 64.4753C90.3202 64.3034 90.3155 64.1315 90.3096 63.9585C90.4673 63.9597 90.6227 63.962 90.7792 63.9632Z"
        fill="#F1EFEF"
      />
      <path
        d="M101.074 63.9633C101.069 64.1328 101.065 64.3012 101.06 64.4707C100.915 64.4707 100.77 64.4718 100.626 64.4718C100.621 64.3023 100.616 64.1317 100.61 63.9622V63.9633C100.766 63.9633 100.92 63.9633 101.074 63.9633Z"
        fill="#F1EFEF"
      />
      <path
        d="M49.5375 63.9646C49.5375 64.1164 49.5375 64.2683 49.5375 64.4201C49.3821 64.4272 49.2255 64.4342 49.0702 64.4413C49.0537 64.2824 49.036 64.1235 49.0195 63.9657C49.0348 63.9599 49.0501 63.9551 49.0654 63.9504C49.2232 63.9551 49.3797 63.9599 49.5375 63.9646Z"
        fill="#F1EFEF"
      />
      <path
        d="M28.444 64.4717C28.4393 64.3022 28.4346 64.1315 28.4287 63.962V63.9632C28.5841 63.962 28.7407 63.9597 28.896 63.9585C28.8913 64.1304 28.8854 64.3022 28.8807 64.4741C28.7359 64.4729 28.59 64.4729 28.444 64.4717Z"
        fill="#F1EFEF"
      />
      <path
        d="M45.433 52.8194C44.7137 52.8264 43.9933 52.8323 43.2741 52.8394C43.167 52.8406 43.0599 52.8453 42.9539 52.8488L42.9551 52.8217C42.9527 51.8506 42.9516 50.8806 42.9492 49.9095L42.9539 49.9048C43.7779 49.906 44.6031 49.9071 45.4271 49.9083C45.4294 50.8795 45.4318 51.8494 45.433 52.8194Z"
        fill="#CFE3E7"
      />
      <path
        d="M42.9527 47.4365C42.9527 48.2594 42.9527 49.0822 42.9527 49.905L42.948 49.9097C41.991 49.9097 41.0351 49.9085 40.0781 49.9085C40.0781 49.0834 40.0793 48.2582 40.0793 47.4318C41.0351 47.4318 41.9921 47.4307 42.948 47.4307L42.9527 47.4365Z"
        fill="#CFE3E7"
      />
      <path
        d="M94.4908 43.8567C93.5338 43.8496 92.5767 43.8426 91.6197 43.8355C91.6186 43.686 91.6174 43.5365 91.6162 43.387C92.4484 43.3823 93.2807 43.3764 94.1141 43.3705C94.2412 43.3694 94.3683 43.3599 94.4955 43.3552L94.4919 43.3764C94.4908 43.5318 94.4896 43.686 94.4884 43.8414L94.4908 43.8567Z"
        fill="#F1F0F0"
      />
      <path
        d="M39.249 42.4937C39.5198 42.4995 39.7893 42.5054 40.0601 42.5113C40.0636 42.7985 40.0683 43.0857 40.0718 43.373L40.0707 43.3741C39.8011 43.3718 39.5315 43.3694 39.262 43.3671C39.2573 43.0775 39.2537 42.7856 39.249 42.4937Z"
        fill={outline}
      />
      <path
        d="M42.9513 47.4306C41.9955 47.4306 41.0385 47.4318 40.0827 47.4318L40.0674 47.4353C40.0709 46.516 40.0756 45.5966 40.0792 44.6785C41.0385 44.6832 41.9967 44.6879 42.9561 44.6938C42.9549 45.606 42.9537 46.5183 42.9513 47.4306Z"
        fill="#F1F1F1"
      />
      <path
        d="M40.0707 43.8472C40.073 44.1238 40.0742 44.4004 40.0765 44.677C39.8011 44.6747 39.5245 44.6712 39.249 44.6688C39.2502 44.3969 39.2514 44.1261 39.2526 43.8542C39.5256 43.8531 39.7987 43.8495 40.0707 43.8472C40.0707 43.8472 40.0718 43.8472 40.0707 43.8472Z"
        fill={outline}
      />
      <path
        d="M79.1357 43.8472C79.4088 43.8495 79.6819 43.8519 79.955 43.8542C79.9562 44.1261 79.9574 44.3969 79.9586 44.6688C79.6866 44.6676 79.4147 44.6653 79.1428 44.6641C79.1416 44.3934 79.1393 44.1203 79.1357 43.8472Z"
        fill={outline}
      />
      <path
        d="M14.5351 55.0159C13.7982 55.0148 13.0613 55.0159 12.3245 55.0124C12.2185 55.0124 12.1138 54.9959 12.0078 54.9877C12.0078 54.7134 12.0078 54.4391 12.0078 54.1649C12.8506 54.1566 13.6946 54.1484 14.5375 54.1401L14.5339 54.1602C14.5339 54.4368 14.5328 54.7146 14.5328 54.9912L14.5351 55.0159Z"
        fill={fill}
      />
      <path
        d="M40.0727 43.8472C39.7996 43.8496 39.5265 43.8519 39.2534 43.8543C39.2463 43.8472 39.2405 43.839 39.2334 43.8319C39.2346 43.6848 39.2346 43.5376 39.2358 43.3893C39.2428 43.3822 39.2511 43.374 39.2593 43.3669C39.5289 43.3693 39.7984 43.3717 40.068 43.374C40.068 43.5329 40.0703 43.6907 40.0727 43.8472Z"
        fill={fill}
      />
      <path
        d="M68.8352 63.1312C67.9158 63.1289 66.9965 63.1277 66.0783 63.1253C66.0783 62.1695 66.0783 61.2125 66.0771 60.2555C66.9953 60.2555 67.9123 60.2567 68.8305 60.2567L68.8481 60.252C68.8446 61.2113 68.8399 62.1707 68.8352 63.1312Z"
        fill="#F1F0F0"
      />
      <path
        d="M66.0769 60.2567C66.0769 61.2137 66.0769 62.1695 66.0781 63.1265C65.2341 63.1324 64.3889 63.1394 63.5449 63.1453L63.5484 63.1242C63.5484 62.1671 63.5484 61.2113 63.5484 60.2543C64.3901 60.2531 65.2317 60.2531 66.0734 60.252L66.0769 60.2567Z"
        fill="#CFE3E7"
      />
      <path
        d="M60.6768 63.9715C60.6709 63.6949 60.6651 63.4171 60.6592 63.1405C60.6674 63.1323 60.6745 63.124 60.6827 63.1169C61.6374 63.1193 62.592 63.1217 63.5467 63.124L63.5431 63.1452C63.5431 63.4159 63.5443 63.6879 63.5443 63.9586C62.5897 63.9621 61.6327 63.9668 60.6768 63.9715Z"
        fill={fill}
      />
      <path
        d="M68.834 63.13C68.8387 62.1707 68.8434 61.2113 68.8469 60.252C69.1153 60.2531 69.3825 60.2543 69.6509 60.2543L69.6721 60.2531C69.6697 61.2137 69.6686 62.173 69.6662 63.1336C69.3896 63.1324 69.1118 63.1312 68.834 63.13Z"
        fill={fill}
      />
      <path
        d="M76.373 63.1216C76.373 62.1658 76.373 61.2099 76.373 60.2541C77.2924 60.2541 78.2117 60.2541 79.1311 60.2529C79.1334 61.2135 79.1346 62.1728 79.137 63.1334C78.2153 63.1298 77.2947 63.1263 76.373 63.1216Z"
        fill="#F1F1F1"
      />
      <path
        d="M79.9703 63.9702C79.6961 63.9644 79.4206 63.9585 79.1463 63.9514C79.1428 63.6783 79.1393 63.4064 79.1357 63.1333C79.4088 63.1357 79.6831 63.1392 79.9562 63.1415C79.9609 63.417 79.9668 63.6924 79.9715 63.9679L79.9703 63.9702Z"
        fill={outline}
      />
      <path
        d="M73.8444 55.0112C73.8444 55.8129 73.8349 56.6133 73.8479 57.415C73.8514 57.6527 73.7914 57.7363 73.5406 57.7328C72.7002 57.7175 71.8597 57.7281 71.0181 57.7281L70.998 57.7328C71.0028 56.824 71.0075 55.9141 71.0134 55.0054C71.9562 55.0054 72.9003 55.0089 73.8444 55.0112Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.3752 57.7246C76.374 56.8217 76.3729 55.9201 76.3717 55.0172L76.3682 54.9937C76.4847 54.9995 76.6001 55.0101 76.7166 55.0113C77.5229 55.016 78.3293 55.0195 79.1368 55.0231C79.1344 55.9236 79.1321 56.8253 79.1285 57.7258C78.2104 57.727 77.2922 57.7258 76.3752 57.7246Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.3683 60.2541C75.5278 60.2517 74.6862 60.2506 73.8457 60.2482C73.8634 59.509 73.8904 58.7709 73.8904 58.0317C73.8904 57.788 73.9611 57.7162 74.2035 57.7209C74.9251 57.735 75.6479 57.7256 76.3695 57.7245C76.3695 58.5685 76.3695 59.4113 76.3683 60.2541Z"
        fill="#B3D6DD"
      />
      <path
        d="M73.847 55.0112C72.903 55.0088 71.9601 55.0065 71.016 55.0041C71.0172 54.9865 71.016 54.9688 71.0137 54.9511C71.0137 54.6851 71.0137 54.4179 71.0149 54.1519C71.9589 54.1495 72.903 54.1484 73.847 54.146C73.8659 54.1531 73.8859 54.1613 73.9047 54.1684C73.9047 54.4403 73.9047 54.7122 73.9059 54.9841C73.8847 54.9924 73.8659 55.0018 73.847 55.0112Z"
        fill={fill}
      />
      <path
        d="M73.9006 54.9828C73.9006 54.7108 73.9006 54.4389 73.8994 54.167C74.7234 54.1647 75.5474 54.1635 76.3714 54.1611C76.369 54.4389 76.3667 54.7167 76.3643 54.9945L76.3679 55.0181C75.651 55.0169 74.9329 55.0169 74.2161 55.0122C74.1113 55.011 74.0065 54.9934 73.9006 54.9828Z"
        fill={fill}
      />
      <path
        d="M71.0103 54.95C71.0127 54.9676 71.0139 54.9853 71.0127 55.0029C71.008 55.9117 71.0033 56.8216 70.9974 57.7303C70.7196 57.728 70.443 57.7256 70.1652 57.7233H70.1357C70.1428 56.8181 70.151 55.914 70.1581 55.0088C70.443 54.99 70.7267 54.97 71.0103 54.95Z"
        fill={fill}
      />
      <path
        d="M69.6507 60.2552C69.3823 60.2541 69.1151 60.2529 68.8468 60.2529L68.8291 60.2576C68.835 59.4136 68.8397 58.5708 68.8444 57.7268C69.1151 57.7279 69.3859 57.7279 69.6566 57.7291L69.6719 57.7256C69.6649 58.5672 69.6578 59.4112 69.6507 60.2552Z"
        fill={fill}
      />
      <path
        d="M70.1606 55.0099C70.1536 55.9151 70.1453 56.8191 70.1383 57.7243C69.9841 57.7243 69.8287 57.7243 69.6745 57.7231L69.6592 57.7267C69.6627 56.8262 69.6662 55.9245 69.6698 55.024C69.8299 55.0157 69.9888 55.0075 70.1489 54.9993L70.1606 55.0099Z"
        fill="#F1F0F0"
      />
      <path
        d="M115.138 47.4329C115.139 48.2569 115.14 49.0808 115.141 49.9048L115.135 49.9107C114.18 49.9095 113.223 49.9095 112.267 49.9084C112.261 49.0832 112.255 48.258 112.249 47.4329L112.269 47.4352C113.226 47.434 114.182 47.434 115.138 47.4329Z"
        fill="#CFE3E7"
      />
      <path
        d="M112.251 47.4329C112.257 48.2581 112.263 49.0832 112.269 49.9084L112.252 49.9049C111.98 49.9049 111.708 49.9049 111.436 49.9049C111.433 49.7789 111.429 49.6518 111.428 49.5258C111.42 48.8266 111.412 48.1262 111.403 47.427L111.428 47.4282C111.702 47.4294 111.977 47.4317 112.251 47.4329Z"
        fill={fill}
      />
      <path
        d="M110.088 44.6667C110.363 44.6715 110.639 44.6762 110.914 44.6809C110.916 45.599 110.92 46.5172 110.922 47.4354L110.9 47.4342C110.628 47.4342 110.357 47.4342 110.085 47.4354C110.078 46.5196 110.071 45.6049 110.065 44.6891C110.072 44.6809 110.081 44.6738 110.088 44.6667Z"
        fill={fill}
      />
      <path
        d="M111.401 47.427C111.409 48.1262 111.417 48.8266 111.426 49.5258C111.427 49.6518 111.431 49.7789 111.434 49.9049L111.406 49.9037C111.243 49.9049 111.08 49.9072 110.917 49.9084C110.911 49.0832 110.905 48.2581 110.899 47.4329L110.922 47.4341C111.081 47.4329 111.241 47.4305 111.401 47.427Z"
        fill="#CFE2E5"
      />
      <path
        d="M79.1381 43.8472C79.1405 44.1203 79.1428 44.3922 79.1464 44.6653L79.1252 44.6853C78.2082 44.6888 77.2912 44.6923 76.373 44.6959L76.3742 44.67C76.3742 44.3981 76.3742 44.1273 76.373 43.8554C77.2947 43.8531 78.2164 43.8495 79.1381 43.8472Z"
        fill={fill}
      />
      <path
        d="M73.9 44.6677C74.724 44.6689 75.548 44.6701 76.372 44.6701L76.3708 44.696C76.3731 45.6071 76.3755 46.5182 76.3778 47.4304L76.372 47.4363C75.6492 47.4363 74.9253 47.4422 74.2025 47.4316C73.9859 47.4281 73.8882 47.4705 73.8941 47.7188C73.9118 48.3533 73.9118 48.989 73.8941 49.6234C73.887 49.8718 73.9847 49.9142 74.2013 49.9107C74.9241 49.9001 75.648 49.9059 76.3708 49.9059L76.3755 49.9107C76.3755 50.8806 76.3755 51.8517 76.3743 52.8217C75.5492 52.8311 74.724 52.8405 73.8988 52.8488C73.8788 52.8417 73.8588 52.8346 73.8388 52.8288C73.84 51.9589 73.8329 51.0878 73.8458 50.2179C73.8494 49.9789 73.787 49.8965 73.5374 49.9012C72.6958 49.9154 71.8541 49.9059 71.0137 49.9048C71.0148 49.082 71.0172 48.258 71.0184 47.4352C71.8589 47.4352 72.7005 47.4293 73.541 47.4399C73.7599 47.4422 73.8517 47.3963 73.847 47.1503C73.8305 46.3298 73.84 45.5082 73.8388 44.6877C73.86 44.6807 73.88 44.6736 73.9 44.6677Z"
        fill="#CFE3E7"
      />
      <path
        d="M73.8385 44.6863C73.8396 45.5068 73.8302 46.3284 73.8467 47.1489C73.8514 47.3949 73.7596 47.4408 73.5406 47.4385C72.7002 47.4279 71.8585 47.4338 71.0181 47.4338L70.998 47.4385C71.0051 46.5168 71.0122 45.5963 71.0181 44.6746C71.9586 44.6781 72.8991 44.6828 73.8385 44.6863Z"
        fill="#F1F1F1"
      />
      <path
        d="M70.1357 44.6712C70.1405 44.4029 70.1463 44.1333 70.151 43.8649C70.4359 43.8637 70.7208 43.8637 71.0045 43.8625C71.0092 44.1333 71.0151 44.404 71.0198 44.6748C70.7255 44.6736 70.43 44.6724 70.1357 44.6712C70.1357 44.6712 70.1357 44.6724 70.1357 44.6712Z"
        fill={outline}
      />
      <path
        d="M99.7859 39.6142C100.058 39.6142 100.331 39.6142 100.603 39.613C100.606 40.5724 100.611 41.5329 100.615 42.4923L100.595 42.5099C100.324 42.504 100.053 42.4981 99.7835 42.4923C99.7823 42.3757 99.78 42.2592 99.78 42.1426C99.7729 41.2986 99.7659 40.4558 99.7588 39.6118L99.7859 39.6142Z"
        fill={fill}
      />
      <path
        d="M101.083 42.5004C101.087 42.7888 101.09 43.076 101.094 43.3644L101.075 43.3821C100.919 43.3797 100.763 43.3762 100.607 43.3739C100.602 43.0855 100.598 42.7971 100.594 42.5098L100.614 42.4922C100.769 42.4945 100.926 42.4981 101.083 42.5004Z"
        fill={fill}
      />
      <path
        d="M101.942 43.3659C101.95 43.526 101.957 43.6861 101.965 43.8462L101.946 43.8662C101.657 43.8603 101.368 43.8533 101.079 43.8474C101.078 43.692 101.076 43.5378 101.075 43.3824L101.094 43.3647C101.377 43.3647 101.659 43.3659 101.942 43.3659Z"
        fill={fill}
      />
      <path
        d="M101.967 43.846C102.908 43.8436 103.849 43.8413 104.79 43.8401L104.787 43.8613C104.789 44.1297 104.789 44.398 104.79 44.6664C103.848 44.6676 102.905 44.67 101.964 44.6711C101.959 44.4028 101.953 44.1344 101.948 43.866L101.967 43.846Z"
        fill={fill}
      />
      <path
        d="M104.79 44.6666C104.788 44.3983 104.788 44.1299 104.787 43.8615C105.631 43.8603 106.475 43.8603 107.319 43.8591C107.319 44.1299 107.319 44.4018 107.319 44.6725L107.324 44.6914C106.478 44.689 105.631 44.6867 104.786 44.6843L104.79 44.6666Z"
        fill={fill}
      />
      <path
        d="M97.0206 37.0846C97.934 37.0834 98.8463 37.0822 99.7598 37.0811C99.768 37.9251 99.7762 38.7691 99.7845 39.6142L99.7562 39.6131C98.8451 39.6142 97.934 39.6154 97.023 39.6178L97.0194 39.6142C97.0194 38.7726 97.0182 37.9321 97.0182 37.0905C97.0159 37.0893 97.0206 37.0846 97.0206 37.0846Z"
        fill="#CFE3E7"
      />
      <path
        d="M121.195 53.6636C120.926 53.6624 120.655 53.6612 120.385 53.6589C120.384 53.3893 120.383 53.1197 120.382 52.8502C120.655 52.849 120.927 52.8466 121.2 52.8455C121.198 53.1186 121.196 53.3916 121.195 53.6636Z"
        fill={outline}
      />
      <path
        d="M24.8395 47.4341C24.8383 46.5206 24.8371 45.6084 24.8359 44.6961C25.7541 44.6926 26.6711 44.689 27.5892 44.6843L27.5928 44.6855C27.5881 45.6025 27.5845 46.5183 27.5798 47.4353C26.6652 47.4353 25.7529 47.4341 24.8395 47.4341Z"
        fill="#F1F1F1"
      />
      <path
        d="M22.3037 47.4338C23.1477 47.4338 23.9929 47.4338 24.8369 47.4338C24.8357 48.2578 24.8345 49.0806 24.8334 49.9046C23.9905 49.9046 23.1477 49.9046 22.3049 49.9046C22.3061 49.0806 22.3049 48.2578 22.3037 47.4338Z"
        fill="#B3D6DD"
      />
      <path
        d="M58.5423 49.9095C58.8142 49.9084 59.0861 49.9084 59.358 49.9072L59.3792 49.906C59.378 50.883 59.3769 51.86 59.3757 52.8371C59.0991 52.8394 58.8213 52.8418 58.5446 52.8441C58.5376 52.8347 58.5293 52.8253 58.5234 52.8159C58.5293 51.8483 58.5364 50.8795 58.5423 49.9095Z"
        fill={fill}
      />
      <path
        d="M55.7799 53.6577C55.7799 53.3869 55.7799 53.115 55.7811 52.8443C56.5886 52.8419 57.3961 52.8419 58.2036 52.8384C58.3095 52.8384 58.4167 52.8254 58.5226 52.8184C58.5297 52.8278 58.5367 52.8372 58.5438 52.8454C58.5403 53.1232 58.5367 53.401 58.532 53.6788C57.6139 53.6788 56.6945 53.6788 55.7764 53.6777L55.7799 53.6577Z"
        fill={fill}
      />
      <path
        d="M53.2477 54.1366C53.2465 53.9835 53.2465 53.8293 53.2453 53.6763C54.0893 53.6704 54.9333 53.6645 55.7773 53.6575L55.775 53.6775C55.775 53.8317 55.775 53.9859 55.775 54.1389C54.931 54.146 54.0881 54.1542 53.2441 54.1613C53.2465 54.1625 53.2477 54.1366 53.2477 54.1366Z"
        fill="#CFE3E7"
      />
      <path
        d="M50.3525 55.0066C50.3572 54.717 50.362 54.4286 50.3655 54.1391C51.326 54.1379 52.2866 54.1379 53.2471 54.1367L53.2447 54.1626C53.2459 54.4392 53.2483 54.717 53.2495 54.9937C53.1223 54.9995 52.9964 55.0101 52.8692 55.0113C52.0358 55.0172 51.2036 55.0219 50.3702 55.0266L50.3525 55.0066Z"
        fill={fill}
      />
      <path
        d="M59.3774 47.4316C59.5281 47.4328 59.6776 47.434 59.8283 47.4352L59.8483 47.4328C59.8424 48.258 59.8365 49.0831 59.8306 49.9083C59.68 49.9071 59.5293 49.9071 59.3786 49.906L59.3574 49.9071C59.3645 49.082 59.3715 48.2568 59.3774 47.4316Z"
        fill="#CFE3E7"
      />
      <path
        d="M59.8277 47.4354C59.8266 46.5184 59.8254 45.6014 59.8242 44.6856L59.8454 44.6667C60.1173 44.6691 60.3904 44.6703 60.6623 44.6726C60.6718 44.6821 60.68 44.6903 60.6894 44.6997C60.6835 45.6096 60.6765 46.5196 60.6706 47.4307C60.3963 47.4318 60.122 47.433 59.8478 47.4354H59.8277Z"
        fill={fill}
      />
      <path
        d="M94.4953 63.9762C93.5383 63.9751 92.5813 63.9727 91.6243 63.9715L91.6055 63.9539C91.6102 63.6796 91.6149 63.4042 91.6196 63.1299C92.579 63.1334 93.5371 63.1381 94.4965 63.1417C94.4953 63.4124 94.4953 63.682 94.4941 63.9527L94.4953 63.9762Z"
        fill={fill}
      />
      <path
        d="M84.1959 63.975C83.2389 63.9726 82.2807 63.9714 81.3237 63.9691L81.3037 63.9514C81.3072 63.6783 81.3108 63.4064 81.3143 63.1333C82.2748 63.1357 83.2354 63.1392 84.1959 63.1415C84.1947 63.4111 84.1947 63.6807 84.1936 63.9514L84.1959 63.975Z"
        fill={fill}
      />
      <path
        d="M60.659 63.1404C60.3882 63.1416 60.1187 63.144 59.8479 63.1451L59.8291 63.1275C59.8362 62.1693 59.8421 61.2111 59.8491 60.2529C60.1199 60.2541 60.3894 60.2541 60.6602 60.2553C60.6672 61.2099 60.6755 62.1634 60.6825 63.1181C60.6743 63.1239 60.6672 63.1322 60.659 63.1404Z"
        fill={fill}
      />
      <path
        d="M59.3704 63.9632C59.3657 63.6901 59.3621 63.4181 59.3574 63.145L59.3751 63.1262C59.5258 63.1262 59.6764 63.1262 59.8271 63.1262L59.8459 63.1439C59.8412 63.417 59.8377 63.6901 59.833 63.962C59.6788 63.9632 59.5246 63.9632 59.3704 63.9632Z"
        fill={fill}
      />
      <path
        d="M53.2471 63.1452C53.2471 63.4159 53.2483 63.6855 53.2483 63.9562C52.2924 63.9621 51.3354 63.968 50.3796 63.9739L50.3584 63.9538C50.3619 63.6796 50.3666 63.4053 50.3702 63.131C51.3295 63.1287 52.2889 63.1263 53.2483 63.1228L53.2471 63.1452Z"
        fill={fill}
      />
      <path
        d="M115.14 63.975C114.183 63.9738 113.226 63.9715 112.269 63.9703L112.249 63.9526C112.253 63.6795 112.256 63.4076 112.26 63.1345C113.22 63.1381 114.18 63.1404 115.14 63.1439C115.139 63.4135 115.139 63.6831 115.138 63.9526C115.138 63.9514 115.14 63.975 115.14 63.975Z"
        fill={fill}
      />
      <path
        d="M40.0755 63.9632C40.0707 63.6901 40.0672 63.4181 40.0625 63.145L40.0802 63.1262C41.0383 63.1321 41.9953 63.1368 42.9535 63.1427C42.9524 63.4123 42.9524 63.6818 42.9512 63.9514L42.9535 63.9749C41.9942 63.9714 41.0348 63.9667 40.0755 63.9632Z"
        fill={fill}
      />
      <path
        d="M22.3078 63.9764C21.3508 63.9752 20.3938 63.974 19.4368 63.9717L19.418 63.954C19.4239 63.6786 19.4286 63.4031 19.4344 63.1277C20.3926 63.1324 21.3508 63.1371 22.3078 63.1418C22.3066 63.4126 22.3066 63.6833 22.3055 63.9528C22.3055 63.954 22.3078 63.9764 22.3078 63.9764Z"
        fill={fill}
      />
      <path
        d="M32.601 63.9702C31.6616 63.9691 30.7211 63.9679 29.7817 63.9667C29.7817 63.9667 29.7617 63.9455 29.7617 63.9467C29.7653 63.6783 29.7688 63.4088 29.7723 63.1404C30.7152 63.1427 31.6592 63.1451 32.6021 63.1463C32.601 63.4135 32.5998 63.6819 32.5998 63.9491L32.601 63.9702Z"
        fill={fill}
      />
      <path
        d="M104.789 63.9691C103.849 63.9679 102.909 63.9668 101.969 63.9656C101.962 63.9585 101.955 63.9515 101.948 63.9444C101.952 63.6772 101.956 63.41 101.96 63.1416C102.904 63.1428 103.847 63.1439 104.79 63.1451C104.789 63.4123 104.787 63.6795 104.786 63.9468C104.787 63.9479 104.789 63.9691 104.789 63.9691Z"
        fill={fill}
      />
      <path
        d="M110.066 44.6888C110.073 45.6046 110.08 46.5193 110.086 47.4351L110.069 47.4304C109.154 47.4304 108.238 47.4316 107.321 47.4316C107.322 46.5181 107.322 45.6046 107.323 44.6912L107.318 44.6724C108.234 44.6771 109.15 44.683 110.066 44.6888Z"
        fill="#F1F0F0"
      />
      <path
        d="M27.581 63.9762C26.664 63.9762 25.7482 63.9762 24.8313 63.975L24.8324 63.9527C24.8313 63.6819 24.8313 63.4112 24.8301 63.1416C25.7494 63.1369 26.6688 63.1334 27.5881 63.1287C27.5928 63.4041 27.5963 63.6796 27.601 63.955C27.5952 63.9621 27.5881 63.9691 27.581 63.9762Z"
        fill={fill}
      />
      <path
        d="M37.9063 63.145C37.9016 63.4181 37.8981 63.6901 37.8934 63.9632C36.9729 63.9679 36.0524 63.9714 35.1318 63.9761L35.133 63.9537C35.133 63.683 35.1318 63.4123 35.1318 63.1415C36.05 63.1368 36.9693 63.1321 37.8875 63.1262L37.9063 63.145Z"
        fill={fill}
      />
      <path
        d="M48.1824 63.9668C47.2643 63.9704 46.3449 63.9739 45.4268 63.9774L45.4279 63.9551C45.4279 63.6831 45.4279 63.4124 45.4279 63.1405C46.3496 63.1393 47.2713 63.1381 48.193 63.137C48.1965 63.4077 48.2012 63.6784 48.2048 63.948L48.1824 63.9668Z"
        fill={fill}
      />
      <path
        d="M55.7822 63.1264C54.9382 63.1323 54.0942 63.1394 53.249 63.1452L53.2514 63.1241C53.2514 62.1671 53.2514 61.2112 53.2514 60.2542C54.0918 60.253 54.9335 60.2507 55.774 60.2495L55.7799 60.2554C55.7799 61.2124 55.781 62.1694 55.7822 63.1264Z"
        fill="#CFE3E7"
      />
      <path
        d="M58.5213 60.2528C57.6066 60.2528 56.692 60.254 55.7774 60.254L55.7715 60.2481C55.7738 59.4076 55.775 58.566 55.7774 57.7255C56.6896 57.7243 57.6019 57.7243 58.5142 57.7231C58.5213 57.8385 58.5319 57.955 58.533 58.0704C58.5389 58.7979 58.5424 59.5253 58.5472 60.2528H58.5213Z"
        fill="#CFE3E7"
      />
      <path
        d="M59.3604 63.145C59.0849 63.138 58.8095 63.1309 58.534 63.1239C58.5305 62.1669 58.527 61.2099 58.5234 60.2528H58.5493C58.8189 60.2517 59.0885 60.2517 59.358 60.2505C59.3651 61.2087 59.371 62.1669 59.378 63.1262L59.3604 63.145Z"
        fill={fill}
      />
      <path
        d="M99.7779 63.9611C99.7568 63.9623 99.7344 63.9634 99.7132 63.9658C98.815 63.9693 97.9169 63.9729 97.0187 63.9764L97.0199 63.954C97.0188 63.6833 97.0188 63.4126 97.0176 63.143C97.9357 63.1383 98.8539 63.1324 99.7732 63.1277C99.7756 63.4055 99.7768 63.6833 99.7779 63.9611Z"
        fill={fill}
      />
      <path
        d="M99.7791 63.961C99.7779 63.6832 99.7768 63.4054 99.7744 63.1264L99.7768 63.1252C100.051 63.1311 100.326 63.1382 100.601 63.1441C100.605 63.4172 100.609 63.6891 100.614 63.9622V63.961C100.335 63.9622 100.057 63.9622 99.7791 63.961Z"
        fill={outline}
      />
      <path
        d="M110.067 63.9728C109.15 63.9728 108.232 63.974 107.315 63.974L107.316 63.9516C107.315 63.6821 107.315 63.4113 107.313 63.1418C108.234 63.1382 109.155 63.1359 110.075 63.1323C110.079 63.4066 110.083 63.6797 110.087 63.954L110.067 63.9728Z"
        fill={fill}
      />
      <path
        d="M120.368 63.9705C119.449 63.9729 118.531 63.9752 117.614 63.9776L117.615 63.9552C117.615 63.6845 117.614 63.4126 117.614 63.1418C118.532 63.1371 119.451 63.1324 120.369 63.1277L120.388 63.1465C120.388 63.4161 120.388 63.6845 120.388 63.954L120.368 63.9705Z"
        fill={fill}
      />
      <path
        d="M121.212 63.1252C121.214 62.1682 121.217 61.2112 121.22 60.2542C121.388 60.2542 121.556 60.2542 121.723 60.2542C121.724 61.2135 121.725 62.1717 121.727 63.131L121.729 63.1322C121.557 63.131 121.385 63.1299 121.214 63.1287L121.212 63.1252Z"
        fill="#F1EFEF"
      />
      <path
        d="M17.232 63.9716C16.3326 63.9728 15.4345 63.974 14.5352 63.9751L14.5363 63.9528C14.5363 63.6844 14.5363 63.4148 14.5375 63.1464L14.5352 63.1252C15.4392 63.1311 16.3432 63.1358 17.2473 63.1417C17.2496 63.4113 17.2508 63.6809 17.2531 63.9504C17.2461 63.9575 17.239 63.9645 17.232 63.9716Z"
        fill={fill}
      />
      <path
        d="M89.4232 63.9666C88.5227 63.969 87.6222 63.9713 86.7217 63.9737L86.7229 63.9513C86.7229 63.6818 86.7217 63.4122 86.7217 63.1427C87.6257 63.1415 88.5286 63.1403 89.4326 63.1379C89.4361 63.4075 89.4397 63.6759 89.4432 63.9454L89.4232 63.9666Z"
        fill={fill}
      />
      <path
        d="M60.666 43.3835C60.6696 43.533 60.6731 43.6813 60.6766 43.8308C60.6707 43.839 60.6637 43.8461 60.6566 43.8532C60.3871 43.8555 60.1163 43.8567 59.8468 43.859L59.8291 43.8414C59.8338 43.686 59.8373 43.5306 59.842 43.3752C60.1175 43.3776 60.3918 43.38 60.666 43.3835Z"
        fill={fill}
      />
      <path
        d="M18.1279 49.9083C18.2821 49.9083 18.4363 49.9083 18.5905 49.9083L18.607 49.9048C18.6 50.8794 18.5917 51.8541 18.5847 52.8288C18.434 52.8323 18.2833 52.837 18.1326 52.8405C18.1315 51.8635 18.1291 50.8865 18.1279 49.9083Z"
        fill="#F1F0F0"
      />
      <path
        d="M17.25 53.6623C17.2524 53.3951 17.2559 53.1267 17.2582 52.8595C17.5502 52.8536 17.8409 52.8477 18.1328 52.8418C18.1281 53.1125 18.1234 53.3845 18.1175 53.6552C17.8291 53.6587 17.5408 53.6611 17.2524 53.6646L17.25 53.6623Z"
        fill={outline}
      />
      <path
        d="M14.5389 54.14C14.5389 53.9858 14.5389 53.8316 14.5389 53.6774C15.4429 53.6727 16.3469 53.6668 17.2522 53.6621L17.2545 53.6645C17.2533 53.8234 17.2522 53.9835 17.251 54.1424C16.3458 54.1483 15.4406 54.1541 14.5353 54.16C14.5342 54.16 14.5389 54.14 14.5389 54.14Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.6102 47.4329C18.8833 47.4318 19.1564 47.4318 19.4295 47.4306L19.4519 47.4282C19.4448 47.5342 19.4342 47.6413 19.433 47.7472C19.4283 48.4665 19.426 49.1869 19.4224 49.9061C19.1517 49.9061 18.881 49.9049 18.6102 49.9049L18.5938 49.9084C18.5985 49.0833 18.6043 48.2581 18.6102 47.4329Z"
        fill={fill}
      />
      <path
        d="M97.0248 52.823C97.0248 51.8518 97.0236 50.8795 97.0236 49.9084C97.9359 49.9084 98.8494 49.9072 99.7616 49.9072C99.7628 50.8784 99.764 51.8495 99.7652 52.8206C98.8517 52.8289 97.9371 52.8371 97.0225 52.8453L97.0248 52.823Z"
        fill="#F1F1F1"
      />
      <path
        d="M94.4936 49.9046C94.4924 49.0806 94.4912 48.2578 94.4912 47.4338C95.3352 47.435 96.178 47.4362 97.022 47.4374C97.0232 48.2614 97.0244 49.0842 97.0256 49.9082C96.1816 49.907 95.3376 49.9058 94.4936 49.9046Z"
        fill="#B3D6DD"
      />
      <path
        d="M94.4901 53.6608C94.4901 53.3889 94.4889 53.117 94.4889 52.8451C95.3329 52.8368 96.1769 52.8298 97.0209 52.8215L97.0197 52.8427C97.0197 53.1146 97.0185 53.3866 97.0185 53.6573C96.1745 53.6632 95.3305 53.6691 94.4854 53.675L94.4901 53.6608Z"
        fill={fill}
      />
      <path
        d="M91.6104 54.1376C91.6139 53.9858 91.6174 53.8339 91.6209 53.6821C92.5779 53.675 93.535 53.668 94.492 53.6609L94.4884 53.6762C94.4896 53.8292 94.4896 53.9834 94.4908 54.1365C93.5302 54.1365 92.5697 54.1376 91.6104 54.1376Z"
        fill="#F1F0F0"
      />
      <path
        d="M89.4365 55.0016C89.4401 54.7214 89.4448 54.4413 89.4483 54.1611C89.7296 54.1611 90.0098 54.1611 90.2911 54.1611C90.2958 54.4413 90.3005 54.7214 90.3041 55.0004L90.2923 55.0098C90.0098 55.0098 89.7285 55.011 89.4459 55.011L89.4365 55.0016Z"
        fill={outline}
      />
      <path
        d="M90.791 55.0158C90.7945 54.7274 90.7981 54.4402 90.8004 54.1518C91.0712 54.1471 91.3419 54.1424 91.6115 54.1377C91.6068 54.4273 91.6021 54.7168 91.5974 55.0076C91.329 55.0111 91.0606 55.0147 90.7922 55.017L90.791 55.0158Z"
        fill={outline}
      />
      <path
        d="M90.3059 55.0007C90.4672 55.0054 90.6273 55.0113 90.7885 55.016L90.7909 55.0172C90.785 55.9201 90.7803 56.8241 90.7744 57.727C90.6214 57.7258 90.4684 57.7258 90.3142 57.7246C90.3071 56.8194 90.3 55.9142 90.293 55.009L90.3059 55.0007Z"
        fill="#F1F1F1"
      />
      <path
        d="M86.724 54.9924C87.6292 54.996 88.5345 54.9983 89.4409 55.0019L89.4503 55.0113C89.4444 55.9165 89.4373 56.8205 89.4314 57.7257C88.5309 57.7257 87.6293 57.7257 86.7287 57.7257C86.7264 56.8229 86.724 55.9188 86.7217 55.016L86.724 54.9924Z"
        fill="#F1F1F1"
      />
      <path
        d="M79.1462 49.9072C79.4169 49.9072 79.6877 49.9072 79.9584 49.9072C79.9643 50.8783 79.9714 51.8483 79.9772 52.8194C79.9714 52.8288 79.9643 52.8382 79.9584 52.8465C79.6818 52.8429 79.4052 52.8406 79.1285 52.8371C79.1274 51.86 79.1262 50.883 79.125 49.906L79.1462 49.9072Z"
        fill={fill}
      />
      <path
        d="M80.4767 52.8335C80.4838 53.1089 80.4897 53.3855 80.4967 53.661L80.4779 53.6822C80.3084 53.6798 80.1377 53.6775 79.9682 53.6751C79.9658 53.3985 79.9635 53.123 79.96 52.8464C79.967 52.8382 79.9729 52.8288 79.9788 52.8193C80.1459 52.824 80.3107 52.8288 80.4767 52.8335Z"
        fill={fill}
      />
      <path
        d="M81.3164 53.6703C81.3176 53.8257 81.3188 53.9799 81.32 54.1353L81.3011 54.1541C81.0304 54.1483 80.7597 54.1436 80.4889 54.1377C80.4854 53.9858 80.4818 53.8351 80.4795 53.6833L80.4983 53.6621C80.7702 53.6645 81.0433 53.6668 81.3164 53.6703Z"
        fill={fill}
      />
      <path
        d="M84.2005 54.1623C84.1969 54.4319 84.1934 54.7003 84.191 54.9698C83.2305 54.9851 82.27 54.9993 81.3082 55.0146C81.3047 54.7273 81.3024 54.4401 81.2988 54.1541L81.3177 54.1353C82.1723 54.1388 83.0269 54.1411 83.8814 54.1458C83.9886 54.1458 84.0945 54.1564 84.2005 54.1623Z"
        fill={fill}
      />
      <path
        d="M81.3098 55.0137C82.2703 54.9984 83.2308 54.9843 84.1926 54.969C84.1961 54.9843 84.1984 54.9984 84.2008 55.0137C84.1984 55.9166 84.1973 56.8194 84.1949 57.7223C83.2379 57.7235 82.2821 57.7247 81.3251 57.7258C81.3192 56.823 81.3145 55.9189 81.3086 55.0161L81.3098 55.0137Z"
        fill="#F1F1F1"
      />
      <path
        d="M84.1943 57.7232C84.1967 56.8204 84.1979 55.9175 84.2002 55.0146C85.0407 55.0146 85.88 55.0158 86.7205 55.0158C86.7228 55.9187 86.7252 56.8227 86.7275 57.7256L86.7228 57.7303C85.8812 57.7291 85.0395 57.7291 84.1979 57.7279L84.1943 57.7232Z"
        fill="#CFE3E7"
      />
      <path
        d="M79.1438 47.4339C79.1438 48.2579 79.145 49.0831 79.145 49.9071L79.1238 49.9059C78.2068 49.9071 77.2899 49.9082 76.3729 49.9094L76.3682 49.9047C76.3682 49.0819 76.3682 48.2579 76.3682 47.4351L76.3741 47.4292C77.2899 47.4304 78.2068 47.4327 79.1226 47.4339H79.1438Z"
        fill="#CFE3E7"
      />
      <path
        d="M24.8345 63.1417C24.8357 63.4125 24.8357 63.6832 24.8369 63.9528C23.9929 63.9528 23.1501 63.9528 22.3061 63.9528C22.3072 63.682 22.3072 63.4113 22.3084 63.1417L22.3037 63.1252C23.1489 63.1252 23.9941 63.1252 24.8404 63.1252L24.8345 63.1417Z"
        fill={fill}
      />
      <path
        d="M14.541 63.1462C14.541 63.4146 14.541 63.6842 14.5398 63.9526C13.697 63.9526 12.853 63.9526 12.0102 63.9537C12.0113 63.683 12.0113 63.4134 12.0125 63.1427L12.0078 63.1262C12.8518 63.1333 13.6958 63.1392 14.541 63.1462Z"
        fill={fill}
      />
      <path
        d="M107.316 63.1417C107.317 63.4112 107.317 63.682 107.318 63.9515C106.474 63.9504 105.63 63.9492 104.786 63.9468C104.787 63.6796 104.788 63.4124 104.79 63.144L104.786 63.1276C105.631 63.1264 106.475 63.1252 107.32 63.124C107.32 63.1252 107.316 63.1417 107.316 63.1417Z"
        fill={fill}
      />
      <path
        d="M35.1304 63.1415C35.1304 63.4123 35.1316 63.683 35.1316 63.9537C34.2876 63.9526 33.4448 63.9502 32.6008 63.949C32.602 63.6818 32.6031 63.4134 32.6031 63.1462L32.5996 63.1297C33.4448 63.1286 34.2888 63.1274 35.134 63.1262L35.1304 63.1415Z"
        fill={fill}
      />
      <path
        d="M97.022 63.1417C97.0232 63.4125 97.0232 63.6832 97.0244 63.9528C96.1804 63.9528 95.3376 63.9528 94.4936 63.9528C94.4947 63.682 94.4947 63.4113 94.4959 63.1417L94.4912 63.1252C95.3364 63.1252 96.1816 63.1252 97.0279 63.1252L97.022 63.1417Z"
        fill={fill}
      />
      <path
        d="M86.7215 63.1439C86.7215 63.4134 86.7226 63.683 86.7226 63.9526C85.8786 63.9526 85.0358 63.9526 84.1918 63.9526C84.193 63.683 84.193 63.4123 84.1942 63.1427L84.1895 63.1262C85.0346 63.1262 85.8798 63.1262 86.7238 63.1274C86.725 63.1274 86.7215 63.1439 86.7215 63.1439Z"
        fill={fill}
      />
      <path
        d="M45.4271 63.1405C45.4271 63.4124 45.4271 63.6831 45.4271 63.955C44.6019 63.9538 43.7767 63.9527 42.9516 63.9515C42.9527 63.6819 42.9528 63.4124 42.9539 63.1416L42.9492 63.1252C43.7756 63.124 44.6031 63.124 45.4294 63.1228L45.4271 63.1405Z"
        fill={fill}
      />
      <path
        d="M117.612 63.1405C117.612 63.4112 117.614 63.6832 117.614 63.9539C116.788 63.9527 115.963 63.9515 115.138 63.9515C115.139 63.682 115.139 63.4124 115.14 63.1429L115.136 63.1264C115.962 63.1252 116.79 63.1252 117.616 63.124L117.612 63.1405Z"
        fill={fill}
      />
      <path
        d="M97.022 47.4364C96.178 47.4352 95.3352 47.434 94.4912 47.4328C94.4924 46.5194 94.4936 45.6071 94.4947 44.6948L94.4936 44.6689C95.3387 44.676 96.1828 44.6842 97.0279 44.6913C97.0279 45.6048 97.0268 46.5182 97.0268 47.4317L97.022 47.4364Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.133 43.3538C35.1307 43.0749 35.1283 42.7971 35.126 42.5181C35.9417 42.5134 36.7563 42.5075 37.5721 42.5016C37.6792 42.5004 37.7851 42.4957 37.8922 42.4922L37.9122 42.5098C37.9075 42.7982 37.904 43.0866 37.8993 43.375C36.9776 43.3774 36.0547 43.3786 35.133 43.3809C35.1319 43.3797 35.133 43.3538 35.133 43.3538Z"
        fill={fill}
      />
      <path
        d="M37.9004 39.6133C38.1712 39.6145 38.4419 39.6145 38.7127 39.6156L38.7374 39.6133C38.7315 39.7298 38.7233 39.8464 38.7221 39.9617C38.7174 40.8081 38.7138 41.6544 38.7091 42.5008C38.4419 42.5043 38.1759 42.5067 37.9087 42.5102L37.8887 42.4925C37.8922 41.5332 37.8957 40.5726 37.9004 39.6133Z"
        fill={fill}
      />
      <path
        d="M29.7666 44.6597C29.769 44.3913 29.7713 44.1229 29.7737 43.8545C30.7165 43.8498 31.6594 43.8463 32.6023 43.8416C32.6023 43.8416 32.6011 43.8627 32.6011 43.8616C32.6023 44.1299 32.6023 44.3972 32.6035 44.6655C31.6641 44.6714 30.726 44.6761 29.7866 44.682C29.7807 44.675 29.7737 44.6667 29.7666 44.6597Z"
        fill={fill}
      />
      <path
        d="M32.6043 44.6653C32.6031 44.3969 32.6031 44.1297 32.602 43.8613C33.446 43.8542 34.29 43.8472 35.134 43.8401L35.1304 43.8554C35.1304 44.1261 35.1316 44.398 35.1316 44.6688C34.2876 44.6735 33.4436 44.6794 32.5996 44.6841L32.6043 44.6653Z"
        fill={fill}
      />
      <path
        d="M35.1295 43.3799C36.0512 43.3776 36.9741 43.3764 37.8958 43.374H37.8969C37.8922 43.5294 37.8887 43.6848 37.884 43.8402C36.9647 43.8449 36.0453 43.8508 35.126 43.8555L35.1295 43.8402C35.1307 43.6871 35.1307 43.5329 35.1295 43.3799Z"
        fill="#F1F1F1"
      />
      <path
        d="M39.2249 37.0811C39.232 37.9251 39.2402 38.7691 39.2473 39.6131L39.2202 39.6119C39.059 39.6119 38.8977 39.6119 38.7376 39.6119L38.7129 39.6142C38.72 38.7702 38.727 37.9262 38.7341 37.0822C38.8977 37.0822 39.0613 37.0822 39.2249 37.0811Z"
        fill="#CFE2E5"
      />
      <path
        d="M94.4877 42.4972C94.4877 41.5367 94.4877 40.5774 94.4865 39.6168L94.4901 39.6133C95.3317 39.6133 96.1745 39.6133 97.0162 39.6133L97.0197 39.6168C97.0185 40.5774 97.0162 41.5379 97.015 42.4984C96.1722 42.5067 95.3282 42.5161 94.4854 42.5243L94.4877 42.4972Z"
        fill="#CFE3E7"
      />
      <path
        d="M19.418 49.9071C19.4215 49.1878 19.4239 48.4674 19.4286 47.7482C19.4297 47.6423 19.4403 47.5351 19.4474 47.4292C20.3985 47.4316 21.3508 47.4327 22.3019 47.4351C22.3031 48.2591 22.3043 49.0819 22.3055 49.9059L22.3008 49.9106C21.3485 49.9094 20.3973 49.9082 19.445 49.9071H19.418Z"
        fill="#CFE3E7"
      />
      <path
        d="M97.0222 39.6134C96.1806 39.6134 95.3377 39.6134 94.4961 39.6134C94.4961 38.7717 94.4973 37.9312 94.4973 37.0896C95.3389 37.0896 96.1794 37.0896 97.021 37.0896C97.021 37.9312 97.021 38.7717 97.0222 39.6134Z"
        fill="#B3D6DD"
      />
      <path
        d="M14.541 63.1465C13.697 63.1394 12.853 63.1336 12.0078 63.1265C12.009 62.1695 12.009 61.2125 12.0102 60.2567L12.0149 60.252C12.8553 60.252 13.6958 60.252 14.5363 60.252C14.5375 61.2101 14.5375 62.1671 14.5386 63.1253L14.541 63.1465Z"
        fill="#CFE3E7"
      />
      <path
        d="M79.1275 47.4354C78.2117 47.4342 77.2947 47.4318 76.3789 47.4307C76.3766 46.5196 76.3742 45.6073 76.373 44.6962C77.29 44.6926 78.207 44.6891 79.1252 44.6868C79.1252 45.6026 79.1264 46.5184 79.1275 47.4354Z"
        fill="#F1F1F1"
      />
      <path
        d="M63.5467 43.8555C63.5467 44.1274 63.5455 44.3982 63.5455 44.6701L63.5479 44.6948C62.5956 44.696 61.6421 44.6972 60.6898 44.6984C60.6804 44.6889 60.6721 44.6807 60.6627 44.6713C60.6615 44.3982 60.6604 44.1251 60.6592 43.8532C60.6662 43.8461 60.6721 43.8379 60.6792 43.8308C61.5279 43.8367 62.3766 43.8426 63.2253 43.8496C63.3324 43.8496 63.4396 43.8532 63.5467 43.8555Z"
        fill={fill}
      />
      <path
        d="M63.5461 44.6699C64.3901 44.677 65.2341 44.684 66.0781 44.6911C66.0781 45.6046 66.0781 46.5192 66.0781 47.4326C65.2341 47.4326 64.3889 47.4326 63.5449 47.4326C63.5461 46.5204 63.5473 45.6069 63.5484 44.6946L63.5461 44.6699Z"
        fill="#CFE3E7"
      />
      <path
        d="M66.0771 47.4338C66.0771 46.5203 66.0771 45.6057 66.0771 44.6922C66.9941 44.6887 67.9123 44.6852 68.8293 44.6816C68.8293 44.6816 68.8305 44.6828 68.8316 44.6828C68.8316 44.8358 68.8316 44.9877 68.8328 45.1407C68.8046 45.1513 68.7763 45.1619 68.7481 45.1725C67.7098 45.0136 66.8917 45.3726 66.5386 46.2366C66.3903 46.5992 66.4209 47.0335 66.3703 47.4349C66.2714 47.4338 66.1749 47.4338 66.0771 47.4338Z"
        fill="#F1EFEF"
      />
      <path
        d="M28.8887 47.4342C28.8887 46.5136 28.8899 45.5943 28.8899 44.6738C29.1806 44.6691 29.4725 44.6644 29.7633 44.6597C29.7703 44.6679 29.7774 44.675 29.7833 44.6832C29.7774 44.7997 29.768 44.9175 29.7668 45.034C29.7609 45.8356 29.7562 46.6372 29.7515 47.44C29.4725 47.4377 29.1935 47.4353 28.9146 47.433L28.8887 47.4342Z"
        fill={fill}
      />
      <path
        d="M27.5771 47.4353C27.5819 46.5183 27.5854 45.6013 27.5901 44.6855C27.8703 44.6832 28.1504 44.6808 28.4306 44.6785C28.4317 45.5978 28.4341 46.5171 28.4353 47.4353L28.4153 47.4329C28.1445 47.4341 27.8726 47.4341 27.6019 47.4353H27.5771Z"
        fill={fill}
      />
      <path
        d="M28.4333 47.4352C28.5851 47.4352 28.7382 47.434 28.89 47.434C28.89 47.434 28.9171 47.4316 28.9159 47.4316C28.9089 48.2556 28.903 49.0796 28.8971 49.9036C28.7417 49.906 28.5863 49.9071 28.4298 49.9095C28.4239 49.0843 28.418 48.2592 28.4121 47.434L28.4333 47.4352Z"
        fill="#CFE3E7"
      />
      <path
        d="M14.5363 60.2517C13.6958 60.2517 12.8553 60.2517 12.0148 60.2517C12.0148 59.4101 12.0137 58.5696 12.0137 57.728C12.8565 57.728 13.6981 57.728 14.541 57.7268C14.5398 58.5673 14.5398 59.4089 14.5386 60.2494L14.5363 60.2517Z"
        fill="#B3D6DD"
      />
      <path
        d="M38.7363 39.6133C38.8975 39.6133 39.0588 39.6133 39.2189 39.6133C39.2271 40.5738 39.2342 41.5344 39.2424 42.4937C39.0694 42.5114 38.8964 42.5279 38.7245 42.5455C38.7186 42.5302 38.7139 42.5161 38.708 42.5008C38.7115 41.6544 38.7151 40.8081 38.721 39.9617C38.7221 39.8452 38.7315 39.7298 38.7363 39.6133Z"
        fill="#F1EFEF"
      />
      <path
        d="M14.5373 57.7267C14.5362 56.8226 14.5338 55.9186 14.5326 55.0145C14.5326 55.0145 14.5303 54.9898 14.5303 54.991C15.4367 54.9981 16.3442 55.0063 17.2506 55.0134C17.2494 55.9162 17.2483 56.8203 17.2471 57.7231C16.3442 57.7255 15.4414 57.7255 14.5373 57.7267Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.958 63.1416C101.955 63.4088 101.95 63.676 101.946 63.9444C101.656 63.9502 101.366 63.9573 101.075 63.9632C101.08 63.6901 101.083 63.417 101.087 63.1439C101.377 63.1427 101.666 63.1416 101.956 63.1404L101.958 63.1416Z"
        fill={outline}
      />
      <path
        d="M89.4471 63.9466C89.4436 63.6771 89.4401 63.4087 89.4365 63.1391V63.1379C89.7261 63.1426 90.0157 63.1474 90.3052 63.1521C90.3088 63.4204 90.3123 63.6888 90.3158 63.9584C90.0251 63.9537 89.7355 63.9502 89.4471 63.9466Z"
        fill={outline}
      />
      <path
        d="M48.2012 63.9492C48.1977 63.6784 48.193 63.4077 48.1895 63.1381V63.137C48.479 63.1428 48.7698 63.1476 49.0593 63.1534C49.0617 63.4195 49.0641 63.6843 49.0664 63.9504C49.0511 63.9551 49.0358 63.961 49.0205 63.9657C48.7474 63.9598 48.4743 63.9539 48.2012 63.9492Z"
        fill={outline}
      />
      <path
        d="M29.7717 63.1391C29.7682 63.4075 29.7646 63.6771 29.7611 63.9454C29.4715 63.9502 29.182 63.9537 28.8936 63.9584C28.8971 63.6888 28.9006 63.4204 28.9041 63.1509C29.1937 63.1462 29.4833 63.1426 29.7729 63.1379C29.7717 63.1379 29.7717 63.1391 29.7717 63.1391Z"
        fill={outline}
      />
      <path
        d="M17.2559 63.9502C17.2535 63.6807 17.2524 63.4111 17.25 63.1416L17.2512 63.1404C17.5408 63.1439 17.8291 63.1463 18.1187 63.1498C18.1223 63.4205 18.1258 63.6901 18.1293 63.9608C17.8374 63.9573 17.5466 63.9538 17.2559 63.9502Z"
        fill={outline}
      />
      <path
        d="M42.9549 52.8486C42.9549 53.1182 42.9537 53.3877 42.9537 53.6573L42.9549 53.6785C41.9943 53.675 41.0338 53.6726 40.0732 53.6691C40.0756 53.3924 40.078 53.1146 40.0803 52.838C41.0385 52.8321 41.9967 52.8262 42.956 52.8215L42.9549 52.8486Z"
        fill={fill}
      />
      <path
        d="M45.4308 53.6787C45.4296 53.8305 45.4284 53.9824 45.4284 54.1342L45.4308 54.1601C44.6056 54.1542 43.7816 54.1483 42.9565 54.1413C42.9565 53.9871 42.9553 53.8329 42.9553 53.6787L42.9541 53.6575C43.7793 53.6645 44.6056 53.6716 45.4308 53.6787Z"
        fill="#CFE3E7"
      />
      <path
        d="M48.1952 54.1494C48.1975 54.4319 48.2011 54.7156 48.2034 54.9993L48.1893 55.0216C47.2664 55.0134 46.3447 55.0051 45.4219 54.9969C45.4242 54.7179 45.4254 54.4401 45.4278 54.1611L45.4254 54.1353C46.3495 54.1388 47.2723 54.1447 48.1952 54.1494Z"
        fill={fill}
      />
      <path
        d="M49.0499 55.0089C49.0558 55.9141 49.0629 56.8193 49.0688 57.7245H49.0393C48.7615 57.7269 48.4837 57.728 48.2048 57.7304C48.2 56.8275 48.1942 55.9235 48.1895 55.0207C48.1895 55.0207 48.2036 54.9995 48.2036 54.9983C48.4861 55.0018 48.7674 55.0053 49.0499 55.0089Z"
        fill={fill}
      />
      <path
        d="M49.5283 57.7269C49.5342 56.824 49.5401 55.9212 49.546 55.0171C49.8144 55.0136 50.0827 55.0089 50.3523 55.0054L50.3711 55.0266C50.3676 55.9259 50.3653 56.8264 50.3617 57.7257C50.091 57.7257 49.8202 57.7245 49.5495 57.7245L49.5283 57.7269Z"
        fill={fill}
      />
      <path
        d="M49.0735 57.7246C49.2265 57.7258 49.3807 57.727 49.5338 57.7281L49.555 57.7258C49.5502 58.5698 49.5444 59.4126 49.5396 60.2566C49.3807 60.2578 49.2218 60.2578 49.0629 60.259C49.0464 60.2578 49.03 60.2566 49.0146 60.2543C49.0241 59.4114 49.0347 58.5686 49.0441 57.7258C49.0441 57.7246 49.0735 57.7246 49.0735 57.7246Z"
        fill="#CFE2E5"
      />
      <path
        d="M27.6057 63.955C27.601 63.6796 27.5975 63.4041 27.5928 63.1287H27.5939C27.8682 63.1345 28.1425 63.1393 28.4156 63.1451C28.4203 63.4182 28.4238 63.6902 28.4285 63.9633V63.9621C28.1543 63.9609 27.88 63.9574 27.6057 63.955Z"
        fill={outline}
      />
      <path
        d="M19.4307 63.1274C19.4248 63.4028 19.4201 63.6783 19.4142 63.9537C19.1411 63.9561 18.8668 63.9596 18.5938 63.962V63.9632C18.5985 63.6901 18.602 63.4181 18.6067 63.145C18.881 63.1392 19.1552 63.1333 19.4307 63.1262V63.1274Z"
        fill={outline}
      />
      <path
        d="M50.3725 63.1309C50.3689 63.4051 50.3642 63.6794 50.3607 63.9537C50.0864 63.9572 49.8122 63.9607 49.5391 63.9643C49.5391 63.6865 49.5402 63.4098 49.5402 63.132C49.818 63.132 50.0947 63.132 50.3725 63.1309Z"
        fill={outline}
      />
      <path
        d="M81.3141 63.1333C81.3105 63.4064 81.307 63.6783 81.3035 63.9514C81.0292 63.9573 80.7549 63.9632 80.4807 63.9679L80.4795 63.9667C80.4842 63.6913 80.4889 63.417 80.4936 63.1415C80.7667 63.1404 81.0398 63.1368 81.3141 63.1333C81.3141 63.1333 81.3141 63.1345 81.3141 63.1333Z"
        fill={outline}
      />
      <path
        d="M91.6149 63.1299C91.6102 63.4042 91.6054 63.6796 91.6007 63.9539C91.3276 63.9574 91.0545 63.9598 90.7803 63.9633V63.9645C90.785 63.6914 90.7885 63.4195 90.7932 63.1464C91.0663 63.1405 91.3406 63.1346 91.6149 63.1299Z"
        fill={outline}
      />
      <path
        d="M110.088 63.9537C110.084 63.6794 110.08 63.4063 110.076 63.132C110.354 63.132 110.632 63.132 110.908 63.1309C110.905 63.4051 110.901 63.6782 110.898 63.9513C110.627 63.9525 110.358 63.9525 110.088 63.9537Z"
        fill={outline}
      />
      <path
        d="M111.423 63.1263C111.253 63.1287 111.082 63.1299 110.91 63.1322C110.911 62.1729 110.913 61.2135 110.914 60.2542C111.081 60.2542 111.248 60.2542 111.416 60.2542C111.419 61.2112 111.422 62.1682 111.425 63.124L111.423 63.1263Z"
        fill="#F1EFEF"
      />
      <path
        d="M112.26 63.1334C112.256 63.4065 112.253 63.6784 112.249 63.9515C111.983 63.9362 111.629 64.0174 111.479 63.8773C111.344 63.7526 111.432 63.3853 111.423 63.1252C111.423 63.1252 111.424 63.1228 111.425 63.1228C111.703 63.1275 111.982 63.131 112.26 63.1334Z"
        fill={outline}
      />
      <path
        d="M120.387 63.9528C120.387 63.6832 120.387 63.4148 120.387 63.1452C120.661 63.1382 120.935 63.1323 121.211 63.1252L121.212 63.1276C121.211 63.4066 121.21 63.6867 121.208 63.9657C120.934 63.961 120.66 63.9563 120.387 63.9528Z"
        fill={outline}
      />
      <path
        d="M94.4912 42.5242C95.334 42.516 96.178 42.5065 97.0209 42.4983C97.0209 42.4983 97.0173 42.5207 97.0173 42.5195C97.0197 42.7961 97.022 43.0739 97.0256 43.3505C96.1827 43.3588 95.3387 43.367 94.4959 43.3753L94.4995 43.3541C94.4959 43.0786 94.4936 42.802 94.4912 42.5242Z"
        fill={fill}
      />
      <path
        d="M97.0279 44.6926C96.1828 44.6856 95.3387 44.6773 94.4936 44.6702C94.4936 44.3995 94.4947 44.1276 94.4947 43.8568L94.4912 43.8416C95.3352 43.8474 96.1804 43.8533 97.0244 43.8592C97.0244 44.1299 97.0244 44.4019 97.0244 44.6726L97.0279 44.6926Z"
        fill={fill}
      />
      <path
        d="M68.834 45.1397C68.834 44.9866 68.834 44.8348 68.834 44.6818C69.1094 44.6759 69.3849 44.6712 69.6603 44.6653L69.6815 44.6853C69.6709 45.0184 69.6603 45.3515 69.6509 45.6835C69.3802 45.5211 69.1106 45.3586 68.8399 45.195C68.8422 45.1762 68.8399 45.1573 68.834 45.1397Z"
        fill={fill}
      />
      <path
        d="M60.6591 43.8533C60.6603 44.1264 60.6615 44.3995 60.6626 44.6714C60.3907 44.669 60.1176 44.6678 59.8457 44.6655C59.8469 44.3959 59.8481 44.1275 59.8492 43.858C60.1188 43.8568 60.3884 43.8544 60.6591 43.8533Z"
        fill={outline}
      />
      <path
        d="M117.615 49.9083C117.614 50.8783 117.614 51.8471 117.612 52.817V52.8441C116.787 52.8382 115.961 52.8311 115.136 52.8252C115.136 51.8541 115.137 50.8818 115.137 49.9107L115.143 49.9048C115.966 49.906 116.79 49.9071 117.615 49.9083Z"
        fill="#CFE3E7"
      />
      <path
        d="M69.6484 45.6837C69.659 45.3506 69.6696 45.0175 69.679 44.6855C69.8309 44.6808 69.9827 44.6761 70.1358 44.6714C70.1381 45.1469 70.1452 45.6237 70.1417 46.0992C70.1405 46.2287 70.1063 46.3594 70.0875 46.4889C69.9404 46.2217 69.7944 45.9533 69.6484 45.6837Z"
        fill="#F1EFEF"
      />
      <path
        d="M40.0645 63.145C39.7902 63.1392 39.5159 63.1333 39.2405 63.1262C39.2381 62.168 39.2358 61.211 39.2334 60.2528L39.2581 60.254C39.5265 60.2528 39.7937 60.2517 40.0621 60.2505C40.0692 61.2087 40.075 62.1669 40.0821 63.1262L40.0645 63.145Z"
        fill={fill}
      />
      <path
        d="M38.728 63.13C38.4537 63.1359 38.1806 63.1406 37.9063 63.1465L37.8887 63.1277C37.8957 62.1695 37.9016 61.2113 37.9087 60.252C38.1759 60.2531 38.4431 60.2543 38.7115 60.2555L38.7338 60.2543C38.7315 61.2125 38.7291 62.1707 38.728 63.13Z"
        fill={fill}
      />
      <path
        d="M39.233 60.2541C39.0659 60.2541 38.8975 60.2541 38.7304 60.2541L38.708 60.2553C38.7162 59.4101 38.7257 58.5661 38.7339 57.7209C38.8987 57.7209 39.0635 57.7197 39.2283 57.7197C39.2342 57.8268 39.2424 57.9328 39.2436 58.0399C39.2495 58.778 39.253 59.5172 39.2577 60.2553L39.233 60.2541Z"
        fill="#D5DBDB"
      />
      <path
        d="M80.4944 63.1427C80.4897 63.4181 80.485 63.6924 80.4803 63.9678C80.3096 63.9678 80.1401 63.969 79.9694 63.969C79.9647 63.6936 79.9588 63.4181 79.9541 63.1427C79.9612 63.1345 79.9682 63.1274 79.9741 63.1191C80.1401 63.1191 80.3072 63.1203 80.4732 63.1203C80.4803 63.1286 80.4873 63.1356 80.4944 63.1427Z"
        fill={fill}
      />
      <path
        d="M121.207 63.9658C121.208 63.6868 121.209 63.4067 121.211 63.1277C121.382 63.1289 121.554 63.13 121.725 63.1312C121.724 63.4102 121.724 63.688 121.723 63.967C121.552 63.9658 121.379 63.9658 121.207 63.9658Z"
        fill={fill}
      />
      <path
        d="M120.37 63.1263C119.452 63.131 118.534 63.1357 117.615 63.1404L117.62 63.1239C117.618 62.1669 117.617 61.2111 117.614 60.2541C118.534 60.2541 119.453 60.2529 120.372 60.2529C120.37 61.2111 120.37 62.1693 120.37 63.1263Z"
        fill="#F1F1F1"
      />
      <path
        d="M115.141 57.7231C115.965 57.7243 116.789 57.7255 117.613 57.7267C117.613 58.5695 117.613 59.4123 117.613 60.254C116.789 60.254 115.966 60.254 115.142 60.254C115.142 59.4111 115.141 58.5671 115.141 57.7231C115.141 57.7231 115.14 57.7243 115.141 57.7231Z"
        fill="#B3D6DD"
      />
      <path
        d="M115.136 57.7246C115.138 58.5686 115.138 59.4114 115.139 60.2554C114.181 60.2554 113.222 60.2543 112.264 60.2543L112.244 60.2554C112.245 59.4114 112.245 58.5686 112.246 57.7246L112.267 57.727C113.224 57.7258 114.181 57.7258 115.136 57.7246Z"
        fill="#CFE3E7"
      />
      <path
        d="M112.26 55.0242C112.263 55.9247 112.265 56.8263 112.267 57.7268L112.247 57.7245C111.975 57.7257 111.705 57.7257 111.433 57.7268C111.423 57.7268 111.413 57.7268 111.403 57.7257C111.412 56.8252 111.42 55.9258 111.429 55.0253C111.7 55.0183 111.971 55.0112 112.241 55.0042C112.24 55.0053 112.26 55.0242 112.26 55.0242Z"
        fill={fill}
      />
      <path
        d="M115.137 53.6774C115.137 53.8316 115.137 53.9869 115.137 54.1412C114.176 54.1412 113.216 54.1423 112.255 54.1423L112.254 54.1412C112.257 53.9858 112.261 53.8316 112.266 53.6762C113.224 53.6715 114.182 53.6656 115.14 53.6609L115.137 53.6774Z"
        fill="#F1F1F1"
      />
      <path
        d="M112.239 55.0054C111.968 55.0124 111.697 55.0195 111.427 55.0265C111.412 55.0195 111.398 55.0101 111.387 54.9995C111.385 54.7193 111.383 54.4391 111.382 54.159C111.395 54.1496 111.41 54.1413 111.425 54.1343C111.701 54.1366 111.977 54.1402 112.253 54.1425L112.254 54.1437C112.248 54.4297 112.243 54.717 112.239 55.0054Z"
        fill={outline}
      />
      <path
        d="M115.136 52.8254C115.961 52.8313 116.787 52.8384 117.612 52.8443C117.614 53.1162 117.615 53.3869 117.615 53.6588C116.79 53.6647 115.963 53.6706 115.138 53.6765L115.142 53.66C115.14 53.3881 115.139 53.1162 115.138 52.8443L115.136 52.8254Z"
        fill={fill}
      />
      <path
        d="M18.6069 63.1452C18.6022 63.4183 18.5986 63.6903 18.5939 63.9634C18.4385 63.9622 18.2832 63.961 18.1278 63.9598C18.1243 63.6891 18.1207 63.4195 18.1172 63.1488L18.1337 63.1276C18.2855 63.1264 18.4362 63.1264 18.588 63.1252L18.6069 63.1452Z"
        fill={fill}
      />
      <path
        d="M90.7957 63.145C90.791 63.4181 90.7875 63.6901 90.7828 63.9632C90.6262 63.9608 90.4709 63.9596 90.3143 63.9573C90.3108 63.6889 90.3072 63.4205 90.3037 63.1509L90.3202 63.1297C90.472 63.1286 90.6239 63.1274 90.7757 63.1262C90.7769 63.1262 90.7957 63.145 90.7957 63.145Z"
        fill={fill}
      />
      <path
        d="M101.088 63.1453C101.083 63.4184 101.08 63.6915 101.075 63.9646C100.921 63.9646 100.767 63.9646 100.613 63.9646C100.608 63.6915 100.604 63.4196 100.6 63.1465L100.617 63.1277C100.768 63.1277 100.919 63.1277 101.069 63.1277L101.088 63.1453Z"
        fill={fill}
      />
      <path
        d="M49.5416 63.132C49.5416 63.4098 49.5404 63.6865 49.5404 63.9643C49.3839 63.9596 49.2261 63.9537 49.0696 63.949C49.0672 63.6829 49.0649 63.4181 49.0625 63.1521L49.0778 63.1309C49.2332 63.132 49.3874 63.132 49.5416 63.132Z"
        fill={fill}
      />
      <path
        d="M28.4251 63.9632C28.4203 63.6901 28.4168 63.4181 28.4121 63.145L28.4298 63.1262C28.5816 63.1274 28.7335 63.1286 28.8853 63.1297L28.9018 63.1509C28.8983 63.4205 28.8947 63.6889 28.8912 63.9584C28.737 63.9596 28.5804 63.962 28.4251 63.9632Z"
        fill={fill}
      />
      <path
        d="M42.9547 52.8219C41.9965 52.8278 41.0383 52.8337 40.079 52.8384L40.0778 52.8372C40.0731 51.859 40.0684 50.882 40.0625 49.9038L40.079 49.9073C41.036 49.9073 41.9918 49.9085 42.9488 49.9085C42.9512 50.8808 42.9535 51.852 42.9547 52.8219Z"
        fill="#F1F1F1"
      />
      <path
        d="M40.0836 47.4329C40.0836 48.258 40.0824 49.0832 40.0824 49.9095L40.0659 49.906C39.7952 49.906 39.5245 49.9072 39.2537 49.9072C39.2526 49.0832 39.2502 48.2604 39.249 47.4364C39.5221 47.4364 39.7952 47.4364 40.0683 47.4364L40.0836 47.4329Z"
        fill={fill}
      />
      <path
        d="M97.0244 43.8589C96.1804 43.853 95.3352 43.8471 94.4912 43.8413C94.4924 43.6859 94.4936 43.5317 94.4947 43.3763C95.3376 43.368 96.1816 43.3598 97.0244 43.3516L97.0232 43.3775C97.022 43.5305 97.022 43.6847 97.0209 43.8377L97.0244 43.8589Z"
        fill="#CFE3E7"
      />
      <path
        d="M38.7282 42.5454C38.9012 42.5278 39.0742 42.5113 39.2461 42.4937C39.2508 42.7856 39.2543 43.0763 39.2591 43.3683C39.2508 43.3753 39.2437 43.3836 39.2355 43.3906C39.0636 43.3871 38.8918 43.3824 38.7188 43.3788C38.7223 43.101 38.7246 42.8232 38.7282 42.5454Z"
        fill={fill}
      />
      <path
        d="M40.0643 47.4352C39.7912 47.4352 39.5181 47.4352 39.2451 47.4352H39.2168C39.2192 46.5217 39.2215 45.6095 39.2239 44.696C39.2321 44.6866 39.2403 44.6784 39.2486 44.6689C39.524 44.6713 39.8007 44.6748 40.0761 44.6772C40.0726 45.5977 40.069 46.5159 40.0643 47.4352Z"
        fill={fill}
      />
      <path
        d="M39.2544 43.8557C39.2532 44.1276 39.252 44.3983 39.2508 44.6702C39.2426 44.6796 39.2344 44.6879 39.2261 44.6973C39.0613 44.6926 38.8965 44.6879 38.7317 44.6832C38.7258 44.4077 38.7188 44.1323 38.7129 43.858L38.7317 43.838C38.8989 43.8368 39.0672 43.8356 39.2344 43.8345C39.2402 43.8404 39.2473 43.8474 39.2544 43.8557Z"
        fill={fill}
      />
      <path
        d="M17.2506 55.0136C16.3442 55.0066 15.4367 54.9983 14.5303 54.9913C14.5303 54.7135 14.5315 54.4368 14.5315 54.159C15.4367 54.1531 16.3419 54.1472 17.2459 54.1414L17.2647 54.1626C17.2659 54.4392 17.2683 54.7158 17.2695 54.9924L17.2506 55.0136Z"
        fill={fill}
      />
      <path
        d="M39.2332 43.8333C39.066 43.8345 38.8977 43.8357 38.7305 43.8369C38.727 43.685 38.7223 43.532 38.7188 43.3801C38.8906 43.3837 39.0625 43.3884 39.2355 43.3919C39.2343 43.5379 39.2332 43.6862 39.2332 43.8333Z"
        fill="#F1EFEF"
      />
      <path
        d="M68.8468 57.7258C68.8421 58.5698 68.8362 59.4126 68.8303 60.2566C67.9121 60.2566 66.9951 60.2554 66.077 60.2554L66.0723 60.2507C66.0734 59.4091 66.0746 58.5674 66.0758 57.7246C66.9916 57.7258 67.9062 57.7258 68.822 57.727C68.822 57.7281 68.8468 57.7258 68.8468 57.7258Z"
        fill="#CFE3E7"
      />
      <path
        d="M60.6815 63.1159C60.6745 62.1613 60.6662 61.2078 60.6592 60.2531L60.6804 60.2578C61.635 60.2555 62.5908 60.2543 63.5455 60.252C63.5455 61.209 63.5455 62.1648 63.5455 63.1218C62.5908 63.1206 61.6362 63.1183 60.6815 63.1159Z"
        fill="#F1F1F1"
      />
      <path
        d="M66.0734 57.7256C66.0722 58.5672 66.071 59.4089 66.0699 60.2517C65.2282 60.2529 64.3866 60.2529 63.5449 60.2541C63.5449 59.4124 63.5449 58.5708 63.5449 57.7291C64.3889 57.7279 65.2306 57.7268 66.0734 57.7256Z"
        fill="#B3D6DD"
      />
      <path
        d="M76.373 60.2543C76.3742 59.4114 76.3742 58.5686 76.3754 57.7246C77.2936 57.7258 78.2105 57.7258 79.1287 57.727L79.1487 57.7246C79.1499 58.5686 79.1499 59.4114 79.1511 60.2554L79.1311 60.2543C78.2117 60.2543 77.2924 60.2543 76.373 60.2543Z"
        fill="#CFE3E7"
      />
      <path
        d="M79.9572 63.1428C79.6841 63.1404 79.4098 63.1369 79.1368 63.1345C79.1344 62.174 79.1332 61.2146 79.1309 60.2541L79.1509 60.2553C79.4193 60.2541 79.6876 60.2541 79.9572 60.2529C79.9643 61.2088 79.9713 62.1634 79.9784 63.1192C79.9713 63.1263 79.9643 63.1345 79.9572 63.1428Z"
        fill={fill}
      />
      <path
        d="M76.3682 54.9948C76.3705 54.717 76.3729 54.4392 76.3752 54.1614V54.1367C77.2969 54.1391 78.2198 54.1414 79.1415 54.1438C79.1462 54.431 79.1509 54.7182 79.1556 55.0054L79.1368 55.0243C78.3304 55.0207 77.5241 55.0172 76.7166 55.0125C76.6001 55.0113 76.4847 55.0007 76.3682 54.9948Z"
        fill={fill}
      />
      <path
        d="M79.125 57.7269C79.1274 56.8264 79.1297 55.9247 79.1332 55.0242L79.1521 55.0054C79.4216 55.0113 79.69 55.0171 79.9596 55.023C79.9596 55.9235 79.9608 56.824 79.9608 57.7257C79.6888 57.7257 79.4169 57.7257 79.145 57.7257C79.145 57.7245 79.125 57.7269 79.125 57.7269Z"
        fill={fill}
      />
      <path
        d="M73.8445 54.1447C72.9004 54.147 71.9564 54.1482 71.0123 54.1506L71.0088 54.1459C71.0135 53.9881 71.0182 53.8316 71.0229 53.6738C71.9623 53.6738 72.9016 53.675 73.8421 53.675C73.8433 53.8316 73.8433 53.9881 73.8445 54.1447Z"
        fill="#F1F1F1"
      />
      <path
        d="M73.8432 54.1449C73.842 53.9883 73.842 53.8318 73.8408 53.6764C73.8608 53.6705 73.8808 53.6658 73.8997 53.6599C74.7248 53.6658 75.5488 53.6717 76.374 53.6788C76.374 53.8318 76.3728 53.9848 76.3728 54.1367V54.1614C75.5488 54.1637 74.7248 54.1649 73.9009 54.1673C73.882 54.1602 73.862 54.152 73.8432 54.1449Z"
        fill="#CFE3E7"
      />
      <path
        d="M71.0081 54.95C70.7245 54.97 70.4408 54.99 70.1583 55.01L70.1465 54.9994C70.1477 54.7193 70.15 54.4391 70.1512 54.1601C70.4361 54.1554 70.7221 54.1507 71.007 54.146L71.0105 54.1507C71.0093 54.4167 71.0081 54.6839 71.0081 54.95Z"
        fill={outline}
      />
      <path
        d="M69.6696 55.0252C69.6661 55.9257 69.6625 56.8274 69.659 57.7279C69.3883 57.7267 69.1175 57.7267 68.8468 57.7255L68.8232 57.7279C68.8303 56.825 68.8374 55.9222 68.8444 55.0193C69.1128 55.0146 69.3812 55.0111 69.6484 55.0063L69.6696 55.0252Z"
        fill={fill}
      />
      <path
        d="M70.1534 54.1614C70.1522 54.4415 70.1499 54.7217 70.1487 55.0007C69.9886 55.0089 69.8297 55.0171 69.6696 55.0254L69.6484 55.0077C69.6531 54.7193 69.659 54.4309 69.6637 54.1425C69.8215 54.1425 69.9792 54.1414 70.1369 54.1414L70.1534 54.1614Z"
        fill={fill}
      />
      <path
        d="M115.134 49.9107C115.134 50.8818 115.133 51.8541 115.133 52.8252L115.137 52.8453C114.182 52.8394 113.226 52.8347 112.271 52.8288C112.264 51.8541 112.256 50.8794 112.249 49.9048L112.266 49.9083C113.221 49.9095 114.178 49.9107 115.134 49.9107Z"
        fill="#F1F1F1"
      />
      <path
        d="M112.253 49.9048C112.26 50.8794 112.268 51.8541 112.276 52.8288C112.268 52.8358 112.263 52.8429 112.256 52.85C111.979 52.8405 111.701 52.8323 111.424 52.8229C111.42 51.8506 111.415 50.8771 111.409 49.9048L111.437 49.906C111.709 49.906 111.981 49.906 112.253 49.9048Z"
        fill={fill}
      />
      <path
        d="M110.903 47.4342C110.908 48.2594 110.914 49.0845 110.92 49.9097L110.903 49.9062C110.633 49.9062 110.363 49.9073 110.093 49.9073C110.086 49.0822 110.077 48.2558 110.07 47.4307L110.087 47.4354C110.359 47.4342 110.631 47.4342 110.903 47.4342Z"
        fill={fill}
      />
      <path
        d="M111.404 49.9048C111.409 50.8771 111.414 51.8506 111.42 52.8229L111.413 52.8288C111.247 52.83 111.082 52.8311 110.916 52.8323C110.91 51.8565 110.904 50.8818 110.899 49.906L110.917 49.9095C111.078 49.9083 111.241 49.9071 111.404 49.9048Z"
        fill="#F1EFEF"
      />
      <path
        d="M71.0146 49.9048C71.8562 49.906 72.6978 49.9154 73.5383 49.9013C73.7879 49.8966 73.8503 49.979 73.8467 50.218C73.8326 51.0879 73.8397 51.9589 73.8397 52.8288C72.9027 52.83 71.9669 52.8312 71.0299 52.8324C71.024 52.6475 71.0134 52.4616 71.0122 52.2768C71.004 51.4845 70.9981 50.6935 70.9922 49.9013L71.0146 49.9048Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.373 49.9095C77.29 49.9084 78.207 49.9072 79.124 49.906C79.1252 50.883 79.1263 51.86 79.1275 52.8371L79.1263 52.8382C78.2082 52.8394 77.29 52.8406 76.373 52.8418V52.8206C76.373 51.8506 76.373 50.8807 76.373 49.9095Z"
        fill="#F1F1F1"
      />
      <path
        d="M76.3716 47.4365C76.3716 48.2594 76.3716 49.0833 76.3716 49.9062C75.6488 49.9062 74.9249 49.9003 74.2021 49.9109C73.9855 49.9144 73.8878 49.872 73.8949 49.6236C73.9125 48.9892 73.9125 48.3535 73.8949 47.7191C73.8878 47.4707 73.9867 47.4283 74.2033 47.4318C74.9249 47.4424 75.6488 47.4354 76.3716 47.4365Z"
        fill="#B3D6DD"
      />
      <path
        d="M71.0335 52.8321C71.9705 52.831 72.9063 52.8298 73.8433 52.8286C73.8633 52.8357 73.8833 52.8427 73.9034 52.8486C73.9034 53.1182 73.9034 53.3889 73.9045 53.6585C73.8845 53.6644 73.8645 53.6691 73.8457 53.675C72.9063 53.675 71.967 53.6738 71.0264 53.6738L71.0088 53.6538C71.01 53.3877 71.0111 53.1205 71.0123 52.8545C71.0182 52.8474 71.0253 52.8404 71.0335 52.8321Z"
        fill={fill}
      />
      <path
        d="M71.0214 47.435C71.0202 48.2578 71.0179 49.0818 71.0167 49.9046L70.9955 49.9011C70.72 49.9023 70.4434 49.9046 70.168 49.9058C70.1739 49.1254 70.1809 48.3438 70.1868 47.5633C70.2586 47.521 70.3281 47.4468 70.4022 47.4409C70.6012 47.4244 70.8024 47.4374 71.0025 47.4386L71.0214 47.435Z"
        fill={fill}
      />
      <path
        d="M73.9006 53.6599C73.9006 53.3904 73.9006 53.1196 73.8994 52.8501C74.7246 52.8407 75.5498 52.8312 76.3749 52.823V52.8442C76.3737 53.1173 76.3726 53.3904 76.3702 53.6646L76.3737 53.68C75.5509 53.6717 74.7258 53.6658 73.9006 53.6599Z"
        fill={fill}
      />
      <path
        d="M71.0004 47.4386C70.8003 47.4374 70.599 47.4245 70.4 47.441C70.3247 47.4469 70.2564 47.521 70.1846 47.5634C70.1528 47.561 70.1211 47.5587 70.0893 47.5552C70.0881 47.1997 70.0869 46.8442 70.0869 46.4899C70.1057 46.3604 70.1399 46.2309 70.1411 46.1002C70.1446 45.6247 70.1387 45.1479 70.1352 44.6724C70.4306 44.6735 70.7249 44.6747 71.0204 44.6747C71.0145 45.5964 71.0074 46.5169 71.0004 47.4386Z"
        fill={fill}
      />
      <path
        d="M97.0211 42.4984C97.0223 41.5379 97.0235 40.5774 97.0258 39.6168C97.9369 39.6156 98.848 39.6145 99.7603 39.6133C99.7673 40.4573 99.7744 41.3001 99.7815 42.1441C99.7827 42.2606 99.7838 42.3772 99.785 42.4937C99.6591 42.4973 99.5331 42.5031 99.406 42.5043C98.6102 42.5102 97.8133 42.5161 97.0176 42.522C97.0176 42.5208 97.0211 42.4984 97.0211 42.4984Z"
        fill="#F1F1F1"
      />
      <path
        d="M100.595 42.51C100.6 42.7984 100.603 43.0868 100.608 43.3741H100.607C100.331 43.3776 100.056 43.3811 99.7805 43.3847H99.7793C99.7805 43.0868 99.7816 42.789 99.784 42.4912C100.055 42.4983 100.324 42.5042 100.595 42.51Z"
        fill={outline}
      />
      <path
        d="M101.074 43.3823C101.075 43.5377 101.077 43.6919 101.078 43.8473C100.923 43.8449 100.77 43.8426 100.616 43.8402C100.613 43.6848 100.608 43.5294 100.604 43.3752H100.606C100.761 43.3776 100.918 43.38 101.074 43.3823Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.949 43.866C101.953 44.1344 101.959 44.4028 101.964 44.6712C101.672 44.67 101.38 44.6677 101.088 44.6665C101.086 44.3934 101.083 44.1203 101.081 43.8484C101.371 43.8531 101.659 43.8602 101.949 43.866Z"
        fill={outline}
      />
      <path
        d="M101.961 44.6715C102.902 44.6703 103.845 44.6679 104.787 44.6667L104.782 44.6856C104.782 45.6014 104.782 46.5184 104.783 47.4342C103.842 47.4342 102.9 47.433 101.959 47.433C101.958 46.5113 101.959 45.592 101.961 44.6715Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.781 47.4339C104.781 46.5181 104.781 45.6011 104.78 44.6853C105.627 44.6877 106.472 44.69 107.318 44.6924C107.317 45.6058 107.317 46.5193 107.316 47.4327L107.311 47.4374C106.468 47.4374 105.627 47.4386 104.784 47.4386L104.781 47.4339Z"
        fill="#CFE3E7"
      />
      <path
        d="M24.8359 49.9046C24.8371 49.0806 24.8383 48.2578 24.8395 47.4338C25.7529 47.4338 26.6652 47.435 27.5786 47.435H27.6045C27.5987 48.2602 27.5916 49.0854 27.5857 49.9105C26.6711 49.9093 25.7565 49.9093 24.8418 49.9082L24.8359 49.9046Z"
        fill="#CFE3E7"
      />
      <path
        d="M22.3072 49.9048C23.1501 49.9048 23.9929 49.9048 24.8357 49.9048L24.8404 49.9095C24.8404 50.8806 24.8404 51.8518 24.8404 52.8229C23.9952 52.8229 23.1489 52.8229 22.3037 52.8229C22.3037 51.8518 22.3037 50.8806 22.3037 49.9095L22.3072 49.9048Z"
        fill="#CFE3E7"
      />
      <path
        d="M59.3764 49.906C59.5271 49.9071 59.6777 49.9071 59.8284 49.9083L59.8449 49.9048C59.8378 50.8794 59.8296 51.8541 59.8225 52.8288C59.673 52.8323 59.5235 52.8347 59.374 52.8382V52.837C59.374 51.8612 59.3752 50.883 59.3764 49.906Z"
        fill="#F1F0F0"
      />
      <path
        d="M58.5342 53.6786C58.5377 53.4008 58.5412 53.123 58.546 52.8452C58.8226 52.8428 59.1004 52.8405 59.377 52.8381C59.377 52.8381 59.3782 52.8393 59.377 52.8393C59.3711 53.1124 59.3664 53.3867 59.3605 53.6598C59.0863 53.6668 58.8108 53.6739 58.5365 53.6798L58.5342 53.6786Z"
        fill={outline}
      />
      <path
        d="M55.7799 54.1401C55.7799 53.9859 55.7799 53.8317 55.7799 53.6787C56.6981 53.6787 57.6174 53.6787 58.5356 53.6799L58.5379 53.6811C58.5391 53.8317 58.5391 53.9836 58.5403 54.1343C58.525 54.1401 58.5108 54.1496 58.4979 54.1602C57.5903 54.1602 56.6839 54.1602 55.7764 54.1602L55.7799 54.1401Z"
        fill="#F1F0F0"
      />
      <path
        d="M53.2537 54.9936C53.2526 54.7169 53.2502 54.4391 53.249 54.1625C54.093 54.1554 54.9358 54.1472 55.7799 54.1401L55.7763 54.1602C55.7763 54.438 55.7751 54.7146 55.7751 54.9924L55.7775 55.0171C54.937 55.0171 54.0966 55.0171 53.2561 55.0183L53.2537 54.9936Z"
        fill={fill}
      />
      <path
        d="M50.3633 57.7268C50.3668 56.8274 50.3692 55.9269 50.3727 55.0276C51.2061 55.0229 52.0383 55.0182 52.8717 55.0123C52.9989 55.0111 53.126 55.0005 53.252 54.9946L53.2531 55.0182C53.252 55.921 53.2508 56.8239 53.2496 57.7268C52.2938 57.7256 51.3379 57.7244 50.3821 57.7232C50.3809 57.722 50.3633 57.7268 50.3633 57.7268Z"
        fill="#F1F1F1"
      />
      <path
        d="M59.8468 47.4329C60.121 47.4317 60.3953 47.4305 60.6696 47.4282L60.6931 47.427C60.6849 47.5329 60.6719 47.6389 60.6707 47.746C60.666 48.4664 60.6637 49.1856 60.6602 49.906C60.3882 49.906 60.1175 49.906 59.8456 49.9049L59.8291 49.9084C59.835 49.0832 59.8409 48.2581 59.8468 47.4329Z"
        fill={fill}
      />
      <path
        d="M63.5456 44.6948C63.5445 45.6071 63.5433 46.5205 63.5421 47.4328C62.5922 47.4305 61.6422 47.4281 60.6935 47.4258L60.6699 47.4269C60.6758 46.517 60.6829 45.6059 60.6888 44.696C61.6399 44.6972 62.5933 44.696 63.5456 44.6948Z"
        fill="#F1F1F1"
      />
      <path
        d="M94.4943 63.1416C93.5349 63.1381 92.5767 63.1334 91.6174 63.1298H91.6162C91.6186 62.1705 91.6209 61.2123 91.6245 60.2529C92.5803 60.2541 93.5361 60.2553 94.4919 60.2565C94.4908 61.2135 94.4908 62.1693 94.4896 63.1263C94.4896 63.1251 94.4943 63.1416 94.4943 63.1416Z"
        fill="#F1F0F0"
      />
      <path
        d="M84.1961 63.1428C83.2355 63.1405 82.275 63.1369 81.3145 63.1346C81.3168 62.174 81.318 61.2147 81.3203 60.2542C82.2785 60.2542 83.2379 60.2542 84.1961 60.2553C84.1949 61.2123 84.1925 62.1693 84.1914 63.1275L84.1961 63.1428Z"
        fill="#F1F1F1"
      />
      <path
        d="M60.6625 60.2541C60.3917 60.2529 60.1222 60.2529 59.8514 60.2517L59.835 60.2552C59.8408 59.4124 59.8456 58.5684 59.8514 57.7256C60.1234 57.7268 60.3953 57.7279 60.6672 57.7279C60.6731 58.5719 60.6778 59.4148 60.6837 60.2588L60.6625 60.2541Z"
        fill={fill}
      />
      <path
        d="M59.3774 63.1262C59.3704 62.168 59.3645 61.2098 59.3574 60.2505L59.3739 60.254C59.5269 60.254 59.68 60.254 59.833 60.254L59.8495 60.2505C59.8424 61.2087 59.8365 62.1669 59.8295 63.125C59.6776 63.1262 59.5281 63.1262 59.3774 63.1262Z"
        fill="#F1F1F1"
      />
      <path
        d="M53.2494 60.2541C53.2494 61.2111 53.2494 62.1669 53.2494 63.1239C52.2901 63.1263 51.3307 63.1287 50.3713 63.1322C50.3666 62.1728 50.3619 61.2123 50.3584 60.2529L50.3761 60.2576C51.3331 60.2553 52.2912 60.2541 53.2494 60.2541Z"
        fill="#F1F0F0"
      />
      <path
        d="M112.266 60.2529C113.224 60.2529 114.182 60.2541 115.14 60.2541C115.139 61.2111 115.137 62.1681 115.135 63.1251L115.14 63.1416C114.18 63.1393 113.22 63.1357 112.26 63.1322C112.262 62.174 112.264 61.2135 112.266 60.2529Z"
        fill="#F1F1F1"
      />
      <path
        d="M40.0825 63.1262C40.0754 62.168 40.0696 61.2098 40.0625 60.2505L40.079 60.254C41.0372 60.254 41.9953 60.2552 42.9547 60.2552C42.9535 61.2122 42.9535 62.168 42.9523 63.125L42.9571 63.1415C41.9977 63.1368 41.0395 63.1321 40.0825 63.1262Z"
        fill="#F1F1F1"
      />
      <path
        d="M22.3091 63.1416C21.3509 63.1369 20.3928 63.1322 19.4357 63.1275H19.4346C19.4381 62.1693 19.4405 61.2111 19.444 60.2529C20.3986 60.2541 21.3533 60.2553 22.3079 60.2565C22.3068 61.2135 22.3068 62.1693 22.3056 63.1263L22.3091 63.1416Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.6035 63.1463C31.6606 63.144 30.7165 63.1416 29.7737 63.1405V63.1393C29.7713 62.1788 29.769 61.2182 29.7666 60.2577C30.7118 60.2565 31.6559 60.2553 32.6011 60.2542C32.6011 61.2123 32.5999 62.1705 32.5999 63.1287L32.6035 63.1463Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.792 63.1452C103.849 63.144 102.905 63.1428 101.962 63.1417L101.96 63.1405C101.95 63.1005 101.942 63.0592 101.933 63.0192C101.939 62.0987 101.944 61.1794 101.95 60.2589C102.897 60.2577 103.843 60.2553 104.79 60.2542C104.788 61.2123 104.788 62.1705 104.787 63.1287L104.792 63.1452Z"
        fill="#F1F1F1"
      />
      <path
        d="M110.07 47.4307C110.078 48.2558 110.086 49.0822 110.093 49.9073L110.07 49.9062C109.154 49.9062 108.238 49.9073 107.321 49.9073C107.32 49.0834 107.318 48.2594 107.318 47.4365C107.318 47.4365 107.322 47.4318 107.323 47.4318C108.239 47.4318 109.155 47.4307 110.07 47.4307Z"
        fill="#CFE3E7"
      />
      <path
        d="M27.594 63.1288C26.6746 63.1336 25.7553 63.1371 24.8359 63.1418L24.8406 63.1253C24.8395 62.1683 24.8395 61.2125 24.8383 60.2555C25.7541 60.2543 26.6711 60.2531 27.5869 60.252C27.5892 61.2113 27.5916 62.1707 27.594 63.1288Z"
        fill="#F1F0F0"
      />
      <path
        d="M37.9075 60.252C37.9004 61.2101 37.8946 62.1683 37.8875 63.1277C36.9693 63.1324 36.05 63.1371 35.1318 63.143L35.1365 63.1265C35.1354 62.1707 35.1354 61.2137 35.1342 60.2578C36.0535 60.2578 36.9729 60.2567 37.8922 60.2567L37.9075 60.252Z"
        fill="#F1F1F1"
      />
      <path
        d="M48.1918 63.137C47.2701 63.1382 46.3484 63.1394 45.4268 63.1406L45.4315 63.1241C45.4303 62.1682 45.4291 61.2124 45.4279 60.2578C46.3508 60.2578 47.2737 60.2578 48.1965 60.2566C48.1954 61.2171 48.193 62.1765 48.1918 63.137Z"
        fill="#F1F1F1"
      />
      <path
        d="M55.7787 57.7266C55.7763 58.5671 55.7751 59.4087 55.7728 60.2492C54.9323 60.2504 54.0907 60.2527 53.2502 60.2539C53.2502 59.4111 53.249 58.5694 53.249 57.7266C54.0918 57.7254 54.9347 57.7266 55.7787 57.7266Z"
        fill="#B3D6DD"
      />
      <path
        d="M58.5154 57.7246C57.6031 57.7257 56.6908 57.7257 55.7785 57.7269C55.7774 56.8241 55.7762 55.92 55.7738 55.0172L55.7715 54.9924C56.6802 54.9936 57.5878 54.9948 58.4954 54.996C58.506 55.0101 58.5201 55.0207 58.5366 55.0266C58.5366 55.9247 58.5366 56.8241 58.5366 57.7222L58.5154 57.7246Z"
        fill="#F1F1F1"
      />
      <path
        d="M59.3592 60.2518C59.0897 60.253 58.8201 60.253 58.5505 60.2542C58.5458 59.5267 58.5423 58.7992 58.5364 58.0718C58.5352 57.9564 58.5235 57.8399 58.5176 57.7245L58.5411 57.7222C58.8142 57.7233 59.0873 57.7245 59.3604 57.7257C59.3663 58.5685 59.371 59.4125 59.3769 60.2554L59.3592 60.2518Z"
        fill={fill}
      />
      <path
        d="M99.7732 63.1265C98.8551 63.1312 97.9369 63.1371 97.0176 63.1418L97.0223 63.1253C97.0211 62.1683 97.0211 61.2125 97.0199 60.2555C97.9346 60.2543 98.8504 60.2531 99.765 60.252C99.7685 61.2101 99.7721 62.1671 99.7744 63.1253L99.7732 63.1265Z"
        fill="#F1F1F1"
      />
      <path
        d="M99.779 63.1265C99.7754 62.1683 99.7719 61.2113 99.7695 60.2531L99.7954 60.2543C100.065 60.2531 100.333 60.2531 100.603 60.252C100.61 61.2101 100.616 62.1683 100.623 63.1277L100.605 63.1465C100.329 63.1394 100.054 63.1324 99.779 63.1265Z"
        fill={fill}
      />
      <path
        d="M110.08 63.1324C109.159 63.1359 108.239 63.1383 107.318 63.1418L107.323 63.1253C107.322 62.1683 107.322 61.2125 107.321 60.2555C108.239 60.2543 109.157 60.2531 110.074 60.252C110.075 61.2125 110.078 62.173 110.08 63.1324Z"
        fill="#F1F1F1"
      />
      <path
        d="M14.5375 63.125C14.5363 62.1669 14.5363 61.2098 14.5352 60.2517L14.5375 60.2505C15.4451 60.2528 16.3526 60.2564 17.259 60.2587C17.2567 61.2193 17.2531 62.1798 17.2508 63.1403L17.2496 63.1415C16.3456 63.1356 15.4415 63.1309 14.5375 63.125Z"
        fill="#F1F1F1"
      />
      <path
        d="M89.435 63.1394C88.5309 63.1405 87.6281 63.1417 86.724 63.1441L86.7276 63.1276C86.7252 62.1694 86.7229 61.2112 86.7217 60.2519L86.724 60.2495C87.6304 60.2519 88.5356 60.2554 89.442 60.2578C89.4397 61.2171 89.4373 62.1777 89.435 63.1394C89.435 63.1394 89.435 63.1382 89.435 63.1394Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.6054 49.9048C18.8761 49.9048 19.1469 49.906 19.4176 49.906L19.4447 49.9048C19.4411 50.8783 19.4376 51.8529 19.4341 52.8264C19.1574 52.8347 18.8808 52.8417 18.603 52.85C18.596 52.8429 18.5889 52.8358 18.583 52.8288C18.5901 51.8553 18.5983 50.8806 18.6054 49.9048Z"
        fill={fill}
      />
      <path
        d="M18.1172 53.6552C18.1219 53.3845 18.1266 53.1126 18.1325 52.8418C18.2832 52.8383 18.4338 52.8336 18.5845 52.8301C18.5904 52.8371 18.5975 52.8442 18.6045 52.8513C18.6022 53.1244 18.5998 53.3974 18.5975 53.6705C18.4421 53.6717 18.2879 53.6741 18.1325 53.6753L18.1172 53.6552Z"
        fill={fill}
      />
      <path
        d="M17.25 54.1426C17.2512 53.9837 17.2524 53.8236 17.2535 53.6647C17.5419 53.6612 17.8303 53.6588 18.1187 53.6553L18.134 53.6753C18.1293 53.8318 18.1246 53.9884 18.1199 54.145C17.8362 54.1508 17.5525 54.1579 17.2677 54.1638L17.25 54.1426Z"
        fill={fill}
      />
      <path
        d="M97.0211 49.9071C97.0199 49.0831 97.0188 48.2603 97.0176 47.4363L97.0223 47.4316C97.9334 47.4316 98.8445 47.4316 99.7568 47.4328C99.7638 47.5388 99.7756 47.6447 99.7756 47.7518C99.7803 48.4699 99.7827 49.1891 99.7862 49.9071L99.7591 49.906C98.8457 49.906 97.9334 49.9071 97.0211 49.9071Z"
        fill="#CFE3E7"
      />
      <path
        d="M99.7623 52.8194C99.7611 51.8483 99.76 50.8771 99.7588 49.906L99.7859 49.9072C100.057 49.9072 100.329 49.906 100.599 49.906C100.604 50.883 100.609 51.8612 100.615 52.8382C100.338 52.8406 100.061 52.8441 99.7847 52.8465C99.7764 52.8371 99.7694 52.8288 99.7623 52.8194Z"
        fill={fill}
      />
      <path
        d="M97.0236 53.6586C97.0236 53.3867 97.0248 53.1148 97.0248 52.8441C97.9394 52.8358 98.8529 52.8276 99.7675 52.8193C99.7746 52.8288 99.7817 52.837 99.7887 52.8464C99.7852 53.123 99.7828 53.4008 99.7793 53.6775C98.86 53.6775 97.9418 53.6786 97.0225 53.6786L97.0236 53.6586Z"
        fill={fill}
      />
      <path
        d="M94.4889 54.1364C94.4877 53.9833 94.4877 53.8291 94.4865 53.6761C95.3305 53.6702 96.1745 53.6643 97.0197 53.6584L97.0173 53.6785C97.0173 53.8315 97.0173 53.9857 97.0173 54.1387C96.1733 54.147 95.3294 54.154 94.4854 54.1623L94.4889 54.1364Z"
        fill="#CFE3E7"
      />
      <path
        d="M91.5947 55.0063C91.5994 54.7167 91.6041 54.4272 91.6089 54.1364C92.5694 54.1364 93.5299 54.1364 94.4893 54.1353C94.4893 54.1353 94.4869 54.1611 94.4869 54.16C94.4881 54.4366 94.4905 54.7144 94.4916 54.9922C94.3551 54.9981 94.2185 55.0087 94.082 55.0099C93.2592 55.0169 92.4375 55.0216 91.6147 55.0275C91.6089 55.0216 91.6018 55.0146 91.5947 55.0063Z"
        fill={fill}
      />
      <path
        d="M89.4307 57.7257C89.4365 56.8204 89.4436 55.9164 89.4495 55.0112C89.732 55.0112 90.0133 55.01 90.2959 55.01C90.3029 55.9152 90.31 56.8204 90.3159 57.7257L90.2888 57.7245C90.0122 57.7245 89.7344 57.7245 89.4566 57.7245L89.4307 57.7257Z"
        fill={fill}
      />
      <path
        d="M90.7754 57.727C90.7813 56.8241 90.786 55.9201 90.7919 55.0172C91.0603 55.0137 91.3286 55.0113 91.597 55.0078C91.6041 55.0149 91.61 55.0231 91.617 55.0302C91.6217 55.9295 91.6253 56.83 91.63 57.7293L91.6053 57.727C91.3357 57.727 91.065 57.7258 90.7954 57.7258C90.7966 57.7246 90.7754 57.727 90.7754 57.727Z"
        fill={fill}
      />
      <path
        d="M90.3159 57.7256C90.4689 57.7268 90.6219 57.7268 90.7761 57.7279L90.7962 57.7256C90.7973 58.5696 90.7973 59.4124 90.7985 60.2564L90.7785 60.2541C90.6208 60.2552 90.463 60.2576 90.3053 60.2588C90.2888 60.2576 90.2723 60.2564 90.2559 60.2541C90.2723 60.1987 90.3053 60.1434 90.3041 60.0881C90.3018 59.3006 90.2935 58.5131 90.2876 57.7256H90.3159Z"
        fill="#CFE3E7"
      />
      <path
        d="M89.4397 60.2578C88.5333 60.2554 87.6281 60.2519 86.7217 60.2495C86.7217 59.4103 86.7217 58.5698 86.7217 57.7305L86.7264 57.7258C87.6269 57.7258 88.5286 57.7258 89.4291 57.7258L89.455 57.7246C89.4491 58.5121 89.4432 59.2996 89.4409 60.0871C89.4409 60.1424 89.4726 60.1978 89.4891 60.2531C89.4726 60.2543 89.4562 60.2554 89.4397 60.2578Z"
        fill="#CFE3E7"
      />
      <path
        d="M79.9607 52.8466C79.9631 53.1232 79.9654 53.3986 79.969 53.6753V53.6765C79.6923 53.6741 79.4145 53.6729 79.1379 53.6706C79.1356 53.3928 79.1332 53.1161 79.1309 52.8383L79.132 52.8372C79.4075 52.8407 79.6841 52.8442 79.9607 52.8466Z"
        fill={outline}
      />
      <path
        d="M80.4781 53.6835C80.4816 53.8354 80.4851 53.9861 80.4887 54.1379C80.3145 54.1379 80.1391 54.1367 79.9648 54.1367C79.966 53.9837 79.9672 53.8307 79.9684 53.6765V53.6753C80.1379 53.6776 80.3086 53.68 80.4781 53.6835Z"
        fill="#F1EFEF"
      />
      <path
        d="M81.2987 54.1529C81.3023 54.4401 81.3046 54.7273 81.3082 55.0134L81.307 55.0157C81.0327 55.0181 80.7596 55.0216 80.4854 55.024C80.4854 54.7273 80.4865 54.4319 80.4865 54.1353C80.7573 54.1423 81.028 54.147 81.2987 54.1529Z"
        fill={outline}
      />
      <path
        d="M84.1946 60.2542C83.2364 60.2542 82.277 60.2542 81.3188 60.253L81.2988 60.2542C81.3 59.4102 81.3 58.5673 81.3012 57.7233L81.3212 57.7257C82.2782 57.7245 83.234 57.7233 84.191 57.7222L84.1946 57.7257C84.1946 58.5697 84.1946 59.4125 84.1946 60.2542Z"
        fill="#CFE3E7"
      />
      <path
        d="M80.4854 55.0253C80.7596 55.023 81.0327 55.0194 81.307 55.0171C81.3129 55.9199 81.3176 56.824 81.3235 57.7268L81.3035 57.7245C81.0327 57.7245 80.7608 57.7245 80.4901 57.7245C80.4889 56.8252 80.4877 55.9258 80.4854 55.0253Z"
        fill={fill}
      />
      <path
        d="M84.1943 60.2539C84.1943 59.4122 84.1943 58.5694 84.1943 57.7278C85.036 57.729 85.8776 57.7289 86.7193 57.7301C86.7193 58.5694 86.7193 59.4099 86.7193 60.2492L86.7169 60.2515C85.8776 60.2527 85.036 60.2527 84.1943 60.2539Z"
        fill="#B3D6DD"
      />
      <path
        d="M24.8381 60.2567C24.8392 61.2137 24.8392 62.1695 24.8404 63.1265C23.9952 63.1265 23.1501 63.1265 22.3037 63.1265C22.3049 62.1695 22.3049 61.2137 22.3061 60.2567L22.3108 60.252C23.1512 60.252 23.9929 60.252 24.8345 60.252L24.8381 60.2567Z"
        fill="#CFE3E7"
      />
      <path
        d="M107.318 60.2566C107.319 61.2136 107.319 62.1694 107.32 63.1264C106.475 63.1276 105.631 63.1288 104.786 63.1299C104.787 62.1718 104.787 61.2136 104.788 60.2554L104.794 60.2495C105.635 60.2507 106.475 60.2519 107.315 60.2519L107.318 60.2566Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.1316 60.2565C35.1328 61.2124 35.1328 62.1694 35.134 63.1252C34.2888 63.1264 33.4448 63.1275 32.5996 63.1287C32.5996 62.1705 32.6008 61.2124 32.6008 60.2542L32.6067 60.2483C33.4471 60.2495 34.2864 60.2506 35.1269 60.2518C35.1281 60.2518 35.1316 60.2565 35.1316 60.2565Z"
        fill="#CFE3E7"
      />
      <path
        d="M97.0197 60.2567C97.0209 61.2137 97.0209 62.1695 97.0221 63.1265C96.1769 63.1265 95.3317 63.1265 94.4854 63.1265C94.4865 62.1695 94.4865 61.2137 94.4877 60.2567L94.4924 60.252C95.3341 60.252 96.1745 60.252 97.0162 60.252L97.0197 60.2567Z"
        fill="#CFE3E7"
      />
      <path
        d="M84.1942 60.2543C85.0358 60.2531 85.8763 60.2531 86.7179 60.252C86.7203 61.2101 86.7226 62.1683 86.7238 63.1277C85.8786 63.1277 85.0335 63.1277 84.1895 63.1265C84.1918 62.1695 84.193 61.2113 84.1942 60.2543Z"
        fill="#CFE3E7"
      />
      <path
        d="M45.4259 60.2578C45.4271 61.2137 45.4282 62.1695 45.4294 63.1242C44.6031 63.1253 43.7756 63.1253 42.9492 63.1265C42.9504 62.1695 42.9504 61.2137 42.9516 60.2567L42.9563 60.252C43.7779 60.252 44.6007 60.252 45.4224 60.252L45.4259 60.2578Z"
        fill="#CFE3E7"
      />
      <path
        d="M115.136 63.1261C115.137 62.1691 115.139 61.2121 115.14 60.2551C115.964 60.2551 116.787 60.2551 117.611 60.2551C117.614 61.2121 117.615 62.168 117.617 63.125C116.788 63.125 115.962 63.125 115.136 63.1261Z"
        fill="#CFE3E7"
      />
      <path
        d="M99.7593 47.4329C98.8482 47.4329 97.9371 47.4329 97.0248 47.4318C97.0248 46.5183 97.026 45.6048 97.026 44.6914L97.0225 44.6714C97.9359 44.6784 98.8482 44.6843 99.7616 44.6914C99.7687 45.6037 99.7746 46.5171 99.7817 47.4306L99.7593 47.4329Z"
        fill="#F1F1F1"
      />
      <path
        d="M38.7293 42.5455C38.7269 42.8233 38.7234 43.1011 38.7211 43.3789C38.448 43.3777 38.1749 43.3765 37.9006 43.3753H37.8994C37.9041 43.0869 37.9077 42.7985 37.9124 42.5102C38.1796 42.5066 38.4456 42.5043 38.7128 42.5007C38.7175 42.516 38.7234 42.5302 38.7293 42.5455Z"
        fill={outline}
      />
      <path
        d="M29.7568 47.4386C29.7615 46.637 29.7663 45.8353 29.7721 45.0325C29.7733 44.916 29.7827 44.7983 29.7886 44.6818C30.728 44.6759 31.6661 44.6712 32.6055 44.6653L32.6008 44.6841C32.6008 45.5999 32.6008 46.5169 32.602 47.4327C31.6614 47.4327 30.7197 47.4339 29.7792 47.4339L29.7568 47.4386Z"
        fill="#F1F0F0"
      />
      <path
        d="M32.6008 47.4338C32.6008 46.518 32.6008 45.601 32.5996 44.6852C33.4436 44.6805 34.2876 44.6746 35.1316 44.6699L35.1304 44.6958C35.1316 45.6081 35.1328 46.5204 35.134 47.4338C34.2911 47.4362 33.4483 47.4373 32.6043 47.4397L32.6008 47.4338Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.1272 43.8554C36.0465 43.8507 36.9658 43.8448 37.8852 43.8401L37.9028 43.8577C37.8969 44.1308 37.8922 44.4039 37.8863 44.677C36.9658 44.6829 36.0465 44.6888 35.126 44.6947L35.1272 44.6688C35.1283 44.398 35.1283 44.1273 35.1272 43.8554Z"
        fill={fill}
      />
      <path
        d="M37.9004 43.3752C38.1735 43.3764 38.4466 43.3776 38.7209 43.3788C38.7244 43.5306 38.7291 43.6836 38.7327 43.8355L38.7138 43.8555C38.4443 43.8567 38.1759 43.8567 37.9063 43.8579L37.8887 43.8402C37.8922 43.686 37.8957 43.5306 37.9004 43.3752Z"
        fill={fill}
      />
      <path
        d="M19.4346 52.8276C19.4381 51.8542 19.4416 50.8795 19.4452 49.906C20.3975 49.9072 21.3486 49.9084 22.3009 49.9095C22.3009 50.8807 22.3009 51.8518 22.3009 52.8229L22.3021 52.8441C21.3474 52.8406 20.3928 52.8359 19.4393 52.8323L19.4346 52.8276Z"
        fill="#F1F1F1"
      />
      <path
        d="M63.5449 47.4338C64.3889 47.4338 65.2341 47.4338 66.0781 47.4338C66.0769 48.2578 66.0757 49.0806 66.0757 49.9046C65.2329 49.9046 64.3901 49.9046 63.5473 49.9046C63.5473 49.0806 63.5461 48.2578 63.5449 47.4338Z"
        fill="#B3D6DD"
      />
      <path
        d="M70.0873 46.4901C70.0885 46.8455 70.0896 47.201 70.0896 47.5565C69.9437 47.8261 69.7965 48.0957 69.6506 48.3664C69.3787 48.5312 69.1056 48.696 68.8336 48.8608C68.1839 49.0067 67.5788 48.9338 67.0444 48.5018C66.6983 48.2216 66.5088 47.8449 66.3711 47.4353C66.4217 47.0339 66.3911 46.5983 66.5394 46.237C66.8926 45.373 67.7107 45.0139 68.7489 45.1728C68.7783 45.1811 68.8089 45.1893 68.8384 45.1976C69.1091 45.36 69.3787 45.5225 69.6494 45.6861C69.7954 45.9533 69.9413 46.2217 70.0873 46.4901Z"
        fill={outline}
      />
      <path
        d="M66.3677 47.434C66.5055 47.8449 66.695 48.2215 67.041 48.5005C67.5755 48.9325 68.1805 49.0055 68.8303 48.8595C68.8279 49.2091 68.8267 49.5599 68.8244 49.9095C67.9086 49.9095 66.9928 49.9084 66.077 49.9084L66.0723 49.9037C66.0734 49.0797 66.0746 48.2569 66.0746 47.4329C66.1735 47.434 66.27 47.434 66.3677 47.434Z"
        fill="#CFE2E5"
      />
      <path
        d="M68.8385 45.1964C68.8091 45.1882 68.7785 45.1799 68.749 45.1717C68.7773 45.1611 68.8055 45.1505 68.8326 45.1399C68.8397 45.1575 68.842 45.1764 68.8385 45.1964Z"
        fill="#E4D4CD"
      />
      <path
        d="M28.8994 49.9036C28.9053 49.0796 28.9124 48.2556 28.9182 47.4316C29.1972 47.434 29.4762 47.4363 29.7552 47.4387L29.7764 47.4352C29.774 47.6 29.7728 47.7648 29.7705 47.9307C29.7611 48.5899 29.7517 49.2491 29.7422 49.9083C29.4691 49.906 29.1949 49.9036 28.9218 49.9013L28.8994 49.9036Z"
        fill={fill}
      />
      <path
        d="M27.582 49.9107C27.5879 49.0855 27.595 48.2603 27.6009 47.434C27.8716 47.4328 28.1435 47.4328 28.4143 47.4316C28.4201 48.2568 28.426 49.082 28.4319 49.9071L28.4154 49.9036C28.1435 49.9048 27.8728 49.9048 27.6009 49.906C27.6009 49.9071 27.582 49.9107 27.582 49.9107Z"
        fill={fill}
      />
      <path
        d="M28.4344 49.9084C28.5898 49.906 28.7452 49.9049 28.9018 49.9025L28.9241 49.9001C28.9171 50.0367 28.9053 50.1732 28.9041 50.3086C28.8971 51.1491 28.8912 51.9907 28.8853 52.8312C28.737 52.83 28.5887 52.8288 28.4403 52.8288C28.4333 51.8542 28.425 50.8795 28.418 49.9049L28.4344 49.9084Z"
        fill="#F1F0F0"
      />
      <path
        d="M17.2567 60.2587C16.3491 60.2563 15.4415 60.2528 14.5352 60.2504C14.5363 59.41 14.5363 58.5683 14.5375 57.7279C15.4404 57.7267 16.3444 57.7255 17.2473 57.7243L17.2626 57.7231C17.2626 57.7231 17.2779 57.7243 17.2767 57.7243C17.2861 58.5671 17.2955 59.41 17.3049 60.254C17.2885 60.2551 17.272 60.2575 17.2567 60.2587Z"
        fill="#CFE3E7"
      />
      <path
        d="M17.25 57.7244C17.2512 56.8216 17.2524 55.9176 17.2535 55.0147C17.2535 55.0147 17.2735 54.9935 17.2735 54.9947C17.5537 55.0017 17.835 55.0088 18.1152 55.0159C18.114 55.9211 18.114 56.8263 18.1128 57.7303C17.835 57.728 17.5584 57.7268 17.2806 57.7244L17.2653 57.7233C17.2641 57.7233 17.25 57.7244 17.25 57.7244Z"
        fill={fill}
      />
      <path
        d="M101.93 63.0192C101.939 63.0593 101.947 63.1005 101.957 63.1405C101.667 63.1417 101.378 63.1428 101.088 63.144L101.07 63.1264C101.076 63.0899 101.082 63.0546 101.088 63.0181C101.369 63.0192 101.649 63.0192 101.93 63.0192Z"
        fill={fill}
      />
      <path
        d="M89.4424 60.2576C89.4589 60.2565 89.4754 60.2553 89.4918 60.2529C89.7473 60.2529 90.0015 60.2529 90.257 60.2529C90.2735 60.2553 90.2899 60.2565 90.3064 60.2576C90.3111 61.2158 90.3158 62.1728 90.3217 63.131L90.3052 63.1522C90.0157 63.1475 89.7261 63.1428 89.4365 63.1381C89.4377 62.1775 89.4401 61.217 89.4424 60.2576Z"
        fill={fill}
      />
      <path
        d="M48.1895 63.1371C48.1918 62.1766 48.193 61.2172 48.1942 60.2567C48.2106 60.2555 48.2271 60.2543 48.2448 60.252C48.5002 60.252 48.7545 60.2531 49.0099 60.2531C49.0264 60.2555 49.0417 60.2578 49.0582 60.2578C49.0641 61.216 49.0699 62.173 49.0747 63.1312L49.0593 63.1524C48.7698 63.1477 48.479 63.1418 48.1895 63.1371Z"
        fill={fill}
      />
      <path
        d="M29.7668 60.2577C29.7692 61.2182 29.7715 62.1788 29.7739 63.1393C29.4843 63.1428 29.1947 63.1475 28.9052 63.1522L28.8887 63.131C28.8934 62.174 28.8981 61.2159 28.9028 60.2589C28.9193 60.2577 28.9358 60.2565 28.9522 60.2542C29.2077 60.2542 29.4619 60.2542 29.7174 60.2542C29.7339 60.2553 29.7503 60.2565 29.7668 60.2577Z"
        fill={fill}
      />
      <path
        d="M17.2582 60.259C17.2747 60.2578 17.2912 60.2555 17.3065 60.2531C17.5619 60.2531 17.8162 60.252 18.0716 60.252C18.0881 60.2531 18.1046 60.2555 18.1223 60.2567C18.1258 61.2137 18.1305 62.1718 18.134 63.1288L18.1175 63.15C17.828 63.1465 17.5396 63.1442 17.25 63.1406C17.2524 62.1801 17.2547 61.2196 17.2582 60.259Z"
        fill={fill}
      />
      <path
        d="M42.9549 53.6786C42.9549 53.8328 42.956 53.987 42.956 54.1412L42.9596 54.1624C42.843 54.1565 42.7277 54.1448 42.6111 54.1448C41.766 54.14 40.922 54.1377 40.0768 54.1342C40.0756 53.9788 40.0744 53.8246 40.0732 53.6692C41.0338 53.6727 41.9943 53.6763 42.9549 53.6786Z"
        fill="#F1F1F1"
      />
      <path
        d="M40.0801 52.8394C40.0777 53.116 40.0754 53.3938 40.073 53.6704C39.7999 53.668 39.5268 53.6657 39.2537 53.6633C39.2526 53.3914 39.2514 53.1195 39.249 52.8476C39.5268 52.8441 39.8035 52.8417 40.0801 52.8394Z"
        fill={outline}
      />
      <path
        d="M45.4283 54.16C45.4259 54.439 45.4247 54.7168 45.4224 54.9958L45.4235 55.0193C44.6019 55.0181 43.7791 55.0158 42.9575 55.0146C42.9551 54.9993 42.9516 54.984 42.9492 54.9687C42.9528 54.7003 42.9551 54.4319 42.9586 54.1635L42.9551 54.1423C43.7791 54.147 44.6043 54.1541 45.4283 54.16Z"
        fill={fill}
      />
      <path
        d="M48.1894 55.0206C48.1941 55.9235 48.2 56.8275 48.2047 57.7304L48.187 57.7268C47.3842 57.7268 46.5802 57.7162 45.7774 57.7327C45.4973 57.7386 45.4196 57.6256 45.4219 57.3702C45.429 56.5874 45.4231 55.8034 45.4231 55.0206L45.4219 54.9971C46.3448 55.0041 47.2677 55.0124 48.1894 55.0206Z"
        fill="#F1F1F1"
      />
      <path
        d="M49.0123 60.2531C48.7568 60.2531 48.5026 60.2519 48.2471 60.2519C48.2295 60.1389 48.1989 60.0247 48.1977 59.9117C48.1918 59.1831 48.1918 58.4556 48.1895 57.727L48.2071 57.7305C48.4849 57.7281 48.7639 57.727 49.0417 57.7246C49.0323 58.5674 49.0217 59.4103 49.0123 60.2531Z"
        fill={fill}
      />
      <path
        d="M49.5391 60.2551C49.5438 59.4111 49.5497 58.5682 49.5544 57.7242C49.8251 57.7242 50.0958 57.7254 50.3666 57.7254L50.3842 57.7207C50.3831 58.5659 50.3807 59.4099 50.3795 60.2551L50.3619 60.2504C50.0935 60.2504 49.8239 60.2504 49.5555 60.2504L49.5391 60.2551Z"
        fill={fill}
      />
      <path
        d="M49.079 63.1324C49.0731 62.1742 49.0684 61.216 49.0625 60.259C49.2214 60.2578 49.3803 60.2578 49.5392 60.2567L49.5557 60.252C49.551 61.2125 49.5475 62.173 49.5428 63.1336C49.3886 63.1324 49.2344 63.1324 49.079 63.1324Z"
        fill="#F1F0F0"
      />
      <path
        d="M27.5903 63.1286C27.5879 62.1705 27.5844 61.2111 27.582 60.2529L27.6056 60.2553C27.8728 60.2553 28.1412 60.2553 28.4084 60.2565L28.4284 60.2541C28.4284 61.2123 28.4296 62.1693 28.4296 63.1275L28.4119 63.1463C28.1388 63.1404 27.8645 63.1345 27.5903 63.1286Z"
        fill={fill}
      />
      <path
        d="M19.439 60.2529C19.4354 61.2111 19.4331 62.1693 19.4295 63.1275C19.1553 63.1334 18.881 63.1392 18.6055 63.1463L18.5879 63.1275C18.5879 62.1693 18.5891 61.2123 18.5891 60.2541L18.6091 60.2553C18.8775 60.2553 19.1447 60.2553 19.4131 60.2541L19.439 60.2529Z"
        fill={fill}
      />
      <path
        d="M49.5391 63.1321C49.5438 62.1716 49.5473 61.211 49.552 60.2505C49.8204 60.2505 50.09 60.2505 50.3583 60.2505C50.3631 61.2098 50.3666 62.1704 50.3713 63.1297C50.0935 63.1321 49.8169 63.1321 49.5391 63.1321Z"
        fill={fill}
      />
      <path
        d="M81.321 60.2531C81.3186 61.2137 81.3174 62.173 81.3151 63.1336C81.042 63.1359 80.7677 63.1395 80.4946 63.143C80.4876 63.1359 80.4817 63.1277 80.4746 63.1206C80.4817 62.1648 80.4887 61.209 80.4946 60.252C80.763 60.2531 81.0314 60.2543 81.2998 60.2543L81.321 60.2531Z"
        fill={fill}
      />
      <path
        d="M91.6241 60.2529C91.6217 61.2123 91.6194 62.1705 91.6159 63.1298C91.3416 63.1345 91.0685 63.1404 90.7942 63.1451L90.7754 63.1263C90.7766 62.1681 90.7766 61.2099 90.7777 60.2529L90.7978 60.2553C91.065 60.2553 91.3322 60.2553 91.5994 60.2553L91.6241 60.2529Z"
        fill={fill}
      />
      <path
        d="M110.076 63.1322C110.074 62.1728 110.073 61.2123 110.07 60.2529L110.092 60.2553C110.358 60.2553 110.625 60.2553 110.891 60.2553L110.912 60.2541C110.911 61.2135 110.91 62.1728 110.908 63.1322C110.631 63.1322 110.354 63.1322 110.076 63.1322Z"
        fill={fill}
      />
      <path
        d="M112.265 60.2529C112.263 61.2135 112.262 62.1728 112.259 63.1334C111.98 63.1298 111.701 63.1263 111.422 63.1239C111.42 62.1669 111.416 61.2099 111.414 60.2541L111.44 60.2553C111.708 60.2553 111.976 60.2553 112.244 60.2553C112.245 60.2553 112.265 60.2529 112.265 60.2529Z"
        fill={fill}
      />
      <path
        d="M111.412 60.2542C111.245 60.2542 111.078 60.2542 110.91 60.2542L110.889 60.2554C110.897 59.4113 110.904 58.5662 110.912 57.7222C111.075 57.7233 111.237 57.7245 111.4 57.7257C111.409 57.7269 111.42 57.7269 111.429 57.7269C111.431 58.5697 111.435 59.4125 111.437 60.2542H111.412Z"
        fill="#D5DBDB"
      />
      <path
        d="M99.785 42.4922C99.7838 42.79 99.7827 43.0878 99.7803 43.3845C98.8621 43.3821 97.9428 43.3797 97.0246 43.3774L97.0258 43.3515C97.0235 43.0737 97.0211 42.7971 97.0176 42.5204C97.8133 42.5146 98.6102 42.5098 99.406 42.5028C99.5331 42.5016 99.6591 42.4957 99.785 42.4922Z"
        fill={fill}
      />
      <path
        d="M99.7591 44.6923C98.8457 44.6852 97.9334 44.6794 97.0199 44.6723C97.0199 44.4016 97.0199 44.1296 97.0199 43.8589L97.0176 43.8389C97.9334 43.8365 98.8504 43.8354 99.7662 43.833C99.7732 43.8401 99.7815 43.846 99.7885 43.853C99.7874 44.1249 99.7862 44.398 99.785 44.6699C99.7768 44.6782 99.7674 44.6852 99.7591 44.6923Z"
        fill={fill}
      />
      <path
        d="M39.257 60.2553C39.2523 59.5172 39.2487 58.778 39.2428 58.0399C39.2417 57.9328 39.2322 57.8268 39.2275 57.7197L39.2452 57.7233C39.5183 57.7244 39.7914 57.7256 40.0645 57.728L40.0798 57.7244C40.0786 58.5684 40.0786 59.4113 40.0774 60.2553L40.0609 60.2517C39.7926 60.2529 39.5242 60.2541 39.257 60.2553Z"
        fill={fill}
      />
      <path
        d="M38.7338 57.7207C38.7256 58.5659 38.7162 59.4099 38.708 60.2551C38.4407 60.2539 38.1724 60.2527 37.9051 60.2515L37.8887 60.2551C37.8946 59.4122 37.8993 58.5682 37.904 57.7254C38.1747 57.7254 38.4466 57.7254 38.7174 57.7254L38.7338 57.7207Z"
        fill={fill}
      />
      <path
        d="M39.2284 57.7199C39.0636 57.7199 38.8989 57.721 38.7341 57.721L38.7188 57.7257C38.7223 56.8288 38.727 55.9318 38.7305 55.0336C38.9 55.0336 39.0695 55.0325 39.239 55.0325C39.2414 55.9294 39.2438 56.8264 39.2461 57.7246L39.2284 57.7199Z"
        fill="#F1EFEF"
      />
      <path
        d="M80.4944 60.2529C80.4873 61.2088 80.4803 62.1646 80.4744 63.1216C80.3072 63.1216 80.1413 63.1204 79.9753 63.1204C79.9682 62.1646 79.9612 61.2099 79.9541 60.2541L79.9706 60.26C80.1401 60.26 80.3096 60.26 80.4791 60.26L80.4944 60.2529Z"
        fill="#F1EFEF"
      />
      <path
        d="M111.444 60.2552C111.441 59.4124 111.438 58.5696 111.436 57.7279C111.707 57.7268 111.978 57.7268 112.25 57.7256C112.249 58.5696 112.249 59.4124 112.248 60.2564C111.979 60.2552 111.711 60.2552 111.444 60.2552Z"
        fill={fill}
      />
      <path
        d="M111.402 57.7255C111.24 57.7243 111.077 57.7231 110.914 57.722L110.899 57.7267C110.903 56.8262 110.906 55.9268 110.91 55.0275C111.069 55.0181 111.228 55.0087 111.387 54.9993C111.4 55.0099 111.413 55.0193 111.427 55.0263C111.419 55.9257 111.41 56.8262 111.402 57.7255Z"
        fill="#F1EFEF"
      />
      <path
        d="M112.274 52.8301C113.228 52.836 114.184 52.8407 115.139 52.8466C115.14 53.1185 115.141 53.3904 115.141 53.6623C114.183 53.667 113.225 53.6729 112.267 53.6776L112.249 53.66C112.25 53.3904 112.251 53.1208 112.253 52.8513C112.261 52.8442 112.267 52.8371 112.274 52.8301Z"
        fill={fill}
      />
      <path
        d="M112.254 54.1414C111.978 54.139 111.701 54.1355 111.426 54.1331C111.426 53.9824 111.425 53.8306 111.425 53.6799C111.699 53.6729 111.973 53.6658 112.248 53.6599L112.265 53.6776C112.261 53.8318 112.257 53.9871 112.254 54.1414Z"
        fill={fill}
      />
      <path
        d="M111.388 54.9985C111.229 55.0079 111.07 55.0173 110.911 55.0267L110.889 55.0079C110.893 54.7183 110.899 54.4287 110.904 54.1392C111.063 54.145 111.223 54.1509 111.382 54.158C111.384 54.4382 111.385 54.7183 111.388 54.9985Z"
        fill={fill}
      />
      <path
        d="M111.384 54.1578C111.225 54.1519 111.065 54.146 110.906 54.139L110.905 54.1401C110.909 53.9871 110.914 53.8329 110.917 53.6799C111.087 53.6799 111.256 53.6787 111.426 53.6787L111.427 53.6799C111.427 53.8306 111.428 53.9824 111.428 54.1331C111.413 54.139 111.398 54.1472 111.384 54.1578Z"
        fill="#F1EFEF"
      />
      <path
        d="M18.5904 60.2529C18.5904 61.2111 18.5892 62.1681 18.5892 63.1263C18.4373 63.1275 18.2867 63.1275 18.1348 63.1286C18.1313 62.1716 18.1266 61.2135 18.123 60.2565C18.2773 60.2553 18.4338 60.2541 18.5904 60.2529Z"
        fill="#F1F1F1"
      />
      <path
        d="M90.7769 60.2529C90.7769 61.2111 90.7757 62.1693 90.7746 63.1263C90.6227 63.1275 90.4709 63.1286 90.319 63.1298C90.3143 62.1716 90.3096 61.2146 90.3037 60.2565C90.4614 60.2565 90.6192 60.2541 90.7769 60.2529Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.089 63.0194C101.083 63.0559 101.078 63.0912 101.072 63.1277C100.921 63.1277 100.77 63.1277 100.62 63.1277C100.613 62.1695 100.607 61.2113 100.6 60.252L100.616 60.2555C100.768 60.2555 100.921 60.2543 101.073 60.2543C101.078 61.1748 101.083 62.0977 101.089 63.0194Z"
        fill="#F1F1F1"
      />
      <path
        d="M28.4348 63.1263C28.4348 62.1681 28.4336 61.2111 28.4336 60.2529C28.5902 60.2541 28.7479 60.2553 28.9044 60.2565C28.8997 61.2135 28.895 62.1716 28.8903 63.1286C28.7385 63.1286 28.5866 63.1275 28.4348 63.1263Z"
        fill="#F1F1F1"
      />
      <path
        d="M40.0784 52.8382C39.8018 52.8418 39.5252 52.8441 39.2486 52.8476C39.2403 52.8382 39.2309 52.8288 39.2227 52.8194C39.2227 51.8483 39.2227 50.8771 39.2227 49.906L39.2497 49.9072C39.5205 49.9072 39.7912 49.906 40.0619 49.906C40.0678 50.883 40.0725 51.8612 40.0784 52.8382Z"
        fill={fill}
      />
      <path
        d="M39.2452 47.4363C39.2464 48.2603 39.2488 49.0831 39.25 49.9071L39.2229 49.906C39.0604 49.9071 38.8968 49.9095 38.7344 49.9107C38.7356 49.0843 38.7367 48.258 38.7379 47.4316C38.898 47.4328 39.0581 47.4352 39.217 47.4363H39.2452Z"
        fill="#CFE3E7"
      />
      <path
        d="M99.7662 43.833C98.8504 43.8354 97.9334 43.8366 97.0176 43.8389C97.0188 43.6859 97.0188 43.5317 97.0199 43.3787C97.9381 43.381 98.8574 43.3834 99.7756 43.3857H99.7768C99.7732 43.5352 99.7697 43.6835 99.7662 43.833Z"
        fill="#F1F0F0"
      />
      <path
        d="M39.2167 47.4364C39.0566 47.4352 38.8965 47.4329 38.7376 47.4317L38.7188 47.4329C38.7223 46.5171 38.7246 45.6013 38.7282 44.6855L38.7293 44.6831C38.8941 44.6878 39.0589 44.6925 39.2237 44.6972C39.2214 45.6095 39.219 46.523 39.2167 47.4364Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.904 43.8578C38.1735 43.8566 38.4431 43.8566 38.7115 43.8555C38.7174 44.1309 38.7244 44.4064 38.7303 44.6806L38.7291 44.683C38.449 44.6806 38.1688 44.6783 37.8887 44.6771C37.8934 44.4052 37.8993 44.1309 37.904 43.8578Z"
        fill={outline}
      />
      <path
        d="M18.112 55.0147C17.8318 55.0076 17.5505 55.0005 17.2703 54.9935C17.2692 54.7169 17.2668 54.4402 17.2656 54.1636C17.5493 54.1577 17.8342 54.1507 18.1179 54.1448L18.1202 54.1483C18.119 54.4344 18.1179 54.7216 18.1167 55.0076L18.112 55.0147Z"
        fill={outline}
      />
      <path
        d="M68.8409 55.0194C68.8338 55.9223 68.8267 56.8252 68.8197 57.728C67.9039 57.7268 66.9893 57.7268 66.0734 57.7257C66.0734 56.8228 66.0723 55.9199 66.0723 55.0171C66.9951 55.0171 67.918 55.0171 68.8397 55.0171C68.8409 55.0183 68.8409 55.0194 68.8409 55.0194Z"
        fill="#F1F0F0"
      />
      <path
        d="M60.6805 60.2588C60.6747 59.4148 60.6699 58.5719 60.6641 57.7279L60.6794 57.7291H60.6947C61.6434 57.7279 62.5934 57.7268 63.5421 57.7256L63.5457 57.7291C63.5457 58.5708 63.5457 59.4124 63.5457 60.2541C62.591 60.2552 61.6352 60.2576 60.6805 60.2588Z"
        fill="#CFE3E7"
      />
      <path
        d="M66.0757 55.0181C66.0757 55.9209 66.0757 56.8238 66.0769 57.7266C65.2341 57.7278 64.3913 57.7278 63.5484 57.729L63.5449 57.7255C63.5461 56.8238 63.5473 55.9209 63.5484 55.0192C64.3901 55.0181 65.2329 55.0181 66.0757 55.0181Z"
        fill="#CFE3E7"
      />
      <path
        d="M79.1465 57.7244C79.4184 57.7244 79.6903 57.7244 79.9622 57.7244L79.9787 57.7197C79.9764 58.5661 79.974 59.4124 79.9717 60.2588L79.9552 60.2529C79.6868 60.2541 79.4172 60.2541 79.1488 60.2553C79.1477 59.4113 79.1477 58.5684 79.1465 57.7244Z"
        fill={fill}
      />
      <path
        d="M76.3754 54.1365C76.3754 53.9835 76.3766 53.8305 76.3766 53.6786L76.373 53.6633C77.2947 53.6657 78.2164 53.668 79.1381 53.6716C79.1393 53.8293 79.1405 53.9859 79.1428 54.1436L79.1417 54.1448C78.2188 54.1401 77.2971 54.1377 76.3754 54.1365Z"
        fill="#F1F1F1"
      />
      <path
        d="M79.9632 55.0216C79.6937 55.0157 79.4241 55.0099 79.1557 55.004C79.151 54.7168 79.1463 54.4295 79.1416 54.1423L79.1428 54.1411C79.4171 54.1388 79.6925 54.1376 79.9668 54.1353C79.9644 54.4307 79.9632 54.7262 79.9632 55.0216Z"
        fill={outline}
      />
      <path
        d="M80.485 55.0253C80.4861 55.9258 80.4873 56.8251 80.4897 57.7256L80.4732 57.7209C80.3084 57.7209 80.1436 57.7209 79.9776 57.7197L79.9611 57.7244C79.9611 56.8239 79.96 55.9222 79.96 55.0217C80.1354 55.0229 80.3107 55.0241 80.485 55.0253C80.485 55.0253 80.4861 55.0253 80.485 55.0253Z"
        fill="#F1EFEF"
      />
      <path
        d="M71.008 54.1459C70.7231 54.1506 70.4371 54.1553 70.1522 54.16L70.1357 54.14C70.1369 53.9811 70.1393 53.8233 70.1404 53.6644C70.4288 53.6609 70.7161 53.6573 71.0045 53.6538L71.0221 53.6738C71.0174 53.8316 71.0127 53.9893 71.008 54.1459Z"
        fill={fill}
      />
      <path
        d="M69.6652 54.1414C69.6605 54.4298 69.6546 54.7181 69.6499 55.0065C69.3815 55.0113 69.1131 55.0148 68.8447 55.0195V55.0171C68.8471 54.7288 68.8494 54.4404 68.8518 54.152C69.1225 54.1484 69.3933 54.1449 69.6652 54.1414Z"
        fill={outline}
      />
      <path
        d="M70.1441 53.6645C70.143 53.8234 70.1406 53.9811 70.1394 54.14C69.9817 54.14 69.824 54.1412 69.6662 54.1412H69.665C69.6686 53.987 69.6721 53.8316 69.6756 53.6774C69.831 53.6727 69.9864 53.6668 70.1418 53.6621C70.1418 53.6621 70.1441 53.6645 70.1441 53.6645Z"
        fill="#F1F0F0"
      />
      <path
        d="M112.249 53.6597C111.974 53.6668 111.7 53.6739 111.426 53.6797L111.425 53.6786C111.421 53.3961 111.418 53.1124 111.414 52.8299C111.414 52.8299 111.421 52.8252 111.421 52.824C111.698 52.8334 111.976 52.8416 112.252 52.851C112.252 53.1206 112.251 53.3902 112.249 53.6597Z"
        fill={outline}
      />
      <path
        d="M110.903 49.906C110.908 50.8818 110.914 51.8565 110.919 52.8323L110.901 52.8512C110.626 52.8453 110.35 52.8406 110.075 52.8347C110.074 51.8589 110.071 50.8818 110.07 49.906L110.093 49.9072C110.362 49.9072 110.633 49.9072 110.903 49.906Z"
        fill={fill}
      />
      <path
        d="M111.411 52.8286C111.415 53.1111 111.418 53.3948 111.422 53.6773C111.252 53.6773 111.083 53.6785 110.913 53.6785L110.895 53.6597C110.896 53.3901 110.896 53.1205 110.897 52.8498L110.915 52.831C111.081 52.831 111.245 52.8298 111.411 52.8286Z"
        fill={fill}
      />
      <path
        d="M70.1662 49.9058C70.4417 49.9047 70.7183 49.9023 70.9937 49.9011C70.9996 50.6933 71.0055 51.4844 71.0137 52.2766C71.0161 52.4626 71.0255 52.6474 71.0314 52.8322C71.0243 52.8392 71.0161 52.8475 71.009 52.8545C70.7218 52.8557 70.4346 52.8557 70.1474 52.8569C70.1391 52.8498 70.1321 52.8416 70.125 52.8333C70.1297 51.8587 70.1344 50.884 70.1403 49.9082L70.1662 49.9058Z"
        fill={fill}
      />
      <path
        d="M79.1381 53.6704C78.2164 53.668 77.2947 53.6657 76.373 53.6621C76.3742 53.389 76.3754 53.1159 76.3778 52.8417C77.2959 52.8405 78.2141 52.8393 79.1311 52.8381C79.1334 53.1159 79.1358 53.3926 79.1381 53.6704Z"
        fill={fill}
      />
      <path
        d="M70.1477 52.8571C70.4349 52.8559 70.7221 52.8559 71.0093 52.8547C71.0082 53.1208 71.007 53.388 71.0058 53.654C70.7174 53.6575 70.429 53.6611 70.1418 53.6646L70.1406 53.6623C70.143 53.3939 70.1453 53.1255 70.1477 52.8571Z"
        fill={outline}
      />
      <path
        d="M69.6484 48.365C69.7944 48.0955 69.9415 47.8259 70.0875 47.5552C70.1193 47.5575 70.1511 47.5599 70.1829 47.5634C70.177 48.3439 70.1699 49.1255 70.164 49.9059L70.1381 49.9094C69.9827 49.9094 69.8274 49.9083 69.672 49.9083C69.6637 49.3938 69.6555 48.8794 69.6484 48.365Z"
        fill="#CFE2E5"
      />
      <path
        d="M99.7695 43.8331C99.7731 43.6836 99.7766 43.5341 99.7801 43.3846C100.056 43.3811 100.331 43.3776 100.606 43.374C100.61 43.5294 100.615 43.6848 100.618 43.839L100.601 43.8566C100.331 43.8555 100.061 43.8531 99.7907 43.8519C99.7848 43.8472 99.7778 43.8402 99.7695 43.8331Z"
        fill={fill}
      />
      <path
        d="M101.079 43.8472C101.081 44.1202 101.083 44.3933 101.086 44.6653L101.066 44.6853C100.919 44.6853 100.77 44.6853 100.623 44.6853L100.603 44.6653C100.602 44.3957 100.601 44.1273 100.6 43.8577L100.617 43.8401C100.771 43.8424 100.926 43.8448 101.079 43.8472Z"
        fill={fill}
      />
      <path
        d="M101.959 44.6715C101.959 45.592 101.958 46.5125 101.958 47.4318C101.947 47.4307 101.938 47.4295 101.927 47.4318C101.646 47.433 101.366 47.4342 101.084 47.4365C101.077 46.5196 101.07 45.6037 101.064 44.6868L101.084 44.6667C101.376 44.6679 101.667 44.6691 101.959 44.6715Z"
        fill={fill}
      />
      <path
        d="M101.959 47.4318C102.9 47.4318 103.842 47.433 104.782 47.433L104.787 47.4365C104.786 48.2594 104.786 49.0822 104.785 49.9038C103.841 49.9026 102.897 49.9015 101.951 49.9003C101.943 49.0775 101.935 48.2535 101.927 47.4307C101.939 47.4307 101.948 47.4307 101.959 47.4318Z"
        fill="#CFE3E7"
      />
      <path
        d="M104.786 49.9062C104.787 49.0834 104.787 48.2606 104.788 47.4389C105.631 47.4389 106.473 47.4377 107.316 47.4377C107.317 48.2617 107.318 49.0857 107.318 49.9085C106.474 49.9074 105.63 49.9062 104.786 49.9062Z"
        fill="#B3D6DD"
      />
      <path
        d="M24.8371 52.823C24.8371 51.8519 24.8371 50.8808 24.8371 49.9096C25.7517 49.9108 26.6664 49.9108 27.581 49.912L27.5998 49.9084C27.5928 50.8796 27.5857 51.8519 27.5798 52.823C26.6652 52.8301 25.7506 52.8371 24.8359 52.8442L24.8371 52.823Z"
        fill="#F1F1F1"
      />
      <path
        d="M22.3037 52.823C23.1489 52.823 23.9952 52.823 24.8404 52.823L24.8392 52.8442C24.8392 53.1161 24.8381 53.388 24.8381 53.6588C23.9941 53.6588 23.1501 53.6588 22.3061 53.6588C22.3061 53.3868 22.3049 53.1149 22.3049 52.8442L22.3037 52.823Z"
        fill={fill}
      />
      <path
        d="M59.8478 49.9048C60.1197 49.9048 60.3904 49.9048 60.6623 49.906L60.6906 49.9048C60.6706 50.8759 60.6341 51.847 60.7188 52.8182C61.6935 52.8182 62.6211 52.8182 63.5475 52.8182L63.5451 52.8453C63.5451 53.1172 63.5463 53.3903 63.5463 53.6622C62.5881 53.6669 61.6311 53.6728 60.6729 53.6775C60.6635 53.4173 60.7518 53.0489 60.6164 52.9241C60.4646 52.7852 60.1103 52.8653 59.8442 52.8511C59.8372 52.8441 59.8301 52.837 59.8242 52.83C59.8325 51.8553 59.8407 50.8806 59.8478 49.9048Z"
        fill={fill}
      />
      <path
        d="M59.3574 53.6585C59.3633 53.3854 59.368 53.1111 59.3739 52.838C59.5234 52.8345 59.6729 52.8321 59.8224 52.8286C59.8283 52.8357 59.8353 52.8427 59.8424 52.8498C59.84 53.1229 59.8377 53.396 59.8353 53.6691C59.6811 53.6714 59.5281 53.6738 59.3739 53.6761L59.3574 53.6585Z"
        fill={fill}
      />
      <path
        d="M58.5365 54.1331C58.5354 53.9824 58.5354 53.8306 58.5342 53.6799C58.8085 53.6729 59.0839 53.667 59.3582 53.6599L59.3758 53.6776C59.3723 53.833 59.3688 53.9872 59.3641 54.1425C59.0874 54.139 58.812 54.1355 58.5365 54.1331Z"
        fill={fill}
      />
      <path
        d="M58.4954 54.9944C57.5878 54.9933 56.6791 54.9921 55.7715 54.9909C55.7715 54.7131 55.7727 54.4353 55.7727 54.1587C56.6802 54.1587 57.5866 54.1587 58.4942 54.1587C58.4942 54.4377 58.4954 54.7166 58.4954 54.9944Z"
        fill={fill}
      />
      <path
        d="M58.4984 54.9947C58.4973 54.7157 58.4973 54.4379 58.4961 54.159C58.509 54.1472 58.5232 54.1389 58.5385 54.1331C58.8139 54.1354 59.0905 54.1389 59.366 54.1413H59.3672C59.3625 54.4309 59.3566 54.7193 59.3519 55.0088C59.0811 55.0147 58.8104 55.0206 58.5396 55.0265C58.5232 55.0194 58.5102 55.01 58.4984 54.9947Z"
        fill={outline}
      />
      <path
        d="M55.774 55.0171C55.7751 55.9199 55.7763 56.824 55.7787 57.7268C54.9358 57.7268 54.0918 57.7268 53.249 57.7257C53.2502 56.8228 53.2514 55.9199 53.2526 55.0171C54.093 55.0171 54.9335 55.0171 55.774 55.0171Z"
        fill="#CFE3E7"
      />
      <path
        d="M50.3799 60.2565C50.3811 59.4114 50.3834 58.5673 50.3846 57.7222C51.3404 57.7233 52.2962 57.7245 53.2521 57.7257C53.2521 58.5685 53.2533 59.4102 53.2533 60.253C52.2962 60.2542 51.3381 60.2554 50.3799 60.2565Z"
        fill="#CFE3E7"
      />
      <path
        d="M63.5445 47.4341C63.5457 48.2581 63.5469 49.0809 63.548 49.9049L63.5433 49.9096C62.5934 49.9084 61.6423 49.9072 60.6923 49.9049L60.6641 49.906C60.6676 49.1856 60.67 48.4664 60.6747 47.746C60.6758 47.6401 60.6888 47.5341 60.697 47.427C61.6458 47.4294 62.5946 47.4317 63.5445 47.4341Z"
        fill="#CFE3E7"
      />
      <path
        d="M94.4906 60.2565C93.5348 60.2553 92.579 60.2541 91.6232 60.2529L91.5996 60.2553C91.602 59.4125 91.6031 58.5696 91.6055 57.7268L91.6302 57.7291C92.5837 57.728 93.5383 57.728 94.4918 57.7268C94.493 58.5685 94.4942 59.4101 94.4954 60.2529C94.4954 60.2517 94.4906 60.2565 94.4906 60.2565Z"
        fill="#CFE3E7"
      />
      <path
        d="M60.6649 57.7279C60.3929 57.7267 60.121 57.7255 59.8491 57.7255L59.8291 57.7279C59.8315 56.8262 59.8338 55.9257 59.8362 55.024L59.8562 55.0063C60.1257 55.0122 60.3965 55.0181 60.666 55.0252C60.6672 55.1511 60.6696 55.2771 60.6707 55.4031C60.679 56.1776 60.6872 56.9533 60.6943 57.7279H60.679C60.6802 57.7291 60.6649 57.7279 60.6649 57.7279Z"
        fill={fill}
      />
      <path
        d="M59.3739 60.2552C59.368 59.4124 59.3633 58.5684 59.3574 57.7256L59.3774 57.7279C59.5281 57.7279 59.6776 57.7279 59.8283 57.7279L59.8483 57.7256C59.8436 58.5684 59.8377 59.4124 59.833 60.2552C59.6811 60.2552 59.5269 60.2552 59.3739 60.2552Z"
        fill="#CFE3E7"
      />
      <path
        d="M40.0781 60.2551C40.0793 59.4111 40.0793 58.5683 40.0805 57.7243C41.0375 57.7243 41.9945 57.7231 42.9515 57.7231L42.9562 57.7279C42.9562 58.5695 42.9574 59.4111 42.9574 60.2528L42.9527 60.2575C41.9957 60.2563 41.0375 60.2551 40.0781 60.2551Z"
        fill="#CFE3E7"
      />
      <path
        d="M22.3018 60.2564C21.3471 60.2553 20.3925 60.2541 19.4378 60.2529L19.4131 60.2541C19.4178 60.1376 19.4249 60.021 19.426 59.9045C19.4331 59.1758 19.439 58.4484 19.4437 57.7197C20.396 57.7221 21.3495 57.7233 22.3018 57.7256C22.3029 58.5673 22.3041 59.4089 22.3053 60.2517L22.3018 60.2564Z"
        fill="#CFE3E7"
      />
      <path
        d="M29.7682 60.2574C29.7517 60.2563 29.7352 60.2551 29.7188 60.2527C29.7364 60.1397 29.7682 60.0255 29.7694 59.9125C29.7753 59.1851 29.7753 58.4564 29.7764 57.7278C30.7193 57.7278 31.661 57.7278 32.6039 57.7278C32.6051 58.5683 32.6074 59.4075 32.6086 60.248L32.6027 60.2539C31.6575 60.2551 30.7134 60.2563 29.7682 60.2574Z"
        fill="#CFE3E7"
      />
      <path
        d="M104.787 60.2541C103.84 60.2552 102.894 60.2576 101.947 60.2588C101.931 60.2576 101.916 60.2552 101.9 60.2529C101.918 60.1399 101.951 60.0269 101.952 59.9127C101.958 59.1852 101.956 58.4577 101.957 57.7291C102.901 57.7279 103.845 57.7268 104.788 57.7256C104.789 58.5661 104.791 59.4065 104.793 60.247L104.787 60.2541Z"
        fill="#CFE3E7"
      />
      <path
        d="M101.899 60.2542C101.914 60.2565 101.931 60.2589 101.946 60.26C101.94 61.1805 101.934 62.0999 101.928 63.0204C101.648 63.0204 101.368 63.0204 101.087 63.0192C101.081 62.0975 101.076 61.1758 101.07 60.2542L101.09 60.2553C101.361 60.2542 101.629 60.2542 101.899 60.2542Z"
        fill={fill}
      />
      <path
        d="M110.07 49.906C110.072 50.8818 110.074 51.8589 110.075 52.8347L110.074 52.8359C109.156 52.83 108.237 52.8241 107.318 52.8194C107.32 51.8483 107.32 50.8783 107.321 49.9072C108.238 49.9072 109.155 49.9072 110.07 49.906Z"
        fill="#F1F1F1"
      />
      <path
        d="M27.5834 60.2527C26.6676 60.2539 25.7506 60.2551 24.8348 60.2562L24.8301 60.2515C24.8313 59.4099 24.8324 58.5682 24.8336 57.7254C25.7482 57.7242 26.6629 57.7219 27.5775 57.7207C27.5822 57.8266 27.5916 57.9338 27.5916 58.0397C27.5975 58.7778 27.601 59.5158 27.6057 60.2539L27.5834 60.2527Z"
        fill="#CFE3E7"
      />
      <path
        d="M37.9052 57.7256C37.9005 58.5684 37.8946 59.4124 37.8887 60.2552C36.9694 60.2552 36.05 60.2564 35.1307 60.2564L35.126 60.2517C35.1272 59.4101 35.1283 58.5672 35.1295 57.7256C36.0477 57.7268 36.9658 57.7268 37.884 57.7279L37.9052 57.7256Z"
        fill="#CFE3E7"
      />
      <path
        d="M48.1874 57.7267C48.1898 58.4554 48.1886 59.184 48.1957 59.9115C48.1969 60.0256 48.2275 60.1386 48.2451 60.2517C48.2286 60.2528 48.2122 60.2552 48.1945 60.2564C47.2716 60.2564 46.3488 60.2564 45.4259 60.2575C45.4259 60.2575 45.4212 60.2528 45.4224 60.2528C45.4235 59.503 45.4165 58.752 45.4294 58.0022C45.433 57.782 45.3647 57.7173 45.1469 57.7208C44.4159 57.7326 43.6849 57.7255 42.9539 57.7267L42.9492 57.722C42.9516 56.8191 42.9539 55.9163 42.9563 55.0134C43.7779 55.0158 44.6007 55.017 45.4224 55.0181C45.4235 55.8009 45.4283 56.5849 45.4212 57.3677C45.4188 57.6231 45.4965 57.7361 45.7767 57.7302C46.5807 57.7161 47.3846 57.7267 48.1874 57.7267Z"
        fill="#CFE3E7"
      />
      <path
        d="M58.5391 55.0264C58.8098 55.0206 59.0805 55.0147 59.3513 55.0088L59.3713 55.0241C59.3736 55.9258 59.376 56.8263 59.3784 57.728L59.3583 57.7256C59.0852 57.7244 58.8122 57.7233 58.5391 57.7221C58.5391 56.8228 58.5391 55.9246 58.5391 55.0264Z"
        fill={fill}
      />
      <path
        d="M99.7673 60.2529C98.8527 60.2541 97.9369 60.2553 97.0223 60.2564L97.0176 60.2517C97.0188 59.4101 97.0199 58.5684 97.0211 57.7256C97.9334 57.7233 98.8468 57.7221 99.7591 57.7197C99.765 57.8363 99.7768 57.9516 99.7779 58.0682C99.7838 58.7968 99.7874 59.5254 99.7921 60.2541L99.7673 60.2529Z"
        fill="#CFE3E7"
      />
      <path
        d="M99.7918 60.2541C99.787 59.5254 99.7835 58.7968 99.7776 58.0682C99.7765 57.9516 99.7659 57.8363 99.7588 57.7197L99.7823 57.7221C100.054 57.7233 100.327 57.7233 100.599 57.7244C100.605 58.5673 100.61 59.4113 100.616 60.2541L100.599 60.2506C100.33 60.2529 100.061 60.2529 99.7918 60.2541Z"
        fill={fill}
      />
      <path
        d="M110.071 60.2529C109.153 60.2541 108.235 60.2552 107.318 60.2564L107.313 60.2517C107.315 59.4101 107.316 58.5672 107.317 57.7256C108.234 57.7268 109.15 57.7268 110.067 57.7279L110.089 57.7256C110.09 58.5684 110.092 59.4124 110.093 60.2552L110.071 60.2529Z"
        fill="#CFE3E7"
      />
      <path
        d="M18.5986 53.6705C18.601 53.3974 18.6033 53.1243 18.6057 52.8512C18.8823 52.8429 19.1589 52.8359 19.4367 52.8276L19.4415 52.8323C19.4332 53.109 19.4262 53.3868 19.4191 53.6634C19.1448 53.6658 18.8717 53.6681 18.5986 53.6705Z"
        fill={outline}
      />
      <path
        d="M18.1172 54.145C18.1219 53.9885 18.1266 53.8319 18.1313 53.6754C18.2867 53.6742 18.4409 53.6718 18.5963 53.6707C18.5951 53.826 18.5927 53.9802 18.5916 54.1356C18.435 54.1403 18.2773 54.145 18.1207 54.1486C18.1195 54.1486 18.1172 54.145 18.1172 54.145Z"
        fill="#F1F1F1"
      />
      <path
        d="M100.602 49.9047C100.331 49.9047 100.059 49.9059 99.7882 49.9059C99.7847 49.1878 99.7823 48.4686 99.7776 47.7506C99.7765 47.6446 99.7659 47.5387 99.7588 47.4316L99.7812 47.4292C100.055 47.4304 100.33 47.4327 100.603 47.4339L100.618 47.4304C100.618 48.2567 100.617 49.0819 100.617 49.9082L100.602 49.9047Z"
        fill={fill}
      />
      <path
        d="M100.615 52.8382C100.61 51.8612 100.605 50.883 100.6 49.906L100.616 49.9107C100.768 49.9107 100.919 49.9107 101.07 49.9107L101.087 49.9072C101.08 50.8818 101.072 51.8565 101.065 52.8312C100.914 52.8324 100.764 52.8359 100.615 52.8382Z"
        fill="#F1F0F0"
      />
      <path
        d="M99.7744 53.6774C99.7779 53.4008 99.7803 53.123 99.7838 52.8464C100.06 52.844 100.337 52.8405 100.614 52.8381C100.614 52.8381 100.615 52.8393 100.614 52.8393C100.608 53.1124 100.603 53.3867 100.597 53.6598C100.323 53.6657 100.049 53.6715 99.7744 53.6774Z"
        fill={outline}
      />
      <path
        d="M97.0223 54.1389C97.0223 53.9859 97.0223 53.8317 97.0223 53.6787C97.9416 53.6787 98.8598 53.6775 99.7791 53.6775H99.7803C99.7791 53.827 99.7768 53.9765 99.7756 54.1248C99.6485 54.1319 99.5225 54.1425 99.3954 54.1436C98.6032 54.1495 97.811 54.153 97.0176 54.1578L97.0223 54.1389Z"
        fill="#F1F0F0"
      />
      <path
        d="M94.4959 54.9935C94.4947 54.7157 94.4924 54.439 94.4912 54.1612C95.3352 54.1542 96.1792 54.1459 97.022 54.1377L97.0185 54.1577C97.0185 54.4355 97.0173 54.7133 97.0173 54.9923L97.0197 55.017C96.1792 55.017 95.3376 55.017 94.4971 55.017L94.4959 54.9935Z"
        fill={fill}
      />
      <path
        d="M94.4908 57.7258C93.5373 57.727 92.5826 57.727 91.6292 57.7281C91.6244 56.8288 91.6209 55.9283 91.6162 55.029C92.439 55.0231 93.2618 55.0184 94.0835 55.0113C94.22 55.0101 94.3566 54.9995 94.4931 54.9937L94.4943 55.0172C94.4931 55.9201 94.4919 56.8229 94.4908 57.7258Z"
        fill="#F1F0F0"
      />
      <path
        d="M90.2548 60.2531C89.9994 60.2531 89.7451 60.2531 89.4897 60.2531C89.4732 60.1978 89.4414 60.1424 89.4414 60.0871C89.4438 59.2996 89.4496 58.5121 89.4555 57.7246C89.7333 57.7246 90.01 57.7246 90.2878 57.7246C90.2936 58.5121 90.3007 59.2996 90.3042 60.0871C90.3031 60.1424 90.2713 60.1978 90.2548 60.2531Z"
        fill={fill}
      />
      <path
        d="M91.6058 57.7255C91.6034 58.5683 91.6022 59.4111 91.5999 60.254C91.3327 60.254 91.0655 60.254 90.7982 60.254C90.7971 59.41 90.7971 58.5671 90.7959 57.7231C91.0655 57.7255 91.3362 57.7255 91.6058 57.7255Z"
        fill={fill}
      />
      <path
        d="M79.9644 54.1353C79.6902 54.1377 79.4147 54.1389 79.1404 54.1412C79.1393 53.9835 79.1381 53.8269 79.1357 53.6692C79.4124 53.6715 79.6902 53.6727 79.9668 53.6751C79.9668 53.8293 79.9656 53.9823 79.9644 54.1353Z"
        fill={fill}
      />
      <path
        d="M80.485 55.0252C80.3096 55.024 80.1354 55.0228 79.96 55.0216C79.9611 54.7262 79.9623 54.4307 79.9623 54.1353C80.1365 54.1353 80.3119 54.1364 80.4861 54.1364C80.4861 54.4331 80.485 54.7297 80.485 55.0252Z"
        fill={fill}
      />
      <path
        d="M81.3021 60.2551C81.0337 60.2539 80.7654 60.2527 80.497 60.2527L80.4805 60.2586C80.4781 59.4122 80.477 58.5671 80.4746 57.7207L80.4911 57.7254C80.7618 57.7254 81.0337 57.7254 81.3045 57.7254C81.3033 58.5682 81.3033 59.4111 81.3021 60.2551Z"
        fill={fill}
      />
      <path
        d="M24.8345 57.7256C24.8334 58.5672 24.8322 59.4089 24.831 60.2517C23.9894 60.2517 23.1489 60.2517 22.3072 60.2517C22.3061 59.4101 22.3049 58.5684 22.3037 57.7256C23.1477 57.7256 23.9917 57.7256 24.8345 57.7256Z"
        fill="#B3D6DD"
      />
      <path
        d="M107.319 57.7256C107.318 58.5672 107.317 59.4101 107.316 60.2517C106.475 60.2505 105.635 60.2493 104.796 60.2493C104.795 59.4089 104.792 58.5684 104.791 57.7279C105.633 57.7268 106.477 57.7268 107.319 57.7256Z"
        fill="#B3D6DD"
      />
      <path
        d="M35.133 57.7256C35.1318 58.5672 35.1306 59.4101 35.1294 60.2517C34.289 60.2505 33.4485 60.2493 32.6092 60.2482C32.608 59.4077 32.6057 58.5684 32.6045 57.7279C33.4473 57.7268 34.2901 57.7268 35.133 57.7256Z"
        fill="#B3D6DD"
      />
      <path
        d="M97.022 57.7256C97.0209 58.5672 97.0197 59.4089 97.0185 60.2517C96.1769 60.2517 95.3364 60.2517 94.4947 60.2517C94.4936 59.4101 94.4924 58.5684 94.4912 57.7256C95.3352 57.7256 96.1792 57.7256 97.022 57.7256Z"
        fill="#B3D6DD"
      />
      <path
        d="M42.9541 57.7267C43.6851 57.7267 44.4161 57.7338 45.1471 57.7208C45.3649 57.7173 45.4331 57.7821 45.4296 58.0022C45.4167 58.752 45.4237 59.503 45.4225 60.2528C44.6009 60.2528 43.7781 60.2528 42.9565 60.2528C42.9553 59.4112 42.9553 58.5684 42.9541 57.7267Z"
        fill="#B3D6DD"
      />
      <path
        d="M100.6 47.4353C100.326 47.4341 100.052 47.4317 99.7788 47.4306C99.7717 46.5171 99.7659 45.6048 99.7588 44.6914C99.767 44.6843 99.7764 44.6784 99.7847 44.6702C100.057 44.6678 100.329 44.6667 100.602 44.6643L100.622 44.6843C100.615 45.6025 100.607 46.5195 100.6 47.4353Z"
        fill={fill}
      />
      <path
        d="M29.7402 49.9082C29.7497 49.249 29.7591 48.5898 29.7685 47.9306C29.7708 47.7658 29.7732 47.601 29.7744 47.435C30.7149 47.435 31.6566 47.4338 32.5971 47.4338L32.6018 47.4386C32.6007 48.2602 32.6007 49.083 32.5995 49.9046C31.6566 49.9058 30.7149 49.907 29.772 49.9093C29.7626 49.9093 29.7508 49.9093 29.7402 49.9082Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.126 44.6947C36.0465 44.6888 36.9658 44.6829 37.8863 44.677C37.8899 45.5963 37.8946 46.5157 37.8981 47.4338L37.8828 47.4303C36.9835 47.4315 36.0842 47.4327 35.186 47.4338C35.1672 47.4338 35.1483 47.4327 35.1307 47.4327V47.4315C35.1283 46.5204 35.1272 45.6081 35.126 44.6947Z"
        fill="#F1F0F0"
      />
      <path
        d="M32.5996 49.9048C32.6008 49.0832 32.6008 48.2604 32.602 47.4388C33.4448 47.4364 34.2876 47.4352 35.1316 47.4329C35.1316 47.4329 35.1328 47.434 35.1316 47.434C35.1304 48.258 35.1293 49.082 35.1281 49.9048C34.2853 49.9048 33.4424 49.9048 32.5996 49.9048Z"
        fill="#B3D6DD"
      />
      <path
        d="M19.418 53.6633C19.425 53.3867 19.4333 53.1089 19.4403 52.8323C20.395 52.8358 21.3496 52.8405 22.3043 52.8441C22.3043 53.116 22.3055 53.3879 22.3055 53.6586L22.3078 53.6786C21.352 53.681 20.3962 53.6822 19.4403 53.6845C19.4321 53.6775 19.425 53.6704 19.418 53.6633Z"
        fill={fill}
      />
      <path
        d="M63.5438 49.9048C64.3866 49.9048 65.2294 49.9048 66.0722 49.9048L66.077 49.9095C66.0758 50.8806 66.0758 51.8518 66.0746 52.8229C65.2306 52.83 64.3866 52.8382 63.5426 52.8453L63.5449 52.8182C63.5426 51.8482 63.5414 50.8783 63.5391 49.9083C63.5391 49.9095 63.5438 49.9048 63.5438 49.9048Z"
        fill="#CFE3E7"
      />
      <path
        d="M69.6472 48.3652C69.6543 48.8796 69.6625 49.394 69.6696 49.9084L69.6531 49.9049C69.3824 49.9049 69.1116 49.9061 68.8409 49.9061L68.8232 49.9096C68.8256 49.56 68.8268 49.2092 68.8291 48.8596C69.1022 48.6948 69.3741 48.53 69.6472 48.3652Z"
        fill={fill}
      />
      <path
        d="M66.0771 52.823C66.0783 51.8518 66.0783 50.8807 66.0795 49.9096C66.9953 49.9096 67.9111 49.9108 68.8269 49.9108L68.8446 49.9072C68.8363 50.8807 68.8293 51.8542 68.821 52.8277C67.9052 52.8253 66.9918 52.8242 66.0771 52.823Z"
        fill="#F1F1F1"
      />
      <path
        d="M28.8838 52.8322C28.8897 51.9917 28.8944 51.1501 28.9026 50.3096C28.9038 50.173 28.9156 50.0365 28.9226 49.9011C29.1957 49.9035 29.47 49.9058 29.7431 49.9082C29.7537 49.9094 29.7643 49.9094 29.7749 49.9094C29.7772 50.8876 29.7784 51.8657 29.7808 52.8428C29.4888 52.8475 29.1969 52.8522 28.905 52.8557C28.8979 52.8487 28.8909 52.8404 28.8838 52.8322Z"
        fill={fill}
      />
      <path
        d="M27.582 52.8217C27.5891 51.8506 27.5962 50.8783 27.6032 49.9071C27.8751 49.906 28.1459 49.906 28.4178 49.9048C28.4249 50.8794 28.4331 51.8541 28.4402 52.8288C28.4331 52.8358 28.4272 52.8429 28.4201 52.85C28.1482 52.8488 27.8751 52.8476 27.6032 52.8464C27.595 52.8394 27.5879 52.8311 27.582 52.8217Z"
        fill={fill}
      />
      <path
        d="M28.4392 52.8301C28.5875 52.8313 28.7358 52.8324 28.8841 52.8324C28.8912 52.8407 28.8982 52.8489 28.9053 52.856C28.9029 53.1255 28.9006 53.3951 28.8982 53.6647C28.7405 53.667 28.5828 53.6682 28.425 53.6705C28.4227 53.3974 28.4203 53.1244 28.418 52.8513C28.4262 52.8442 28.4333 52.8371 28.4392 52.8301Z"
        fill={fill}
      />
      <path
        d="M18.0698 60.2516C17.8143 60.2516 17.5601 60.2528 17.3046 60.2528C17.2952 59.41 17.2858 58.5671 17.2764 57.7231C17.5542 57.7255 17.832 57.7267 18.1086 57.729L18.1274 57.7255C18.1251 58.4541 18.1263 59.1828 18.1192 59.9102C18.118 60.0244 18.0874 60.1386 18.0698 60.2516Z"
        fill={fill}
      />
      <path
        d="M18.1123 57.7293C18.1135 56.8241 18.1135 55.9189 18.1147 55.0149L18.1194 55.0078C18.2783 55.0137 18.4372 55.0184 18.5961 55.0243C18.5996 55.926 18.6032 56.8265 18.6067 57.7282L18.5914 57.7246C18.4372 57.7258 18.2842 57.7258 18.13 57.727C18.1311 57.727 18.1123 57.7293 18.1123 57.7293Z"
        fill="#F1F1F1"
      />
      <path
        d="M29.7754 57.7279C29.7742 58.4566 29.7742 59.184 29.7683 59.9127C29.7671 60.0257 29.7354 60.1399 29.7177 60.2529C29.4623 60.2529 29.208 60.2529 28.9526 60.2529C28.9361 60.1976 28.9043 60.1422 28.9043 60.0869C28.9067 59.2994 28.9137 58.5119 28.9184 57.7256C29.1974 57.7279 29.4752 57.7303 29.7542 57.7326C29.7554 57.7326 29.7754 57.7279 29.7754 57.7279Z"
        fill={fill}
      />
      <path
        d="M28.9195 57.7256C28.9136 58.5131 28.9065 59.3006 28.9042 60.0869C28.9042 60.1422 28.9359 60.1976 28.9524 60.2529C28.9359 60.2552 28.9195 60.2564 28.903 60.2576C28.7464 60.2564 28.5887 60.2552 28.4321 60.2541L28.4121 60.2564C28.4192 59.4124 28.4262 58.5696 28.4333 57.7256C28.5875 57.7256 28.7405 57.7268 28.8947 57.7268C28.8936 57.7256 28.9195 57.7256 28.9195 57.7256Z"
        fill="#CFE3E7"
      />
      <path
        d="M18.1307 57.727C18.2849 57.7258 18.438 57.7258 18.5922 57.7246C18.5992 58.5686 18.6063 59.4114 18.6133 60.2554L18.5933 60.2543C18.4368 60.2554 18.2814 60.2566 18.1248 60.2566C18.1084 60.2554 18.0907 60.2543 18.0742 60.2519C18.0919 60.1389 18.1225 60.0247 18.1237 59.9117C18.1284 59.1831 18.1284 58.4544 18.1307 57.727Z"
        fill="#CFE3E7"
      />
      <path
        d="M42.9594 54.1637C42.9559 54.4321 42.9536 54.7005 42.95 54.9689C42.5698 54.983 42.1884 55.0042 41.8082 55.0112C41.2302 55.0206 40.6534 55.0206 40.0755 55.0242L40.0566 55.0054C40.0578 54.7217 40.059 54.438 40.059 54.1531L40.0778 54.1343C40.923 54.1378 41.767 54.1402 42.6122 54.1449C42.7275 54.146 42.8441 54.1566 42.9594 54.1637Z"
        fill={fill}
      />
      <path
        d="M39.2534 53.6621C39.5265 53.6645 39.7996 53.6668 40.0727 53.6692C40.0739 53.8245 40.075 53.9788 40.0762 54.1341L40.0574 54.153C39.7902 54.1518 39.5241 54.1506 39.2569 54.1483C39.2499 54.1412 39.2416 54.133 39.2346 54.1259C39.2346 53.9788 39.2334 53.8316 39.2334 53.6845C39.2393 53.6774 39.2463 53.6703 39.2534 53.6621Z"
        fill={fill}
      />
      <path
        d="M39.2486 52.8476C39.2498 53.1195 39.251 53.3915 39.2533 53.6634C39.2463 53.6704 39.2404 53.6787 39.2333 53.6857C39.0638 53.6822 38.8931 53.6787 38.7236 53.6752C38.7272 53.395 38.7295 53.116 38.7331 52.8359C38.8967 52.8312 39.0603 52.8253 39.2239 52.8206C39.231 52.8288 39.2404 52.8382 39.2486 52.8476Z"
        fill={fill}
      />
      <path
        d="M40.0731 55.0243C40.6511 55.0208 41.2279 55.0208 41.8058 55.0114C42.1872 55.0055 42.5674 54.9831 42.9476 54.969C42.9512 54.9843 42.9535 54.9996 42.9559 55.0149C42.9535 55.9178 42.9512 56.8206 42.9488 57.7235C41.9918 57.7235 41.0348 57.7247 40.0778 57.7247L40.0625 57.7282C40.066 56.8265 40.0696 55.926 40.0731 55.0243Z"
        fill="#F1F1F1"
      />
      <path
        d="M28.4294 57.7242C28.4223 58.5682 28.4153 59.4111 28.4082 60.2551C28.141 60.2551 27.8726 60.2551 27.6054 60.2539C27.6007 59.5158 27.5972 58.7778 27.5913 58.0397C27.5901 57.9338 27.5819 57.8266 27.5771 57.7207L27.5972 57.7242C27.8691 57.7254 28.1422 57.7266 28.4141 57.7278L28.4294 57.7242Z"
        fill={fill}
      />
      <path
        d="M18.6091 60.2553C18.602 59.4113 18.595 58.5684 18.5879 57.7244L18.6032 57.728C18.8763 57.7268 19.1494 57.7256 19.4225 57.7233L19.4437 57.7197C19.4378 58.4484 19.4319 59.1758 19.4248 59.9045C19.4237 60.021 19.4166 60.1376 19.4119 60.2541C19.1447 60.2541 18.8775 60.2553 18.6091 60.2553Z"
        fill={fill}
      />
      <path
        d="M110.095 60.2554C110.094 59.4125 110.093 58.5685 110.092 57.7257C110.363 57.7257 110.633 57.7269 110.904 57.7269C110.904 57.7269 110.918 57.7233 110.918 57.7222C110.91 58.5662 110.903 59.4113 110.895 60.2554C110.629 60.2554 110.361 60.2554 110.095 60.2554Z"
        fill={fill}
      />
      <path
        d="M100.602 44.6653C100.33 44.6676 100.058 44.6688 99.7852 44.6712C99.7863 44.3981 99.7875 44.1262 99.7887 43.8542C100.058 43.8554 100.328 43.8578 100.599 43.859C100.6 44.1273 100.601 44.3969 100.602 44.6653Z"
        fill={outline}
      />
      <path
        d="M40.0752 55.0242C40.0717 55.9258 40.0693 56.8275 40.0658 57.728C39.7927 57.7269 39.5196 57.7257 39.2465 57.7233C39.2442 56.8263 39.2418 55.9294 39.2383 55.0312C39.2453 55.023 39.2536 55.0159 39.2606 55.0077C39.5255 55.0065 39.7904 55.0053 40.0552 55.0042L40.0752 55.0242Z"
        fill={fill}
      />
      <path
        d="M38.729 55.0336C38.7254 55.9306 38.7207 56.8276 38.7172 57.7257C38.4465 57.7257 38.1745 57.7257 37.9038 57.7257L37.8838 57.7281C37.8897 56.8252 37.8944 55.9212 37.9003 55.0183C38.1698 55.016 38.4382 55.0148 38.7078 55.0125C38.716 55.0183 38.7231 55.0266 38.729 55.0336Z"
        fill={fill}
      />
      <path
        d="M39.2377 55.0324C39.0682 55.0324 38.8987 55.0336 38.7292 55.0336C38.7221 55.0265 38.7151 55.0182 38.708 55.0112C38.7115 54.7204 38.7162 54.4285 38.7198 54.1366C38.8916 54.133 39.0623 54.1295 39.2342 54.126C39.2412 54.133 39.2495 54.1413 39.2566 54.1483C39.2577 54.4344 39.2589 54.7216 39.2601 55.0088C39.253 55.0171 39.246 55.0241 39.2377 55.0324Z"
        fill={fill}
      />
      <path
        d="M80.4733 57.7197C80.4757 58.566 80.4769 59.4112 80.4792 60.2576C80.3097 60.2576 80.1402 60.2576 79.9707 60.2576C79.9731 59.4112 79.9754 58.5649 79.9778 57.7185C80.1426 57.7197 80.3074 57.7197 80.4733 57.7197Z"
        fill="#D5DBDB"
      />
      <path
        d="M110.9 57.727C110.629 57.727 110.359 57.7258 110.088 57.7258L110.065 57.7282C110.071 56.8253 110.078 55.9225 110.084 55.0184C110.353 55.0149 110.62 55.0113 110.888 55.0078L110.911 55.0267C110.907 55.9272 110.904 56.8265 110.9 57.727Z"
        fill={fill}
      />
      <path
        d="M110.892 55.0079C110.624 55.0114 110.356 55.015 110.088 55.0185H110.087C110.09 54.7289 110.094 54.4393 110.098 54.1498C110.367 54.1462 110.638 54.1427 110.907 54.1403L110.909 54.1392C110.903 54.4287 110.897 54.7183 110.892 55.0079Z"
        fill={outline}
      />
      <path
        d="M110.904 54.1402C110.634 54.1437 110.363 54.1472 110.094 54.1496L110.073 54.1319C110.071 53.9813 110.071 53.8294 110.07 53.6788L110.089 53.6599C110.359 53.6599 110.627 53.6599 110.897 53.6599L110.915 53.6788C110.911 53.833 110.907 53.986 110.904 54.1402Z"
        fill={fill}
      />
      <path
        d="M100.616 60.2554C100.61 59.4126 100.605 58.5686 100.6 57.7258L100.62 57.7281C100.77 57.727 100.921 57.7258 101.072 57.7246C101.079 58.5686 101.086 59.4114 101.093 60.2554L101.073 60.2543C100.92 60.2543 100.768 60.2543 100.616 60.2554Z"
        fill="#CFE3E7"
      />
      <path
        d="M39.2261 52.8194C39.0625 52.8241 38.8988 52.83 38.7352 52.8347L38.7329 52.8311C38.7282 51.8565 38.7235 50.8818 38.7188 49.9071L38.7376 49.9095C38.9 49.9083 39.0636 49.906 39.2261 49.9048C39.2261 50.8759 39.2261 51.8482 39.2261 52.8194Z"
        fill="#F1F1F1"
      />
      <path
        d="M38.7421 47.4307C38.7409 48.257 38.7397 49.0834 38.7386 49.9097L38.7197 49.9073C38.449 49.9073 38.1794 49.9073 37.9087 49.9073C37.9016 49.0822 37.8957 48.257 37.8887 47.4318L37.904 47.4354C38.1771 47.4342 38.4502 47.433 38.7221 47.4318L38.7421 47.4307Z"
        fill={fill}
      />
      <path
        d="M38.7185 47.433C38.4455 47.4342 38.1724 47.4353 37.9004 47.4365C37.8969 46.5172 37.8922 45.5978 37.8887 44.6797C38.1688 44.682 38.449 44.6844 38.7291 44.6856C38.7256 45.6002 38.7221 46.5172 38.7185 47.433Z"
        fill={fill}
      />
      <path
        d="M18.5939 55.024C18.435 55.0181 18.2761 55.0134 18.1172 55.0075C18.1184 54.7215 18.1195 54.4342 18.1207 54.1482C18.2773 54.1435 18.435 54.1388 18.5916 54.1353L18.6116 54.1517C18.6128 54.4366 18.6139 54.7215 18.6151 55.0063L18.5939 55.024Z"
        fill={fill}
      />
      <path
        d="M68.8514 54.1531C68.8491 54.4415 68.8467 54.7299 68.8432 55.0183C67.9203 55.0183 66.9974 55.0183 66.0757 55.0183C65.2329 55.0183 64.3913 55.0183 63.5484 55.0183L63.552 54.9959C63.552 54.7169 63.5508 54.4368 63.5508 54.1578L63.5449 54.1378C64.1617 54.1401 64.7786 54.1436 65.3965 54.1425C66.5419 54.1413 67.6884 54.1366 68.8338 54.1331L68.8514 54.1531Z"
        fill={fill}
      />
      <path
        d="M60.6982 57.7279C60.6899 56.9534 60.6829 56.1777 60.6746 55.4031C60.6735 55.2772 60.6711 55.1512 60.6699 55.0252C60.8159 55.0217 60.9607 55.0146 61.1066 55.0135C61.9224 55.0064 62.7381 55.0005 63.5539 54.9946L63.5504 55.017C63.5492 55.9187 63.548 56.8215 63.5468 57.7232C62.5969 57.7256 61.6469 57.7268 60.6982 57.7279Z"
        fill="#F1F1F1"
      />
      <path
        d="M69.6719 53.6775C69.6684 53.8317 69.6649 53.9871 69.6613 54.1413C69.3906 54.1448 69.121 54.1483 68.8503 54.1519L68.8326 54.1319C68.8315 53.9812 68.8303 53.8305 68.8291 53.6787L68.8468 53.6586C69.1163 53.6586 69.3859 53.6586 69.6543 53.6575L69.6719 53.6775Z"
        fill={fill}
      />
      <path
        d="M70.1452 52.8569C70.1428 53.1253 70.1404 53.3937 70.1381 53.6621C69.9827 53.6668 69.8273 53.6727 69.6719 53.6774C69.6719 53.6774 69.6543 53.6586 69.6543 53.6598C69.6555 53.3902 69.6566 53.1206 69.6578 52.8511L69.679 52.8311C69.8273 52.8322 69.9745 52.8334 70.1228 52.8346C70.1299 52.8416 70.1369 52.8499 70.1452 52.8569Z"
        fill={fill}
      />
      <path
        d="M110.897 53.6609C110.627 53.6609 110.359 53.6609 110.089 53.6609C110.083 53.3866 110.076 53.1111 110.07 52.8369L110.071 52.8357C110.347 52.8416 110.622 52.8463 110.898 52.8522C110.898 53.1217 110.898 53.3913 110.897 53.6609Z"
        fill={outline}
      />
      <path
        d="M70.1265 52.8347C69.9782 52.8335 69.831 52.8323 69.6827 52.8311C69.6768 52.724 69.6674 52.6169 69.6674 52.5098C69.6639 51.6411 69.6615 50.7735 69.6592 49.9048L69.6757 49.9083C69.831 49.9083 69.9864 49.9083 70.1418 49.9095C70.1359 50.8842 70.1312 51.8588 70.1265 52.8347Z"
        fill="#F1EFEF"
      />
      <path
        d="M100.604 47.4351C100.612 46.5181 100.619 45.6023 100.625 44.6853C100.772 44.6853 100.92 44.6853 101.067 44.6853C101.074 45.6023 101.081 46.5181 101.087 47.4351L101.072 47.4315C100.921 47.4315 100.77 47.4315 100.62 47.4315L100.604 47.4351Z"
        fill="#F1F0F0"
      />
      <path
        d="M101.93 47.4318C101.938 48.2547 101.946 49.0786 101.954 49.9015C101.939 49.9038 101.924 49.9073 101.908 49.9097C101.635 49.9085 101.362 49.9062 101.088 49.905L101.071 49.9085C101.071 49.0822 101.07 48.257 101.07 47.4307L101.086 47.4342C101.368 47.4342 101.648 47.433 101.93 47.4318Z"
        fill={fill}
      />
      <path
        d="M101.905 49.9094C101.921 49.9058 101.936 49.9035 101.951 49.9011C102.895 49.9023 103.839 49.9035 104.785 49.9047C104.785 50.8793 104.786 51.8528 104.786 52.8275C103.848 52.8298 102.908 52.8322 101.97 52.8333C101.948 51.8599 101.926 50.8852 101.905 49.9094Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.787 52.8288C104.787 51.8542 104.786 50.8807 104.786 49.906C105.63 49.9072 106.474 49.9072 107.318 49.9084C107.317 50.8795 107.317 51.8494 107.316 52.8206V52.8465C106.473 52.8488 105.63 52.8512 104.787 52.8535C104.786 52.8535 104.787 52.8288 104.787 52.8288Z"
        fill="#CFE2E5"
      />
      <path
        d="M24.8336 53.6588C24.8336 53.3868 24.8348 53.1149 24.8348 52.8442C25.7494 52.8371 26.664 52.8301 27.5787 52.823C27.5846 52.8312 27.5916 52.8395 27.5987 52.8477C27.5963 53.1232 27.594 53.3998 27.5904 53.6752C26.6699 53.6764 25.7506 53.6776 24.8301 53.6788L24.8336 53.6588Z"
        fill={fill}
      />
      <path
        d="M22.3037 53.6584C23.1477 53.6584 23.9917 53.6584 24.8357 53.6584L24.8334 53.6785C24.8334 53.8315 24.8334 53.9857 24.8334 54.1387C23.9905 54.1387 23.1477 54.1387 22.3049 54.1387C22.3049 53.9857 22.3049 53.8315 22.3049 53.6785L22.3037 53.6584Z"
        fill="#CFE3E7"
      />
      <path
        d="M63.5407 49.9095C63.5431 50.8795 63.5442 51.8494 63.5466 52.8194C62.619 52.8194 61.6914 52.8194 60.718 52.8194C60.6332 51.8483 60.6685 50.8771 60.6897 49.906C61.6396 49.906 62.5896 49.9084 63.5407 49.9095Z"
        fill="#F1F1F1"
      />
      <path
        d="M66.0746 52.823C66.9892 52.8242 67.9039 52.8253 68.8185 52.8277C68.8267 52.8348 68.8338 52.8418 68.8408 52.8501C68.842 53.1208 68.8432 53.3904 68.8444 53.6611L68.8267 53.6811C67.0646 53.6811 65.3012 53.68 63.5391 53.68L63.5438 53.6635C63.5438 53.3916 63.5426 53.1185 63.5426 52.8465C64.3866 52.8383 65.2306 52.8301 66.0746 52.823Z"
        fill={fill}
      />
      <path
        d="M60.6735 53.6774C61.6316 53.6727 62.5886 53.6668 63.5468 53.6621L63.5421 53.6786C63.5433 53.8316 63.5433 53.9835 63.5445 54.1365L63.5504 54.1565C62.5898 54.1483 61.6293 54.1412 60.6699 54.133C60.6711 53.9811 60.6723 53.8293 60.6735 53.6774C60.6723 53.6786 60.6735 53.6774 60.6735 53.6774Z"
        fill="#F1F0F0"
      />
      <path
        d="M59.8398 53.6705C59.8422 53.3974 59.8446 53.1243 59.8469 52.8512C60.1129 52.8665 60.4673 52.7853 60.6191 52.9242C60.7545 53.049 60.665 53.4162 60.6756 53.6776L60.6744 53.6787C60.3943 53.6752 60.1165 53.6728 59.8398 53.6705Z"
        fill={outline}
      />
      <path
        d="M59.3633 54.1412C59.3668 53.9858 59.3703 53.8316 59.3751 53.6763C59.5293 53.6739 59.6823 53.6715 59.8365 53.6692C59.8377 53.8269 59.8388 53.9835 59.8412 54.1412H59.84C59.6811 54.1412 59.5222 54.1412 59.3633 54.1412Z"
        fill="#F1F1F1"
      />
      <path
        d="M59.3678 54.1414C59.5256 54.1414 59.6845 54.1414 59.8422 54.1414C59.8469 54.4298 59.8528 54.7181 59.8575 55.0065L59.8375 55.0242C59.6821 55.0242 59.5279 55.0242 59.3726 55.0242L59.3525 55.0089C59.3572 54.7193 59.3631 54.4309 59.3678 54.1414Z"
        fill={fill}
      />
      <path
        d="M59.374 55.0242C59.5294 55.0242 59.6836 55.0242 59.839 55.0242C59.8366 55.9259 59.8343 56.8264 59.8319 57.728C59.6813 57.728 59.5318 57.728 59.3811 57.728C59.3787 56.8264 59.3764 55.9247 59.374 55.0242Z"
        fill="#F1F1F1"
      />
      <path
        d="M59.8551 55.0065C59.8504 54.7181 59.8446 54.4297 59.8398 54.1413H59.841C60.1165 54.1389 60.3919 54.1366 60.6674 54.1331C60.6662 54.4309 60.6662 54.7275 60.665 55.0241C60.3954 55.0194 60.1247 55.0124 59.8551 55.0065Z"
        fill={outline}
      />
      <path
        d="M22.3043 57.7257C21.352 57.7233 20.3985 57.7221 19.4462 57.7198L19.425 57.7233C19.425 56.8228 19.4238 55.9223 19.4238 55.0218C19.5886 55.0183 19.7546 55.0136 19.9194 55.0112C20.7163 55.0042 21.5144 54.9983 22.3113 54.9912L22.309 55.0147C22.3066 55.92 22.3054 56.8228 22.3043 57.7257Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.6043 57.728C31.6614 57.728 30.7197 57.728 29.7768 57.728L29.7568 57.7315C29.7627 56.8263 29.7686 55.9211 29.7745 55.0171C30.7162 55.0147 31.6579 55.0124 32.5996 55.01C32.6008 55.9164 32.602 56.8216 32.6043 57.728Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.786 57.728C103.842 57.7292 102.898 57.7304 101.955 57.7315L101.933 57.7339C101.941 56.8275 101.948 55.9223 101.955 55.0159C102.897 55.0135 103.84 55.0112 104.781 55.01C104.782 55.9152 104.785 56.8216 104.786 57.728Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.091 60.2554C101.084 59.4114 101.077 58.5686 101.07 57.7246L101.084 57.7281C101.367 57.7293 101.649 57.7317 101.932 57.7328L101.954 57.7305C101.953 58.458 101.954 59.1854 101.95 59.9141C101.948 60.0271 101.917 60.1401 101.898 60.2543C101.629 60.2543 101.361 60.2543 101.091 60.2554Z"
        fill={fill}
      />
      <path
        d="M110.07 52.837C110.076 53.1113 110.083 53.3868 110.089 53.661L110.07 53.6799C109.151 53.674 108.233 53.6681 107.313 53.6622C107.313 53.3903 107.315 53.1184 107.315 52.8465V52.8206C108.233 52.8253 109.151 52.8312 110.07 52.837Z"
        fill={fill}
      />
      <path
        d="M27.5799 57.721C26.6652 57.7222 25.7506 57.7246 24.836 57.7257C24.8348 56.8229 24.8336 55.9188 24.8324 55.016L24.8301 54.9924C24.9749 54.9995 25.1197 55.0101 25.2644 55.0113C26.0402 55.0195 26.8159 55.0242 27.5916 55.0301C27.594 55.9283 27.5975 56.8264 27.5999 57.7246L27.5799 57.721Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.9028 55.017C37.8969 55.9198 37.8922 56.8239 37.8863 57.7267C36.9682 57.7255 36.05 57.7255 35.1318 57.7244C35.1318 56.8227 35.133 55.9198 35.133 55.0181C36.0559 55.017 36.9788 55.0158 37.9004 55.0134L37.9028 55.017Z"
        fill="#F1F1F1"
      />
      <path
        d="M99.7615 57.7211C98.8492 57.7234 97.9357 57.7246 97.0235 57.727C97.0223 56.8241 97.0211 55.9212 97.0199 55.0184L97.0176 54.9937C97.1836 55.0007 97.3495 55.0101 97.5155 55.0125C98.2689 55.0207 99.0234 55.0278 99.7768 55.0349C99.7791 55.9318 99.7815 56.8276 99.785 57.7246L99.7615 57.7211Z"
        fill="#F1F1F1"
      />
      <path
        d="M99.7827 57.7233C99.7803 56.8263 99.7779 55.9305 99.7744 55.0335C99.7827 55.0253 99.7897 55.017 99.798 55.0088C100.066 55.0111 100.335 55.0147 100.603 55.017C100.609 55.9199 100.614 56.8239 100.62 57.7268L100.6 57.7244C100.328 57.7244 100.055 57.7244 99.7827 57.7233Z"
        fill={fill}
      />
      <path
        d="M110.087 55.0181C110.081 55.9209 110.074 56.8238 110.068 57.7278C109.151 57.7266 108.234 57.7266 107.318 57.7255C107.318 56.8238 107.32 55.9209 107.32 55.0192C108.241 55.0192 109.164 55.0181 110.086 55.0181H110.087Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.5938 54.1341C18.5949 53.9788 18.5973 53.8245 18.5985 53.6692C18.8716 53.6668 19.1446 53.6645 19.4177 53.6621C19.4248 53.6692 19.4319 53.6762 19.4389 53.6833C19.4354 53.834 19.4307 53.9835 19.4272 54.1341C19.1564 54.14 18.8845 54.1447 18.6138 54.1506L18.5938 54.1341Z"
        fill={fill}
      />
      <path
        d="M101.074 47.4316C101.074 48.258 101.075 49.0832 101.075 49.9095C100.924 49.9095 100.773 49.9095 100.621 49.9095C100.621 49.0832 100.622 48.258 100.622 47.4316C100.773 47.4316 100.924 47.4316 101.074 47.4316Z"
        fill="#CFE3E7"
      />
      <path
        d="M101.907 49.9095C101.928 50.8842 101.951 51.86 101.972 52.8347C101.964 52.8429 101.957 52.8511 101.948 52.8582C101.66 52.8559 101.373 52.8523 101.084 52.85L101.064 52.8288C101.072 51.8541 101.08 50.8794 101.087 49.9048C101.36 49.9071 101.634 49.9083 101.907 49.9095Z"
        fill={fill}
      />
      <path
        d="M100.6 53.6585C100.605 53.3854 100.61 53.1111 100.616 52.838C100.766 52.8345 100.915 52.8321 101.065 52.8286L101.083 52.8498C101.081 53.1229 101.079 53.396 101.078 53.6703C100.923 53.6726 100.77 53.675 100.616 53.6773L100.6 53.6585Z"
        fill={fill}
      />
      <path
        d="M99.7744 54.1249C99.7756 53.9754 99.778 53.8259 99.7791 53.6776C100.053 53.6717 100.328 53.6658 100.602 53.6599L100.62 53.6776C100.616 53.833 100.613 53.9872 100.608 54.1425C100.337 54.1449 100.066 54.1472 99.7968 54.1496C99.7885 54.1414 99.7815 54.1331 99.7744 54.1249Z"
        fill={fill}
      />
      <path
        d="M99.7768 55.0335C99.0234 55.0264 98.2689 55.0206 97.5155 55.0111C97.3495 55.0088 97.1836 54.9994 97.0176 54.9923C97.0176 54.7145 97.0188 54.4355 97.0188 54.1577C97.811 54.153 98.6032 54.1495 99.3966 54.1436C99.5237 54.1424 99.6496 54.1306 99.7768 54.1248C99.7838 54.133 99.7909 54.1401 99.7991 54.1483C99.8003 54.4355 99.8015 54.7216 99.8015 55.0088C99.7921 55.017 99.785 55.0253 99.7768 55.0335Z"
        fill={fill}
      />
      <path
        d="M97.0185 55.0171C97.0197 55.9199 97.0209 56.8228 97.022 57.7257C96.178 57.7257 95.3352 57.7257 94.4912 57.7257C94.4924 56.8228 94.4936 55.9199 94.4947 55.0171C95.3364 55.0171 96.178 55.0171 97.0185 55.0171Z"
        fill="#CFE3E7"
      />
      <path
        d="M24.831 55.0159C24.8322 55.9187 24.8334 56.8228 24.8345 57.7256C23.9905 57.7256 23.1477 57.7256 22.3037 57.7256C22.3049 56.8228 22.3061 55.9187 22.3072 55.0159C23.1489 55.0159 23.9905 55.0159 24.831 55.0159Z"
        fill="#CFE3E7"
      />
      <path
        d="M107.316 55.0193C107.316 55.921 107.315 56.8238 107.315 57.7255C106.472 57.7255 105.629 57.7267 104.785 57.7267C104.784 56.8203 104.781 55.9151 104.78 55.0087C104.781 54.9922 104.783 54.9758 104.786 54.9604C104.832 54.9769 104.878 55.0075 104.923 55.0075C105.721 55.004 106.518 54.9969 107.316 54.9911V55.0193Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.134 55.0193C35.134 55.921 35.1328 56.8238 35.1328 57.7255C34.29 57.7267 33.4471 57.7267 32.6043 57.7279C32.6031 56.8215 32.6008 55.9163 32.5996 55.0099C32.6008 54.9934 32.6031 54.9769 32.6055 54.9604C33.4483 54.9699 34.2923 54.9805 35.1351 54.9899L35.134 55.0193Z"
        fill="#CFE3E7"
      />
      <path
        d="M29.7783 52.8429C29.776 51.8647 29.7748 50.8865 29.7725 49.9095C30.7153 49.9083 31.657 49.9071 32.5999 49.9048C32.5999 50.8794 32.6011 51.8529 32.6011 52.8276C31.6594 52.8335 30.7189 52.8382 29.7783 52.8429Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.8872 47.4316C37.8943 48.2568 37.9002 49.082 37.9072 49.9071L37.8861 49.906C36.9879 49.906 36.0886 49.906 35.1904 49.906C35.2104 49.8118 35.2458 49.7176 35.2469 49.6235C35.2516 48.9878 35.2516 48.3522 35.2469 47.7177C35.2458 47.6235 35.2104 47.5293 35.1904 47.4352C36.0898 47.434 36.9891 47.4328 37.8872 47.4316Z"
        fill="#CFE3E7"
      />
      <path
        d="M35.1907 47.435C35.2107 47.5292 35.246 47.6234 35.2472 47.7175C35.2519 48.3532 35.2519 48.9888 35.2472 49.6233C35.246 49.7175 35.2107 49.8116 35.1907 49.9058C35.1719 49.9058 35.1542 49.907 35.1365 49.9093L35.1318 49.9046C35.133 49.0806 35.1342 48.2567 35.1354 47.4338C35.1542 47.4338 35.1719 47.4338 35.1907 47.435Z"
        fill="#CFE3E7"
      />
      <path
        d="M32.6008 52.8276C32.6008 51.8529 32.5996 50.8794 32.5996 49.9048C33.4424 49.9048 34.2853 49.9048 35.1281 49.9048L35.1328 49.9095C35.1328 50.8806 35.1328 51.8518 35.1328 52.8229C35.0268 52.8288 34.9197 52.8382 34.8138 52.8394C34.0757 52.8453 33.3377 52.8488 32.6008 52.8535V52.8276Z"
        fill="#CFE3E7"
      />
      <path
        d="M19.4238 54.1354C19.4274 53.9848 19.4321 53.8353 19.4356 53.6846C20.3914 53.6822 21.3473 53.6811 22.3043 53.6787C22.3043 53.8317 22.3043 53.9859 22.3043 54.139L22.3078 54.159C21.3473 54.1507 20.3855 54.1437 19.4238 54.1354Z"
        fill="#F1F0F0"
      />
      <path
        d="M69.6541 49.9048C69.6565 50.7735 69.6588 51.6411 69.6624 52.5098C69.6624 52.6169 69.673 52.724 69.6777 52.8311L69.6565 52.8511C69.3846 52.8511 69.1126 52.85 68.8407 52.85C68.8337 52.8417 68.8266 52.8347 68.8184 52.8276C68.8266 51.8541 68.8337 50.8806 68.8419 49.9071C69.1126 49.906 69.3834 49.906 69.6541 49.9048Z"
        fill={fill}
      />
      <path
        d="M28.8936 53.6647C28.8959 53.3951 28.8983 53.1255 28.9006 52.856C29.1925 52.8513 29.4845 52.8477 29.7764 52.843C29.7717 53.1126 29.767 53.3833 29.7623 53.6529C29.4739 53.6576 29.1843 53.6611 28.8959 53.6658C28.8947 53.6658 28.8936 53.6647 28.8936 53.6647Z"
        fill={outline}
      />
      <path
        d="M27.5928 53.6752C27.5951 53.3997 27.5975 53.1231 27.601 52.8477C27.8729 52.8488 28.146 52.85 28.4179 52.8512C28.4203 53.1243 28.4227 53.3974 28.425 53.6705C28.146 53.6716 27.8694 53.6728 27.5928 53.6752Z"
        fill={outline}
      />
      <path
        d="M28.4229 53.6704C28.5806 53.6681 28.7383 53.6669 28.8961 53.6646L28.8972 53.6657C28.8961 53.8235 28.8949 53.9812 28.8937 54.1389C28.7383 54.1377 28.5841 54.1354 28.4287 54.1342C28.4252 53.98 28.424 53.8246 28.4229 53.6704Z"
        fill="#F1F1F1"
      />
      <path
        d="M19.4224 55.0231C19.4224 55.9236 19.4236 56.8241 19.4236 57.7246C19.1505 57.7258 18.8774 57.727 18.6043 57.7293C18.6008 56.8277 18.5973 55.9272 18.5938 55.0255L18.6138 55.0078C18.8845 55.0125 19.1529 55.0172 19.4224 55.0231Z"
        fill={fill}
      />
      <path
        d="M29.7729 55.017C29.767 55.9222 29.7611 56.8274 29.7552 57.7315C29.4762 57.7291 29.1973 57.7268 28.9194 57.7244H28.8936C28.8947 56.8215 28.8971 55.9199 28.8983 55.017C28.9053 55.0099 28.9124 55.0029 28.9194 54.9958C29.1973 54.9958 29.4739 54.9946 29.7517 54.9946C29.7587 55.0029 29.7658 55.0099 29.7729 55.017Z"
        fill={fill}
      />
      <path
        d="M28.8994 55.0181C28.8982 55.9209 28.8959 56.8226 28.8947 57.7255C28.7405 57.7255 28.5875 57.7243 28.4333 57.7243L28.418 57.7278C28.4215 56.8261 28.425 55.9256 28.4286 55.0239C28.5863 55.0216 28.7429 55.0204 28.8994 55.0181Z"
        fill="#F1F1F1"
      />
      <path
        d="M39.2574 55.0089C39.2563 54.7217 39.2551 54.4357 39.2539 54.1484C39.5211 54.1496 39.7883 54.1508 40.0544 54.1531C40.0532 54.4368 40.052 54.7217 40.052 55.0054C39.7871 55.0066 39.5223 55.0077 39.2574 55.0089Z"
        fill={outline}
      />
      <path
        d="M39.2332 54.126C39.0613 54.1295 38.8906 54.1331 38.7188 54.1366C38.7199 53.9824 38.7211 53.8282 38.7223 53.6728V53.6716C38.8918 53.6752 39.0625 53.6787 39.232 53.6822C39.232 53.8317 39.232 53.9789 39.2332 54.126Z"
        fill="#F1EFEF"
      />
      <path
        d="M38.735 52.8346C38.7315 53.1148 38.7291 53.3938 38.7256 53.6739V53.6751C38.4525 53.6704 38.1794 53.6657 37.9063 53.661C37.9004 53.3867 37.8946 53.1136 37.8887 52.8393V52.8382C38.17 52.8358 38.4502 52.8346 38.7315 52.8323L38.735 52.8346Z"
        fill={outline}
      />
      <path
        d="M28.4237 55.0242C28.4201 55.9259 28.4166 56.8264 28.4131 57.7281C28.1411 57.7269 27.868 57.7257 27.5961 57.7245C27.5938 56.8264 27.5902 55.9282 27.5879 55.0301C27.595 55.0218 27.6032 55.0148 27.6103 55.0065C27.8751 55.0065 28.1388 55.0054 28.4036 55.0054C28.4036 55.0065 28.4237 55.0242 28.4237 55.0242Z"
        fill={fill}
      />
      <path
        d="M38.7199 54.1377C38.7163 54.4296 38.7128 54.7204 38.7081 55.0123C38.4385 55.0146 38.1702 55.0158 37.9006 55.0182L37.8994 55.0158C37.9018 54.7286 37.9053 54.4414 37.9077 54.153C38.1772 54.1471 38.4491 54.1424 38.7199 54.1377Z"
        fill={outline}
      />
      <path
        d="M110.086 55.0183C109.164 55.0194 108.241 55.0194 107.319 55.0194C107.319 55.0194 107.319 54.99 107.319 54.9912C107.317 54.7134 107.316 54.4356 107.313 54.1578C108.234 54.1495 109.155 54.1413 110.075 54.1331L110.096 54.1507C110.093 54.4391 110.089 54.7287 110.086 55.0183Z"
        fill={fill}
      />
      <path
        d="M110.075 54.133C109.155 54.1412 108.234 54.1494 107.313 54.1577L107.317 54.14C107.318 53.9858 107.319 53.8316 107.321 53.6774L107.317 53.6621C108.236 53.668 109.155 53.6739 110.074 53.6798C110.073 53.8304 110.074 53.9811 110.075 54.133Z"
        fill="#F1F1F1"
      />
      <path
        d="M100.621 57.7268C100.615 56.8239 100.61 55.9199 100.604 55.017L100.607 55.0159C100.765 55.0194 100.921 55.0217 101.079 55.0253C101.082 55.9258 101.086 56.8275 101.088 57.728L101.074 57.7244C100.924 57.7256 100.772 57.7256 100.621 57.7268Z"
        fill="#F1F1F1"
      />
      <path
        d="M38.7301 52.8312C38.4488 52.8335 38.1687 52.8347 37.8873 52.8371C37.8861 51.86 37.885 50.883 37.8838 49.906L37.905 49.9072C38.1757 49.9072 38.4453 49.9072 38.716 49.9072C38.7207 50.8818 38.7254 51.8565 38.7301 52.8312Z"
        fill={fill}
      />
      <path
        d="M19.4251 55.0228C19.1555 55.0169 18.886 55.0122 18.6176 55.0063C18.6164 54.7215 18.6152 54.4366 18.6152 54.1517C18.886 54.1458 19.1579 54.1411 19.4286 54.1353C19.4275 54.4307 19.4263 54.7273 19.4251 55.0228Z"
        fill={outline}
      />
      <path
        d="M60.6641 55.0254C60.6652 54.7287 60.6652 54.4309 60.6664 54.1343C61.6269 54.1425 62.5875 54.1496 63.5468 54.1578C63.5468 54.438 63.548 54.7169 63.548 54.9959C62.7323 55.0018 61.9165 55.0077 61.1008 55.0148C60.956 55.0148 60.81 55.0218 60.6641 55.0254Z"
        fill={fill}
      />
      <path
        d="M63.5414 54.1366C63.5402 53.9836 63.5402 53.8317 63.5391 53.6787C65.3012 53.6787 67.0646 53.6799 68.8267 53.6799C68.8279 53.8306 68.8291 53.9812 68.8303 54.1331C67.6849 54.1366 66.5384 54.1413 65.393 54.1425C64.775 54.1425 64.1582 54.139 63.5414 54.1366Z"
        fill="#E1EAEC"
      />
      <path
        d="M68.8447 52.8486C69.1166 52.8486 69.3886 52.8498 69.6605 52.8498C69.6593 53.1194 69.6581 53.3889 69.6569 53.6585C69.3874 53.6585 69.1178 53.6585 68.8483 53.6585C68.8471 53.3901 68.8459 53.1194 68.8447 52.8486Z"
        fill={outline}
      />
      <path
        d="M101.971 52.8345C102.909 52.8321 103.848 52.8298 104.786 52.8286L104.785 52.8533C104.785 53.1217 104.785 53.3889 104.785 53.6573L104.787 53.6785C103.845 53.6738 102.901 53.6679 101.958 53.6632C101.954 53.396 101.952 53.1276 101.948 52.8604C101.954 52.851 101.962 52.8427 101.971 52.8345Z"
        fill={fill}
      />
      <path
        d="M104.786 53.6565C104.786 53.3881 104.786 53.1209 104.786 52.8525C105.629 52.8502 106.472 52.8478 107.315 52.8455C107.315 53.1174 107.313 53.3893 107.313 53.6612L107.317 53.6765C106.474 53.6706 105.63 53.6636 104.786 53.6565Z"
        fill={fill}
      />
      <path
        d="M24.8336 54.1391C24.8336 53.986 24.8336 53.8319 24.8336 53.6788C25.7541 53.6777 26.6735 53.6765 27.594 53.6753C27.5916 53.826 27.5904 53.9778 27.5881 54.1285C27.4716 54.1344 27.3538 54.1438 27.2373 54.1438C26.4345 54.1497 25.6329 54.1532 24.8301 54.1579L24.8336 54.1391Z"
        fill="#F1F0F0"
      />
      <path
        d="M24.8287 55.0158C23.9882 55.0158 23.1465 55.0158 22.3061 55.0158L22.3084 54.9923C22.3084 54.7145 22.3072 54.4367 22.3072 54.1577L22.3037 54.1377C23.1465 54.1377 23.9894 54.1377 24.8322 54.1377L24.8287 54.1577C24.8287 54.4355 24.8275 54.7133 24.8275 54.9923L24.8287 55.0158Z"
        fill={fill}
      />
      <path
        d="M60.6709 54.1345C60.3954 54.1368 60.12 54.1392 59.8446 54.1427C59.8434 53.9849 59.8422 53.8284 59.8398 53.6707C60.1176 53.673 60.3954 53.6765 60.6732 53.6789C60.6732 53.8308 60.6721 53.9826 60.6709 54.1345Z"
        fill={fill}
      />
      <path
        d="M22.3101 54.1591C22.3101 54.4369 22.3113 54.7159 22.3113 54.9937C21.5144 54.9995 20.7163 55.0066 19.9194 55.0137C19.7546 55.0149 19.5886 55.0207 19.4238 55.0243C19.425 54.7288 19.425 54.4322 19.4262 54.1367C20.3879 54.1438 21.3496 54.1508 22.3101 54.1591Z"
        fill={fill}
      />
      <path
        d="M32.6032 54.9606C32.6008 54.9771 32.5985 54.9936 32.5973 55.01C31.6556 55.0124 30.7139 55.0148 29.7722 55.0171C29.7651 55.01 29.758 55.003 29.751 54.9959C29.7533 54.7181 29.7545 54.4391 29.7557 54.1613C29.7627 54.1543 29.7698 54.1472 29.7769 54.1401C30.7174 54.1425 31.6591 54.1437 32.5996 54.146C32.6008 54.1625 32.602 54.179 32.6043 54.1967C32.6043 54.4509 32.6043 54.7052 32.6032 54.9606Z"
        fill={fill}
      />
      <path
        d="M104.791 54.9605C104.789 54.977 104.786 54.9935 104.785 55.0088C103.843 55.0111 102.9 55.0123 101.959 55.0147C101.952 55.0076 101.945 55.0005 101.938 54.9935C101.943 54.7145 101.949 54.4343 101.955 54.1542C102.899 54.1507 103.842 54.1483 104.786 54.1448C104.787 54.1613 104.789 54.1777 104.791 54.1942C104.791 54.4508 104.791 54.7063 104.791 54.9605Z"
        fill={fill}
      />
      <path
        d="M101.085 57.7279C101.081 56.8274 101.078 55.9257 101.075 55.0252L101.095 55.0052C101.375 55.0017 101.654 54.9982 101.934 54.9946C101.942 55.0017 101.949 55.0088 101.956 55.0158C101.949 55.9222 101.94 56.8274 101.933 57.7338C101.65 57.7315 101.367 57.7291 101.085 57.7279Z"
        fill={fill}
      />
      <path
        d="M24.8301 54.9924C24.8301 54.7146 24.8313 54.4356 24.8313 54.1578C25.6341 54.1531 26.4357 54.1496 27.2385 54.1437C27.355 54.1425 27.4727 54.1331 27.5893 54.1284C27.5963 54.1355 27.6034 54.1425 27.6105 54.1496C27.6116 54.4357 27.6128 54.7217 27.614 55.0077C27.6069 55.0148 27.5987 55.023 27.5916 55.0313C26.8159 55.0254 26.0402 55.0195 25.2644 55.0124C25.1197 55.0101 24.9749 54.9995 24.8301 54.9924Z"
        fill={fill}
      />
      <path
        d="M37.9087 54.1529C37.9063 54.4401 37.9028 54.7273 37.9004 55.0157C36.9776 55.0169 36.0547 55.0181 35.133 55.0205L35.1342 54.991C35.1342 54.7144 35.133 54.4378 35.133 54.1611L35.1318 54.1364C36.0512 54.1364 36.9717 54.1353 37.891 54.1353L37.9087 54.1529Z"
        fill={fill}
      />
      <path
        d="M99.7983 55.0089C99.7971 54.7217 99.7959 54.4356 99.7959 54.1484C100.067 54.1461 100.337 54.1437 100.607 54.1414H100.608C100.607 54.4321 100.607 54.724 100.606 55.0148L100.603 55.016C100.335 55.0148 100.067 55.0124 99.7983 55.0089Z"
        fill={outline}
      />
      <path
        d="M101.951 52.8593C101.954 53.1265 101.957 53.3949 101.96 53.6621C101.96 53.6621 101.957 53.6645 101.958 53.6645C101.666 53.6668 101.373 53.6692 101.081 53.6715C101.083 53.3984 101.086 53.1253 101.087 52.8511C101.374 52.8534 101.663 52.8558 101.951 52.8593Z"
        fill={outline}
      />
      <path
        d="M100.604 54.1412C100.608 53.9858 100.612 53.8316 100.616 53.6763C100.77 53.6739 100.923 53.6715 101.078 53.6692C101.079 53.8257 101.081 53.9835 101.082 54.14H101.081C100.922 54.1412 100.763 54.1412 100.604 54.1412Z"
        fill="#F1F1F1"
      />
      <path
        d="M104.791 54.9608C104.791 54.7065 104.791 54.4511 104.792 54.1969C104.905 54.1792 105.019 54.1486 105.132 54.1474C105.861 54.1415 106.59 54.1415 107.318 54.1392L107.315 54.1568C107.317 54.4346 107.318 54.7124 107.321 54.9914C106.523 54.9973 105.726 55.0044 104.928 55.0079C104.882 55.0079 104.836 54.9773 104.791 54.9608Z"
        fill={fill}
      />
      <path
        d="M35.133 54.1612C35.133 54.4378 35.1341 54.7144 35.1341 54.9911C34.2913 54.9805 33.4473 54.9711 32.6045 54.9616C32.6045 54.7062 32.6045 54.4508 32.6057 54.1965C32.661 54.18 32.7163 54.1494 32.7716 54.1494C33.5591 54.1494 34.3466 54.1553 35.133 54.1612Z"
        fill={fill}
      />
      <path
        d="M29.7666 53.6528C29.7713 53.3832 29.776 53.1125 29.7807 52.8429C30.7224 52.8382 31.663 52.8323 32.6047 52.8276L32.6035 52.8524C32.6047 53.1207 32.6047 53.3891 32.6058 53.6575C31.6641 53.6622 30.7236 53.6669 29.7819 53.6716C29.7819 53.6728 29.7666 53.6528 29.7666 53.6528Z"
        fill={fill}
      />
      <path
        d="M37.8877 49.906C37.8888 50.883 37.89 51.86 37.8912 52.8371V52.8382C36.973 52.8394 36.0549 52.8418 35.1367 52.8429L35.1379 52.8218C35.1379 51.8506 35.1379 50.8795 35.1379 49.9095C35.1556 49.9072 35.1744 49.906 35.1932 49.906C36.0902 49.906 36.9883 49.906 37.8877 49.906Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.6031 53.6588C32.602 53.3904 32.602 53.122 32.6008 52.8536C33.3388 52.8489 34.0769 52.8454 34.8138 52.8395C34.9197 52.8383 35.0269 52.8289 35.1328 52.823L35.1316 52.8442C35.1316 53.1161 35.1304 53.388 35.1304 53.6599C34.2864 53.6646 33.4436 53.6705 32.5996 53.6752L32.6031 53.6588Z"
        fill={fill}
      />
      <path
        d="M28.8936 54.139C28.8947 53.9813 28.8959 53.8235 28.8971 53.6658C29.1867 53.6611 29.4751 53.6575 29.7635 53.6528L29.7788 53.6728C29.7776 53.8282 29.7764 53.9836 29.7752 54.139C29.7682 54.146 29.7611 54.1531 29.754 54.1602C29.4739 54.1602 29.1937 54.1602 28.9124 54.159L28.8936 54.139Z"
        fill={fill}
      />
      <path
        d="M27.5879 54.1286C27.5902 53.9779 27.5914 53.826 27.5938 53.6754C27.8704 53.6742 28.147 53.6718 28.4248 53.6707C28.426 53.826 28.4284 53.9802 28.4295 54.1356L28.4095 54.1533C28.1435 54.1521 27.8763 54.1521 27.6103 54.1509C27.6032 54.1427 27.595 54.1356 27.5879 54.1286Z"
        fill={fill}
      />
      <path
        d="M28.8981 55.0183C28.7415 55.0207 28.5838 55.0218 28.4272 55.0242L28.4072 55.0065C28.4084 54.7217 28.4096 54.4368 28.4096 54.1519L28.4296 54.1343C28.585 54.1355 28.7392 54.1378 28.8946 54.139C28.8946 54.139 28.9157 54.1602 28.9157 54.159C28.9169 54.438 28.9181 54.7169 28.9205 54.9959C28.9122 55.0042 28.9052 55.0112 28.8981 55.0183Z"
        fill={fill}
      />
      <path
        d="M28.9197 54.9971C28.9186 54.7181 28.9174 54.4391 28.915 54.1602C29.1952 54.1602 29.4765 54.1602 29.7567 54.1613C29.7555 54.4403 29.7532 54.7181 29.752 54.9959C29.4742 54.9959 29.1975 54.9959 28.9197 54.9971Z"
        fill={outline}
      />
      <path
        d="M38.7233 54.1378C38.4525 54.1425 38.1818 54.1484 37.9099 54.1531L37.8922 54.1355C37.891 53.9825 37.8898 53.8306 37.8887 53.6776L37.9063 53.6599C38.1794 53.6646 38.4525 53.6693 38.7256 53.674C38.7256 53.8282 38.7244 53.9836 38.7233 54.1378Z"
        fill={fill}
      />
      <path
        d="M35.1283 53.6586C35.1283 53.3867 35.1295 53.1148 35.1295 52.8428C36.0477 52.8417 36.9658 52.8393 37.884 52.8381C37.8899 53.1124 37.8958 53.3855 37.9016 53.6598L37.884 53.6774C36.9647 53.6786 36.0453 53.6786 35.126 53.6798L35.1283 53.6586Z"
        fill={fill}
      />
      <path
        d="M28.4086 54.1518C28.4075 54.4366 28.4063 54.7215 28.4063 55.0064C28.1414 55.0064 27.8778 55.0075 27.6129 55.0075C27.6117 54.7215 27.6106 54.4355 27.6094 54.1494C27.8754 54.1506 28.1414 54.1506 28.4086 54.1518Z"
        fill={outline}
      />
      <path
        d="M107.317 54.1389C106.588 54.1412 105.86 54.1401 105.131 54.1471C105.017 54.1483 104.904 54.1789 104.791 54.1966C104.788 54.1801 104.787 54.1636 104.786 54.1459C104.787 53.9894 104.788 53.8328 104.79 53.6774C104.79 53.6774 104.787 53.6574 104.787 53.6562C105.631 53.6633 106.475 53.6692 107.319 53.6763C107.319 53.8305 107.318 53.9847 107.317 54.1389Z"
        fill="#CFE3E7"
      />
      <path
        d="M100.608 54.1414C100.766 54.1414 100.925 54.1414 101.082 54.1414C101.087 54.4298 101.092 54.717 101.097 55.0054L101.077 55.0254C100.919 55.0219 100.762 55.0195 100.604 55.016C100.607 54.724 100.607 54.4333 100.608 54.1414Z"
        fill={fill}
      />
      <path
        d="M104.791 53.6774C104.79 53.8339 104.789 53.9905 104.787 54.1459C103.843 54.1494 102.901 54.1529 101.956 54.1553L101.948 54.1494C101.952 53.987 101.955 53.8245 101.959 53.6632L101.962 53.6609C102.904 53.6668 103.847 53.6715 104.791 53.6774Z"
        fill="#F1F1F1"
      />
      <path
        d="M29.7773 54.1402C29.7785 53.9848 29.7797 53.8294 29.7809 53.674C30.7226 53.6693 31.6631 53.6646 32.6048 53.6599L32.6013 53.6764C32.6013 53.833 32.6001 53.9907 32.6001 54.1472C31.6596 54.1437 30.7179 54.1414 29.7773 54.1402Z"
        fill="#F1F1F1"
      />
      <path
        d="M32.5996 54.1446C32.5996 53.988 32.6008 53.8303 32.6008 53.6738C33.4448 53.669 34.2876 53.6632 35.1316 53.6584L35.1304 53.6785C35.1304 53.8303 35.1316 53.9833 35.1316 54.1352L35.1328 54.1599C34.3453 54.1552 33.5578 54.1493 32.7715 54.147C32.7161 54.147 32.6608 54.1776 32.6055 54.194C32.6031 54.1787 32.6008 54.1611 32.5996 54.1446Z"
        fill="#CFE3E7"
      />
      <path
        d="M101.095 55.0054C101.09 54.717 101.086 54.4298 101.081 54.1414H101.082C101.369 54.1437 101.657 54.1473 101.944 54.1496L101.952 54.1555C101.946 54.4356 101.94 54.7146 101.934 54.9948C101.654 54.9983 101.375 55.0018 101.095 55.0054Z"
        fill={outline}
      />
      <path
        d="M35.133 54.1366C35.133 53.9847 35.1318 53.8317 35.1318 53.6798C36.0512 53.6787 36.9705 53.6787 37.8898 53.6775C37.891 53.8305 37.8922 53.9824 37.8934 54.1354C36.9729 54.1354 36.0523 54.1354 35.133 54.1366Z"
        fill="#F1F1F1"
      />
      <path
        d="M101.947 54.1507C101.66 54.1484 101.373 54.1448 101.086 54.1425C101.085 53.9859 101.082 53.8282 101.081 53.6716C101.373 53.6693 101.666 53.6669 101.958 53.6646C101.954 53.8258 101.951 53.9883 101.947 54.1507Z"
        fill={fill}
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="68.389"
          y1="34.9875"
          x2="68.389"
          y2="0.2843"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
